/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__("./app/redux.js");
	
	__webpack_require__("./app/preact/index.js");
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.moment = _moment2.default;

/***/ },

/***/ "./app/components/zodiac-sign-picker.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderTitle = function () {
	            if (_this.props.title) {
	                return (0, _preact.h)(
	                    'h3',
	                    null,
	                    _this.props.title
	                );
	            }
	
	            return (0, _preact.h)(
	                'p',
	                null,
	                'Choose A Sign:'
	            );
	        }, _this.renderViewAllLink = function () {
	            if (_this.props.view_all_link) {
	                return (0, _preact.h)(
	                    'a',
	                    { href: _this.props.base_url + '/view-all', 'class': 'header' },
	                    'View All Horoscopes'
	                );
	            }
	
	            return null;
	        }, _this.renderGeneralLink = function () {
	            if (_this.props.general_link) {
	                return (0, _preact.h)(
	                    'a',
	                    { href: _this.props.base_url + '/general', 'class': 'header' },
	                    'General Horoscope'
	                );
	            }
	
	            return null;
	        }, _this.renderTiles = function () {
	            if (_this.props.mode == 'tiles' || _this.state.isOpen) {
	                var _ref2 = _this.props.logged_in ? ['LI Click', 'LI Impression'] : ['LO Click', 'LO Impression'],
	                    _ref3 = _slicedToArray(_ref2, 2),
	                    click_action = _ref3[0],
	                    impression_action = _ref3[1];
	
	                _this.trackEvent(impression_action, _this.props.page_name);
	
	                return (0, _preact.h)(
	                    'div',
	                    { 'class': 'zodiac-signs' },
	                    _this.props.signs.map(function (sign) {
	
	                        return (0, _preact.h)(
	                            'a',
	                            {
	                                'class': 'zodiac-sign ' + sign.name,
	                                href: _this.props.base_url + '/' + sign.name,
	                                onClick: function onClick() {
	                                    return _this.trackEvent(click_action, sign.name);
	                                }
	                            },
	                            (0, _preact.h)(
	                                'p',
	                                { 'class': 'sign' },
	                                sign.name
	                            ),
	                            (0, _preact.h)(
	                                'p',
	                                { 'class': 'dates' },
	                                sign.start,
	                                ' - ',
	                                sign.end
	                            )
	                        );
	                    })
	                );
	            }
	
	            return null;
	        }, _this.renderFooterLink = function () {
	            if (_this.props.footer_link) {
	                return (0, _preact.h)(
	                    'a',
	                    { href: _this.props.base_url + '/general', 'class': 'footer' },
	                    'GENERAL HOROSCOPE'
	                );
	            }
	
	            return null;
	        }, _this.trackEvent = function (action, label) {
	            _this.props.trackEvent(['Zodiac Sign Picker', action, label]);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render() {
	            return (0, _preact.h)(
	                'zodiac-sign-picker',
	                null,
	                (0, _preact.h)(
	                    'row',
	                    null,
	                    (0, _preact.h)(
	                        'column',
	                        { 'class': 'is-6 is-12-mobile' },
	                        this.renderTitle()
	                    ),
	                    (0, _preact.h)(
	                        'column',
	                        { 'class': 'is-6 is-12-mobile' },
	                        this.renderViewAllLink(),
	                        this.renderGeneralLink()
	                    )
	                ),
	                this.renderTiles(),
	                (0, _preact.h)(
	                    'row',
	                    null,
	                    (0, _preact.h)(
	                        'column',
	                        { 'class': 'is-12' },
	                        this.renderFooterLink()
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        signs: state.zodiac && state.zodiac.signs,
	        logged_in: state.user && state.user.logged_in
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        trackEvent: function trackEvent(payload) {
	            return dispatch({ type: 'ga:event', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "../node_modules/redux/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__("../node_modules/redux/lib/createStore.js");
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__("../node_modules/redux/lib/combineReducers.js");
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__("../node_modules/redux/lib/bindActionCreators.js");
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__("../node_modules/redux/lib/applyMiddleware.js");
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__("../node_modules/redux/lib/compose.js");
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__("../node_modules/redux/lib/utils/warning.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },

/***/ "../node_modules/redux/lib/createStore.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__("../node_modules/lodash/isPlainObject.js");
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__("../node_modules/symbol-observable/lib/index.js");
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },

/***/ "../node_modules/lodash/isPlainObject.js":
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__("../node_modules/lodash/_baseGetTag.js"),
	    getPrototype = __webpack_require__("../node_modules/lodash/_getPrototype.js"),
	    isObjectLike = __webpack_require__("../node_modules/lodash/isObjectLike.js");
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },

/***/ "../node_modules/lodash/_baseGetTag.js":
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__("../node_modules/lodash/_Symbol.js"),
	    getRawTag = __webpack_require__("../node_modules/lodash/_getRawTag.js"),
	    objectToString = __webpack_require__("../node_modules/lodash/_objectToString.js");
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  value = Object(value);
	  return (symToStringTag && symToStringTag in value)
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },

/***/ "../node_modules/lodash/_Symbol.js":
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__("../node_modules/lodash/_root.js");
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },

/***/ "../node_modules/lodash/_root.js":
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__("../node_modules/lodash/_freeGlobal.js");
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },

/***/ "../node_modules/lodash/_freeGlobal.js":
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ "../node_modules/lodash/_getRawTag.js":
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__("../node_modules/lodash/_Symbol.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },

/***/ "../node_modules/lodash/_objectToString.js":
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },

/***/ "../node_modules/lodash/_getPrototype.js":
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__("../node_modules/lodash/_overArg.js");
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },

/***/ "../node_modules/lodash/_overArg.js":
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },

/***/ "../node_modules/lodash/isObjectLike.js":
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },

/***/ "../node_modules/symbol-observable/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__("../node_modules/symbol-observable/lib/ponyfill.js");
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__("../node_modules/webpack/buildin/module.js")(module)))

/***/ },

/***/ "../node_modules/webpack/buildin/module.js":
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },

/***/ "../node_modules/symbol-observable/lib/ponyfill.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },

/***/ "../node_modules/redux/lib/combineReducers.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__("../node_modules/redux/lib/createStore.js");
	
	var _isPlainObject = __webpack_require__("../node_modules/lodash/isPlainObject.js");
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__("../node_modules/redux/lib/utils/warning.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },

/***/ "../node_modules/redux/lib/utils/warning.js":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },

/***/ "../node_modules/redux/lib/bindActionCreators.js":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },

/***/ "../node_modules/redux/lib/applyMiddleware.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__("../node_modules/redux/lib/compose.js");
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },

/***/ "../node_modules/redux/lib/compose.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },

/***/ "../node_modules/babel-regenerator-runtime/runtime.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var iteratorSymbol =
	    typeof Symbol === "function" && Symbol.iterator || "@@iterator";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = Object.create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    // This invoke function is written in a style that assumes some
	    // calling function (or Promise) will handle exceptions.
	    function invoke(method, arg) {
	      var result = generator[method](arg);
	      var value = result.value;
	      return value instanceof AwaitArgument
	        ? Promise.resolve(value.arg).then(invokeNext, invokeThrow)
	        : Promise.resolve(value).then(function(unwrapped) {
	            // When a yielded Promise is resolved, its final value becomes
	            // the .value of the Promise<{value,done}> result for the
	            // current iteration. If the Promise is rejected, however, the
	            // result for this iteration will be rejected with the same
	            // reason. Note that rejections of yielded Promises are not
	            // thrown back into the generator function, as is the case
	            // when an awaited Promise is rejected. This difference in
	            // behavior between yield and await is important, because it
	            // allows the consumer to decide what to do with the yielded
	            // rejection (swallow it and continue, manually .throw it back
	            // into the generator, abandon iteration, whatever). With
	            // await, by contrast, there is no opportunity to examine the
	            // rejection reason outside the generator function, so the
	            // only option is to throw it from the await expression, and
	            // let the generator function handle the exception.
	            result.value = unwrapped;
	            return result;
	          });
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var invokeNext = invoke.bind(generator, "next");
	    var invokeThrow = invoke.bind(generator, "throw");
	    var invokeReturn = invoke.bind(generator, "return");
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return invoke(method, arg);
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : new Promise(function (resolve) {
	          resolve(callInvokeWithMethodAndArg());
	        });
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          context._sent = arg;
	
	          if (state === GenStateSuspendedYield) {
	            context.sent = arg;
	          } else {
	            context.sent = undefined;
	          }
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      this.sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__("../node_modules/process/browser.js")))

/***/ },

/***/ "../node_modules/process/browser.js":
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },

/***/ "../node_modules/redux-saga/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.utils = exports.effects = exports.detach = exports.CANCEL = exports.delay = exports.throttle = exports.takeLatest = exports.takeEvery = exports.buffers = exports.channel = exports.eventChannel = exports.END = exports.runSaga = undefined;
	
	var _runSaga = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/runSaga.js");
	
	Object.defineProperty(exports, 'runSaga', {
	  enumerable: true,
	  get: function get() {
	    return _runSaga.runSaga;
	  }
	});
	
	var _channel = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/channel.js");
	
	Object.defineProperty(exports, 'END', {
	  enumerable: true,
	  get: function get() {
	    return _channel.END;
	  }
	});
	Object.defineProperty(exports, 'eventChannel', {
	  enumerable: true,
	  get: function get() {
	    return _channel.eventChannel;
	  }
	});
	Object.defineProperty(exports, 'channel', {
	  enumerable: true,
	  get: function get() {
	    return _channel.channel;
	  }
	});
	
	var _buffers = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/buffers.js");
	
	Object.defineProperty(exports, 'buffers', {
	  enumerable: true,
	  get: function get() {
	    return _buffers.buffers;
	  }
	});
	
	var _sagaHelpers = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/sagaHelpers/index.js");
	
	Object.defineProperty(exports, 'takeEvery', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.takeEvery;
	  }
	});
	Object.defineProperty(exports, 'takeLatest', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.takeLatest;
	  }
	});
	Object.defineProperty(exports, 'throttle', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.throttle;
	  }
	});
	
	var _utils = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/utils.js");
	
	Object.defineProperty(exports, 'delay', {
	  enumerable: true,
	  get: function get() {
	    return _utils.delay;
	  }
	});
	Object.defineProperty(exports, 'CANCEL', {
	  enumerable: true,
	  get: function get() {
	    return _utils.CANCEL;
	  }
	});
	
	var _io = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/io.js");
	
	Object.defineProperty(exports, 'detach', {
	  enumerable: true,
	  get: function get() {
	    return _io.detach;
	  }
	});
	
	var _middleware = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/middleware.js");
	
	var _middleware2 = /*#__PURE__*/_interopRequireDefault(_middleware);
	
	var _effects = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var effects = /*#__PURE__*/_interopRequireWildcard(_effects);
	
	var _utils2 = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/utils.js");
	
	var utils = /*#__PURE__*/_interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _middleware2.default;
	exports.effects = effects;
	exports.utils = utils;

/***/ },

/***/ "../node_modules/redux-saga/lib/internal/runSaga.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runSaga = runSaga;
	
	var _utils = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/utils.js");
	
	var _proc = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/proc.js");
	
	var _proc2 = /*#__PURE__*/_interopRequireDefault(_proc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
	var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';
	
	function runSaga(storeInterface, saga) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var iterator = void 0;
	
	  if (_utils.is.iterator(storeInterface)) {
	    if (false) {
	      (0, _utils.log)('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
	    }
	    iterator = storeInterface;
	    storeInterface = saga;
	  } else {
	    (0, _utils.check)(saga, _utils.is.func, NON_GENERATOR_ERR);
	    iterator = saga.apply(undefined, args);
	    (0, _utils.check)(iterator, _utils.is.iterator, NON_GENERATOR_ERR);
	  }
	
	  var _storeInterface = storeInterface,
	      subscribe = _storeInterface.subscribe,
	      dispatch = _storeInterface.dispatch,
	      getState = _storeInterface.getState,
	      context = _storeInterface.context,
	      sagaMonitor = _storeInterface.sagaMonitor,
	      logger = _storeInterface.logger,
	      onError = _storeInterface.onError;
	
	
	  var effectId = (0, _utils.uid)();
	
	  if (sagaMonitor) {
	    // monitors are expected to have a certain interface, let's fill-in any missing ones
	    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || _utils.noop;
	    sagaMonitor.effectResolved = sagaMonitor.effectResolved || _utils.noop;
	    sagaMonitor.effectRejected = sagaMonitor.effectRejected || _utils.noop;
	    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || _utils.noop;
	    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || _utils.noop;
	
	    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
	  }
	
	  var task = (0, _proc2.default)(iterator, subscribe, (0, _utils.wrapSagaDispatch)(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);
	
	  if (sagaMonitor) {
	    sagaMonitor.effectResolved(effectId, task);
	  }
	
	  return task;
	}

/***/ },

/***/ "../node_modules/redux-saga/lib/internal/utils.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.check = check;
	exports.hasOwn = hasOwn;
	exports.remove = remove;
	exports.deferred = deferred;
	exports.arrayOfDeffered = arrayOfDeffered;
	exports.delay = delay;
	exports.createMockTask = createMockTask;
	exports.autoInc = autoInc;
	exports.makeIterator = makeIterator;
	exports.log = log;
	exports.deprecate = deprecate;
	var sym = exports.sym = function sym(id) {
	  return '@@redux-saga/' + id;
	};
	
	var TASK = /*#__PURE__*/exports.TASK = sym('TASK');
	var HELPER = /*#__PURE__*/exports.HELPER = sym('HELPER');
	var MATCH = /*#__PURE__*/exports.MATCH = sym('MATCH');
	var CANCEL = /*#__PURE__*/exports.CANCEL = sym('CANCEL_PROMISE');
	var SAGA_ACTION = /*#__PURE__*/exports.SAGA_ACTION = sym('SAGA_ACTION');
	var SELF_CANCELLATION = /*#__PURE__*/exports.SELF_CANCELLATION = sym('SELF_CANCELLATION');
	var konst = exports.konst = function konst(v) {
	  return function () {
	    return v;
	  };
	};
	var kTrue = /*#__PURE__*/exports.kTrue = konst(true);
	var kFalse = /*#__PURE__*/exports.kFalse = konst(false);
	var noop = exports.noop = function noop() {};
	var ident = exports.ident = function ident(v) {
	  return v;
	};
	
	function check(value, predicate, error) {
	  if (!predicate(value)) {
	    log('error', 'uncaught at check', error);
	    throw new Error(error);
	  }
	}
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	function hasOwn(object, property) {
	  return is.notUndef(object) && hasOwnProperty.call(object, property);
	}
	
	var is = exports.is = {
	  undef: function undef(v) {
	    return v === null || v === undefined;
	  },
	  notUndef: function notUndef(v) {
	    return v !== null && v !== undefined;
	  },
	  func: function func(f) {
	    return typeof f === 'function';
	  },
	  number: function number(n) {
	    return typeof n === 'number';
	  },
	  string: function string(s) {
	    return typeof s === 'string';
	  },
	  array: Array.isArray,
	  object: function object(obj) {
	    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
	  },
	  promise: function promise(p) {
	    return p && is.func(p.then);
	  },
	  iterator: function iterator(it) {
	    return it && is.func(it.next) && is.func(it.throw);
	  },
	  iterable: function iterable(it) {
	    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
	  },
	  task: function task(t) {
	    return t && t[TASK];
	  },
	  observable: function observable(ob) {
	    return ob && is.func(ob.subscribe);
	  },
	  buffer: function buffer(buf) {
	    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
	  },
	  pattern: function pattern(pat) {
	    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
	  },
	  channel: function channel(ch) {
	    return ch && is.func(ch.take) && is.func(ch.close);
	  },
	  helper: function helper(it) {
	    return it && it[HELPER];
	  },
	  stringableFunc: function stringableFunc(f) {
	    return is.func(f) && hasOwn(f, 'toString');
	  }
	};
	
	var object = exports.object = {
	  assign: function assign(target, source) {
	    for (var i in source) {
	      if (hasOwn(source, i)) {
	        target[i] = source[i];
	      }
	    }
	  }
	};
	
	function remove(array, item) {
	  var index = array.indexOf(item);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	}
	
	var array = exports.array = {
	  from: function from(obj) {
	    var arr = Array(obj.length);
	    for (var i in obj) {
	      if (hasOwn(obj, i)) {
	        arr[i] = obj[i];
	      }
	    }
	    return arr;
	  }
	};
	
	function deferred() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var def = _extends({}, props);
	  var promise = new Promise(function (resolve, reject) {
	    def.resolve = resolve;
	    def.reject = reject;
	  });
	  def.promise = promise;
	  return def;
	}
	
	function arrayOfDeffered(length) {
	  var arr = [];
	  for (var i = 0; i < length; i++) {
	    arr.push(deferred());
	  }
	  return arr;
	}
	
	function delay(ms) {
	  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  var timeoutId = void 0;
	  var promise = new Promise(function (resolve) {
	    timeoutId = setTimeout(function () {
	      return resolve(val);
	    }, ms);
	  });
	
	  promise[CANCEL] = function () {
	    return clearTimeout(timeoutId);
	  };
	
	  return promise;
	}
	
	function createMockTask() {
	  var _ref;
	
	  var running = true;
	  var _result = void 0,
	      _error = void 0;
	
	  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
	    return running;
	  }, _ref.result = function result() {
	    return _result;
	  }, _ref.error = function error() {
	    return _error;
	  }, _ref.setRunning = function setRunning(b) {
	    return running = b;
	  }, _ref.setResult = function setResult(r) {
	    return _result = r;
	  }, _ref.setError = function setError(e) {
	    return _error = e;
	  }, _ref;
	}
	
	function autoInc() {
	  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = /*#__PURE__*/exports.uid = autoInc();
	
	var kThrow = function kThrow(err) {
	  throw err;
	};
	var kReturn = function kReturn(value) {
	  return { value: value, done: true };
	};
	function makeIterator(next) {
	  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
	  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var isHelper = arguments[3];
	
	  var iterator = { name: name, next: next, throw: thro, return: kReturn };
	
	  if (isHelper) {
	    iterator[HELPER] = true;
	  }
	  if (typeof Symbol !== 'undefined') {
	    iterator[Symbol.iterator] = function () {
	      return iterator;
	    };
	  }
	  return iterator;
	}
	
	/**
	  Print error in a useful way whether in a browser environment
	  (with expandable error stack traces), or in a node.js environment
	  (text-only log output)
	 **/
	function log(level, message) {
	  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  /*eslint-disable no-console*/
	  if (typeof window === 'undefined') {
	    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
	  } else {
	    console[level](message, error);
	  }
	}
	
	function deprecate(fn, deprecationWarning) {
	  return function () {
	    if (false) log('warn', deprecationWarning);
	    return fn.apply(undefined, arguments);
	  };
	}
	
	var updateIncentive = exports.updateIncentive = function updateIncentive(deprecated, preferred) {
	  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
	};
	
	var internalErr = exports.internalErr = function internalErr(err) {
	  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
	};
	
	var createSetContextWarning = exports.createSetContextWarning = function createSetContextWarning(ctx, props) {
	  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
	};
	
	var wrapSagaDispatch = exports.wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
	  return function (action) {
	    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
	  };
	};
	
	var cloneableGenerator = exports.cloneableGenerator = function cloneableGenerator(generatorFunc) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var history = [];
	    var gen = generatorFunc.apply(undefined, args);
	    return {
	      next: function next(arg) {
	        history.push(arg);
	        return gen.next(arg);
	      },
	      clone: function clone() {
	        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
	        history.forEach(function (arg) {
	          return clonedGen.next(arg);
	        });
	        return clonedGen;
	      },
	      return: function _return(value) {
	        return gen.return(value);
	      },
	      throw: function _throw(exception) {
	        return gen.throw(exception);
	      }
	    };
	  };
	};

/***/ },

/***/ "../node_modules/redux-saga/lib/internal/proc.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TASK_CANCEL = exports.CHANNEL_END = exports.NOT_ITERATOR_ERROR = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = proc;
	
	var _utils = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/utils.js");
	
	var _scheduler = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/scheduler.js");
	
	var _io = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/io.js");
	
	var _channel = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/channel.js");
	
	var _buffers = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/buffers.js");
	
	function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }
	
	var NOT_ITERATOR_ERROR = exports.NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';
	
	var CHANNEL_END = exports.CHANNEL_END = {
	  toString: function toString() {
	    return '@@redux-saga/CHANNEL_END';
	  }
	};
	var TASK_CANCEL = exports.TASK_CANCEL = {
	  toString: function toString() {
	    return '@@redux-saga/TASK_CANCEL';
	  }
	};
	
	var matchers = {
	  wildcard: function wildcard() {
	    return _utils.kTrue;
	  },
	  default: function _default(pattern) {
	    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
	      return input.type === pattern;
	    } : function (input) {
	      return input.type === String(pattern);
	    };
	  },
	  array: function array(patterns) {
	    return function (input) {
	      return patterns.some(function (p) {
	        return matcher(p)(input);
	      });
	    };
	  },
	  predicate: function predicate(_predicate) {
	    return function (input) {
	      return _predicate(input);
	    };
	  }
	};
	
	function matcher(pattern) {
	  // prettier-ignore
	  return (pattern === '*' ? matchers.wildcard : _utils.is.array(pattern) ? matchers.array : _utils.is.stringableFunc(pattern) ? matchers.default : _utils.is.func(pattern) ? matchers.predicate : matchers.default)(pattern);
	}
	
	/**
	  Used to track a parent task and its forks
	  In the new fork model, forked tasks are attached by default to their parent
	  We model this using the concept of Parent task && main Task
	  main task is the main flow of the current Generator, the parent tasks is the
	  aggregation of the main tasks + all its forked tasks.
	  Thus the whole model represents an execution tree with multiple branches (vs the
	  linear execution tree in sequential (non parallel) programming)
	
	  A parent tasks has the following semantics
	  - It completes if all its forks either complete or all cancelled
	  - If it's cancelled, all forks are cancelled as well
	  - It aborts if any uncaught error bubbles up from forks
	  - If it completes, the return value is the one returned by the main task
	**/
	function forkQueue(name, mainTask, cb) {
	  var tasks = [],
	      result = void 0,
	      completed = false;
	  addTask(mainTask);
	
	  function abort(err) {
	    cancelAll();
	    cb(err, true);
	  }
	
	  function addTask(task) {
	    tasks.push(task);
	    task.cont = function (res, isErr) {
	      if (completed) {
	        return;
	      }
	
	      (0, _utils.remove)(tasks, task);
	      task.cont = _utils.noop;
	      if (isErr) {
	        abort(res);
	      } else {
	        if (task === mainTask) {
	          result = res;
	        }
	        if (!tasks.length) {
	          completed = true;
	          cb(result);
	        }
	      }
	    };
	    // task.cont.cancel = task.cancel
	  }
	
	  function cancelAll() {
	    if (completed) {
	      return;
	    }
	    completed = true;
	    tasks.forEach(function (t) {
	      t.cont = _utils.noop;
	      t.cancel();
	    });
	    tasks = [];
	  }
	
	  return {
	    addTask: addTask,
	    cancelAll: cancelAll,
	    abort: abort,
	    getTasks: function getTasks() {
	      return tasks;
	    },
	    taskNames: function taskNames() {
	      return tasks.map(function (t) {
	        return t.name;
	      });
	    }
	  };
	}
	
	function createTaskIterator(_ref) {
	  var context = _ref.context,
	      fn = _ref.fn,
	      args = _ref.args;
	
	  if (_utils.is.iterator(fn)) {
	    return fn;
	  }
	
	  // catch synchronous failures; see #152 and #441
	  var result = void 0,
	      error = void 0;
	  try {
	    result = fn.apply(context, args);
	  } catch (err) {
	    error = err;
	  }
	
	  // i.e. a generator function returns an iterator
	  if (_utils.is.iterator(result)) {
	    return result;
	  }
	
	  // do not bubble up synchronous failures for detached forks
	  // instead create a failed task. See #152 and #441
	  return error ? (0, _utils.makeIterator)(function () {
	    throw error;
	  }) : (0, _utils.makeIterator)(function () {
	    var pc = void 0;
	    var eff = { done: false, value: result };
	    var ret = function ret(value) {
	      return { done: true, value: value };
	    };
	    return function (arg) {
	      if (!pc) {
	        pc = true;
	        return eff;
	      } else {
	        return ret(arg);
	      }
	    };
	  }());
	}
	
	var wrapHelper = function wrapHelper(helper) {
	  return { fn: helper };
	};
	
	function proc(iterator) {
	  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
	    return _utils.noop;
	  };
	  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _utils.noop;
	  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _utils.noop;
	  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
	  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
	  var cont = arguments[8];
	
	  (0, _utils.check)(iterator, _utils.is.iterator, NOT_ITERATOR_ERROR);
	
	  var effectsString = '[...effects]';
	  var runParallelEffect = (0, _utils.deprecate)(runAllEffect, (0, _utils.updateIncentive)(effectsString, 'all(' + effectsString + ')'));
	
	  var sagaMonitor = options.sagaMonitor,
	      logger = options.logger,
	      onError = options.onError;
	
	  var log = logger || _utils.log;
	  var logError = function logError(err) {
	    var message = err.sagaStack;
	
	    if (!message && err.stack) {
	      message = err.stack.split('\n')[0].indexOf(err.message) !== -1 ? err.stack : 'Error: ' + err.message + '\n' + err.stack;
	    }
	
	    log('error', 'uncaught at ' + name, message || err.message || err);
	  };
	  var stdChannel = (0, _channel.stdChannel)(subscribe);
	  var taskContext = Object.create(parentContext);
	  /**
	    Tracks the current effect cancellation
	    Each time the generator progresses. calling runEffect will set a new value
	    on it. It allows propagating cancellation to child effects
	  **/
	  next.cancel = _utils.noop;
	
	  /**
	    Creates a new task descriptor for this generator, We'll also create a main task
	    to track the main flow (besides other forked tasks)
	  **/
	  var task = newTask(parentEffectId, name, iterator, cont);
	  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
	  var taskQueue = forkQueue(name, mainTask, end);
	
	  /**
	    cancellation of the main task. We'll simply resume the Generator with a Cancel
	  **/
	  function cancelMain() {
	    if (mainTask.isRunning && !mainTask.isCancelled) {
	      mainTask.isCancelled = true;
	      next(TASK_CANCEL);
	    }
	  }
	
	  /**
	    This may be called by a parent generator to trigger/propagate cancellation
	    cancel all pending tasks (including the main task), then end the current task.
	     Cancellation propagates down to the whole execution tree holded by this Parent task
	    It's also propagated to all joiners of this task and their execution tree/joiners
	     Cancellation is noop for terminated/Cancelled tasks tasks
	  **/
	  function cancel() {
	    /**
	      We need to check both Running and Cancelled status
	      Tasks can be Cancelled but still Running
	    **/
	    if (iterator._isRunning && !iterator._isCancelled) {
	      iterator._isCancelled = true;
	      taskQueue.cancelAll();
	      /**
	        Ending with a Never result will propagate the Cancellation to all joiners
	      **/
	      end(TASK_CANCEL);
	    }
	  }
	  /**
	    attaches cancellation logic to this task's continuation
	    this will permit cancellation to propagate down the call chain
	  **/
	  cont && (cont.cancel = cancel);
	
	  // tracks the running status
	  iterator._isRunning = true;
	
	  // kicks up the generator
	  next();
	
	  // then return the task descriptor to the caller
	  return task;
	
	  /**
	    This is the generator driver
	    It's a recursive async/continuation function which calls itself
	    until the generator terminates or throws
	  **/
	  function next(arg, isErr) {
	    // Preventive measure. If we end up here, then there is really something wrong
	    if (!mainTask.isRunning) {
	      throw new Error('Trying to resume an already finished generator');
	    }
	
	    try {
	      var result = void 0;
	      if (isErr) {
	        result = iterator.throw(arg);
	      } else if (arg === TASK_CANCEL) {
	        /**
	          getting TASK_CANCEL automatically cancels the main task
	          We can get this value here
	           - By cancelling the parent task manually
	          - By joining a Cancelled task
	        **/
	        mainTask.isCancelled = true;
	        /**
	          Cancels the current effect; this will propagate the cancellation down to any called tasks
	        **/
	        next.cancel();
	        /**
	          If this Generator has a `return` method then invokes it
	          This will jump to the finally block
	        **/
	        result = _utils.is.func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
	      } else if (arg === CHANNEL_END) {
	        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
	        result = _utils.is.func(iterator.return) ? iterator.return() : { done: true };
	      } else {
	        result = iterator.next(arg);
	      }
	
	      if (!result.done) {
	        runEffect(result.value, parentEffectId, '', next);
	      } else {
	        /**
	          This Generator has ended, terminate the main task and notify the fork queue
	        **/
	        mainTask.isMainRunning = false;
	        mainTask.cont && mainTask.cont(result.value);
	      }
	    } catch (error) {
	      if (mainTask.isCancelled) {
	        logError(error);
	      }
	      mainTask.isMainRunning = false;
	      mainTask.cont(error, true);
	    }
	  }
	
	  function end(result, isErr) {
	    iterator._isRunning = false;
	    stdChannel.close();
	    if (!isErr) {
	      iterator._result = result;
	      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
	    } else {
	      if (result instanceof Error) {
	        Object.defineProperty(result, 'sagaStack', {
	          value: 'at ' + name + ' \n ' + (result.sagaStack || result.stack),
	          configurable: true
	        });
	      }
	      if (!task.cont) {
	        if (result instanceof Error && onError) {
	          onError(result);
	        } else {
	          logError(result);
	        }
	      }
	      iterator._error = result;
	      iterator._isAborted = true;
	      iterator._deferredEnd && iterator._deferredEnd.reject(result);
	    }
	    task.cont && task.cont(result, isErr);
	    task.joiners.forEach(function (j) {
	      return j.cb(result, isErr);
	    });
	    task.joiners = null;
	  }
	
	  function runEffect(effect, parentEffectId) {
	    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var cb = arguments[3];
	
	    var effectId = (0, _utils.uid)();
	    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });
	
	    /**
	      completion callback and cancel callback are mutually exclusive
	      We can't cancel an already completed effect
	      And We can't complete an already cancelled effectId
	    **/
	    var effectSettled = void 0;
	
	    // Completion callback passed to the appropriate effect runner
	    function currCb(res, isErr) {
	      if (effectSettled) {
	        return;
	      }
	
	      effectSettled = true;
	      cb.cancel = _utils.noop; // defensive measure
	      if (sagaMonitor) {
	        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
	      }
	      cb(res, isErr);
	    }
	    // tracks down the current cancel
	    currCb.cancel = _utils.noop;
	
	    // setup cancellation logic on the parent cb
	    cb.cancel = function () {
	      // prevents cancelling an already completed effect
	      if (effectSettled) {
	        return;
	      }
	
	      effectSettled = true;
	      /**
	        propagates cancel downward
	        catch uncaught cancellations errors; since we can no longer call the completion
	        callback, log errors raised during cancellations into the console
	      **/
	      try {
	        currCb.cancel();
	      } catch (err) {
	        logError(err);
	      }
	      currCb.cancel = _utils.noop; // defensive measure
	
	      sagaMonitor && sagaMonitor.effectCancelled(effectId);
	    };
	
	    /**
	      each effect runner must attach its own logic of cancellation to the provided callback
	      it allows this generator to propagate cancellation downward.
	       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
	      And the setup must occur before calling the callback
	       This is a sort of inversion of control: called async functions are responsible
	      for completing the flow by calling the provided continuation; while caller functions
	      are responsible for aborting the current flow by calling the attached cancel function
	       Library users can attach their own cancellation logic to promises by defining a
	      promise[CANCEL] method in their returned promises
	      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
	    **/
	    var data = void 0;
	    // prettier-ignore
	    return (
	      // Non declarative effect
	      _utils.is.promise(effect) ? resolvePromise(effect, currCb) : _utils.is.helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : _utils.is.iterator(effect) ? resolveIterator(effect, effectId, name, currCb)
	
	      // declarative effects
	      : _utils.is.array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = _io.asEffect.take(effect)) ? runTakeEffect(data, currCb) : (data = _io.asEffect.put(effect)) ? runPutEffect(data, currCb) : (data = _io.asEffect.all(effect)) ? runAllEffect(data, effectId, currCb) : (data = _io.asEffect.race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = _io.asEffect.call(effect)) ? runCallEffect(data, effectId, currCb) : (data = _io.asEffect.cps(effect)) ? runCPSEffect(data, currCb) : (data = _io.asEffect.fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = _io.asEffect.join(effect)) ? runJoinEffect(data, currCb) : (data = _io.asEffect.cancel(effect)) ? runCancelEffect(data, currCb) : (data = _io.asEffect.select(effect)) ? runSelectEffect(data, currCb) : (data = _io.asEffect.actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = _io.asEffect.flush(effect)) ? runFlushEffect(data, currCb) : (data = _io.asEffect.cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = _io.asEffect.getContext(effect)) ? runGetContextEffect(data, currCb) : (data = _io.asEffect.setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
	    );
	  }
	
	  function resolvePromise(promise, cb) {
	    var cancelPromise = promise[_utils.CANCEL];
	    if (_utils.is.func(cancelPromise)) {
	      cb.cancel = cancelPromise;
	    } else if (_utils.is.func(promise.abort)) {
	      cb.cancel = function () {
	        return promise.abort();
	      };
	      // TODO: add support for the fetch API, whenever they get around to
	      // adding cancel support
	    }
	    promise.then(cb, function (error) {
	      return cb(error, true);
	    });
	  }
	
	  function resolveIterator(iterator, effectId, name, cb) {
	    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
	  }
	
	  function runTakeEffect(_ref2, cb) {
	    var channel = _ref2.channel,
	        pattern = _ref2.pattern,
	        maybe = _ref2.maybe;
	
	    channel = channel || stdChannel;
	    var takeCb = function takeCb(inp) {
	      return inp instanceof Error ? cb(inp, true) : (0, _channel.isEnd)(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
	    };
	    try {
	      channel.take(takeCb, matcher(pattern));
	    } catch (err) {
	      return cb(err, true);
	    }
	    cb.cancel = takeCb.cancel;
	  }
	
	  function runPutEffect(_ref3, cb) {
	    var channel = _ref3.channel,
	        action = _ref3.action,
	        resolve = _ref3.resolve;
	
	    /**
	      Schedule the put in case another saga is holding a lock.
	      The put will be executed atomically. ie nested puts will execute after
	      this put has terminated.
	    **/
	    (0, _scheduler.asap)(function () {
	      var result = void 0;
	      try {
	        result = (channel ? channel.put : dispatch)(action);
	      } catch (error) {
	        // If we have a channel or `put.resolve` was used then bubble up the error.
	        if (channel || resolve) return cb(error, true);
	        logError(error);
	      }
	
	      if (resolve && _utils.is.promise(result)) {
	        resolvePromise(result, cb);
	      } else {
	        return cb(result);
	      }
	    });
	    // Put effects are non cancellables
	  }
	
	  function runCallEffect(_ref4, effectId, cb) {
	    var context = _ref4.context,
	        fn = _ref4.fn,
	        args = _ref4.args;
	
	    var result = void 0;
	    // catch synchronous failures; see #152
	    try {
	      result = fn.apply(context, args);
	    } catch (error) {
	      return cb(error, true);
	    }
	    return _utils.is.promise(result) ? resolvePromise(result, cb) : _utils.is.iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
	  }
	
	  function runCPSEffect(_ref5, cb) {
	    var context = _ref5.context,
	        fn = _ref5.fn,
	        args = _ref5.args;
	
	    // CPS (ie node style functions) can define their own cancellation logic
	    // by setting cancel field on the cb
	
	    // catch synchronous failures; see #152
	    try {
	      var cpsCb = function cpsCb(err, res) {
	        return _utils.is.undef(err) ? cb(res) : cb(err, true);
	      };
	      fn.apply(context, args.concat(cpsCb));
	      if (cpsCb.cancel) {
	        cb.cancel = function () {
	          return cpsCb.cancel();
	        };
	      }
	    } catch (error) {
	      return cb(error, true);
	    }
	  }
	
	  function runForkEffect(_ref6, effectId, cb) {
	    var context = _ref6.context,
	        fn = _ref6.fn,
	        args = _ref6.args,
	        detached = _ref6.detached;
	
	    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });
	
	    try {
	      (0, _scheduler.suspend)();
	      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : _utils.noop);
	
	      if (detached) {
	        cb(_task);
	      } else {
	        if (taskIterator._isRunning) {
	          taskQueue.addTask(_task);
	          cb(_task);
	        } else if (taskIterator._error) {
	          taskQueue.abort(taskIterator._error);
	        } else {
	          cb(_task);
	        }
	      }
	    } finally {
	      (0, _scheduler.flush)();
	    }
	    // Fork effects are non cancellables
	  }
	
	  function runJoinEffect(t, cb) {
	    if (t.isRunning()) {
	      var joiner = { task: task, cb: cb };
	      cb.cancel = function () {
	        return (0, _utils.remove)(t.joiners, joiner);
	      };
	      t.joiners.push(joiner);
	    } else {
	      t.isAborted() ? cb(t.error(), true) : cb(t.result());
	    }
	  }
	
	  function runCancelEffect(taskToCancel, cb) {
	    if (taskToCancel === _utils.SELF_CANCELLATION) {
	      taskToCancel = task;
	    }
	    if (taskToCancel.isRunning()) {
	      taskToCancel.cancel();
	    }
	    cb();
	    // cancel effects are non cancellables
	  }
	
	  function runAllEffect(effects, effectId, cb) {
	    var keys = Object.keys(effects);
	
	    if (!keys.length) {
	      return cb(_utils.is.array(effects) ? [] : {});
	    }
	
	    var completedCount = 0;
	    var completed = void 0;
	    var results = {};
	    var childCbs = {};
	
	    function checkEffectEnd() {
	      if (completedCount === keys.length) {
	        completed = true;
	        cb(_utils.is.array(effects) ? _utils.array.from(_extends({}, results, { length: keys.length })) : results);
	      }
	    }
	
	    keys.forEach(function (key) {
	      var chCbAtKey = function chCbAtKey(res, isErr) {
	        if (completed) {
	          return;
	        }
	        if (isErr || (0, _channel.isEnd)(res) || res === CHANNEL_END || res === TASK_CANCEL) {
	          cb.cancel();
	          cb(res, isErr);
	        } else {
	          results[key] = res;
	          completedCount++;
	          checkEffectEnd();
	        }
	      };
	      chCbAtKey.cancel = _utils.noop;
	      childCbs[key] = chCbAtKey;
	    });
	
	    cb.cancel = function () {
	      if (!completed) {
	        completed = true;
	        keys.forEach(function (key) {
	          return childCbs[key].cancel();
	        });
	      }
	    };
	
	    keys.forEach(function (key) {
	      return runEffect(effects[key], effectId, key, childCbs[key]);
	    });
	  }
	
	  function runRaceEffect(effects, effectId, cb) {
	    var completed = void 0;
	    var keys = Object.keys(effects);
	    var childCbs = {};
	
	    keys.forEach(function (key) {
	      var chCbAtKey = function chCbAtKey(res, isErr) {
	        if (completed) {
	          return;
	        }
	
	        if (isErr) {
	          // Race Auto cancellation
	          cb.cancel();
	          cb(res, true);
	        } else if (!(0, _channel.isEnd)(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
	          var _response;
	
	          cb.cancel();
	          completed = true;
	          var response = (_response = {}, _response[key] = res, _response);
	          cb(_utils.is.array(effects) ? [].slice.call(_extends({}, response, { length: keys.length })) : response);
	        }
	      };
	      chCbAtKey.cancel = _utils.noop;
	      childCbs[key] = chCbAtKey;
	    });
	
	    cb.cancel = function () {
	      // prevents unnecessary cancellation
	      if (!completed) {
	        completed = true;
	        keys.forEach(function (key) {
	          return childCbs[key].cancel();
	        });
	      }
	    };
	    keys.forEach(function (key) {
	      if (completed) {
	        return;
	      }
	      runEffect(effects[key], effectId, key, childCbs[key]);
	    });
	  }
	
	  function runSelectEffect(_ref7, cb) {
	    var selector = _ref7.selector,
	        args = _ref7.args;
	
	    try {
	      var state = selector.apply(undefined, [getState()].concat(args));
	      cb(state);
	    } catch (error) {
	      cb(error, true);
	    }
	  }
	
	  function runChannelEffect(_ref8, cb) {
	    var pattern = _ref8.pattern,
	        buffer = _ref8.buffer;
	
	    var match = matcher(pattern);
	    match.pattern = pattern;
	    cb((0, _channel.eventChannel)(subscribe, buffer || _buffers.buffers.fixed(), match));
	  }
	
	  function runCancelledEffect(data, cb) {
	    cb(!!mainTask.isCancelled);
	  }
	
	  function runFlushEffect(channel, cb) {
	    channel.flush(cb);
	  }
	
	  function runGetContextEffect(prop, cb) {
	    cb(taskContext[prop]);
	  }
	
	  function runSetContextEffect(props, cb) {
	    _utils.object.assign(taskContext, props);
	    cb();
	  }
	
	  function newTask(id, name, iterator, cont) {
	    var _done, _ref9, _mutatorMap;
	
	    iterator._deferredEnd = null;
	    return _ref9 = {}, _ref9[_utils.TASK] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
	      if (iterator._deferredEnd) {
	        return iterator._deferredEnd.promise;
	      } else {
	        var def = (0, _utils.deferred)();
	        iterator._deferredEnd = def;
	        if (!iterator._isRunning) {
	          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
	        }
	        return def.promise;
	      }
	    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
	      return iterator._isRunning;
	    }, _ref9.isCancelled = function isCancelled() {
	      return iterator._isCancelled;
	    }, _ref9.isAborted = function isAborted() {
	      return iterator._isAborted;
	    }, _ref9.result = function result() {
	      return iterator._result;
	    }, _ref9.error = function error() {
	      return iterator._error;
	    }, _ref9.setContext = function setContext(props) {
	      (0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)('task', props));
	      _utils.object.assign(taskContext, props);
	    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
	  }
	}

/***/ },

/***/ "../node_modules/redux-saga/lib/internal/scheduler.js":
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.asap = asap;
	exports.suspend = suspend;
	exports.flush = flush;
	var queue = [];
	/**
	  Variable to hold a counting semaphore
	  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
	    already suspended)
	  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
	    triggers flushing the queued tasks.
	**/
	var semaphore = 0;
	
	/**
	  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
	  and flushed after this task has finished (assuming the scheduler endup in a released
	  state).
	**/
	function exec(task) {
	  try {
	    suspend();
	    task();
	  } finally {
	    release();
	  }
	}
	
	/**
	  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
	**/
	function asap(task) {
	  queue.push(task);
	
	  if (!semaphore) {
	    suspend();
	    flush();
	  }
	}
	
	/**
	  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
	  scheduler is released.
	**/
	function suspend() {
	  semaphore++;
	}
	
	/**
	  Puts the scheduler in a `released` state.
	**/
	function release() {
	  semaphore--;
	}
	
	/**
	  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
	**/
	function flush() {
	  release();
	
	  var task = void 0;
	  while (!semaphore && (task = queue.shift()) !== undefined) {
	    exec(task);
	  }
	}

/***/ },

/***/ "../node_modules/redux-saga/lib/internal/io.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.asEffect = exports.takem = exports.detach = undefined;
	exports.take = take;
	exports.put = put;
	exports.all = all;
	exports.race = race;
	exports.call = call;
	exports.apply = apply;
	exports.cps = cps;
	exports.fork = fork;
	exports.spawn = spawn;
	exports.join = join;
	exports.cancel = cancel;
	exports.select = select;
	exports.actionChannel = actionChannel;
	exports.cancelled = cancelled;
	exports.flush = flush;
	exports.getContext = getContext;
	exports.setContext = setContext;
	exports.takeEvery = takeEvery;
	exports.takeLatest = takeLatest;
	exports.throttle = throttle;
	
	var _utils = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/utils.js");
	
	var _sagaHelpers = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/sagaHelpers/index.js");
	
	var IO = /*#__PURE__*/(0, _utils.sym)('IO');
	var TAKE = 'TAKE';
	var PUT = 'PUT';
	var ALL = 'ALL';
	var RACE = 'RACE';
	var CALL = 'CALL';
	var CPS = 'CPS';
	var FORK = 'FORK';
	var JOIN = 'JOIN';
	var CANCEL = 'CANCEL';
	var SELECT = 'SELECT';
	var ACTION_CHANNEL = 'ACTION_CHANNEL';
	var CANCELLED = 'CANCELLED';
	var FLUSH = 'FLUSH';
	var GET_CONTEXT = 'GET_CONTEXT';
	var SET_CONTEXT = 'SET_CONTEXT';
	
	var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';
	
	var effect = function effect(type, payload) {
	  var _ref;
	
	  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
	};
	
	var detach = exports.detach = function detach(eff) {
	  (0, _utils.check)(asEffect.fork(eff), _utils.is.object, 'detach(eff): argument must be a fork effect');
	  eff[FORK].detached = true;
	  return eff;
	};
	
	function take() {
	  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';
	
	  if (arguments.length) {
	    (0, _utils.check)(arguments[0], _utils.is.notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
	  }
	  if (_utils.is.pattern(patternOrChannel)) {
	    return effect(TAKE, { pattern: patternOrChannel });
	  }
	  if (_utils.is.channel(patternOrChannel)) {
	    return effect(TAKE, { channel: patternOrChannel });
	  }
	  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
	}
	
	take.maybe = function () {
	  var eff = take.apply(undefined, arguments);
	  eff[TAKE].maybe = true;
	  return eff;
	};
	
	var takem = /*#__PURE__*/exports.takem = (0, _utils.deprecate)(take.maybe, /*#__PURE__*/(0, _utils.updateIncentive)('takem', 'take.maybe'));
	
	function put(channel, action) {
	  if (arguments.length > 1) {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'put(channel, action): argument channel is undefined');
	    (0, _utils.check)(channel, _utils.is.channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
	    (0, _utils.check)(action, _utils.is.notUndef, 'put(channel, action): argument action is undefined');
	  } else {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'put(action): argument action is undefined');
	    action = channel;
	    channel = null;
	  }
	  return effect(PUT, { channel: channel, action: action });
	}
	
	put.resolve = function () {
	  var eff = put.apply(undefined, arguments);
	  eff[PUT].resolve = true;
	  return eff;
	};
	
	put.sync = /*#__PURE__*/(0, _utils.deprecate)(put.resolve, /*#__PURE__*/(0, _utils.updateIncentive)('put.sync', 'put.resolve'));
	
	function all(effects) {
	  return effect(ALL, effects);
	}
	
	function race(effects) {
	  return effect(RACE, effects);
	}
	
	function getFnCallDesc(meth, fn, args) {
	  (0, _utils.check)(fn, _utils.is.notUndef, meth + ': argument fn is undefined');
	
	  var context = null;
	  if (_utils.is.array(fn)) {
	    var _fn = fn;
	    context = _fn[0];
	    fn = _fn[1];
	  } else if (fn.fn) {
	    var _fn2 = fn;
	    context = _fn2.context;
	    fn = _fn2.fn;
	  }
	  if (context && _utils.is.string(fn) && _utils.is.func(context[fn])) {
	    fn = context[fn];
	  }
	  (0, _utils.check)(fn, _utils.is.func, meth + ': argument ' + fn + ' is not a function');
	
	  return { context: context, fn: fn, args: args };
	}
	
	function call(fn) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return effect(CALL, getFnCallDesc('call', fn, args));
	}
	
	function apply(context, fn) {
	  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
	}
	
	function cps(fn) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    args[_key2 - 1] = arguments[_key2];
	  }
	
	  return effect(CPS, getFnCallDesc('cps', fn, args));
	}
	
	function fork(fn) {
	  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    args[_key3 - 1] = arguments[_key3];
	  }
	
	  return effect(FORK, getFnCallDesc('fork', fn, args));
	}
	
	function spawn(fn) {
	  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    args[_key4 - 1] = arguments[_key4];
	  }
	
	  return detach(fork.apply(undefined, [fn].concat(args)));
	}
	
	function join() {
	  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	    tasks[_key5] = arguments[_key5];
	  }
	
	  if (tasks.length > 1) {
	    return all(tasks.map(function (t) {
	      return join(t);
	    }));
	  }
	  var task = tasks[0];
	  (0, _utils.check)(task, _utils.is.notUndef, 'join(task): argument task is undefined');
	  (0, _utils.check)(task, _utils.is.task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
	  return effect(JOIN, task);
	}
	
	function cancel() {
	  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	    tasks[_key6] = arguments[_key6];
	  }
	
	  if (tasks.length > 1) {
	    return all(tasks.map(function (t) {
	      return cancel(t);
	    }));
	  }
	  var task = tasks[0];
	  if (tasks.length === 1) {
	    (0, _utils.check)(task, _utils.is.notUndef, 'cancel(task): argument task is undefined');
	    (0, _utils.check)(task, _utils.is.task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
	  }
	  return effect(CANCEL, task || _utils.SELF_CANCELLATION);
	}
	
	function select(selector) {
	  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
	    args[_key7 - 1] = arguments[_key7];
	  }
	
	  if (arguments.length === 0) {
	    selector = _utils.ident;
	  } else {
	    (0, _utils.check)(selector, _utils.is.notUndef, 'select(selector,[...]): argument selector is undefined');
	    (0, _utils.check)(selector, _utils.is.func, 'select(selector,[...]): argument ' + selector + ' is not a function');
	  }
	  return effect(SELECT, { selector: selector, args: args });
	}
	
	/**
	  channel(pattern, [buffer])    => creates an event channel for store actions
	**/
	function actionChannel(pattern, buffer) {
	  (0, _utils.check)(pattern, _utils.is.notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
	  if (arguments.length > 1) {
	    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
	    (0, _utils.check)(buffer, _utils.is.buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
	  }
	  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
	}
	
	function cancelled() {
	  return effect(CANCELLED, {});
	}
	
	function flush(channel) {
	  (0, _utils.check)(channel, _utils.is.channel, 'flush(channel): argument ' + channel + ' is not valid channel');
	  return effect(FLUSH, channel);
	}
	
	function getContext(prop) {
	  (0, _utils.check)(prop, _utils.is.string, 'getContext(prop): argument ' + prop + ' is not a string');
	  return effect(GET_CONTEXT, prop);
	}
	
	function setContext(props) {
	  (0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)(null, props));
	  return effect(SET_CONTEXT, props);
	}
	
	function takeEvery(patternOrChannel, worker) {
	  for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
	    args[_key8 - 2] = arguments[_key8];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers.takeEveryHelper, patternOrChannel, worker].concat(args));
	}
	
	function takeLatest(patternOrChannel, worker) {
	  for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
	    args[_key9 - 2] = arguments[_key9];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers.takeLatestHelper, patternOrChannel, worker].concat(args));
	}
	
	function throttle(ms, pattern, worker) {
	  for (var _len10 = arguments.length, args = Array(_len10 > 3 ? _len10 - 3 : 0), _key10 = 3; _key10 < _len10; _key10++) {
	    args[_key10 - 3] = arguments[_key10];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers.throttleHelper, ms, pattern, worker].concat(args));
	}
	
	var createAsEffectType = function createAsEffectType(type) {
	  return function (effect) {
	    return effect && effect[IO] && effect[type];
	  };
	};
	
	var asEffect = exports.asEffect = {
	  take: /*#__PURE__*/createAsEffectType(TAKE),
	  put: /*#__PURE__*/createAsEffectType(PUT),
	  all: /*#__PURE__*/createAsEffectType(ALL),
	  race: /*#__PURE__*/createAsEffectType(RACE),
	  call: /*#__PURE__*/createAsEffectType(CALL),
	  cps: /*#__PURE__*/createAsEffectType(CPS),
	  fork: /*#__PURE__*/createAsEffectType(FORK),
	  join: /*#__PURE__*/createAsEffectType(JOIN),
	  cancel: /*#__PURE__*/createAsEffectType(CANCEL),
	  select: /*#__PURE__*/createAsEffectType(SELECT),
	  actionChannel: /*#__PURE__*/createAsEffectType(ACTION_CHANNEL),
	  cancelled: /*#__PURE__*/createAsEffectType(CANCELLED),
	  flush: /*#__PURE__*/createAsEffectType(FLUSH),
	  getContext: /*#__PURE__*/createAsEffectType(GET_CONTEXT),
	  setContext: /*#__PURE__*/createAsEffectType(SET_CONTEXT)
	};

/***/ },

/***/ "../node_modules/redux-saga/lib/internal/sagaHelpers/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.throttleHelper = exports.takeLatestHelper = exports.takeEveryHelper = exports.throttle = exports.takeLatest = exports.takeEvery = undefined;
	
	var _takeEvery = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/sagaHelpers/takeEvery.js");
	
	var _takeEvery2 = /*#__PURE__*/_interopRequireDefault(_takeEvery);
	
	var _takeLatest = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/sagaHelpers/takeLatest.js");
	
	var _takeLatest2 = /*#__PURE__*/_interopRequireDefault(_takeLatest);
	
	var _throttle = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/sagaHelpers/throttle.js");
	
	var _throttle2 = /*#__PURE__*/_interopRequireDefault(_throttle);
	
	var _utils = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var deprecationWarning = function deprecationWarning(helperName) {
	  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
	};
	
	var takeEvery = /*#__PURE__*/(0, _utils.deprecate)(_takeEvery2.default, /*#__PURE__*/deprecationWarning('takeEvery'));
	var takeLatest = /*#__PURE__*/(0, _utils.deprecate)(_takeLatest2.default, /*#__PURE__*/deprecationWarning('takeLatest'));
	var throttle = /*#__PURE__*/(0, _utils.deprecate)(_throttle2.default, /*#__PURE__*/deprecationWarning('throttle'));
	
	exports.takeEvery = takeEvery;
	exports.takeLatest = takeLatest;
	exports.throttle = throttle;
	exports.takeEveryHelper = _takeEvery2.default;
	exports.takeLatestHelper = _takeLatest2.default;
	exports.throttleHelper = _throttle2.default;

/***/ },

/***/ "../node_modules/redux-saga/lib/internal/sagaHelpers/takeEvery.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = takeEvery;
	
	var _fsmIterator = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/sagaHelpers/fsmIterator.js");
	
	var _fsmIterator2 = /*#__PURE__*/_interopRequireDefault(_fsmIterator);
	
	var _io = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/io.js");
	
	var _channel = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/channel.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function takeEvery(patternOrChannel, worker) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var yTake = { done: false, value: (0, _io.take)(patternOrChannel) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	
	  var action = void 0,
	      setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return (0, _fsmIterator2.default)({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel.END ? [_fsmIterator.qEnd] : ['q1', yFork(action)];
	    }
	  }, 'q1', 'takeEvery(' + (0, _fsmIterator.safeName)(patternOrChannel) + ', ' + worker.name + ')');
	}

/***/ },

/***/ "../node_modules/redux-saga/lib/internal/sagaHelpers/fsmIterator.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.qEnd = undefined;
	exports.safeName = safeName;
	exports.default = fsmIterator;
	
	var _utils = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/utils.js");
	
	var done = { done: true, value: undefined };
	var qEnd = exports.qEnd = {};
	
	function safeName(patternOrChannel) {
	  if (_utils.is.channel(patternOrChannel)) {
	    return 'channel';
	  } else if (Array.isArray(patternOrChannel)) {
	    return String(patternOrChannel.map(function (entry) {
	      return String(entry);
	    }));
	  } else {
	    return String(patternOrChannel);
	  }
	}
	
	function fsmIterator(fsm, q0) {
	  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';
	
	  var updateState = void 0,
	      qNext = q0;
	
	  function next(arg, error) {
	    if (qNext === qEnd) {
	      return done;
	    }
	
	    if (error) {
	      qNext = qEnd;
	      throw error;
	    } else {
	      updateState && updateState(arg);
	
	      var _fsm$qNext = fsm[qNext](),
	          q = _fsm$qNext[0],
	          output = _fsm$qNext[1],
	          _updateState = _fsm$qNext[2];
	
	      qNext = q;
	      updateState = _updateState;
	      return qNext === qEnd ? done : output;
	    }
	  }
	
	  return (0, _utils.makeIterator)(next, function (error) {
	    return next(null, error);
	  }, name, true);
	}

/***/ },

/***/ "../node_modules/redux-saga/lib/internal/channel.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.UNDEFINED_INPUT_ERROR = exports.INVALID_BUFFER = exports.isEnd = exports.END = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.emitter = emitter;
	exports.channel = channel;
	exports.eventChannel = eventChannel;
	exports.stdChannel = stdChannel;
	
	var _utils = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/utils.js");
	
	var _buffers = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/buffers.js");
	
	var _scheduler = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/scheduler.js");
	
	var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
	var END = exports.END = { type: CHANNEL_END_TYPE };
	var isEnd = exports.isEnd = function isEnd(a) {
	  return a && a.type === CHANNEL_END_TYPE;
	};
	
	function emitter() {
	  var subscribers = [];
	
	  function subscribe(sub) {
	    subscribers.push(sub);
	    return function () {
	      return (0, _utils.remove)(subscribers, sub);
	    };
	  }
	
	  function emit(item) {
	    var arr = subscribers.slice();
	    for (var i = 0, len = arr.length; i < len; i++) {
	      arr[i](item);
	    }
	  }
	
	  return {
	    subscribe: subscribe,
	    emit: emit
	  };
	}
	
	var INVALID_BUFFER = exports.INVALID_BUFFER = 'invalid buffer passed to channel factory function';
	var UNDEFINED_INPUT_ERROR = exports.UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';
	
	if (false) {
	  exports.UNDEFINED_INPUT_ERROR = UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
	}
	
	function channel() {
	  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _buffers.buffers.fixed();
	
	  var closed = false;
	  var takers = [];
	
	  (0, _utils.check)(buffer, _utils.is.buffer, INVALID_BUFFER);
	
	  function checkForbiddenStates() {
	    if (closed && takers.length) {
	      throw (0, _utils.internalErr)('Cannot have a closed channel with pending takers');
	    }
	    if (takers.length && !buffer.isEmpty()) {
	      throw (0, _utils.internalErr)('Cannot have pending takers with non empty buffer');
	    }
	  }
	
	  function put(input) {
	    checkForbiddenStates();
	    (0, _utils.check)(input, _utils.is.notUndef, UNDEFINED_INPUT_ERROR);
	    if (closed) {
	      return;
	    }
	    if (!takers.length) {
	      return buffer.put(input);
	    }
	    for (var i = 0; i < takers.length; i++) {
	      var cb = takers[i];
	      if (!cb[_utils.MATCH] || cb[_utils.MATCH](input)) {
	        takers.splice(i, 1);
	        return cb(input);
	      }
	    }
	  }
	
	  function take(cb) {
	    checkForbiddenStates();
	    (0, _utils.check)(cb, _utils.is.func, "channel.take's callback must be a function");
	
	    if (closed && buffer.isEmpty()) {
	      cb(END);
	    } else if (!buffer.isEmpty()) {
	      cb(buffer.take());
	    } else {
	      takers.push(cb);
	      cb.cancel = function () {
	        return (0, _utils.remove)(takers, cb);
	      };
	    }
	  }
	
	  function flush(cb) {
	    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
	    (0, _utils.check)(cb, _utils.is.func, "channel.flush' callback must be a function");
	    if (closed && buffer.isEmpty()) {
	      cb(END);
	      return;
	    }
	    cb(buffer.flush());
	  }
	
	  function close() {
	    checkForbiddenStates();
	    if (!closed) {
	      closed = true;
	      if (takers.length) {
	        var arr = takers;
	        takers = [];
	        for (var i = 0, len = arr.length; i < len; i++) {
	          arr[i](END);
	        }
	      }
	    }
	  }
	
	  return {
	    take: take,
	    put: put,
	    flush: flush,
	    close: close,
	    get __takers__() {
	      return takers;
	    },
	    get __closed__() {
	      return closed;
	    }
	  };
	}
	
	function eventChannel(subscribe) {
	  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _buffers.buffers.none();
	  var matcher = arguments[2];
	
	  /**
	    should be if(typeof matcher !== undefined) instead?
	    see PR #273 for a background discussion
	  **/
	  if (arguments.length > 2) {
	    (0, _utils.check)(matcher, _utils.is.func, 'Invalid match function passed to eventChannel');
	  }
	
	  var chan = channel(buffer);
	  var close = function close() {
	    if (!chan.__closed__) {
	      if (unsubscribe) {
	        unsubscribe();
	      }
	      chan.close();
	    }
	  };
	  var unsubscribe = subscribe(function (input) {
	    if (isEnd(input)) {
	      close();
	      return;
	    }
	    if (matcher && !matcher(input)) {
	      return;
	    }
	    chan.put(input);
	  });
	  if (chan.__closed__) {
	    unsubscribe();
	  }
	
	  if (!_utils.is.func(unsubscribe)) {
	    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
	  }
	
	  return {
	    take: chan.take,
	    flush: chan.flush,
	    close: close
	  };
	}
	
	function stdChannel(subscribe) {
	  var chan = eventChannel(function (cb) {
	    return subscribe(function (input) {
	      if (input[_utils.SAGA_ACTION]) {
	        cb(input);
	        return;
	      }
	      (0, _scheduler.asap)(function () {
	        return cb(input);
	      });
	    });
	  });
	
	  return _extends({}, chan, {
	    take: function take(cb, matcher) {
	      if (arguments.length > 1) {
	        (0, _utils.check)(matcher, _utils.is.func, "channel.take's matcher argument must be a function");
	        cb[_utils.MATCH] = matcher;
	      }
	      chan.take(cb);
	    }
	  });
	}

/***/ },

/***/ "../node_modules/redux-saga/lib/internal/buffers.js":
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.buffers = exports.BUFFER_OVERFLOW = undefined;
	
	var _utils = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/utils.js");
	
	var BUFFER_OVERFLOW = exports.BUFFER_OVERFLOW = "Channel's Buffer overflow!";
	
	var ON_OVERFLOW_THROW = 1;
	var ON_OVERFLOW_DROP = 2;
	var ON_OVERFLOW_SLIDE = 3;
	var ON_OVERFLOW_EXPAND = 4;
	
	var zeroBuffer = { isEmpty: _utils.kTrue, put: _utils.noop, take: _utils.noop };
	
	function ringBuffer() {
	  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
	  var overflowAction = arguments[1];
	
	  var arr = new Array(limit);
	  var length = 0;
	  var pushIndex = 0;
	  var popIndex = 0;
	
	  var push = function push(it) {
	    arr[pushIndex] = it;
	    pushIndex = (pushIndex + 1) % limit;
	    length++;
	  };
	
	  var take = function take() {
	    if (length != 0) {
	      var it = arr[popIndex];
	      arr[popIndex] = null;
	      length--;
	      popIndex = (popIndex + 1) % limit;
	      return it;
	    }
	  };
	
	  var flush = function flush() {
	    var items = [];
	    while (length) {
	      items.push(take());
	    }
	    return items;
	  };
	
	  return {
	    isEmpty: function isEmpty() {
	      return length == 0;
	    },
	    put: function put(it) {
	      if (length < limit) {
	        push(it);
	      } else {
	        var doubledLimit = void 0;
	        switch (overflowAction) {
	          case ON_OVERFLOW_THROW:
	            throw new Error(BUFFER_OVERFLOW);
	          case ON_OVERFLOW_SLIDE:
	            arr[pushIndex] = it;
	            pushIndex = (pushIndex + 1) % limit;
	            popIndex = pushIndex;
	            break;
	          case ON_OVERFLOW_EXPAND:
	            doubledLimit = 2 * limit;
	
	            arr = flush();
	
	            length = arr.length;
	            pushIndex = arr.length;
	            popIndex = 0;
	
	            arr.length = doubledLimit;
	            limit = doubledLimit;
	
	            push(it);
	            break;
	          default:
	          // DROP
	        }
	      }
	    },
	    take: take,
	    flush: flush
	  };
	}
	
	var buffers = exports.buffers = {
	  none: function none() {
	    return zeroBuffer;
	  },
	  fixed: function fixed(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_THROW);
	  },
	  dropping: function dropping(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_DROP);
	  },
	  sliding: function sliding(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
	  },
	  expanding: function expanding(initialSize) {
	    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
	  }
	};

/***/ },

/***/ "../node_modules/redux-saga/lib/internal/sagaHelpers/takeLatest.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = takeLatest;
	
	var _fsmIterator = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/sagaHelpers/fsmIterator.js");
	
	var _fsmIterator2 = /*#__PURE__*/_interopRequireDefault(_fsmIterator);
	
	var _io = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/io.js");
	
	var _channel = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/channel.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function takeLatest(patternOrChannel, worker) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var yTake = { done: false, value: (0, _io.take)(patternOrChannel) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	  var yCancel = function yCancel(task) {
	    return { done: false, value: (0, _io.cancel)(task) };
	  };
	
	  var task = void 0,
	      action = void 0;
	  var setTask = function setTask(t) {
	    return task = t;
	  };
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return (0, _fsmIterator2.default)({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel.END ? [_fsmIterator.qEnd] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
	    },
	    q3: function q3() {
	      return ['q1', yFork(action), setTask];
	    }
	  }, 'q1', 'takeLatest(' + (0, _fsmIterator.safeName)(patternOrChannel) + ', ' + worker.name + ')');
	}

/***/ },

/***/ "../node_modules/redux-saga/lib/internal/sagaHelpers/throttle.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = throttle;
	
	var _fsmIterator = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/sagaHelpers/fsmIterator.js");
	
	var _fsmIterator2 = /*#__PURE__*/_interopRequireDefault(_fsmIterator);
	
	var _io = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/io.js");
	
	var _channel = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/channel.js");
	
	var _buffers = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/buffers.js");
	
	var _utils = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function throttle(delayLength, pattern, worker) {
	  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    args[_key - 3] = arguments[_key];
	  }
	
	  var action = void 0,
	      channel = void 0;
	
	  var yActionChannel = { done: false, value: (0, _io.actionChannel)(pattern, _buffers.buffers.sliding(1)) };
	  var yTake = function yTake() {
	    return { done: false, value: (0, _io.take)(channel) };
	  };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	  var yDelay = { done: false, value: (0, _io.call)(_utils.delay, delayLength) };
	
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	  var setChannel = function setChannel(ch) {
	    return channel = ch;
	  };
	
	  return (0, _fsmIterator2.default)({
	    q1: function q1() {
	      return ['q2', yActionChannel, setChannel];
	    },
	    q2: function q2() {
	      return ['q3', yTake(), setAction];
	    },
	    q3: function q3() {
	      return action === _channel.END ? [_fsmIterator.qEnd] : ['q4', yFork(action)];
	    },
	    q4: function q4() {
	      return ['q2', yDelay];
	    }
	  }, 'q1', 'throttle(' + (0, _fsmIterator.safeName)(pattern) + ', ' + worker.name + ')');
	}

/***/ },

/***/ "../node_modules/redux-saga/lib/internal/middleware.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = sagaMiddlewareFactory;
	
	var _utils = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/utils.js");
	
	var _channel = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/channel.js");
	
	var _runSaga = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/runSaga.js");
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function sagaMiddlewareFactory() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var _ref$context = _ref.context,
	      context = _ref$context === undefined ? {} : _ref$context,
	      options = _objectWithoutProperties(_ref, ['context']);
	
	  var sagaMonitor = options.sagaMonitor,
	      logger = options.logger,
	      onError = options.onError;
	
	
	  if (_utils.is.func(options)) {
	    if (true) {
	      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
	    } else {
	      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
	    }
	  }
	
	  if (logger && !_utils.is.func(logger)) {
	    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
	  }
	
	  if (false) {
	    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
	  }
	
	  if (onError && !_utils.is.func(onError)) {
	    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
	  }
	
	  if (options.emitter && !_utils.is.func(options.emitter)) {
	    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
	  }
	
	  function sagaMiddleware(_ref2) {
	    var getState = _ref2.getState,
	        dispatch = _ref2.dispatch;
	
	    var sagaEmitter = (0, _channel.emitter)();
	    sagaEmitter.emit = (options.emitter || _utils.ident)(sagaEmitter.emit);
	
	    sagaMiddleware.run = _runSaga.runSaga.bind(null, {
	      context: context,
	      subscribe: sagaEmitter.subscribe,
	      dispatch: dispatch,
	      getState: getState,
	      sagaMonitor: sagaMonitor,
	      logger: logger,
	      onError: onError
	    });
	
	    return function (next) {
	      return function (action) {
	        if (sagaMonitor && sagaMonitor.actionDispatched) {
	          sagaMonitor.actionDispatched(action);
	        }
	        var result = next(action); // hit reducers
	        sagaEmitter.emit(action);
	        return result;
	      };
	    };
	  }
	
	  sagaMiddleware.run = function () {
	    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
	  };
	
	  sagaMiddleware.setContext = function (props) {
	    (0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)('sagaMiddleware', props));
	    _utils.object.assign(context, props);
	  };
	
	  return sagaMiddleware;
	}

/***/ },

/***/ "../node_modules/redux-saga/lib/effects.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _io = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/io.js");
	
	Object.defineProperty(exports, 'take', {
	  enumerable: true,
	  get: function get() {
	    return _io.take;
	  }
	});
	Object.defineProperty(exports, 'takem', {
	  enumerable: true,
	  get: function get() {
	    return _io.takem;
	  }
	});
	Object.defineProperty(exports, 'put', {
	  enumerable: true,
	  get: function get() {
	    return _io.put;
	  }
	});
	Object.defineProperty(exports, 'all', {
	  enumerable: true,
	  get: function get() {
	    return _io.all;
	  }
	});
	Object.defineProperty(exports, 'race', {
	  enumerable: true,
	  get: function get() {
	    return _io.race;
	  }
	});
	Object.defineProperty(exports, 'call', {
	  enumerable: true,
	  get: function get() {
	    return _io.call;
	  }
	});
	Object.defineProperty(exports, 'apply', {
	  enumerable: true,
	  get: function get() {
	    return _io.apply;
	  }
	});
	Object.defineProperty(exports, 'cps', {
	  enumerable: true,
	  get: function get() {
	    return _io.cps;
	  }
	});
	Object.defineProperty(exports, 'fork', {
	  enumerable: true,
	  get: function get() {
	    return _io.fork;
	  }
	});
	Object.defineProperty(exports, 'spawn', {
	  enumerable: true,
	  get: function get() {
	    return _io.spawn;
	  }
	});
	Object.defineProperty(exports, 'join', {
	  enumerable: true,
	  get: function get() {
	    return _io.join;
	  }
	});
	Object.defineProperty(exports, 'cancel', {
	  enumerable: true,
	  get: function get() {
	    return _io.cancel;
	  }
	});
	Object.defineProperty(exports, 'select', {
	  enumerable: true,
	  get: function get() {
	    return _io.select;
	  }
	});
	Object.defineProperty(exports, 'actionChannel', {
	  enumerable: true,
	  get: function get() {
	    return _io.actionChannel;
	  }
	});
	Object.defineProperty(exports, 'cancelled', {
	  enumerable: true,
	  get: function get() {
	    return _io.cancelled;
	  }
	});
	Object.defineProperty(exports, 'flush', {
	  enumerable: true,
	  get: function get() {
	    return _io.flush;
	  }
	});
	Object.defineProperty(exports, 'getContext', {
	  enumerable: true,
	  get: function get() {
	    return _io.getContext;
	  }
	});
	Object.defineProperty(exports, 'setContext', {
	  enumerable: true,
	  get: function get() {
	    return _io.setContext;
	  }
	});
	Object.defineProperty(exports, 'takeEvery', {
	  enumerable: true,
	  get: function get() {
	    return _io.takeEvery;
	  }
	});
	Object.defineProperty(exports, 'takeLatest', {
	  enumerable: true,
	  get: function get() {
	    return _io.takeLatest;
	  }
	});
	Object.defineProperty(exports, 'throttle', {
	  enumerable: true,
	  get: function get() {
	    return _io.throttle;
	  }
	});

/***/ },

/***/ "../node_modules/redux-saga/lib/utils.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/utils.js");
	
	Object.defineProperty(exports, 'TASK', {
	  enumerable: true,
	  get: function get() {
	    return _utils.TASK;
	  }
	});
	Object.defineProperty(exports, 'SAGA_ACTION', {
	  enumerable: true,
	  get: function get() {
	    return _utils.SAGA_ACTION;
	  }
	});
	Object.defineProperty(exports, 'noop', {
	  enumerable: true,
	  get: function get() {
	    return _utils.noop;
	  }
	});
	Object.defineProperty(exports, 'is', {
	  enumerable: true,
	  get: function get() {
	    return _utils.is;
	  }
	});
	Object.defineProperty(exports, 'deferred', {
	  enumerable: true,
	  get: function get() {
	    return _utils.deferred;
	  }
	});
	Object.defineProperty(exports, 'arrayOfDeffered', {
	  enumerable: true,
	  get: function get() {
	    return _utils.arrayOfDeffered;
	  }
	});
	Object.defineProperty(exports, 'createMockTask', {
	  enumerable: true,
	  get: function get() {
	    return _utils.createMockTask;
	  }
	});
	Object.defineProperty(exports, 'cloneableGenerator', {
	  enumerable: true,
	  get: function get() {
	    return _utils.cloneableGenerator;
	  }
	});
	
	var _io = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/io.js");
	
	Object.defineProperty(exports, 'asEffect', {
	  enumerable: true,
	  get: function get() {
	    return _io.asEffect;
	  }
	});
	
	var _proc = /*#__PURE__*/__webpack_require__("../node_modules/redux-saga/lib/internal/proc.js");
	
	Object.defineProperty(exports, 'CHANNEL_END', {
	  enumerable: true,
	  get: function get() {
	    return _proc.CHANNEL_END;
	  }
	});

/***/ },

/***/ "./app/reducers/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.rootReducer = rootReducer;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var reducers = ['promo-message', 'catalog', 'compatibility-chooser', 'content', 'cookie', 'daily-updates', 'deck', 'decks', 'email-unsub', 'hexagram', 'horoscope', 'karmacoin-store', 'mail-lists', 'mobile-nav-dropdown', 'moon-phase', 'nav-bar-mobile', 'number', 'oranum', 'planet-tracker', 'product', 'product-message', 'query-params', 'recaptcha', 'route', 'tarot-reading', 'tcod', 'user', 'zodiac'].reduce(function (reducerObject, reducerName) {
	    return _extends({}, reducerObject, _defineProperty({}, reducerName, __webpack_require__(1)("./" + reducerName)));
	}, {});
	
	var initialData = Object.keys(reducers).reduce(function (initial, reducerName) {
	    var initialReducerInitial = reducers[reducerName].initial;
	    var reducerInitial = typeof initialReducerInitial === 'undefined' ? null : initialReducerInitial;
	    return _extends({}, initial, _defineProperty({}, reducerName, reducerInitial));
	}, {});
	
	function rootReducer(state, action) {
	    if (!/:/.test(action.type)) {
	        return _extends({}, initialData, state);
	    }
	
	    var _action$type$split = action.type.split(':'),
	        _action$type$split2 = _slicedToArray(_action$type$split, 2),
	        reducerName = _action$type$split2[0],
	        methodName = _action$type$split2[1];
	
	    var reducerMethod = reducers[reducerName] && reducers[reducerName][methodName];
	    var reducerState = state[reducerName] || initialData[reducerName];
	    var newReducerState = reducerMethod ? reducerMethod(reducerState, action.payload, action.error) : reducerState;
	    return _extends({}, state, _defineProperty({}, reducerName, newReducerState));
	}

/***/ },

/***/ 1:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./catalog": "./app/reducers/catalog.js",
		"./catalog.js": "./app/reducers/catalog.js",
		"./compatibility-chooser": "./app/reducers/compatibility-chooser.js",
		"./compatibility-chooser.js": "./app/reducers/compatibility-chooser.js",
		"./content": "./app/reducers/content.js",
		"./content.js": "./app/reducers/content.js",
		"./cookie": "./app/reducers/cookie.js",
		"./cookie.js": "./app/reducers/cookie.js",
		"./daily-updates": "./app/reducers/daily-updates.js",
		"./daily-updates.js": "./app/reducers/daily-updates.js",
		"./deck": "./app/reducers/deck.js",
		"./deck.js": "./app/reducers/deck.js",
		"./decks": "./app/reducers/decks.js",
		"./decks.js": "./app/reducers/decks.js",
		"./email-unsub": "./app/reducers/email-unsub.js",
		"./email-unsub.js": "./app/reducers/email-unsub.js",
		"./hexagram": "./app/reducers/hexagram.js",
		"./hexagram.js": "./app/reducers/hexagram.js",
		"./horoscope": "./app/reducers/horoscope.js",
		"./horoscope.js": "./app/reducers/horoscope.js",
		"./index": "./app/reducers/index.js",
		"./index.js": "./app/reducers/index.js",
		"./karmacoin-store": "./app/reducers/karmacoin-store.js",
		"./karmacoin-store.js": "./app/reducers/karmacoin-store.js",
		"./mail-lists": "./app/reducers/mail-lists.js",
		"./mail-lists.js": "./app/reducers/mail-lists.js",
		"./mobile-nav-dropdown": "./app/reducers/mobile-nav-dropdown.js",
		"./mobile-nav-dropdown.js": "./app/reducers/mobile-nav-dropdown.js",
		"./moon-phase": "./app/reducers/moon-phase.js",
		"./moon-phase.js": "./app/reducers/moon-phase.js",
		"./nav-bar-mobile": "./app/reducers/nav-bar-mobile.js",
		"./nav-bar-mobile.js": "./app/reducers/nav-bar-mobile.js",
		"./number": "./app/reducers/number.js",
		"./number.js": "./app/reducers/number.js",
		"./oranum": "./app/reducers/oranum.js",
		"./oranum.js": "./app/reducers/oranum.js",
		"./planet-tracker": "./app/reducers/planet-tracker.js",
		"./planet-tracker.js": "./app/reducers/planet-tracker.js",
		"./product": "./app/reducers/product.js",
		"./product-message": "./app/reducers/product-message.js",
		"./product-message.js": "./app/reducers/product-message.js",
		"./product.js": "./app/reducers/product.js",
		"./promo-message": "./app/reducers/promo-message.js",
		"./promo-message.js": "./app/reducers/promo-message.js",
		"./query-params": "./app/reducers/query-params.js",
		"./query-params.js": "./app/reducers/query-params.js",
		"./recaptcha": "./app/reducers/recaptcha.js",
		"./recaptcha.js": "./app/reducers/recaptcha.js",
		"./route": "./app/reducers/route.js",
		"./route.js": "./app/reducers/route.js",
		"./tarot-reading": "./app/reducers/tarot-reading.js",
		"./tarot-reading.js": "./app/reducers/tarot-reading.js",
		"./tcod": "./app/reducers/tcod.js",
		"./tcod.js": "./app/reducers/tcod.js",
		"./user": "./app/reducers/user.js",
		"./user.js": "./app/reducers/user.js",
		"./zodiac": "./app/reducers/zodiac.js",
		"./zodiac.js": "./app/reducers/zodiac.js"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1;


/***/ },

/***/ "./app/reducers/catalog.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.update = update;
	exports.filter = filter;
	
	var _underscore = __webpack_require__("../node_modules/underscore/underscore.js");
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function update(state, payload) {
	    return _extends({}, state, payload);
	}
	
	function isPartialMatch(needles, haystack) {
	    if (!needles || !needles.length) {
	        return true;
	    }
	    if (!haystack || !haystack.length) {
	        return true;
	    }
	    needles = _underscore2.default.uniq(needles.sort(), true);
	    haystack = _underscore2.default.uniq(haystack.sort(), true);
	    return needles.some(function (needle) {
	        return haystack.indexOf(needle) !== -1;
	    });
	}
	
	function isPriceMatch(needle, product) {
	    if (!needle) {
	        return true;
	    }
	    if (needle === 'free') {
	        return product.price_key === 'free';
	    }
	    if (needle === 'on_sale') {
	        return product.on_sale;
	    }
	    if (needle === 'trial_pay') {
	        return product.trial_pay_link;
	    }
	    return true;
	}
	
	function isTextMatch(needles, product) {
	    if (!needles || !needles.length) {
	        return true;
	    }
	    var normalizeText = function normalizeText(text) {
	        return text.replace(/-.,/, ' ').trim().toLowerCase();
	    };
	    var haystack = normalizeText((product.product_name || '') + ' ' + (product.short_description || ''));
	    return normalizeText(needles).split(/\s+/).every(function (needle) {
	        return haystack.indexOf(needle) !== -1;
	    });
	}
	
	function filterProducts(products, filter) {
	    if (!Object.keys(filter).length) {
	        return products;
	    }
	
	    return products.filter(function (product) {
	        return isPartialMatch(filter.category, product.category) && isPartialMatch(filter.modality, product.modality) && isTextMatch(filter.search, product) && isPriceMatch(filter.price, product);
	    });
	}
	
	function filter(state, payload) {
	    var filteredProducts = filterProducts(state.products, payload.filters);
	    return _extends({}, state, {
	        inputs: payload.inputs,
	        filter: payload.filters,
	        filteredProducts: filteredProducts
	    });
	}

/***/ },

/***/ "../node_modules/underscore/underscore.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind,
	    nativeCreate       = Object.create;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.8.3';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, undefinedOnly) {
	    return function(obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };
	
	  var property = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = property('length');
	  var isArrayLike = function(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }
	
	    return function(obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, startIndex) {
	    var output = [], idx = 0;
	    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0, len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    return _.unzip(arguments);
	  };
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function(array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Generator function to create the indexOf and lastIndexOf functions
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	            i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    var bound = function() {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys =  _.keys(obj),
	          length = keys.length,
	          results = {},
	          currentKey;
	      for (var index = 0; index < length; index++) {
	        currentKey = keys[index];
	        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	      }
	      return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(object, oiteratee, context) {
	    var result = {}, obj = object, iteratee, keys;
	    if (obj == null) return result;
	    if (_.isFunction(oiteratee)) {
	      keys = _.allKeys(obj);
	      iteratee = optimizeCb(oiteratee, context);
	    } else {
	      keys = flatten(arguments, false, false, 1);
	      iteratee = function(value, key, obj) { return key in obj; };
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  _.property = property;
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    return obj == null ? function(){} : function(key) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function() {
	    return '' + this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}.call(this));


/***/ },

/***/ "./app/reducers/compatibility-chooser.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.set = set;
	var initial = exports.initial = {
	    base_url: null,
	    path: null,
	    hash: null,
	    submitting: false
	};
	
	function set(state, payload) {
	    return _extends({}, state, payload);
	}

/***/ },

/***/ "./app/reducers/content.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.nav = nav;
	exports.promoted = promoted;
	exports.hexagram = hexagram;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initial = exports.initial = {
	    nav: null,
	    promoted: null,
	    hexagram: null
	};
	
	function nav(state, payload) {
	    return _extends({}, state, { nav: _extends({}, state.nav, _defineProperty({}, payload.tag, payload.data)) });
	}
	
	function promoted(state, payload) {
	    return _extends({}, state, { promoted: payload });
	}
	
	function hexagram(state, payload) {
	    return _extends({}, state, { hexagram: payload });
	}

/***/ },

/***/ "./app/reducers/cookie.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.remove = exports.set = exports.initial = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _jsCookie = __webpack_require__("../node_modules/js-cookie/src/js.cookie.js");
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initial = exports.initial = _jsCookie2.default.getJSON();
	
	var set = exports.set = function set(state, cookie) {
	    return _extends({}, state, _defineProperty({}, cookie.name, cookie.value));
	};
	
	var remove = exports.remove = function remove(state, name) {
	    return _extends({}, state, _defineProperty({}, name, undefined));
	};

/***/ },

/***/ "../node_modules/js-cookie/src/js.cookie.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.1.4
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader = false;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function init (converter) {
			function api (key, value, attributes) {
				var result;
				if (typeof document === 'undefined') {
					return;
				}
	
				// Write
	
				if (arguments.length > 1) {
					attributes = extend({
						path: '/'
					}, api.defaults, attributes);
	
					if (typeof attributes.expires === 'number') {
						var expires = new Date();
						expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
						attributes.expires = expires;
					}
	
					// We're using "expires" because "max-age" is not supported by IE
					attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
					try {
						result = JSON.stringify(value);
						if (/^[\{\[]/.test(result)) {
							value = result;
						}
					} catch (e) {}
	
					if (!converter.write) {
						value = encodeURIComponent(String(value))
							.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
					} else {
						value = converter.write(value, key);
					}
	
					key = encodeURIComponent(String(key));
					key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
					key = key.replace(/[\(\)]/g, escape);
	
					var stringifiedAttributes = '';
	
					for (var attributeName in attributes) {
						if (!attributes[attributeName]) {
							continue;
						}
						stringifiedAttributes += '; ' + attributeName;
						if (attributes[attributeName] === true) {
							continue;
						}
						stringifiedAttributes += '=' + attributes[attributeName];
					}
					return (document.cookie = key + '=' + value + stringifiedAttributes);
				}
	
				// Read
	
				if (!key) {
					result = {};
				}
	
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all. Also prevents odd result when
				// calling "get()"
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var rdecode = /(%[0-9A-Z]{2})+/g;
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = parts[0].replace(rdecode, decodeURIComponent);
						cookie = converter.read ?
							converter.read(cookie, name) : converter(cookie, name) ||
							cookie.replace(rdecode, decodeURIComponent);
	
						if (this.json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						if (key === name) {
							result = cookie;
							break;
						}
	
						if (!key) {
							result[name] = cookie;
						}
					} catch (e) {}
				}
	
				return result;
			}
	
			api.set = api;
			api.get = function (key) {
				return api.call(api, key);
			};
			api.getJSON = function () {
				return api.apply({
					json: true
				}, [].slice.call(arguments));
			};
			api.defaults = {};
	
			api.remove = function (key, attributes) {
				api(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ },

/***/ "./app/reducers/daily-updates.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.update = update;
	function update(state, payload) {
	    return payload;
	}

/***/ },

/***/ "./app/reducers/deck.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.update = update;
	exports.spread = spread;
	exports.update_spread = update_spread;
	
	var _underscore = __webpack_require__("../node_modules/underscore/underscore.js");
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function update(state, payload) {
	    var spread = void 0;
	    if (!state) {
	        spread = _underscore2.default.shuffle(payload.cards).map(function (card) {
	            return card.index;
	        });
	    } else {
	        spread = state.spread;
	    }
	    return _extends({}, payload, { spread: spread });
	}
	
	function spread(state, payload) {
	    return _extends({}, state, { spread: state.spread.map(function (cardId) {
	            return cardId == payload ? 'picked' : cardId;
	        })
	    });
	}
	
	function update_spread(state, payload) {
	    return _extends({}, state, { spread: payload });
	}

/***/ },

/***/ "./app/reducers/decks.js":
/***/ function(module, exports) {

	// array of available deck objects comes from window.appState
	"use strict";

/***/ },

/***/ "./app/reducers/email-unsub.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.subscribed = subscribed;
	function subscribed(state, payload) {
	    return _extends({}, state, { subscribed: payload });
	}

/***/ },

/***/ "./app/reducers/hexagram.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.update = update;
	function update(state, payload) {
	    return _extends({}, state, payload);
	}

/***/ },

/***/ "./app/reducers/horoscope.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.update = update;
	function update(state, payload) {
	    return _extends({}, state, payload);
	}

/***/ },

/***/ "./app/reducers/karmacoin-store.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.upc = upc;
	exports.power_upc = power_upc;
	exports.packages = packages;
	function upc(state, payload) {
	    return _extends({}, state, { upc: payload });
	}
	
	function power_upc(state, payload) {
	    return _extends({}, state, { power_upc: payload, upc: payload });
	}
	
	function packages(state, pkgs) {
	    var standard_packages_min_coins = 50;
	    var power_packages_min_coins = 2000;
	
	    var kcpackages = pkgs.reduce(function (kcpackages, pkg) {
	        var kcs = pkg.free_kcs + pkg.paid_kcs;
	        var percent = 0;
	
	        if (pkg.label && pkg.label.match(/[0-9]+\%/)) {
	            percent = pkg.label.match(/[0-9]+\%/)[0];
	        }
	
	        pkg.percent = percent;
	
	        if (kcs >= power_packages_min_coins) {
	            kcpackages.power.push(pkg);
	        } else if (kcs > standard_packages_min_coins) {
	            kcpackages.standard.push(pkg);
	        }
	
	        return kcpackages;
	    }, { power: [], standard: [] });
	
	    return _extends({}, state, {
	        packages: {
	            power: kcpackages.power,
	            standard: kcpackages.standard.reverse()
	        }
	    });
	}

/***/ },

/***/ "./app/reducers/mail-lists.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.update = update;
	exports.error = error;
	exports.toggle_intention = toggle_intention;
	function update(state, payload) {
	    var lists = payload.map(function (list) {
	        return _extends({}, list, { dirty: false });
	    });
	    return _extends({}, state, { lists: lists, dirty: false });
	}
	
	function error(state, payload) {
	    return _extends({}, state, { error: payload });
	}
	
	function toggle_intention(state, payload) {
	    var lists = state.lists.map(function (list) {
	        if (list.code === payload) {
	            return _extends({}, list, { intent: !list.intent });
	        }
	        return list;
	    });
	    var dirty = lists.some(function (list) {
	        return list.intent;
	    });
	    return _extends({}, state, { lists: lists, dirty: dirty });
	}

/***/ },

/***/ "./app/reducers/mobile-nav-dropdown.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.initial = undefined;
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var path = document.location.pathname;
	var linkMoment = (0, _moment2.default)().date() < 27 ? (0, _moment2.default)() : (0, _moment2.default)().add(1, 'months');
	var displayMonth = linkMoment.format('MMMM');
	var displayYear = linkMoment.format('YYYY');
	var linkMonthYear = linkMoment.format('MMMM-YYYY').toLowerCase();
	var dropdowns = [{
	    regex: /^\/daily-horoscope(\/.+)?$/i,
	    links: [{
	        label: 'Free 3-Card Tarot Reading',
	        url: '/readings-reports/tarot-readings/free',
	        logged_in: {
	            label: 'Daily Reflection Tarot Reading',
	            url: '/readings-reports/tarot-readings/daily-reflection'
	        }
	    }, {
	        label: 'Get Your Moon and Rising Sign',
	        url: '/cosmic-profile',
	        logged_in: {
	            label: 'Celtic Cross Tarot Reading',
	            url: '/readings-reports/tarot-readings/celtic-cross'
	        }
	    }, {
	        label: 'Weekly Love Horoscope',
	        url: '/astrology/weekly-love-horoscopes'
	    }, {
	        label: displayMonth + ' Horoscope',
	        url: '/horoscopes/' + linkMonthYear
	    }]
	}, {
	    regex: /^\/daily-love-horoscope(\/.+)?$/i,
	    links: [{
	        label: 'Free 3-Card Love Tarot Reading',
	        url: '/readings-reports/tarot-readings/free/love',
	        logged_in: {
	            label: 'Relationship Bottom Line Tarot Reading',
	            url: '/readings-reports/tarot-readings/bottom-line/relationship'
	        }
	    }, {
	        label: 'Get Your Moon and Rising Sign',
	        url: '/cosmic-profile',
	        logged_in: {
	            label: 'Love Celtic Cross Tarot Reading',
	            url: '/readings-reports/tarot-readings/celtic-cross/love'
	        }
	    }, {
	        label: 'Weekly Love Horoscope',
	        url: '/astrology/weekly-love-horoscopes'
	    }, {
	        label: displayMonth + ' Love Horoscope',
	        url: '/horoscopes/' + linkMonthYear + '-love'
	    }]
	}, {
	    regex: /^\/daily-tarot-card(\/.+)?$/i,
	    links: [{
	        label: 'Free 3-Card Tarot Reading',
	        url: '/readings-reports/tarot-readings/free',
	        logged_in: {
	            label: 'Daily Reflection Tarot Reading',
	            url: '/readings-reports/tarot-readings/daily-reflection'
	        }
	    }, {
	        label: 'Get Your Tarot Birth Card',
	        url: '/cosmic-profile',
	        logged_in: {
	            label: 'Celtic Cross Tarot Reading',
	            url: '/readings-reports/tarot-readings/celtic-cross'
	        }
	    }, {
	        label: 'Weekly Tarot Reading',
	        url: '/tarot/reading-' + linkMonthYear
	    }, {
	        label: displayYear + ' Yearly Tarot Reading',
	        url: '/tarot/reading-' + displayYear
	    }]
	}, {
	    regex: /^\/daily-hexagram(\/.+)?$/i,
	    links: [{
	        label: 'Free I Ching Reading',
	        url: 'https://product.tarot.com/oracle/iching-reading/basic.php',
	        logged_in: {
	            label: 'Love I Ching Reading',
	            url: 'https://product.tarot.com/oracle/iching-reading/love/'
	        }
	    }, {
	        label: 'Get Your Chinese Zodiac Sign',
	        url: '/cosmic-profile',
	        logged_in: {
	            label: 'I Ching Reading',
	            url: 'https://product.tarot.com/oracle/iching-reading/basic.php'
	        }
	    }, {
	        label: 'About the I Ching Hexagrams',
	        url: '/eastern-wisdom#iching'
	    }, {
	        label: 'About the Art of Feng Shui',
	        url: '/eastern-wisdom#feng-shui'
	    }]
	}, {
	    regex: /^\/daily-number(\/.+)?$/i,
	    links: [{
	        label: 'Get Your Life Path Number',
	        url: '/cosmic-profile',
	        logged_in: {
	            label: 'Numerology Compatibility Report',
	            url: 'https://product.tarot.com/numerology/getreport.php?state=ENTRY&chartId=2'
	        }
	    }, {
	        label: 'Free Numerology Compatibility Report',
	        url: 'https://product.tarot.com/numerology/getreport.php?state=ENTRY&chartId=4',
	        logged_in: {
	            label: 'Numerology Forecast Report',
	            url: '/readings-reports/numerology-reports/1-year-forecast'
	        }
	    }, {
	        label: displayYear + ' Numerology Forecast',
	        url: '/numerology/' + displayYear + '-predictions'
	    }, {
	        label: 'Dating By the Numbers',
	        url: '/articles/numerology/sun-numbers-dating-love-compatibility'
	    }]
	}, {
	    regex: /^\/daily-psychic-tip(\/.+)?$/i,
	    links: [{
	        label: 'Free 3-Card Tarot Reading',
	        url: '/readings-reports/tarot-readings/free',
	        logged_in: {
	            label: 'Daily Reflection Tarot Reading',
	            url: '/readings-reports/tarot-readings/daily-reflection'
	        }
	    }, {
	        label: 'Get Your Moon and Rising Sign',
	        url: '/cosmic-profile',
	        logged_in: {
	            label: 'Celtic Cross Tarot Reading',
	            url: '/readings-reports/tarot-readings/celtic-cross'
	        }
	    }, {
	        label: 'Weekly Love Horoscope',
	        url: '/astrology/weekly-love-horoscopes'
	    }, {
	        label: displayMonth + ' Horoscope',
	        url: '/horoscopes/' + linkMonthYear
	    }]
	}, {
	    regex: /^\/astrology\/weekly-love-horoscopes(\/.+)?$/i,
	    links: [{
	        label: 'FREE Love Compatibility',
	        url: '/astrology/compatibility/love',
	        logged_in: {
	            label: 'Soulmate Tarot Reading',
	            url: '/readings-reports/tarot-readings/soulmate'
	        }
	    }, {
	        label: 'FREE Love Tarot Reading',
	        url: '/readings-reports/tarot-readings/free/love',
	        logged_in: {
	            label: 'Reconciliation Tarot Reading',
	            url: '/readings-reports/tarot-readings/reconciliation'
	        }
	    }, {
	        label: displayMonth + ' Love Horoscope',
	        url: '/daily-love-horoscope',
	        logged_in: {
	            label: displayMonth + ' Love Horoscope',
	            url: '/horoscopes/monthly-love'
	        }
	    }, {
	        label: displayYear + ' Yearly Love Horoscope',
	        url: '/horoscopes/' + displayYear + '-love'
	    }]
	}, {
	    regex: /^\/horoscopes\/(?:(?:jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)\w+\-)?20[0-9]{2}(\/.+)?-love$/i,
	    links: [{
	        label: 'Free 3-Card Love Tarot Reading',
	        url: '/readings-reports/tarot-readings/free/love',
	        logged_in: {
	            label: 'Relationship Bottom Line Tarot Reading',
	            url: '/readings-reports/tarot-readings/bottom-line/relationship'
	        }
	    }, {
	        label: 'Get Your Moon and Rising Sign',
	        url: '/cosmic-profile',
	        logged_in: {
	            label: 'Love Celtic Cross Tarot Reading',
	            url: '/readings-reports/tarot-readings/celtic-cross/love'
	        }
	    }, {
	        label: 'Weekly Love Horoscope',
	        url: '/astrology/weekly-love-horoscopes',
	        logged_in: {
	            label: 'Romantic Compatibility Report',
	            url: 'https://product.tarot.com/astrology/getreport.php?state=ENTRY&chart_ID=16'
	        }
	    }, {
	        label: 'Love and Compatibility',
	        url: '/love-and-compatibility',
	        logged_in: {
	            label: 'Personalized Love Forecast',
	            url: 'https://product.tarot.com/astrology/getreport.php?state=ENTRY&chart_ID=21'
	        }
	    }]
	}, {
	    regex: /^\/horoscopes\/(?:(?:jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)\w+\-)?20[0-9]{2}(\/.+)?$/i,
	    links: [{
	        label: 'Daily Reflection Tarot Reading',
	        url: '/readings-reports/tarot-readings/daily-reflection'
	    }, {
	        label: 'Get Your Moon and Rising Sign',
	        url: '/cosmic-profile',
	        logged_in: {
	            label: 'Revelation Tarot Reading',
	            url: '/readings-reports/tarot-readings/revelation'
	        }
	    }, {
	        label: 'Born on the Cusp',
	        url: '/astrology/cusps/born-on-the-zodiac-cusp',
	        logged_in: {
	            label: '30-Day Forecast',
	            url: 'https://product.tarot.com/astrology/getreport.php?state=ENTRY&chart_ID=35'
	        }
	    }, {
	        label: 'View All Horoscopes',
	        url: '/horoscopes'
	    }]
	}].filter(function (_ref) {
	    var regex = _ref.regex;
	    return regex.test(path);
	});
	
	var initial = exports.initial = dropdowns.length ? dropdowns[0].links : null;

/***/ },

/***/ "../node_modules/moment/moment.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.18.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(2)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var string, match, dayFormat,
	        dateFormat, timeFormat, tzFormat;
	    var timezones = {
	        ' GMT': ' +0000',
	        ' EDT': ' -0400',
	        ' EST': ' -0500',
	        ' CDT': ' -0500',
	        ' CST': ' -0600',
	        ' MDT': ' -0600',
	        ' MST': ' -0700',
	        ' PDT': ' -0700',
	        ' PST': ' -0800'
	    };
	    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
	    var timezone, timezoneIndex;
	
	    string = config._i
	        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
	        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
	        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
	    match = basicRfcRegex.exec(string);
	
	    if (match) {
	        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
	        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
	        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');
	
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        if (match[1]) { // day of week given
	            var momentDate = new Date(match[2]);
	            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];
	
	            if (match[1].substr(0,3) !== momentDay) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return;
	            }
	        }
	
	        switch (match[5].length) {
	            case 2: // military
	                if (timezoneIndex === 0) {
	                    timezone = ' +0000';
	                } else {
	                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
	                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
	                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
	                }
	                break;
	            case 4: // Zone
	                timezone = timezones[match[5]];
	                break;
	            default: // UT or +/-9999
	                timezone = timezones[' GMT'];
	        }
	        match[5] = timezone;
	        config._i = match.splice(1).join('');
	        tzFormat = ' ZZ';
	        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
	        configFromStringAndFormat(config);
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString() {
	    if (!this.isValid()) {
	        return null;
	    }
	    var m = this.clone().utc();
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        return this.toDate().toISOString();
	    }
	    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.18.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module)))

/***/ },

/***/ 2:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./en-au": "../node_modules/moment/locale/en-au.js",
		"./en-au.js": "../node_modules/moment/locale/en-au.js",
		"./en-ca": "../node_modules/moment/locale/en-ca.js",
		"./en-ca.js": "../node_modules/moment/locale/en-ca.js",
		"./en-gb": "../node_modules/moment/locale/en-gb.js",
		"./en-gb.js": "../node_modules/moment/locale/en-gb.js",
		"./en-ie": "../node_modules/moment/locale/en-ie.js",
		"./en-ie.js": "../node_modules/moment/locale/en-ie.js",
		"./en-nz": "../node_modules/moment/locale/en-nz.js",
		"./en-nz.js": "../node_modules/moment/locale/en-nz.js"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 2;


/***/ },

/***/ "../node_modules/moment/locale/en-au.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("../node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },

/***/ "../node_modules/moment/locale/en-ca.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("../node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },

/***/ "../node_modules/moment/locale/en-gb.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("../node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },

/***/ "../node_modules/moment/locale/en-ie.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("../node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },

/***/ "../node_modules/moment/locale/en-nz.js":
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__("../node_modules/moment/moment.js")) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },

/***/ "./app/reducers/moon-phase.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.set = set;
	function set(state, payload) {
	    return _extends({}, state, payload);
	}

/***/ },

/***/ "./app/reducers/nav-bar-mobile.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.update = update;
	var initial = exports.initial = {
	    isOpen: false,
	    currentOpen: null
	};
	
	function update(state, payload) {
	    return _extends({}, state, payload);
	}

/***/ },

/***/ "./app/reducers/number.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.update = update;
	function update(state, payload) {
	    return payload || null;
	}

/***/ },

/***/ "./app/reducers/oranum.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.update_psychics = update_psychics;
	function update_psychics(state, payload) {
	    return _extends({}, state, { psychics: payload });
	}

/***/ },

/***/ "./app/reducers/planet-tracker.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.data = data;
	function data(state, payload) {
	    return _extends({}, state, { data: payload });
	}

/***/ },

/***/ "./app/reducers/product.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.error = error;
	exports.price = price;
	exports.submitting = submitting;
	exports.subscription = subscription;
	exports.type = type;
	exports.teeup = teeup;
	exports.submit = submit;
	var initial = exports.initial = {
	    price: null,
	    submitting: false,
	    subscription: null,
	    type: null
	};
	
	function error(state, payload) {
	    return _extends({}, state, { error: payload });
	}
	
	function price(state, payload) {
	    return _extends({}, state, { price: payload });
	}
	
	function submitting(state, payload) {
	    return _extends({}, state, { submitting: payload });
	}
	
	function subscription(state, payload) {
	    return _extends({}, state, { subscription: payload });
	}
	
	function type(state, payload) {
	    return _extends({}, state, { type: payload });
	}
	
	function teeup(state, payload) {
	    return _extends({}, state, { teeup: payload });
	}
	
	function submit(state, payload) {
	    return _extends({}, state, { form: payload });
	}

/***/ },

/***/ "./app/reducers/product-message.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.update = update;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initial = exports.initial = {};
	
	function update(state, payload) {
	    var placement = payload.placement;
	    return _extends({}, state, _defineProperty({}, placement, _extends({}, payload, { placement: placement })));
	}

/***/ },

/***/ "./app/reducers/promo-message.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.update = update;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initial = exports.initial = {};
	
	function update(state, payload) {
	    var placement = payload.placement;
	    return _extends({}, state, _defineProperty({}, placement, _extends({}, payload, { placement: placement })));
	}

/***/ },

/***/ "./app/reducers/query-params.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var getQueryParams = exports.getQueryParams = function getQueryParams() {
	    var queryString = window.location.search;
	
	    return queryString ? (/^[?#]/.test(queryString) ? queryString.slice(1) : queryString).split('&').reduce(function (params, param) {
	        var _param$split = param.split('='),
	            _param$split2 = _slicedToArray(_param$split, 2),
	            key = _param$split2[0],
	            val = _param$split2[1];
	
	        params[key] = val ? decodeURIComponent(val.replace(/\+g/, '')) : '';
	        return params;
	    }, {}) : {};
	};
	
	var initial = exports.initial = getQueryParams();

/***/ },

/***/ "./app/reducers/recaptcha.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.update = update;
	var initial = exports.initial = {
	    success: false
	};
	
	function update(state, payload) {
	    return _extends({}, state, payload);
	}

/***/ },

/***/ "./app/reducers/route.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.to = to;
	var initial = exports.initial = window.location.hash.replace(/^#/, '');
	
	function to(state, payload) {
	    return payload;
	}
	
	var hashchanged = exports.hashchanged = to;

/***/ },

/***/ "./app/reducers/tarot-reading.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.initial = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loaded = loaded;
	exports.error = error;
	exports.picked = picked;
	exports.cards = cards;
	exports.positions = positions;
	exports.type = type;
	exports.subject = subject;
	exports.button_text = button_text;
	exports.sampleInterp = sampleInterp;
	exports.loadSaved = loadSaved;
	
	var _underscore = __webpack_require__("../node_modules/underscore/underscore.js");
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initial = exports.initial = {
	    cards: [],
	    error: null,
	    interps: null,
	    positions: [],
	    subject: null,
	    button_text: 'reveal the meaning'
	};
	
	function loaded(state, payload) {
	    return _extends({}, state, { interps: payload });
	}
	
	function error(state, payload) {
	    return _extends({}, state, { error: payload });
	}
	
	function picked(state, payload) {
	    return _extends({}, state, { cards: _underscore2.default.uniq(state.cards.concat(payload.card)) });
	}
	
	function cards(state, payload) {
	    return _extends({}, state, { cards: payload });
	}
	
	function positions(state, payload) {
	    return _extends({}, state, { positions: payload });
	}
	
	function type(state, payload) {
	    return _extends({}, state, { type: payload });
	}
	
	function subject(state, payload) {
	    return _extends({}, state, { subject: payload });
	}
	
	function button_text(state, payload) {
	    return _extends({}, state, { button_text: payload });
	}
	
	function sampleInterp(state, payload) {
	    return _extends({}, state, { sample_interps: payload });
	}
	
	function loadSaved(state, payload) {
	    return _extends({}, state, { cards: payload });
	}

/***/ },

/***/ "./app/reducers/tcod.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.update = update;
	function update(state, payload) {
	    return _extends({}, state, payload);
	}

/***/ },

/***/ "./app/reducers/user.js":
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.update = update;
	exports.profiles = profiles;
	function update(state, payload) {
	    if (!!state.logged_in && !payload.logged_in) {
	        // logging out clears all old state
	        return payload;
	    }
	    return _extends({}, state, payload);
	}
	
	function profiles(state, payload) {
	    return _extends({}, state, { profiles: payload });
	}

/***/ },

/***/ "./app/reducers/zodiac.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var initial = exports.initial = {
	    signs: [{
	        name: 'aries',
	        start: 'Mar 21',
	        end: 'Apr 19'
	    }, {
	        name: 'taurus',
	        start: 'Apr 20',
	        end: 'May 20'
	    }, {
	        name: 'gemini',
	        start: 'May 21',
	        end: 'Jun 20'
	    }, {
	        name: 'cancer',
	        start: 'Jun 21',
	        end: 'Jul 22'
	    }, {
	        name: 'leo',
	        start: 'Jul 23',
	        end: 'Aug 22'
	    }, {
	        name: 'virgo',
	        start: 'Aug 23',
	        end: 'Sep 22'
	    }, {
	        name: 'libra',
	        start: 'Sep 23',
	        end: 'Oct 22'
	    }, {
	        name: 'scorpio',
	        start: 'Oct 23',
	        end: 'Nov 21'
	    }, {
	        name: 'sagittarius',
	        start: 'Nov 22',
	        end: 'Dec 21'
	    }, {
	        name: 'capricorn',
	        start: 'Dec 22',
	        end: 'Jan 19'
	    }, {
	        name: 'aquarius',
	        start: 'Jan 20',
	        end: 'Feb 18'
	    }, {
	        name: 'pisces',
	        start: 'Feb 19',
	        end: 'Mar 20'
	    }]
	};

/***/ },

/***/ "./app/sagas/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var rootSagas = exports.rootSagas = ['catalog', 'compatibility-chooser', 'content', 'cookie', 'cordial', 'cosmic-profile', 'daily-updates', 'deck', 'forecast', 'ga', 'hexagram', 'horoscope', 'i-ching-reading', 'karmacoin-store', 'location', 'member/email-preferences', 'member/email-unsub', 'member/privacy-policy-consent', 'moon-phase', 'number', 'oranum', 'planet-tracker', 'price', 'product-message', 'promo-message', 'promo-tracker', 'raven', 'recaptcha', 'route', 'subscription', 'tarot-ga', 'tarot-reading', 'tcod', 'user/index'].map(function (name) {
	    return __webpack_require__(3)("./" + name).root;
	});

/***/ },

/***/ 3:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./catalog": "./app/sagas/catalog.js",
		"./catalog.js": "./app/sagas/catalog.js",
		"./compatibility-chooser": "./app/sagas/compatibility-chooser.js",
		"./compatibility-chooser.js": "./app/sagas/compatibility-chooser.js",
		"./content": "./app/sagas/content.js",
		"./content.js": "./app/sagas/content.js",
		"./cookie": "./app/sagas/cookie.js",
		"./cookie.js": "./app/sagas/cookie.js",
		"./cordial": "./app/sagas/cordial.js",
		"./cordial.js": "./app/sagas/cordial.js",
		"./cosmic-profile": "./app/sagas/cosmic-profile.js",
		"./cosmic-profile.js": "./app/sagas/cosmic-profile.js",
		"./daily-updates": "./app/sagas/daily-updates.js",
		"./daily-updates.js": "./app/sagas/daily-updates.js",
		"./deck": "./app/sagas/deck.js",
		"./deck.js": "./app/sagas/deck.js",
		"./forecast": "./app/sagas/forecast.js",
		"./forecast.js": "./app/sagas/forecast.js",
		"./ga": "./app/sagas/ga.js",
		"./ga.js": "./app/sagas/ga.js",
		"./hexagram": "./app/sagas/hexagram.js",
		"./hexagram.js": "./app/sagas/hexagram.js",
		"./horoscope": "./app/sagas/horoscope.js",
		"./horoscope.js": "./app/sagas/horoscope.js",
		"./i-ching-reading": "./app/sagas/i-ching-reading.js",
		"./i-ching-reading.js": "./app/sagas/i-ching-reading.js",
		"./index": "./app/sagas/index.js",
		"./index.js": "./app/sagas/index.js",
		"./karmacoin-store": "./app/sagas/karmacoin-store.js",
		"./karmacoin-store.js": "./app/sagas/karmacoin-store.js",
		"./location": "./app/sagas/location.js",
		"./location.js": "./app/sagas/location.js",
		"./member/email-preferences": "./app/sagas/member/email-preferences.js",
		"./member/email-preferences.js": "./app/sagas/member/email-preferences.js",
		"./member/email-unsub": "./app/sagas/member/email-unsub.js",
		"./member/email-unsub.js": "./app/sagas/member/email-unsub.js",
		"./member/privacy-policy-consent": "./app/sagas/member/privacy-policy-consent.js",
		"./member/privacy-policy-consent.js": "./app/sagas/member/privacy-policy-consent.js",
		"./moon-phase": "./app/sagas/moon-phase.js",
		"./moon-phase.js": "./app/sagas/moon-phase.js",
		"./number": "./app/sagas/number.js",
		"./number.js": "./app/sagas/number.js",
		"./oranum": "./app/sagas/oranum.js",
		"./oranum.js": "./app/sagas/oranum.js",
		"./planet-tracker": "./app/sagas/planet-tracker.js",
		"./planet-tracker.js": "./app/sagas/planet-tracker.js",
		"./price": "./app/sagas/price.js",
		"./price.js": "./app/sagas/price.js",
		"./product-message": "./app/sagas/product-message.js",
		"./product-message.js": "./app/sagas/product-message.js",
		"./promo-message": "./app/sagas/promo-message.js",
		"./promo-message.js": "./app/sagas/promo-message.js",
		"./promo-tracker": "./app/sagas/promo-tracker.js",
		"./promo-tracker.js": "./app/sagas/promo-tracker.js",
		"./raven": "./app/sagas/raven.js",
		"./raven.js": "./app/sagas/raven.js",
		"./recaptcha": "./app/sagas/recaptcha.js",
		"./recaptcha.js": "./app/sagas/recaptcha.js",
		"./route": "./app/sagas/route.js",
		"./route.js": "./app/sagas/route.js",
		"./subscription": "./app/sagas/subscription.js",
		"./subscription.js": "./app/sagas/subscription.js",
		"./tarot-ga": "./app/sagas/tarot-ga.js",
		"./tarot-ga.js": "./app/sagas/tarot-ga.js",
		"./tarot-reading": "./app/sagas/tarot-reading.js",
		"./tarot-reading.js": "./app/sagas/tarot-reading.js",
		"./tcod": "./app/sagas/tcod.js",
		"./tcod.js": "./app/sagas/tcod.js",
		"./user/index": "./app/sagas/user/index.js",
		"./user/index.js": "./app/sagas/user/index.js",
		"./user/login": "./app/sagas/user/login.js",
		"./user/login.js": "./app/sagas/user/login.js",
		"./user/signup-api": "./app/sagas/user/signup-api.js",
		"./user/signup-api.js": "./app/sagas/user/signup-api.js"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 3;


/***/ },

/***/ "./app/sagas/catalog.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.getFilter = getFilter;
	exports.getPrices = getPrices;
	exports.root = root;
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _marked = [getFilter, catalogImpression, getPrices, getPrice, root].map(regeneratorRuntime.mark);
	
	function getFilter(_ref) {
	    var payload = _ref.payload;
	    var inputs, filters, filters_array, filter_string, products, should_fire_event;
	    return regeneratorRuntime.wrap(function getFilter$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.catalog.inputs;
	                    });
	
	                case 2:
	                    inputs = _context.sent;
	                    filters = inputs.reduce(function (filters, input) {
	                        var values = [];
	                        input.count = 0;
	
	                        input.items.forEach(function (item) {
	                            if (item.checked) {
	                                input.count++;
	                                if (item.value.match(/,/)) {
	                                    item.value.split(',').forEach(function (v) {
	                                        values.push(v);
	                                    });
	                                } else {
	                                    values.push(item.value);
	                                }
	                            }
	                        });
	
	                        if (values.length) {
	                            filters[input.key] = values;
	                        }
	
	                        return filters;
	                    }, {});
	
	
	                    if (payload && payload.search) {
	                        filters.search = payload.search;
	                    }
	
	                    if (payload && payload.price) {
	                        filters.price = payload.price;
	                    }
	
	                    _context.next = 8;
	                    return (0, _effects.put)({
	                        type: 'catalog:filter',
	                        payload: {
	                            filters: filters,
	                            inputs: inputs
	                        }
	                    });
	
	                case 8:
	                    filters_array = [];
	
	                    if (filters.category) {
	                        filters_array.push('category=' + filters.category.join(',').replace(/^,/, ''));
	                    }
	
	                    if (filters.modality) {
	                        filters_array.push('modality=' + filters.modality.join(',').replace(/^,/, ''));
	                    }
	
	                    if (filters.search) {
	                        filters_array.push('search=' + encodeURIComponent(filters.search));
	                    }
	
	                    if (filters.price) {
	                        filters_array.push('price=' + encodeURIComponent(filters.price));
	                    }
	
	                    filter_string = filters_array.join('&');
	                    _context.next = 16;
	                    return (0, _effects.select)(function (state) {
	                        return state.catalog.products;
	                    });
	
	                case 16:
	                    products = _context.sent;
	                    should_fire_event = false;
	                    _context.next = 20;
	                    return (0, _effects.all)(products.map(function (product, index) {
	                        window.ga('ec:addImpression', {
	                            id: product.code,
	                            name: product.product_name,
	                            list: 'Catalog' + (filter_string ? ' - ' + filter_string : ''),
	                            position: index
	                        });
	
	                        if (index % 50 === 0 && should_fire_event) {
	                            should_fire_event = false;
	                            return (0, _effects.call)(catalogImpression, filter_string);
	                        }
	                        should_fire_event = true;
	                        return (0, _effects.call)(function () {});
	                    }));
	
	                case 20:
	                    if (!should_fire_event) {
	                        _context.next = 23;
	                        break;
	                    }
	
	                    _context.next = 23;
	                    return (0, _effects.call)(catalogImpression, filter_string);
	
	                case 23:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function catalogImpression(filter_string) {
	    var logged_in, action;
	    return regeneratorRuntime.wrap(function catalogImpression$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.user.logged_in;
	                    });
	
	                case 2:
	                    logged_in = _context2.sent;
	                    action = logged_in ? 'LI Impression' : 'LO Impression';
	                    _context2.next = 6;
	                    return (0, _effects.put)({
	                        type: 'ga:event',
	                        payload: ['Catalog', action, filter_string || 'No Filter']
	                    });
	
	                case 6:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}
	
	function getPrices(_ref2) {
	    var payload = _ref2.payload;
	    var products;
	    return regeneratorRuntime.wrap(function getPrices$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    _context3.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.catalog.products;
	                    });
	
	                case 2:
	                    products = _context3.sent;
	                    _context3.next = 5;
	                    return products.map(function (product, i) {
	                        return (0, _effects.call)(getPrice, product, i);
	                    });
	
	                case 5:
	                    _context3.next = 7;
	                    return (0, _effects.put)({
	                        type: 'catalog:get-filter',
	                        payload: payload
	                    });
	
	                case 7:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _marked[2], this);
	}
	
	function getPrice(product, i) {
	    var do_not_lookup, products, kc, on_sale, _ref3, _ref4, api, params, price;
	
	    return regeneratorRuntime.wrap(function getPrice$(_context4) {
	        while (1) {
	            switch (_context4.prev = _context4.next) {
	                case 0:
	                    do_not_lookup = ['karma-coin-package', 'daily-horoscope-iphone-app'];
	                    _context4.next = 3;
	                    return (0, _effects.select)(function (state) {
	                        return state.catalog.products;
	                    });
	
	                case 3:
	                    products = _context4.sent;
	                    kc = 0;
	                    on_sale = true;
	
	                    if (do_not_lookup.includes(product.code)) {
	                        _context4.next = 23;
	                        break;
	                    }
	
	                    _context4.next = 9;
	                    return (0, _effects.all)([(0, _effects.select)(function (state) {
	                        return state.api.host;
	                    }), (0, _effects.select)(function (state) {
	                        return state.api.params;
	                    })]);
	
	                case 9:
	                    _ref3 = _context4.sent;
	                    _ref4 = _slicedToArray(_ref3, 2);
	                    api = _ref4[0];
	                    params = _ref4[1];
	                    _context4.prev = 13;
	                    _context4.next = 16;
	                    return (0, _effects.call)(_util.getJSON, api + '/commerce/price/' + product.code, params);
	
	                case 16:
	                    price = _context4.sent;
	
	
	                    if (price && price.kc && price.kc.current && price.kc.original) {
	                        kc = price.kc.current;
	                        on_sale = price.kc.current > price.kc.original;
	                    }
	                    _context4.next = 23;
	                    break;
	
	                case 20:
	                    _context4.prev = 20;
	                    _context4.t0 = _context4['catch'](13);
	                    return _context4.abrupt('return');
	
	                case 23:
	
	                    products[i].kc = kc;
	                    products[i].on_sale = on_sale;
	
	                    _context4.next = 27;
	                    return (0, _effects.put)({
	                        type: 'catalog:update',
	                        payload: {
	                            products: products
	                        }
	                    });
	
	                case 27:
	                case 'end':
	                    return _context4.stop();
	            }
	        }
	    }, _marked[3], this, [[13, 20]]);
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context5) {
	        while (1) {
	            switch (_context5.prev = _context5.next) {
	                case 0:
	                    return _context5.delegateYield([(0, _reduxSaga.takeEvery)('catalog:get-filter', getFilter), (0, _reduxSaga.takeEvery)('catalog:get-prices', getPrices)], 't0', 1);
	
	                case 1:
	                case 'end':
	                    return _context5.stop();
	            }
	        }
	    }, _marked[4], this);
	}

/***/ },

/***/ "./app/util.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.hasTouchEvents = exports.params = exports.bind = exports.attributesToObject = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.getJSON = getJSON;
	exports.postJSON = postJSON;
	exports.putJSON = putJSON;
	exports.deleteJSON = deleteJSON;
	exports.truncate = truncate;
	exports.getFavoriteDeck = getFavoriteDeck;
	exports.ordinal = ordinal;
	exports.shuffle = shuffle;
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _underscore = __webpack_require__("../node_modules/underscore/underscore.js");
	
	var _scroll = __webpack_require__("./app/scroll.js");
	
	var _marked = [getFavoriteDeck].map(regeneratorRuntime.mark);
	
	// NOTE: despite their names, none of these methods enforce JSON requests or responses :(
	function getJSON(url) {
	    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var args = _extends({}, options, { type: 'GET', data: data, xhrFields: { withCredentials: true } });
	    return Promise.resolve($.ajax(url, args));
	}
	
	function postJSON(url) {
	    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var args = _extends({}, options, { type: 'POST', data: data, xhrFields: { withCredentials: true } });
	    return Promise.resolve($.ajax(url, args));
	}
	
	function putJSON(url) {
	    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var args = _extends({}, options, { type: 'PUT', data: data, xhrFields: { withCredentials: true } });
	    return Promise.resolve($.ajax(url, args));
	}
	
	function deleteJSON(url) {
	    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var args = _extends({}, options, { type: 'DELETE', data: data, xhrFields: { withCredentials: true } });
	    return Promise.resolve($.ajax(url, args));
	}
	
	function truncate(str, max) {
	    if (!str || str.length <= max) {
	        return str + ' ';
	    }
	    var charLimit = str.substring(0, max);
	    var wordLimit = Math.min(charLimit.length, charLimit.lastIndexOf(' '));
	    return charLimit.substring(0, wordLimit).trim() + '… ';
	}
	
	var attributesToObject = exports.attributesToObject = function attributesToObject(attrs) {
	    return Array.prototype.reduce.call(attrs, function (obj, attr) {
	        obj[attr.name] = attr.value;
	        return obj;
	    }, {});
	};
	
	var bind = exports.bind = function bind(context, names) {
	    names.forEach(function (name) {
	        var original = context[name];
	        context[name] = function bound() {
	            return original.apply(context, arguments);
	        };
	    });
	};
	
	function getFavoriteDeck(user) {
	    var decks;
	    return regeneratorRuntime.wrap(function getFavoriteDeck$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    if (user.favorite_deck_id) {
	                        _context.next = 2;
	                        break;
	                    }
	
	                    return _context.abrupt('return', null);
	
	                case 2:
	                    _context.next = 4;
	                    return (0, _effects.select)(function (state) {
	                        return state.decks;
	                    });
	
	                case 4:
	                    decks = _context.sent;
	
	                    if (!(!decks || !decks.length)) {
	                        _context.next = 7;
	                        break;
	                    }
	
	                    return _context.abrupt('return', null);
	
	                case 7:
	                    return _context.abrupt('return', (0, _underscore.find)(decks, function (deck) {
	                        return deck.deck == user.favorite_deck_id;
	                    }));
	
	                case 8:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	var params = exports.params = function params(obj) {
	    return Object.keys(obj).map(function (k) {
	        return k + '=' + encodeURIComponent(obj[k]);
	    }).join('&');
	};
	
	var hasTouchEvents = exports.hasTouchEvents = document.children ? document.children[0].classList.contains('touchevents') : document.childNodes[1].classList.contains('touchevents');
	
	//use hashes that start with '!' to trigger smoothScrollToElement on page load
	if (window.location.hash && window.location.hash.match(/\!/)) {
	    var hash = window.location.hash.replace(/\!/, '');
	    var target = document.querySelector(hash);
	
	    if (target) {
	        (0, _scroll.smoothScrollToElement)(target);
	    }
	}
	
	function ordinal(num) {
	    var j = num % 10;
	    var k = num % 100;
	
	    if (j == 1 && k != 11) {
	        return num + 'st';
	    }
	
	    if (j == 2 && k != 12) {
	        return num + 'nd';
	    }
	
	    if (j == 3 && k != 13) {
	        return num + 'rd';
	    }
	
	    return num + 'th';
	}
	
	function shuffle(array) {
	    var m = array.length;
	    var t = void 0,
	        i = void 0;
	
	    while (m) {
	        i = Math.floor(Math.random() * m--); // Pick a remaining element…
	
	        // And swap it with the current element.
	        t = array[m];
	        array[m] = array[i];
	        array[i] = t;
	    }
	
	    return array;
	}

/***/ },

/***/ "./app/scroll.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.smoothScrollToElement = smoothScrollToElement;
	
	var _smoothscrollPolyfill = __webpack_require__("../node_modules/smoothscroll-polyfill/dist/smoothscroll.js");
	
	var polyfilled = false; // scroll({ behavior: 'smoot', ...
	function smoothScrollToElement(el) {
	    if (!polyfilled) {
	        (0, _smoothscrollPolyfill.polyfill)();
	        polyfilled = true;
	    }
	
	    var docTop = document.body.scrollTop || document.documentElement.scrollTop;
	
	    var elTopBound = el.getBoundingClientRect().top;
	    var elTopMargin = Math.max(parseInt(window.getComputedStyle(el).marginTop), 0);
	
	    var headerElement = document.querySelector('.tarot-desktop-header') || document.querySelector('.user-bar') || document.querySelector('tarot-top-bar');
	    var offset = headerElement ? headerElement.offsetHeight : 0;
	
	    var scrollTop = Math.max(docTop + elTopBound - elTopMargin - offset, 0);
	    window.scroll({ top: scrollTop, behavior: 'smooth' });
	}
	
	// passive events
	(function () {
	    /*eslint-disable */
	    var passiveSupported = false;
	
	    window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
	        get: function get() {
	            passiveSupported = true;
	        }
	    }));
	
	    if (typeof onWheel !== 'undefined') {
	        document.addEventListener('wheel', onWheel, passiveSupported ? { passive: true } : false);
	    }
	
	    if (typeof onMouseWheel !== 'undefined') {
	        document.addEventListener('mousewheel', onMouseWheel, passiveSupported ? { passive: true } : false);
	    }
	
	    if (typeof onTouchStart !== 'undefined') {
	        document.addEventListener('touchstart', onTouchStart, passiveSupported ? { passive: true } : false);
	    }
	
	    if (typeof onTouchMove !== 'undefined') {
	        document.addEventListener('touchmove', onTouchMove, passiveSupported ? { passive: true } : false);
	    }
	})();

/***/ },

/***/ "../node_modules/smoothscroll-polyfill/dist/smoothscroll.js":
/***/ function(module, exports, __webpack_require__) {

	/* smoothscroll v0.4.0 - 2017 - Dustan Kasten, Jeremias Menichelli - MIT License */
	(function () {
	  'use strict';
	
	  /*
	   * aliases
	   * w: window global object
	   * d: document
	   */
	  var w = window;
	  var d = document;
	
	  /**
	   * indicates if a the current browser is made by Microsoft
	   * @method isMicrosoftBrowser
	   * @param {String} userAgent
	   * @returns {Boolean}
	   */
	  function isMicrosoftBrowser(userAgent) {
	    var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];
	
	    return new RegExp(userAgentPatterns.join('|')).test(userAgent);
	  }
	
	   // polyfill
	  function polyfill() {
	    // return if scroll behavior is supported and polyfill is not forced
	    if ('scrollBehavior' in d.documentElement.style
	      && w.__forceSmoothScrollPolyfill__ !== true) {
	      return;
	    }
	
	    // globals
	    var Element = w.HTMLElement || w.Element;
	    var SCROLL_TIME = 468;
	
	    /*
	     * IE has rounding bug rounding down clientHeight and clientWidth and
	     * rounding up scrollHeight and scrollWidth causing false positives
	     * on hasScrollableSpace
	     */
	    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;
	
	    // object gathering original scroll methods
	    var original = {
	      scroll: w.scroll || w.scrollTo,
	      scrollBy: w.scrollBy,
	      elementScroll: Element.prototype.scroll || scrollElement,
	      scrollIntoView: Element.prototype.scrollIntoView
	    };
	
	    // define timing method
	    var now = w.performance && w.performance.now
	      ? w.performance.now.bind(w.performance)
	      : Date.now;
	
	    /**
	     * changes scroll position inside an element
	     * @method scrollElement
	     * @param {Number} x
	     * @param {Number} y
	     * @returns {undefined}
	     */
	    function scrollElement(x, y) {
	      this.scrollLeft = x;
	      this.scrollTop = y;
	    }
	
	    /**
	     * returns result of applying ease math function to a number
	     * @method ease
	     * @param {Number} k
	     * @returns {Number}
	     */
	    function ease(k) {
	      return 0.5 * (1 - Math.cos(Math.PI * k));
	    }
	
	    /**
	     * indicates if a smooth behavior should be applied
	     * @method shouldBailOut
	     * @param {Number|Object} firstArg
	     * @returns {Boolean}
	     */
	    function shouldBailOut(firstArg) {
	      if (firstArg === null
	        || typeof firstArg !== 'object'
	        || firstArg.behavior === undefined
	        || firstArg.behavior === 'auto'
	        || firstArg.behavior === 'instant') {
	        // first argument is not an object/null
	        // or behavior is auto, instant or undefined
	        return true;
	      }
	
	      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
	        // first argument is an object and behavior is smooth
	        return false;
	      }
	
	      // throw error when behavior is not supported
	      throw new TypeError(
	        'behavior member of ScrollOptions '
	        + firstArg.behavior
	        + ' is not a valid value for enumeration ScrollBehavior.'
	      );
	    }
	
	    /**
	     * indicates if an element has scrollable space in the provided axis
	     * @method hasScrollableSpace
	     * @param {Node} el
	     * @param {String} axis
	     * @returns {Boolean}
	     */
	    function hasScrollableSpace(el, axis) {
	      if (axis === 'Y') {
	        return (el.clientHeight + ROUNDING_TOLERANCE) < el.scrollHeight;
	      }
	
	      if (axis === 'X') {
	        return (el.clientWidth + ROUNDING_TOLERANCE) < el.scrollWidth;
	      }
	    }
	
	    /**
	     * indicates if an element has a scrollable overflow property in the axis
	     * @method canOverflow
	     * @param {Node} el
	     * @param {String} axis
	     * @returns {Boolean}
	     */
	    function canOverflow(el, axis) {
	      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];
	
	      return overflowValue === 'auto' || overflowValue === 'scroll';
	    }
	
	    /**
	     * indicates if an element can be scrolled in either axis
	     * @method isScrollable
	     * @param {Node} el
	     * @param {String} axis
	     * @returns {Boolean}
	     */
	    function isScrollable(el) {
	      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
	      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');
	
	      return isScrollableY || isScrollableX;
	    }
	
	    /**
	     * finds scrollable parent of an element
	     * @method findScrollableParent
	     * @param {Node} el
	     * @returns {Node} el
	     */
	    function findScrollableParent(el) {
	      var isBody;
	
	      do {
	        el = el.parentNode;
	
	        isBody = el === d.body;
	      } while (isBody === false && isScrollable(el) === false);
	
	      isBody = null;
	
	      return el;
	    }
	
	    /**
	     * self invoked function that, given a context, steps through scrolling
	     * @method step
	     * @param {Object} context
	     * @returns {undefined}
	     */
	    function step(context) {
	      var time = now();
	      var value;
	      var currentX;
	      var currentY;
	      var elapsed = (time - context.startTime) / SCROLL_TIME;
	
	      // avoid elapsed times higher than one
	      elapsed = elapsed > 1 ? 1 : elapsed;
	
	      // apply easing to elapsed time
	      value = ease(elapsed);
	
	      currentX = context.startX + (context.x - context.startX) * value;
	      currentY = context.startY + (context.y - context.startY) * value;
	
	      context.method.call(context.scrollable, currentX, currentY);
	
	      // scroll more if we have not reached our destination
	      if (currentX !== context.x || currentY !== context.y) {
	        w.requestAnimationFrame(step.bind(w, context));
	      }
	    }
	
	    /**
	     * scrolls window or element with a smooth behavior
	     * @method smoothScroll
	     * @param {Object|Node} el
	     * @param {Number} x
	     * @param {Number} y
	     * @returns {undefined}
	     */
	    function smoothScroll(el, x, y) {
	      var scrollable;
	      var startX;
	      var startY;
	      var method;
	      var startTime = now();
	
	      // define scroll context
	      if (el === d.body) {
	        scrollable = w;
	        startX = w.scrollX || w.pageXOffset;
	        startY = w.scrollY || w.pageYOffset;
	        method = original.scroll;
	      } else {
	        scrollable = el;
	        startX = el.scrollLeft;
	        startY = el.scrollTop;
	        method = scrollElement;
	      }
	
	      // scroll looping over a frame
	      step({
	        scrollable: scrollable,
	        method: method,
	        startTime: startTime,
	        startX: startX,
	        startY: startY,
	        x: x,
	        y: y
	      });
	    }
	
	    // ORIGINAL METHODS OVERRIDES
	    // w.scroll and w.scrollTo
	    w.scroll = w.scrollTo = function() {
	      // avoid action when no arguments are passed
	      if (arguments[0] === undefined) {
	        return;
	      }
	
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0]) === true) {
	        original.scroll.call(
	          w,
	          arguments[0].left !== undefined
	            ? arguments[0].left
	            : typeof arguments[0] !== 'object'
	              ? arguments[0]
	              : (w.scrollX || w.pageXOffset),
	          // use top prop, second argument if present or fallback to scrollY
	          arguments[0].top !== undefined
	            ? arguments[0].top
	            : arguments[1] !== undefined
	              ? arguments[1]
	              : (w.scrollY || w.pageYOffset)
	        );
	
	        return;
	      }
	
	      // LET THE SMOOTHNESS BEGIN!
	      smoothScroll.call(
	        w,
	        d.body,
	        arguments[0].left !== undefined
	          ? ~~arguments[0].left
	          : (w.scrollX || w.pageXOffset),
	        arguments[0].top !== undefined
	          ? ~~arguments[0].top
	          : (w.scrollY || w.pageYOffset)
	      );
	    };
	
	    // w.scrollBy
	    w.scrollBy = function() {
	      // avoid action when no arguments are passed
	      if (arguments[0] === undefined) {
	        return;
	      }
	
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0])) {
	        original.scrollBy.call(
	          w,
	          arguments[0].left !== undefined
	            ? arguments[0].left
	            : typeof arguments[0] !== 'object'
	              ? arguments[0]
	              : 0,
	          arguments[0].top !== undefined
	            ? arguments[0].top
	            : arguments[1] !== undefined
	             ? arguments[1]
	             : 0
	        );
	
	        return;
	      }
	
	      // LET THE SMOOTHNESS BEGIN!
	      smoothScroll.call(
	        w,
	        d.body,
	        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
	        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
	      );
	    };
	
	    // Element.prototype.scroll and Element.prototype.scrollTo
	    Element.prototype.scroll = Element.prototype.scrollTo = function() {
	      // avoid action when no arguments are passed
	      if (arguments[0] === undefined) {
	        return;
	      }
	
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0]) === true) {
	        // if one number is passed, throw error to match Firefox implementation
	        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
	          throw new SyntaxError('Value couldn\'t be converted');
	        }
	
	        original.elementScroll.call(
	          this,
	          // use left prop, first number argument or fallback to scrollLeft
	          arguments[0].left !== undefined
	            ? ~~arguments[0].left
	            : typeof arguments[0] !== 'object'
	              ? ~~arguments[0]
	              : this.scrollLeft,
	          // use top prop, second argument or fallback to scrollTop
	          arguments[0].top !== undefined
	            ? ~~arguments[0].top
	            : arguments[1] !== undefined
	              ? ~~arguments[1]
	              : this.scrollTop
	        );
	
	        return;
	      }
	
	      var left = arguments[0].left;
	      var top = arguments[0].top;
	
	      // LET THE SMOOTHNESS BEGIN!
	      smoothScroll.call(
	        this,
	        this,
	        typeof left === 'undefined' ? this.scrollLeft : ~~left,
	        typeof top === 'undefined' ? this.scrollTop : ~~top
	      );
	    };
	
	    // Element.prototype.scrollBy
	    Element.prototype.scrollBy = function() {
	      // avoid action when no arguments are passed
	      if (arguments[0] === undefined) {
	        return;
	      }
	
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0]) === true) {
	        original.elementScroll.call(
	          this,
	          arguments[0].left !== undefined
	            ? ~~arguments[0].left + this.scrollLeft
	            : ~~arguments[0] + this.scrollLeft,
	          arguments[0].top !== undefined
	            ? ~~arguments[0].top + this.scrollTop
	            : ~~arguments[1] + this.scrollTop
	        );
	
	        return;
	      }
	
	      this.scroll({
	        left: ~~arguments[0].left + this.scrollLeft,
	        top: ~~arguments[0].top + this.scrollTop,
	        behavior: arguments[0].behavior
	      });
	    };
	
	    // Element.prototype.scrollIntoView
	    Element.prototype.scrollIntoView = function() {
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0]) === true) {
	        original.scrollIntoView.call(
	          this,
	          arguments[0] === undefined
	            ? true
	            : arguments[0]
	        );
	
	        return;
	      }
	
	      // LET THE SMOOTHNESS BEGIN!
	      var scrollableParent = findScrollableParent(this);
	      var parentRects = scrollableParent.getBoundingClientRect();
	      var clientRects = this.getBoundingClientRect();
	
	      if (scrollableParent !== d.body) {
	        // reveal element inside parent
	        smoothScroll.call(
	          this,
	          scrollableParent,
	          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
	          scrollableParent.scrollTop + clientRects.top - parentRects.top
	        );
	
	        // reveal parent in viewport unless is fixed
	        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
	          w.scrollBy({
	            left: parentRects.left,
	            top: parentRects.top,
	            behavior: 'smooth'
	          });
	        }
	      } else {
	        // reveal element in viewport
	        w.scrollBy({
	          left: clientRects.left,
	          top: clientRects.top,
	          behavior: 'smooth'
	        });
	      }
	    };
	  }
	
	  if (true) {
	    // commonjs
	    module.exports = { polyfill: polyfill };
	  } else {
	    // global
	    polyfill();
	  }
	
	}());


/***/ },

/***/ "./app/sagas/compatibility-chooser.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.report = report;
	exports.setChineseSign = setChineseSign;
	exports.root = root;
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _marked = [report, setChineseSign, root].map(regeneratorRuntime.mark);
	
	function report() {
	    var user, _ref, base_url, path, hash, submitting, url;
	
	    return regeneratorRuntime.wrap(function report$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.user;
	                    });
	
	                case 2:
	                    user = _context.sent;
	                    _context.next = 5;
	                    return (0, _effects.select)(function (state) {
	                        return state['compatibility-chooser'];
	                    });
	
	                case 5:
	                    _ref = _context.sent;
	                    base_url = _ref.base_url;
	                    path = _ref.path;
	                    hash = _ref.hash;
	                    submitting = _ref.submitting;
	                    url = base_url + path.name + '#!' + hash.name;
	                    _context.next = 13;
	                    return (0, _effects.put)({ type: 'product:type', payload: 'Report' });
	
	                case 13:
	                    if (user.logged_in) {
	                        _context.next = 16;
	                        break;
	                    }
	
	                    _context.next = 16;
	                    return (0, _effects.all)([(0, _effects.put)({ type: 'route:to', payload: 'login' }), (0, _effects.take)('user:logged-in')]);
	
	                case 16:
	                    if (!submitting) {
	                        _context.next = 18;
	                        break;
	                    }
	
	                    return _context.abrupt('return');
	
	                case 18:
	                    _context.next = 20;
	                    return (0, _effects.put)({ type: 'compatibility-chooser:set', payload: { submitting: true } });
	
	                case 20:
	                    _context.next = 22;
	                    return (0, _effects.put)({ type: 'location:href', payload: url });
	
	                case 22:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function setChineseSign(_ref2) {
	    var _ref2$payload = _ref2.payload,
	        which = _ref2$payload.which,
	        date = _ref2$payload.date;
	    var mDate, month, day, year, sign, payload;
	    return regeneratorRuntime.wrap(function setChineseSign$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    mDate = (0, _moment2.default)(date);
	                    month = mDate.format('MM');
	                    day = mDate.format('DD');
	                    year = mDate.format('YYYY');
	                    _context2.next = 6;
	                    return (0, _effects.call)(_util.getJSON, '/api/compat-meter/getchinese?month=' + month + '&day=' + day + '&year=' + year);
	
	                case 6:
	                    sign = _context2.sent;
	
	                    if (!sign.data.sign) {
	                        _context2.next = 11;
	                        break;
	                    }
	
	                    payload = _defineProperty({}, which, { name: sign.data.sign.toLowerCase() });
	                    _context2.next = 11;
	                    return (0, _effects.put)({ type: 'compatibility-chooser:set', payload: payload });
	
	                case 11:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    return _context3.delegateYield([(0, _reduxSaga.takeEvery)('compatibility-chooser:report', report), (0, _reduxSaga.takeEvery)('compatibility-chooser:setChineseSign', setChineseSign)], 't0', 1);
	
	                case 1:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _marked[2], this);
	}

/***/ },

/***/ "./app/sagas/content.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.getContentData = getContentData;
	exports.fetchNav = fetchNav;
	exports.fetchPromoted = fetchPromoted;
	exports.fetchHexagram = fetchHexagram;
	exports.root = root;
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _marked = [getContentData, fetchNav, fetchPromoted, fetchHexagram, root].map(regeneratorRuntime.mark);
	
	function getContentData(args) {
	    var api, default_args;
	    return regeneratorRuntime.wrap(function getContentData$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.api.host;
	                    });
	
	                case 2:
	                    api = _context.sent;
	                    default_args = {
	                        partner: 'viz',
	                        key: '2fae913ecc625545',
	                        content_type: 'content',
	                        property: 'cygnus',
	                        limit: 2
	                    };
	                    _context.next = 6;
	                    return (0, _effects.call)(_util.getJSON, api + '/content/content', _extends({}, default_args, args));
	
	                case 6:
	                    return _context.abrupt('return', _context.sent);
	
	                case 7:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function fetchNav(_ref) {
	    var tag = _ref.payload;
	    var data;
	    return regeneratorRuntime.wrap(function fetchNav$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _effects.call)(getContentData, { tag: encodeURIComponent(tag) });
	
	                case 2:
	                    data = _context2.sent;
	                    _context2.next = 5;
	                    return (0, _effects.put)({
	                        type: 'content:nav',
	                        payload: {
	                            tag: tag,
	                            data: data
	                        }
	                    });
	
	                case 5:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}
	
	function fetchPromoted(_ref2) {
	    var limit = _ref2.payload;
	    var stories;
	    return regeneratorRuntime.wrap(function fetchPromoted$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    _context3.next = 2;
	                    return (0, _effects.call)(_util.getJSON, '/api/content/promoted', { limit: limit });
	
	                case 2:
	                    stories = _context3.sent;
	                    _context3.next = 5;
	                    return (0, _effects.put)({
	                        type: 'content:promoted',
	                        payload: stories
	                    });
	
	                case 5:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _marked[2], this);
	}
	
	function fetchHexagram(_ref3) {
	    var limit = _ref3.payload;
	    var data;
	    return regeneratorRuntime.wrap(function fetchHexagram$(_context4) {
	        while (1) {
	            switch (_context4.prev = _context4.next) {
	                case 0:
	                    _context4.next = 2;
	                    return (0, _effects.call)(getContentData, {
	                        content_type: null,
	                        node_type: ['article', 'blog'],
	                        property: 'cygnus',
	                        tag: 'hexagram',
	                        limit: limit
	                    });
	
	                case 2:
	                    data = _context4.sent;
	                    _context4.next = 5;
	                    return (0, _effects.put)({
	                        type: 'content:hexagram',
	                        payload: data
	                    });
	
	                case 5:
	                case 'end':
	                    return _context4.stop();
	            }
	        }
	    }, _marked[3], this);
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context5) {
	        while (1) {
	            switch (_context5.prev = _context5.next) {
	                case 0:
	                    return _context5.delegateYield([(0, _reduxSaga.takeEvery)('content:fetchNav', fetchNav), (0, _reduxSaga.takeEvery)('content:fetchPromoted', fetchPromoted), (0, _reduxSaga.takeEvery)('content:fetchHexagram', fetchHexagram)], 't0', 1);
	
	                case 1:
	                case 'end':
	                    return _context5.stop();
	            }
	        }
	    }, _marked[4], this);
	}

/***/ },

/***/ "./app/sagas/cookie.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.root = root;
	
	var _jsCookie = __webpack_require__("../node_modules/js-cookie/src/js.cookie.js");
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [set, remove, root].map(regeneratorRuntime.mark);
	
	function getOpts(opts) {
	    return _extends({}, opts || {}, {
	        domain: '.tarot.com',
	        secure: /^https:/.test(location)
	    });
	}
	
	function set(_ref) {
	    var cookie = _ref.payload;
	    var opts;
	    return regeneratorRuntime.wrap(function set$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    // automatic JSON.stringify(cookie.value)
	                    opts = getOpts(cookie.opts);
	                    _context.next = 3;
	                    return (0, _effects.call)([_jsCookie2.default, _jsCookie2.default.set], cookie.name, cookie.value, opts);
	
	                case 3:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function remove(_ref2) {
	    var name = _ref2.payload;
	    var opts;
	    return regeneratorRuntime.wrap(function remove$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    opts = getOpts();
	                    _context2.next = 3;
	                    return (0, _effects.call)([_jsCookie2.default, _jsCookie2.default.remove], name, opts);
	
	                case 3:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    _context3.next = 2;
	                    return (0, _effects.all)([(0, _reduxSaga.takeEvery)('cookie:set', set), (0, _reduxSaga.takeEvery)('cookie:remove', remove)]);
	
	                case 2:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _marked[2], this);
	}

/***/ },

/***/ "./app/sagas/cordial.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.setupCordial = setupCordial;
	exports.getBrowseEvent = getBrowseEvent;
	exports.sendSavedBrowseEvents = sendSavedBrowseEvents;
	exports.saveBrowseEvent = saveBrowseEvent;
	exports.sendBrowseEvent = sendBrowseEvent;
	exports.watchUser = watchUser;
	exports.watchBrowseEvents = watchBrowseEvents;
	exports.root = root;
	
	var _underscore = __webpack_require__("../node_modules/underscore/underscore.js");
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [setupCordial, getBrowseEvent, sendSavedBrowseEvents, saveBrowseEvent, sendBrowseEvent, watchUser, watchBrowseEvents, root].map(regeneratorRuntime.mark); /*global cordial, CordialTrack */
	
	
	function setupCordial() {
	    var key;
	    return regeneratorRuntime.wrap(function setupCordial$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.cordial && state.cordial.key;
	                    });
	
	                case 2:
	                    key = _context.sent;
	                    _context.next = 5;
	                    return (0, _effects.call)(function () {
	                        return new Promise(function (resolve) {
	                            var tag = document.createElement('script');
	                            tag.async = true;
	                            tag.onload = resolve;
	                            tag.setAttribute('data-auto-track', false);
	                            tag.setAttribute('data-cordial-track-key', key);
	                            tag.setAttribute('data-cordial-url', 'track.cordial.io');
	                            tag.src = 'https://track.cordial.io/track.js';
	                            document.body.appendChild(tag);
	                        });
	                    });
	
	                case 5:
	                    _context.next = 7;
	                    return (0, _effects.call)(function () {
	                        return new Promise(function (resolve) {
	                            return (
	                                // The Cordial script creates an iframe that sends a window.postMessage
	                                // event at regular intervals, but we only care that it happens at least once
	                                // to ensure we have access to window.cordial and its methods
	                                window.addEventListener('message', function messageListenerEnd(e) {
	                                    if (e.origin === 'https://track.cordial.io') {
	                                        window.removeEventListener('message', messageListenerEnd);
	                                        resolve();
	                                    }
	                                })
	                            );
	                        });
	                    });
	
	                case 7:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function getBrowseEvent() {
	    var _ref, _ref2, desc, teeup;
	
	    return regeneratorRuntime.wrap(function getBrowseEvent$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _effects.all)([(0, _effects.select)(function (state) {
	                        return state.product.description;
	                    }), (0, _effects.select)(function (state) {
	                        return state.product.teeup;
	                    })]);
	
	                case 2:
	                    _ref = _context2.sent;
	                    _ref2 = _slicedToArray(_ref, 2);
	                    desc = _ref2[0];
	                    teeup = _ref2[1];
	                    return _context2.abrupt('return', desc ? {
	                        category: desc.categories[0],
	                        product: desc.product_name,
	                        productID: desc.code,
	                        placement: 'teeup' } : {
	                        category: teeup.product_type,
	                        product: teeup.display_name,
	                        productID: teeup.code,
	                        placement: 'module'
	                    });
	
	                case 7:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}
	
	function sendSavedBrowseEvents() {
	    var events;
	    return regeneratorRuntime.wrap(function sendSavedBrowseEvents$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    _context3.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.cookie['cordial-events'] || [];
	                    });
	
	                case 2:
	                    events = _context3.sent;
	                    _context3.next = 5;
	                    return (0, _effects.put)({ type: 'cookie:remove', payload: 'cordial-events' });
	
	                case 5:
	                    _context3.next = 7;
	                    return _underscore2.default.last(events, 5).map(function (event) {
	                        return (0, _effects.call)([cordial, cordial.event], 'browse', event);
	                    });
	
	                case 7:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _marked[2], this);
	}
	
	function saveBrowseEvent(event) {
	    var events;
	    return regeneratorRuntime.wrap(function saveBrowseEvent$(_context4) {
	        while (1) {
	            switch (_context4.prev = _context4.next) {
	                case 0:
	                    _context4.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.cookie['cordial-events'] || [];
	                    });
	
	                case 2:
	                    events = _context4.sent;
	
	                    events.push(event);
	                    _context4.next = 6;
	                    return (0, _effects.put)({ type: 'cookie:set', payload: {
	                            name: 'cordial-events',
	                            value: events,
	                            opts: { expires: .042 } } });
	
	                case 6:
	                case 'end':
	                    return _context4.stop();
	            }
	        }
	    }, _marked[3], this);
	}
	
	function sendBrowseEvent(event) {
	    return regeneratorRuntime.wrap(function sendBrowseEvent$(_context5) {
	        while (1) {
	            switch (_context5.prev = _context5.next) {
	                case 0:
	                    _context5.prev = 0;
	                    _context5.next = 3;
	                    return (0, _effects.call)([cordial, cordial.event], 'browse', event);
	
	                case 3:
	                    _context5.next = 9;
	                    break;
	
	                case 5:
	                    _context5.prev = 5;
	                    _context5.t0 = _context5['catch'](0);
	                    _context5.next = 9;
	                    return (0, _effects.put)({ type: 'raven:error', payload: { error: _context5.t0, message: 'sendBrowseEvent' } });
	
	                case 9:
	                case 'end':
	                    return _context5.stop();
	            }
	        }
	    }, _marked[4], this, [[0, 5]]);
	}
	
	function watchUser() {
	    var _this = this;
	
	    var _loop;
	
	    return regeneratorRuntime.wrap(function watchUser$(_context7) {
	        while (1) {
	            switch (_context7.prev = _context7.next) {
	                case 0:
	                    _loop = regeneratorRuntime.mark(function _loop() {
	                        var user;
	                        return regeneratorRuntime.wrap(function _loop$(_context6) {
	                            while (1) {
	                                switch (_context6.prev = _context6.next) {
	                                    case 0:
	                                        _context6.next = 2;
	                                        return (0, _effects.select)(function (state) {
	                                            return state.user;
	                                        });
	
	                                    case 2:
	                                        user = _context6.sent;
	
	                                        if (!user.member_uuid) {
	                                            _context6.next = 31;
	                                            break;
	                                        }
	
	                                        _context6.prev = 4;
	                                        _context6.next = 7;
	                                        return (0, _effects.call)(function () {
	                                            return new Promise(function (resolve, reject) {
	                                                return cordial.identify(user.member_uuid, {
	                                                    knownContactCallback: resolve,
	                                                    unknownContactCallback: function unknownContactCallback() {
	                                                        return reject(new Error('identifyUserFailure'));
	                                                    }
	                                                });
	                                            });
	                                        });
	
	                                    case 7:
	                                        _context6.next = 20;
	                                        break;
	
	                                    case 9:
	                                        _context6.prev = 9;
	                                        _context6.t0 = _context6['catch'](4);
	                                        _context6.prev = 11;
	                                        _context6.next = 14;
	                                        return (0, _effects.call)([cordial, cordial.contact], { m_uuid: user.member_uuid }, { upsert: true });
	
	                                    case 14:
	                                        _context6.next = 20;
	                                        break;
	
	                                    case 16:
	                                        _context6.prev = 16;
	                                        _context6.t1 = _context6['catch'](11);
	                                        _context6.next = 20;
	                                        return (0, _effects.put)({ type: 'raven:error', payload: { error: _context6.t1, message: 'cordial.contact' } });
	
	                                    case 20:
	                                        _context6.prev = 20;
	                                        _context6.next = 23;
	                                        return (0, _effects.call)(sendSavedBrowseEvents);
	
	                                    case 23:
	                                        _context6.next = 29;
	                                        break;
	
	                                    case 25:
	                                        _context6.prev = 25;
	                                        _context6.t2 = _context6['catch'](20);
	                                        _context6.next = 29;
	                                        return (0, _effects.put)({ type: 'raven:error', payload: { error: _context6.t2, message: 'sendSavedBrowseEvents' } });
	
	                                    case 29:
	                                        _context6.next = 40;
	                                        break;
	
	                                    case 31:
	                                        _context6.prev = 31;
	                                        _context6.next = 34;
	                                        return (0, _effects.call)([cordial, cordial.forget]);
	
	                                    case 34:
	                                        _context6.next = 40;
	                                        break;
	
	                                    case 36:
	                                        _context6.prev = 36;
	                                        _context6.t3 = _context6['catch'](31);
	                                        _context6.next = 40;
	                                        return (0, _effects.put)({ type: 'raven:error', payload: { error: _context6.t3, message: 'cordial.forget' } });
	
	                                    case 40:
	                                        _context6.next = 42;
	                                        return (0, _effects.take)(['user:logged-in', 'user:logged-out']);
	
	                                    case 42:
	                                    case 'end':
	                                        return _context6.stop();
	                                }
	                            }
	                        }, _loop, _this, [[4, 9], [11, 16], [20, 25], [31, 36]]);
	                    });
	
	                case 1:
	                    if (false) {
	                        _context7.next = 5;
	                        break;
	                    }
	
	                    return _context7.delegateYield(_loop(), 't0', 3);
	
	                case 3:
	                    _context7.next = 1;
	                    break;
	
	                case 5:
	                case 'end':
	                    return _context7.stop();
	            }
	        }
	    }, _marked[5], this);
	}
	
	function watchBrowseEvents() {
	    var _ref3, _ref4, event, cordial_cid;
	
	    return regeneratorRuntime.wrap(function watchBrowseEvents$(_context8) {
	        while (1) {
	            switch (_context8.prev = _context8.next) {
	                case 0:
	                    if (false) {
	                        _context8.next = 18;
	                        break;
	                    }
	
	                    _context8.next = 3;
	                    return [(0, _effects.call)(getBrowseEvent), (0, _effects.call)([CordialTrack, CordialTrack.getCordialCookies], 'cID')];
	
	                case 3:
	                    _ref3 = _context8.sent;
	                    _ref4 = _slicedToArray(_ref3, 2);
	                    event = _ref4[0];
	                    cordial_cid = _ref4[1];
	
	                    if (!cordial_cid) {
	                        _context8.next = 12;
	                        break;
	                    }
	
	                    _context8.next = 10;
	                    return (0, _effects.call)(sendBrowseEvent, event);
	
	                case 10:
	                    _context8.next = 14;
	                    break;
	
	                case 12:
	                    _context8.next = 14;
	                    return (0, _effects.call)(saveBrowseEvent, event);
	
	                case 14:
	                    _context8.next = 16;
	                    return (0, _effects.take)('product:teeup');
	
	                case 16:
	                    _context8.next = 0;
	                    break;
	
	                case 18:
	                case 'end':
	                    return _context8.stop();
	            }
	        }
	    }, _marked[6], this);
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context9) {
	        while (1) {
	            switch (_context9.prev = _context9.next) {
	                case 0:
	                    _context9.next = 2;
	                    return (0, _effects.take)('product:teeup');
	
	                case 2:
	                    _context9.next = 4;
	                    return (0, _effects.call)(setupCordial);
	
	                case 4:
	                    _context9.next = 6;
	                    return (0, _effects.call)([CordialTrack, CordialTrack.setCordialCookies], 'cID', '', { expires: 0 });
	
	                case 6:
	                    _context9.next = 8;
	                    return (0, _effects.all)([(0, _effects.fork)(watchUser), (0, _effects.fork)(watchBrowseEvents)]);
	
	                case 8:
	                case 'end':
	                    return _context9.stop();
	            }
	        }
	    }, _marked[7], this);
	}

/***/ },

/***/ "./app/sagas/cosmic-profile.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.init = init;
	exports.root = root;
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _marked = [init, root].map(regeneratorRuntime.mark);
	
	function init() {
	    return regeneratorRuntime.wrap(function init$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.put)({ type: 'product:teeup' });
	
	                case 2:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    return _context2.delegateYield([(0, _reduxSaga.takeEvery)('cosmic-profile:init', init)], 't0', 1);
	
	                case 1:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}

/***/ },

/***/ "./app/sagas/daily-updates.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchUpdates = fetchUpdates;
	exports.root = root;
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [fetchUpdates, root].map(regeneratorRuntime.mark);
	
	function fetchUpdates(date) {
	    var birth_date, url, response;
	    return regeneratorRuntime.wrap(function fetchUpdates$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.user.birth_date;
	                    });
	
	                case 2:
	                    birth_date = _context.sent;
	                    url = '/api/user/dailyupdates';
	                    response = void 0;
	                    _context.prev = 5;
	                    _context.next = 8;
	                    return (0, _effects.call)(_util.getJSON, url,
	                    // date == Y-M-D format
	                    { date: date, birthdate: birth_date || undefined }, { cache: false });
	
	                case 8:
	                    response = _context.sent;
	                    _context.next = 16;
	                    break;
	
	                case 11:
	                    _context.prev = 11;
	                    _context.t0 = _context['catch'](5);
	                    _context.next = 15;
	                    return (0, _effects.put)({ type: 'daily-updates:update' });
	
	                case 15:
	                    return _context.abrupt('return');
	
	                case 16:
	                    _context.next = 18;
	                    return (0, _effects.put)({ type: 'daily-updates:update', payload: response.data });
	
	                case 18:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this, [[5, 11]]);
	}
	
	function root() {
	    var action, date;
	    return regeneratorRuntime.wrap(function root$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _effects.take)('daily-updates:required');
	
	                case 2:
	                    action = _context2.sent;
	                    date = action.payload || (0, _moment2.default)().format('YYYY-MM-DD');
	                    _context2.next = 6;
	                    return (0, _effects.call)(fetchUpdates, date);
	
	                case 6:
	                    if (false) {
	                        _context2.next = 13;
	                        break;
	                    }
	
	                    _context2.next = 9;
	                    return (0, _effects.take)(['user:logged-in', 'user:logged-out']);
	
	                case 9:
	                    _context2.next = 11;
	                    return (0, _effects.fork)(fetchUpdates, date);
	
	                case 11:
	                    _context2.next = 6;
	                    break;
	
	                case 13:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}

/***/ },

/***/ "./app/sagas/deck.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.root = root;
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _marked = [fetchDeck, root].map(regeneratorRuntime.mark);
	
	function fetchDeck(_ref) {
	    var code = _ref.payload;
	    var current, deck;
	    return regeneratorRuntime.wrap(function fetchDeck$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.deck && state.deck.code;
	                    });
	
	                case 2:
	                    current = _context.sent;
	
	                    if (!(code === current)) {
	                        _context.next = 5;
	                        break;
	                    }
	
	                    return _context.abrupt('return');
	
	                case 5:
	                    _context.next = 7;
	                    return (0, _effects.call)(_util.getJSON, '/api/content/deck/' + code);
	
	                case 7:
	                    deck = _context.sent;
	                    _context.next = 10;
	                    return (0, _effects.put)({
	                        type: 'deck:update',
	                        payload: deck
	                    });
	
	                case 10:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _reduxSaga.takeLatest)('deck:required', fetchDeck);
	
	                case 2:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}

/***/ },

/***/ "./app/sagas/forecast.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.init = init;
	exports.submit = submit;
	exports.root = root;
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _marked = [init, submit, root].map(regeneratorRuntime.mark);
	
	function init(upc) {
	    var _ref, _ref2, api, params, _ref3, _ref4, teeup, price;
	
	    return regeneratorRuntime.wrap(function init$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.all)([(0, _effects.select)(function (state) {
	                        return state.api.host;
	                    }), (0, _effects.select)(function (state) {
	                        return state.api.params;
	                    })]);
	
	                case 2:
	                    _ref = _context.sent;
	                    _ref2 = _slicedToArray(_ref, 2);
	                    api = _ref2[0];
	                    params = _ref2[1];
	                    _context.next = 8;
	                    return [(0, _effects.call)(_util.getJSON, '/api/product/description/' + upc + '/teeup'), (0, _effects.call)(_util.getJSON, api + '/commerce/price/' + upc, params)];
	
	                case 8:
	                    _ref3 = _context.sent;
	                    _ref4 = _slicedToArray(_ref3, 2);
	                    teeup = _ref4[0];
	                    price = _ref4[1];
	                    _context.next = 14;
	                    return [(0, _effects.put)({ type: 'product:teeup', payload: teeup }), (0, _effects.put)({ type: 'product:price', payload: price }), (0, _effects.put)({ type: 'product:type', payload: 'Report' })];
	
	                case 14:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function submit(action) {
	    var payload, _ref5, _ref6, upc, user, birthDate, forecastDate, inputs, order;
	
	    return regeneratorRuntime.wrap(function submit$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    payload = action.payload;
	                    _context2.next = 3;
	                    return [(0, _effects.select)(function (state) {
	                        return state.product.teeup.code;
	                    }), (0, _effects.select)(function (state) {
	                        return state.user;
	                    })];
	
	                case 3:
	                    _ref5 = _context2.sent;
	                    _ref6 = _slicedToArray(_ref5, 2);
	                    upc = _ref6[0];
	                    user = _ref6[1];
	
	                    if (user.logged_in) {
	                        _context2.next = 10;
	                        break;
	                    }
	
	                    _context2.next = 10;
	                    return [(0, _effects.put)({
	                        type: 'route:to',
	                        payload: 'login'
	                    }), (0, _effects.take)('user:logged-in')];
	
	                case 10:
	                    _context2.next = 12;
	                    return (0, _effects.put)({ type: 'product:submitting', payload: true });
	
	                case 12:
	                    birthDate = void 0, forecastDate = void 0;
	                    // handle select fields
	
	                    if (!/^\d{4}[-]\d{2}[-]\d{2}$/.test(payload[3].value)) {
	                        birthDate = payload[5].value + '-' + payload[3].value + '-' + payload[4].value;
	                        forecastDate = payload[7].value + '-' + payload[6].value + '-01';
	                    } else {
	                        birthDate = payload[3].value;
	                        forecastDate = payload[4].value + '-01';
	                    }
	
	                    inputs = {
	                        birth_name: payload[0].value,
	                        name: payload[1].value,
	                        gender: payload[2].value,
	                        birth_date: birthDate,
	                        forecast_date: forecastDate
	                    };
	                    _context2.prev = 15;
	                    _context2.next = 18;
	                    return (0, _effects.call)(_util.postJSON, '/api/product/submit/' + upc, JSON.stringify(inputs));
	
	                case 18:
	                    order = _context2.sent;
	                    _context2.next = 21;
	                    return (0, _effects.put)({ type: 'location:href', payload: order.forwarding_url });
	
	                case 21:
	                    _context2.next = 27;
	                    break;
	
	                case 23:
	                    _context2.prev = 23;
	                    _context2.t0 = _context2['catch'](15);
	                    _context2.next = 27;
	                    return [(0, _effects.put)({ type: 'product:error', payload: 'sorry, an error occurred' }), (0, _effects.put)({ type: 'product:submitting', payload: false })];
	
	                case 27:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this, [[15, 23]]);
	}
	
	function root() {
	    var _ref7, upc;
	
	    return regeneratorRuntime.wrap(function root$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    _context3.next = 2;
	                    return (0, _effects.take)('forecast:init');
	
	                case 2:
	                    _ref7 = _context3.sent;
	                    upc = _ref7.payload;
	                    _context3.next = 6;
	                    return (0, _effects.call)(init, upc);
	
	                case 6:
	                    return _context3.delegateYield((0, _reduxSaga.takeEvery)('product:submit', submit), 't0', 7);
	
	                case 7:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _marked[2], this);
	}

/***/ },

/***/ "./app/sagas/ga.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.root = root;
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _marked = [root].map(regeneratorRuntime.mark);
	
	function root() {
	    var action;
	    return regeneratorRuntime.wrap(function root$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    if (false) {
	                        _context.next = 8;
	                        break;
	                    }
	
	                    _context.next = 3;
	                    return (0, _effects.take)('ga:event');
	
	                case 3:
	                    action = _context.sent;
	                    _context.next = 6;
	                    return (0, _effects.apply)(window, window.ga, ['send', 'event'].concat(action.payload));
	
	                case 6:
	                    _context.next = 0;
	                    break;
	
	                case 8:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}

/***/ },

/***/ "./app/sagas/hexagram.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetch = fetch;
	exports.root = root;
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [fetch, root].map(regeneratorRuntime.mark);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function fetch(date, user) {
	    var url, response, payload;
	    return regeneratorRuntime.wrap(function fetch$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    url = '/api/of-the-day/hexagram';
	                    response = void 0;
	                    _context.prev = 2;
	                    _context.next = 5;
	                    return (0, _effects.call)(_util.getJSON, url,
	                    // date == Y-M-D format
	                    { date: date, birthdate: user.birth_date || undefined }, { cache: false });
	
	                case 5:
	                    response = _context.sent;
	                    _context.next = 11;
	                    break;
	
	                case 8:
	                    _context.prev = 8;
	                    _context.t0 = _context['catch'](2);
	                    return _context.abrupt('return');
	
	                case 11:
	                    payload = _defineProperty({}, user.logged_in ? 'you' : 'everyone', response.data);
	                    _context.next = 14;
	                    return (0, _effects.put)({ type: 'hexagram:update', payload: payload });
	
	                case 14:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this, [[2, 8]]);
	}
	
	function root() {
	    var action, date, user, _action;
	
	    return regeneratorRuntime.wrap(function root$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _effects.take)('hexagram:required');
	
	                case 2:
	                    action = _context2.sent;
	                    date = action.payload || (0, _moment2.default)().format('YYYY-MM-DD');
	                    _context2.next = 6;
	                    return (0, _effects.select)(function (state) {
	                        return state.user;
	                    });
	
	                case 6:
	                    user = _context2.sent;
	                    _context2.next = 9;
	                    return (0, _effects.fork)(fetch, date, user);
	
	                case 9:
	                    if (!user) {
	                        _context2.next = 12;
	                        break;
	                    }
	
	                    _context2.next = 12;
	                    return (0, _effects.fork)(fetch, date, { logged_in: false });
	
	                case 12:
	                    if (false) {
	                        _context2.next = 20;
	                        break;
	                    }
	
	                    _context2.next = 15;
	                    return (0, _effects.take)('user:logged-in');
	
	                case 15:
	                    _action = _context2.sent;
	                    _context2.next = 18;
	                    return (0, _effects.fork)(fetch, date, _action.payload);
	
	                case 18:
	                    _context2.next = 12;
	                    break;
	
	                case 20:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}

/***/ },

/***/ "./app/sagas/horoscope.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetch = fetch;
	exports.root = root;
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _marked = [fetch, root].map(regeneratorRuntime.mark);
	
	function fetch(_ref) {
	    var payload = _ref.payload;
	    var response, url, user, signs;
	    return regeneratorRuntime.wrap(function fetch$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    response = void 0;
	                    url = '/api/daily-horoscope';
	                    _context.next = 4;
	                    return (0, _effects.select)(function (state) {
	                        return state.user;
	                    });
	
	                case 4:
	                    user = _context.sent;
	                    _context.next = 7;
	                    return (0, _effects.select)(function (state) {
	                        return state.zodiac && state.zodiac.signs;
	                    });
	
	                case 7:
	                    signs = _context.sent;
	
	
	                    if (user.logged_in && !payload.sign) {
	                        payload.sign = signs[user.default_sign - 1].name;
	                    }
	
	                    _context.prev = 9;
	                    _context.next = 12;
	                    return (0, _effects.call)(_util.getJSON, url, payload);
	
	                case 12:
	                    response = _context.sent;
	                    _context.next = 18;
	                    break;
	
	                case 15:
	                    _context.prev = 15;
	                    _context.t0 = _context['catch'](9);
	                    return _context.abrupt('return');
	
	                case 18:
	                    _context.next = 20;
	                    return (0, _effects.put)({ type: 'horoscope:update', payload: response });
	
	                case 20:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this, [[9, 15]]);
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _reduxSaga.takeEvery)('horoscope:require', fetch);
	
	                case 2:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}

/***/ },

/***/ "./app/sagas/i-ching-reading.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.init = init;
	exports.submit = submit;
	exports.root = root;
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _marked = [init, submit, root].map(regeneratorRuntime.mark);
	
	var submitting = false; // TODO: Why doesn't 'state.product.submitting' work?
	
	function init(_ref) {
	    var payload = _ref.payload;
	    return regeneratorRuntime.wrap(function init$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.all)([(0, _effects.put)({ type: 'price:required', payload: payload.upc }), (0, _effects.put)({ type: 'product:teeup' })]);
	
	                case 2:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function submit(_ref2) {
	    var payload = _ref2.payload;
	    var user, submitting_prod, upc, order;
	    return regeneratorRuntime.wrap(function submit$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.user;
	                    });
	
	                case 2:
	                    user = _context2.sent;
	                    _context2.next = 5;
	                    return (0, _effects.select)(function (state) {
	                        return state.product.submitting;
	                    });
	
	                case 5:
	                    submitting_prod = _context2.sent;
	
	                    if (user.logged_in) {
	                        _context2.next = 9;
	                        break;
	                    }
	
	                    _context2.next = 9;
	                    return (0, _effects.all)([(0, _effects.put)({ type: 'route:to', payload: 'login' }), (0, _effects.take)('user:logged-in')]);
	
	                case 9:
	                    if (!(submitting_prod || submitting)) {
	                        _context2.next = 11;
	                        break;
	                    }
	
	                    return _context2.abrupt('return');
	
	                case 11:
	
	                    submitting = true;
	
	                    _context2.next = 14;
	                    return (0, _effects.put)({ type: 'product:submitting', payload: true });
	
	                case 14:
	                    _context2.next = 16;
	                    return (0, _effects.select)(function (state) {
	                        return state.product.description.code;
	                    });
	
	                case 16:
	                    upc = _context2.sent;
	                    _context2.prev = 17;
	                    _context2.next = 20;
	                    return (0, _effects.call)(_util.postJSON, '/api/product/submit/' + upc, JSON.stringify(payload));
	
	                case 20:
	                    order = _context2.sent;
	                    _context2.next = 23;
	                    return (0, _effects.put)({ type: 'location:href', payload: order.forwarding_url });
	
	                case 23:
	                    _context2.next = 29;
	                    break;
	
	                case 25:
	                    _context2.prev = 25;
	                    _context2.t0 = _context2['catch'](17);
	                    _context2.next = 29;
	                    return (0, _effects.put)({ type: 'tarot-reading:loaded', error: _context2.t0 });
	
	                case 29:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this, [[17, 25]]);
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    return _context3.delegateYield([(0, _reduxSaga.takeEvery)('i-ching-reading:init', init), (0, _reduxSaga.takeEvery)('i-ching-reading:submit', submit)], 't0', 1);
	
	                case 1:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _marked[2], this);
	}

/***/ },

/***/ "./app/sagas/karmacoin-store.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.purchaseCoins = purchaseCoins;
	exports.getKarmaCoinPackages = getKarmaCoinPackages;
	exports.root = root;
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _marked = [purchaseCoins, getKarmaCoinPackages, root].map(regeneratorRuntime.mark);
	
	function purchaseCoins() {
	    var user, upc, response;
	    return regeneratorRuntime.wrap(function purchaseCoins$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.user;
	                    });
	
	                case 2:
	                    user = _context.sent;
	                    _context.next = 5;
	                    return (0, _effects.select)(function (state) {
	                        return state['karmacoin-store'].upc;
	                    });
	
	                case 5:
	                    upc = _context.sent;
	                    _context.next = 8;
	                    return (0, _effects.put)({
	                        type: 'product:type',
	                        payload: 'Karma Coins'
	                    });
	
	                case 8:
	                    if (user.logged_in) {
	                        _context.next = 11;
	                        break;
	                    }
	
	                    _context.next = 11;
	                    return [(0, _effects.put)({
	                        type: 'route:to',
	                        payload: 'login'
	                    }), (0, _effects.take)('user:logged-in')];
	
	                case 11:
	                    _context.next = 13;
	                    return (0, _effects.put)({
	                        type: 'product:submitting',
	                        payload: true
	                    });
	
	                case 13:
	                    _context.prev = 13;
	                    _context.next = 16;
	                    return (0, _effects.call)(_util.postJSON, '/api/product/submit/' + upc);
	
	                case 16:
	                    response = _context.sent;
	                    _context.next = 19;
	                    return (0, _effects.put)({
	                        type: 'location:href',
	                        payload: response.forwarding_url
	                    });
	
	                case 19:
	                    _context.next = 25;
	                    break;
	
	                case 21:
	                    _context.prev = 21;
	                    _context.t0 = _context['catch'](13);
	                    _context.next = 25;
	                    return [(0, _effects.put)({
	                        type: 'product:error',
	                        payload: _context.t0
	                    }), (0, _effects.put)({
	                        type: 'product:submitting',
	                        payload: false
	                    })];
	
	                case 25:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this, [[13, 21]]);
	}
	
	function getKarmaCoinPackages() {
	    var packages;
	    return regeneratorRuntime.wrap(function getKarmaCoinPackages$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _effects.call)(_util.getJSON, '/api/product/karmacoin-packages');
	
	                case 2:
	                    packages = _context2.sent;
	                    _context2.next = 5;
	                    return (0, _effects.put)({
	                        type: 'karmacoin-store:packages',
	                        payload: packages
	                    });
	
	                case 5:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}
	
	function root() {
	    var should_run;
	    return regeneratorRuntime.wrap(function root$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    _context3.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state['karmacoin-store'] && state['karmacoin-store'].upc;
	                    });
	
	                case 2:
	                    should_run = _context3.sent;
	
	                    if (should_run) {
	                        _context3.next = 5;
	                        break;
	                    }
	
	                    return _context3.abrupt('return');
	
	                case 5:
	                    _context3.next = 7;
	                    return (0, _effects.call)(getKarmaCoinPackages);
	
	                case 7:
	                    return _context3.delegateYield([(0, _reduxSaga.takeEvery)(['user:logged-in', 'user:logged-out'], getKarmaCoinPackages), (0, _reduxSaga.takeEvery)('karmacoin-store:purchase', purchaseCoins)], 't0', 8);
	
	                case 8:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _marked[2], this);
	}

/***/ },

/***/ "./app/sagas/location.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.root = root;
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _marked = [watchHref, root].map(regeneratorRuntime.mark); // this saga enables assertions against other sagas
	
	
	function watchHref() {
	    var _ref, href;
	
	    return regeneratorRuntime.wrap(function watchHref$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.take)('location:href');
	
	                case 2:
	                    _ref = _context.sent;
	                    href = _ref.payload;
	
	                    window.location.href = href;
	
	                case 5:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _effects.fork)(watchHref);
	
	                case 2:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}

/***/ },

/***/ "./app/sagas/member/email-preferences.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getLists = getLists;
	exports.saveLists = saveLists;
	exports.root = root;
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _marked = [getLists, saveLists, updateList, root].map(regeneratorRuntime.mark);
	
	var api = void 0;
	var user = void 0;
	
	function getLists() {
	    var lists, subscribed, filtered_lists;
	    return regeneratorRuntime.wrap(function getLists$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.call)(_util.getJSON, api + '/mail/email_list');
	
	                case 2:
	                    lists = _context.sent;
	                    _context.next = 5;
	                    return (0, _effects.call)(_util.getJSON, api + '/mail/subscription/' + user.member_uuid);
	
	                case 5:
	                    subscribed = _context.sent;
	                    filtered_lists = lists.filter(function (list) {
	                        if (list.preferences) {
	                            list.intent = false;
	                            list.subscribed = subscribed.some(function (slist) {
	                                return slist.email_list == list.code && slist.subscribed;
	                            });
	
	                            return list;
	                        }
	
	                        return null;
	                    });
	                    _context.next = 9;
	                    return (0, _effects.put)({
	                        type: 'mail-lists:update',
	                        payload: filtered_lists
	                    });
	
	                case 9:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function saveLists() {
	    var lists;
	    return regeneratorRuntime.wrap(function saveLists$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _effects.all)([(0, _effects.put)({
	                        type: 'product:submitting',
	                        payload: true
	                    }), (0, _effects.put)({
	                        type: 'mail-lists:error',
	                        payload: null
	                    })]);
	
	                case 2:
	                    _context2.next = 4;
	                    return (0, _effects.select)(function (state) {
	                        return state['mail-lists'].lists;
	                    });
	
	                case 4:
	                    lists = _context2.sent;
	                    _context2.prev = 5;
	                    _context2.next = 8;
	                    return (0, _effects.all)(lists.map(function (list) {
	                        return (0, _effects.call)(updateList, list, document.location.href);
	                    }));
	
	                case 8:
	                    _context2.next = 15;
	                    break;
	
	                case 10:
	                    _context2.prev = 10;
	                    _context2.t0 = _context2['catch'](5);
	                    _context2.next = 14;
	                    return (0, _effects.all)([(0, _effects.put)({
	                        type: 'mail-lists:error',
	                        payload: _context2.t0
	                    }), (0, _effects.put)({
	                        type: 'product:submitting',
	                        payload: false
	                    })]);
	
	                case 14:
	                    return _context2.abrupt('return');
	
	                case 15:
	                    _context2.next = 17;
	                    return (0, _effects.all)([(0, _effects.put)({
	                        type: 'mail-lists:update',
	                        payload: lists
	                    }), (0, _effects.put)({
	                        type: 'product:submitting',
	                        payload: false
	                    })]);
	
	                case 17:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this, [[5, 10]]);
	}
	
	function updateList(list, location) {
	    var url;
	    return regeneratorRuntime.wrap(function updateList$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    url = api + '/mail/subscription/' + user.member_uuid + '/' + list.code;
	
	                    if (!(list.subscribed && list.intent)) {
	                        _context3.next = 7;
	                        break;
	                    }
	
	                    _context3.next = 4;
	                    return (0, _effects.call)(_util.deleteJSON, url, { reason: 'prefs', location: location });
	
	                case 4:
	                    list.subscribed = false;
	                    _context3.next = 11;
	                    break;
	
	                case 7:
	                    if (!list.intent) {
	                        _context3.next = 11;
	                        break;
	                    }
	
	                    _context3.next = 10;
	                    return (0, _effects.call)(_util.putJSON, url, { reason: 'prefs', location: location });
	
	                case 10:
	                    list.subscribed = true;
	
	                case 11:
	
	                    list.intent = false;
	
	                    return _context3.abrupt('return', list);
	
	                case 13:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _marked[2], this);
	}
	
	function root() {
	    var should_run;
	    return regeneratorRuntime.wrap(function root$(_context4) {
	        while (1) {
	            switch (_context4.prev = _context4.next) {
	                case 0:
	                    _context4.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state['mail-lists'];
	                    });
	
	                case 2:
	                    should_run = _context4.sent;
	
	                    if (should_run) {
	                        _context4.next = 5;
	                        break;
	                    }
	
	                    return _context4.abrupt('return');
	
	                case 5:
	                    _context4.next = 7;
	                    return (0, _effects.select)(function (state) {
	                        return state.api.host;
	                    });
	
	                case 7:
	                    api = _context4.sent;
	                    _context4.next = 10;
	                    return (0, _effects.select)(function (state) {
	                        return state.user;
	                    });
	
	                case 10:
	                    user = _context4.sent;
	                    _context4.next = 13;
	                    return (0, _effects.call)(getLists);
	
	                case 13:
	                    return _context4.delegateYield((0, _reduxSaga.takeEvery)('mail-lists:save', saveLists), 't0', 14);
	
	                case 14:
	                case 'end':
	                    return _context4.stop();
	            }
	        }
	    }, _marked[3], this);
	}

/***/ },

/***/ "./app/sagas/member/email-unsub.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.saveCurrentLists = saveCurrentLists;
	exports.handleChange = handleChange;
	exports.updateList = updateList;
	exports.root = root;
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _marked = [saveCurrentLists, handleChange, updateList, root].map(regeneratorRuntime.mark);
	
	function saveCurrentLists() {
	    var api, member_uuid, all_lists, subscribed_lists;
	    return regeneratorRuntime.wrap(function saveCurrentLists$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.api.host;
	                    });
	
	                case 2:
	                    api = _context.sent;
	                    _context.next = 5;
	                    return (0, _effects.select)(function (state) {
	                        return state.user.member_uuid;
	                    });
	
	                case 5:
	                    member_uuid = _context.sent;
	                    _context.next = 8;
	                    return (0, _effects.call)(_util.getJSON, api + '/mail/subscription/' + member_uuid);
	
	                case 8:
	                    all_lists = _context.sent;
	                    subscribed_lists = all_lists.filter(function (list) {
	                        return list.subscribed === true;
	                    });
	                    _context.next = 12;
	                    return (0, _effects.put)({
	                        type: 'email-unsub:subscribed',
	                        payload: subscribed_lists
	                    });
	
	                case 12:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function handleChange() {
	    var code, route, old_lists;
	    return regeneratorRuntime.wrap(function handleChange$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state['email-unsub'].code;
	                    });
	
	                case 2:
	                    code = _context2.sent;
	                    _context2.next = 5;
	                    return (0, _effects.select)(function (state) {
	                        return state.route;
	                    });
	
	                case 5:
	                    route = _context2.sent;
	
	                    if (!(route == 'opt-out')) {
	                        _context2.next = 11;
	                        break;
	                    }
	
	                    _context2.next = 9;
	                    return (0, _effects.call)(updateList, code, false);
	
	                case 9:
	                    _context2.next = 22;
	                    break;
	
	                case 11:
	                    if (!(route == 'opt-in')) {
	                        _context2.next = 22;
	                        break;
	                    }
	
	                    if (!(code == 'reengage')) {
	                        _context2.next = 20;
	                        break;
	                    }
	
	                    _context2.next = 15;
	                    return (0, _effects.select)(function (state) {
	                        return state['email-unsub'].subscribed;
	                    });
	
	                case 15:
	                    old_lists = _context2.sent;
	                    _context2.next = 18;
	                    return (0, _effects.all)(old_lists.map(function (list) {
	                        return (0, _effects.call)(updateList, list.email_list, true);
	                    }));
	
	                case 18:
	                    _context2.next = 22;
	                    break;
	
	                case 20:
	                    _context2.next = 22;
	                    return (0, _effects.call)(updateList, code, true);
	
	                case 22:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}
	
	function updateList(code, subscribe) {
	    var api, member_uuid, url;
	    return regeneratorRuntime.wrap(function updateList$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    _context3.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.api.host;
	                    });
	
	                case 2:
	                    api = _context3.sent;
	                    _context3.next = 5;
	                    return (0, _effects.select)(function (state) {
	                        return state.user.member_uuid;
	                    });
	
	                case 5:
	                    member_uuid = _context3.sent;
	                    url = api + '/mail/subscription/' + member_uuid + '/' + code;
	
	                    if (!subscribe) {
	                        _context3.next = 12;
	                        break;
	                    }
	
	                    _context3.next = 10;
	                    return (0, _effects.call)(_util.putJSON, url, {
	                        reason: 'email',
	                        location: document.location.href
	                    });
	
	                case 10:
	                    _context3.next = 14;
	                    break;
	
	                case 12:
	                    _context3.next = 14;
	                    return (0, _effects.call)(_util.deleteJSON, url, {
	                        reason: 'email',
	                        location: document.location.href
	                    });
	
	                case 14:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _marked[2], this);
	}
	
	function root() {
	    var should_run, code;
	    return regeneratorRuntime.wrap(function root$(_context4) {
	        while (1) {
	            switch (_context4.prev = _context4.next) {
	                case 0:
	                    _context4.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state['email-unsub'];
	                    });
	
	                case 2:
	                    should_run = _context4.sent;
	
	                    if (should_run) {
	                        _context4.next = 5;
	                        break;
	                    }
	
	                    return _context4.abrupt('return');
	
	                case 5:
	                    _context4.next = 7;
	                    return (0, _effects.select)(function (state) {
	                        return state.route;
	                    });
	
	                case 7:
	                    if (!_context4.sent) {
	                        _context4.next = 10;
	                        break;
	                    }
	
	                    _context4.next = 10;
	                    return (0, _effects.put)({
	                        type: 'route:to',
	                        payload: ''
	                    });
	
	                case 10:
	                    _context4.next = 12;
	                    return (0, _effects.select)(function (state) {
	                        return state['email-unsub'].code;
	                    });
	
	                case 12:
	                    code = _context4.sent;
	
	                    if (!(code == 'reengage')) {
	                        _context4.next = 16;
	                        break;
	                    }
	
	                    _context4.next = 16;
	                    return (0, _effects.call)(saveCurrentLists);
	
	                case 16:
	                    return _context4.delegateYield((0, _reduxSaga.takeEvery)('route:hashchanged', handleChange), 't0', 17);
	
	                case 17:
	                case 'end':
	                    return _context4.stop();
	            }
	        }
	    }, _marked[3], this);
	}

/***/ },

/***/ "./app/sagas/member/privacy-policy-consent.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.consent = consent;
	exports.root = root;
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _marked = [consent, root].map(regeneratorRuntime.mark);
	
	function consent() {
	    var _ref, host, params, _ref2, logged_in, member_uuid, url;
	
	    return regeneratorRuntime.wrap(function consent$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.api;
	                    });
	
	                case 2:
	                    _ref = _context.sent;
	                    host = _ref.host;
	                    params = _ref.params;
	                    _context.next = 7;
	                    return (0, _effects.select)(function (state) {
	                        return state.user;
	                    });
	
	                case 7:
	                    _ref2 = _context.sent;
	                    logged_in = _ref2.logged_in;
	                    member_uuid = _ref2.member_uuid;
	
	                    if (!(logged_in && member_uuid)) {
	                        _context.next = 14;
	                        break;
	                    }
	
	                    url = host + '/member/member/' + member_uuid + '/privacy_policy';
	                    _context.next = 14;
	                    return (0, _effects.call)(_util.postJSON, url, {
	                        partner: params.partner,
	                        key: params.key
	                    });
	
	                case 14:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    return _context2.delegateYield((0, _reduxSaga.takeEvery)('member:privacy-policy-consent', consent), 't0', 1);
	
	                case 1:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}

/***/ },

/***/ "./app/sagas/moon-phase.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.init = init;
	exports.root = root;
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _marked = [init, root].map(regeneratorRuntime.mark);
	
	function init() {
	    var phase;
	    return regeneratorRuntime.wrap(function init$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.call)(_util.getJSON, '/api/moon-phase/current');
	
	                case 2:
	                    phase = _context.sent;
	                    _context.next = 5;
	                    return (0, _effects.put)({
	                        type: 'moon-phase:set',
	                        payload: phase
	                    });
	
	                case 5:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _reduxSaga.takeLatest)('moon-phase:init', init);
	
	                case 2:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}

/***/ },

/***/ "./app/sagas/number.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetch = fetch;
	exports.watchLogins = watchLogins;
	exports.watchLogouts = watchLogouts;
	exports.root = root;
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [fetch, watchLogins, watchLogouts, root].map(regeneratorRuntime.mark);
	
	function fetch(date, user) {
	    var url, response;
	    return regeneratorRuntime.wrap(function fetch$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    url = '/api/daily-number';
	                    response = void 0;
	                    _context.prev = 2;
	                    _context.next = 5;
	                    return (0, _effects.call)(_util.getJSON, url, { today: date, birth_date: user.birth_date || undefined }, { cache: false });
	
	                case 5:
	                    response = _context.sent;
	                    _context.next = 13;
	                    break;
	
	                case 8:
	                    _context.prev = 8;
	                    _context.t0 = _context['catch'](2);
	                    _context.next = 12;
	                    return (0, _effects.put)({ type: 'number:update' });
	
	                case 12:
	                    return _context.abrupt('return');
	
	                case 13:
	                    _context.next = 15;
	                    return (0, _effects.put)({ type: 'number:update', payload: response });
	
	                case 15:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this, [[2, 8]]);
	}
	
	function watchLogins(date) {
	    var user, action;
	    return regeneratorRuntime.wrap(function watchLogins$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.user;
	                    });
	
	                case 2:
	                    user = _context2.sent;
	
	                    if (!user.logged_in) {
	                        _context2.next = 6;
	                        break;
	                    }
	
	                    _context2.next = 6;
	                    return (0, _effects.fork)(fetch, date, user);
	
	                case 6:
	                    if (false) {
	                        _context2.next = 14;
	                        break;
	                    }
	
	                    _context2.next = 9;
	                    return (0, _effects.take)('user:logged-in');
	
	                case 9:
	                    action = _context2.sent;
	                    _context2.next = 12;
	                    return (0, _effects.fork)(fetch, date, action.payload);
	
	                case 12:
	                    _context2.next = 6;
	                    break;
	
	                case 14:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}
	
	function watchLogouts() {
	    var user;
	    return regeneratorRuntime.wrap(function watchLogouts$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    _context3.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.user;
	                    });
	
	                case 2:
	                    user = _context3.sent;
	
	                    if (user.logged_in) {
	                        _context3.next = 6;
	                        break;
	                    }
	
	                    _context3.next = 6;
	                    return (0, _effects.put)({ type: 'number:update' });
	
	                case 6:
	                    if (false) {
	                        _context3.next = 13;
	                        break;
	                    }
	
	                    _context3.next = 9;
	                    return (0, _effects.take)('user:logged-out');
	
	                case 9:
	                    _context3.next = 11;
	                    return (0, _effects.put)({ type: 'number:update' });
	
	                case 11:
	                    _context3.next = 6;
	                    break;
	
	                case 13:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _marked[2], this);
	}
	
	function root() {
	    var action, date;
	    return regeneratorRuntime.wrap(function root$(_context4) {
	        while (1) {
	            switch (_context4.prev = _context4.next) {
	                case 0:
	                    _context4.next = 2;
	                    return (0, _effects.take)('number:required');
	
	                case 2:
	                    action = _context4.sent;
	                    date = action.payload || (0, _moment2.default)().format('YYYY-MM-DD');
	                    _context4.next = 6;
	                    return (0, _effects.fork)(watchLogins, date);
	
	                case 6:
	                    _context4.next = 8;
	                    return (0, _effects.fork)(watchLogouts);
	
	                case 8:
	                case 'end':
	                    return _context4.stop();
	            }
	        }
	    }, _marked[3], this);
	}

/***/ },

/***/ "./app/sagas/oranum.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getPsychics = getPsychics;
	exports.root = root;
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _marked = [getPsychics, root].map(regeneratorRuntime.mark);
	
	function getPsychics() {
	    var limit, response, opsychics, psychics;
	    return regeneratorRuntime.wrap(function getPsychics$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    limit = /^m[.-]/.test(window.location.hostname) ? 1 : 2;
	                    _context.next = 3;
	                    return (0, _effects.call)(_util.getJSON, '/api/psychics');
	
	                case 3:
	                    response = _context.sent;
	                    opsychics = response && Array.prototype.slice.call(response.querySelectorAll('psychic'), 0, limit);
	                    psychics = opsychics.map(function (psychic) {
	                        return {
	                            likes: psychic.querySelector('likes').textContent,
	                            link: psychic.querySelector('link').textContent,
	                            performerid: psychic.querySelector('performerid').textContent,
	                            thumb: psychic.querySelector('thumb').textContent
	                        };
	                    });
	                    _context.next = 8;
	                    return (0, _effects.put)({
	                        type: 'oranum:update_psychics',
	                        payload: psychics
	                    });
	
	                case 8:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    return _context2.delegateYield([(0, _reduxSaga.takeEvery)('oranum:get-psychics', getPsychics)], 't0', 1);
	
	                case 1:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}

/***/ },

/***/ "./app/sagas/planet-tracker.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.root = root;
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _marked = [init, root].map(regeneratorRuntime.mark);
	
	function init() {
	    var transits;
	    return regeneratorRuntime.wrap(function init$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.call)(_util.getJSON, '/api/product/planet-tracker');
	
	                case 2:
	                    transits = _context.sent;
	                    _context.next = 5;
	                    return (0, _effects.put)({
	                        type: 'planet-tracker:data',
	                        payload: { transits: transits }
	                    });
	
	                case 5:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _reduxSaga.takeLatest)('planet-tracker:init', init);
	
	                case 2:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}

/***/ },

/***/ "./app/sagas/price.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.root = root;
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _marked = [fetchPrice, root].map(regeneratorRuntime.mark);
	
	function fetchPrice(_ref) {
	    var upc = _ref.payload;
	
	    var _ref2, _ref3, api, params, price, vparams, promo;
	
	    return regeneratorRuntime.wrap(function fetchPrice$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.all)([(0, _effects.select)(function (state) {
	                        return state.api.host;
	                    }), (0, _effects.select)(function (state) {
	                        return state.api.params;
	                    })]);
	
	                case 2:
	                    _ref2 = _context.sent;
	                    _ref3 = _slicedToArray(_ref2, 2);
	                    api = _ref3[0];
	                    params = _ref3[1];
	                    _context.next = 8;
	                    return (0, _effects.call)(_util.getJSON, api + '/commerce/price/' + upc, params);
	
	                case 8:
	                    price = _context.sent;
	
	                    if (!(price.usd && price.usd.voucher_upc)) {
	                        _context.next = 18;
	                        break;
	                    }
	
	                    vparams = { partner: params.partner, key: params.key };
	
	                    vparams.upc = price.usd.voucher_upc;
	                    vparams.site = params.partner;
	                    vparams.placement = 'text-teeup-message';
	                    _context.next = 16;
	                    return (0, _effects.call)(_util.getJSON, api + '/rules/voucher-ownership/promo', vparams);
	
	                case 16:
	                    promo = _context.sent;
	
	                    if (promo && promo[0].message) {
	                        price.usd.message = promo[0].message;
	                        price.kc.message = promo[0].message;
	                    }
	
	                case 18:
	                    _context.next = 20;
	                    return (0, _effects.put)({
	                        type: 'product:price',
	                        payload: price
	                    });
	
	                case 20:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _reduxSaga.takeLatest)('price:required', fetchPrice);
	
	                case 2:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}

/***/ },

/***/ "./app/sagas/product-message.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetch = fetch;
	exports.watchPlacement = watchPlacement;
	exports.root = root;
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [fetch, watchPlacement, root].map(regeneratorRuntime.mark);
	
	function fetch(placement, product_result_slug) {
	    var api, data, payload;
	    return regeneratorRuntime.wrap(function fetch$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.api;
	                    });
	
	                case 2:
	                    api = _context.sent;
	                    _context.next = 5;
	                    return (0, _effects.call)(_util.getJSON, api.host + '/rules/voucher-ownership/promo', _extends({}, api.params, {
	                        site: api.params.partner,
	                        placement: placement,
	                        product_result_slug: product_result_slug,
	                        today: (0, _moment2.default)().format('YYYY-MM-DD')
	                    }));
	
	                case 5:
	                    data = _context.sent;
	
	                    if (!(data && data.length)) {
	                        _context.next = 11;
	                        break;
	                    }
	
	                    payload = data[Math.floor(Math.random() * data.length)];
	
	                    payload.placement = placement;
	
	                    _context.next = 11;
	                    return (0, _effects.put)({ type: 'product-message:update', payload: payload });
	
	                case 11:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function watchPlacement(payload) {
	    return regeneratorRuntime.wrap(function watchPlacement$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    if (false) {
	                        _context2.next = 5;
	                        break;
	                    }
	
	                    _context2.next = 3;
	                    return (0, _effects.all)([(0, _effects.call)(fetch, payload.payload.placement, payload.payload.product_result_slug), (0, _effects.take)(['user:logged-in', 'user:logged-out'])]);
	
	                case 3:
	                    _context2.next = 0;
	                    break;
	
	                case 5:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    return _context3.delegateYield((0, _reduxSaga.takeLatest)('product-message:require', watchPlacement), 't0', 1);
	
	                case 1:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _marked[2], this);
	}

/***/ },

/***/ "./app/sagas/promo-message.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.fetch = fetch;
	exports.watchPlacement = watchPlacement;
	exports.root = root;
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [fetch, watchPlacement, root].map(regeneratorRuntime.mark);
	
	var blacklisted_pages = ['/checkout', '/confirm', '/signup'];
	
	function fetch(placement) {
	    var _ref, _ref2, product, user, api, full_placement, data, payload, action;
	
	    return regeneratorRuntime.wrap(function fetch$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return [state.product && state.product.type, state.user, state.api.host];
	                    });
	
	                case 2:
	                    _ref = _context.sent;
	                    _ref2 = _slicedToArray(_ref, 3);
	                    product = _ref2[0];
	                    user = _ref2[1];
	                    api = _ref2[2];
	                    full_placement = product ? placement + '-product' : placement;
	                    _context.next = 10;
	                    return (0, _effects.call)(_util.getJSON, api + '/content/promo-message', {
	                        partner: 'viz',
	                        key: '2fae913ecc625545',
	                        site: /^m[.-]/.test(location.host) ? 'm.tarot.com' : 'www.tarot.com',
	                        placement: full_placement,
	                        today: (0, _moment2.default)().format('YYYY-MM-DD'),
	                        member_uuid: user.member_uuid || undefined
	                    });
	
	                case 10:
	                    data = _context.sent;
	
	                    if (!(data && data.length)) {
	                        _context.next = 17;
	                        break;
	                    }
	
	                    payload = data[Math.floor(Math.random() * data.length)];
	
	                    payload.placement = placement;
	                    action = user.logged_in ? 'LI Impression' : 'LO Impression';
	                    _context.next = 17;
	                    return (0, _effects.all)([(0, _effects.put)({ type: 'promo-message:update', payload: payload }), (0, _effects.put)({
	                        type: 'ga:event',
	                        payload: [placement + ' promo message', action, payload.code]
	                    })]);
	
	                case 17:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function watchPlacement(_ref3) {
	    var placement = _ref3.payload;
	    return regeneratorRuntime.wrap(function watchPlacement$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    if (false) {
	                        _context2.next = 5;
	                        break;
	                    }
	
	                    _context2.next = 3;
	                    return (0, _effects.all)([(0, _effects.call)(fetch, placement), (0, _effects.take)(['user:logged-in', 'user:logged-out'])]);
	
	                case 3:
	                    _context2.next = 0;
	                    break;
	
	                case 5:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    if (!(blacklisted_pages.indexOf(location.pathname) >= 0)) {
	                        _context3.next = 2;
	                        break;
	                    }
	
	                    return _context3.abrupt('return');
	
	                case 2:
	                    return _context3.delegateYield((0, _reduxSaga.takeEvery)('promo-message:require', watchPlacement), 't0', 3);
	
	                case 3:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _marked[2], this);
	}

/***/ },

/***/ "./app/sagas/promo-tracker.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.record = record;
	exports.remove = remove;
	exports.compact = compact;
	exports.recordExternal = recordExternal;
	exports.recordInternal = recordInternal;
	exports.incrementAndExpire = incrementAndExpire;
	exports.setUTM = setUTM;
	exports.root = root;
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [record, remove, recordExternal, recordInternal, incrementAndExpire, setUTM, root].map(regeneratorRuntime.mark);
	
	function record(_ref) {
	    var payload = _ref.payload;
	    return regeneratorRuntime.wrap(function record$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.put)({
	                        type: 'cookie:set',
	                        payload: {
	                            name: 'promo',
	                            value: payload,
	                            opts: { expires: 14 } }
	                    });
	
	                case 2:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function remove() {
	    return regeneratorRuntime.wrap(function remove$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _effects.put)({ type: 'cookie:remove', payload: 'promo' });
	
	                case 2:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}
	
	function compact(parts) {
	    return parts.map(function (part) {
	        return (
	            // ensuring no newlines or other weird spacing
	            part.trim().replace(/\s+/g, ' ')
	        );
	    }).join(':');
	}
	
	// external promos remove internal promos, and are just utm params right now
	function recordExternal(_ref2) {
	    var payload = _ref2.payload;
	    var value;
	    return regeneratorRuntime.wrap(function recordExternal$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    value = compact(payload);
	                    _context3.next = 3;
	                    return (0, _effects.put)({
	                        type: 'promo-tracker:_record',
	                        payload: {
	                            order_promo_external: { value: value, expires: (0, _moment2.default)().add(12, 'hours').format() },
	                            order_promo_internal: undefined,
	                            signup_promo_external: { value: value, expires: 10 },
	                            signup_promo_internal: undefined
	                        }
	                    });
	
	                case 3:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _marked[2], this);
	}
	
	// internal promos preserve external promos, and are things like ga events and promo messages
	function recordInternal(_ref3) {
	    var payload = _ref3.payload;
	    var stored, promo_value;
	    return regeneratorRuntime.wrap(function recordInternal$(_context4) {
	        while (1) {
	            switch (_context4.prev = _context4.next) {
	                case 0:
	                    _context4.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.cookie.promo || {};
	                    });
	
	                case 2:
	                    stored = _context4.sent;
	                    promo_value = compact(payload);
	                    _context4.next = 6;
	                    return (0, _effects.put)({
	                        type: 'promo-tracker:_record',
	                        payload: {
	                            order_promo_external: stored.order_promo_external || undefined,
	                            order_promo_internal: { value: promo_value, expires: 10 },
	                            signup_promo_external: stored.signup_promo_external || undefined,
	                            signup_promo_internal: { value: promo_value, expires: 10 }
	                        }
	                    });
	
	                case 6:
	                case 'end':
	                    return _context4.stop();
	            }
	        }
	    }, _marked[3], this);
	}
	
	// order_promo_external expires after 12 hours
	// signup_promo_external expires after 10 pages
	// order_promo_internal expires after 10 pages
	// signup_promo_internal expires after 10 pages
	function incrementAndExpire() {
	    var new_cookie, stored_cookie, order_promo_external_expires;
	    return regeneratorRuntime.wrap(function incrementAndExpire$(_context5) {
	        while (1) {
	            switch (_context5.prev = _context5.next) {
	                case 0:
	                    new_cookie = {};
	                    _context5.next = 3;
	                    return (0, _effects.select)(function (state) {
	                        return state.cookie.promo || {};
	                    });
	
	                case 3:
	                    stored_cookie = _context5.sent;
	
	
	                    // expiration by time
	                    if (stored_cookie.order_promo_external) {
	                        order_promo_external_expires = (0, _moment2.default)(stored_cookie.order_promo_external.expires);
	
	                        if (stored_cookie.order_promo_external.value && order_promo_external_expires.isValid() && order_promo_external_expires > (0, _moment2.default)()) {
	                            new_cookie.order_promo_external = stored_cookie.order_promo_external;
	                        }
	                    }
	
	                    // expiration by page view
	                    ['order_promo_internal', 'signup_promo_external', 'signup_promo_internal'].forEach(function (type) {
	                        if (stored_cookie[type] && stored_cookie[type].value && stored_cookie[type].expires) {
	                            new_cookie[type] = {
	                                value: stored_cookie[type].value,
	                                expires: stored_cookie[type].expires - 1
	                            };
	                        }
	                    });
	
	                    if (!Object.keys(new_cookie).length) {
	                        _context5.next = 11;
	                        break;
	                    }
	
	                    _context5.next = 9;
	                    return (0, _effects.put)({ type: 'promo-tracker:_record', payload: new_cookie });
	
	                case 9:
	                    _context5.next = 13;
	                    break;
	
	                case 11:
	                    _context5.next = 13;
	                    return (0, _effects.put)({ type: 'promo-tracker:_remove' });
	
	                case 13:
	                case 'end':
	                    return _context5.stop();
	            }
	        }
	    }, _marked[4], this);
	}
	
	function setUTM() {
	    var queryParams, utm_medium, utm_source, utm_campaign, utm_content;
	    return regeneratorRuntime.wrap(function setUTM$(_context6) {
	        while (1) {
	            switch (_context6.prev = _context6.next) {
	                case 0:
	                    _context6.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state['query-params'];
	                    });
	
	                case 2:
	                    queryParams = _context6.sent;
	                    utm_medium = queryParams.utm_medium, utm_source = queryParams.utm_source, utm_campaign = queryParams.utm_campaign, utm_content = queryParams.utm_content;
	
	                    if (!(utm_medium && utm_source && utm_campaign && utm_content)) {
	                        _context6.next = 7;
	                        break;
	                    }
	
	                    _context6.next = 7;
	                    return (0, _effects.put)({
	                        type: 'promo-tracker:recordExternal',
	                        payload: [utm_medium, utm_source, utm_campaign, utm_content]
	                    });
	
	                case 7:
	                case 'end':
	                    return _context6.stop();
	            }
	        }
	    }, _marked[5], this);
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context7) {
	        while (1) {
	            switch (_context7.prev = _context7.next) {
	                case 0:
	                    _context7.next = 2;
	                    return (0, _effects.all)([(0, _reduxSaga.takeEvery)('promo-tracker:_record', record), (0, _reduxSaga.takeEvery)('promo-tracker:_remove', remove), (0, _reduxSaga.takeEvery)('promo-tracker:recordExternal', recordExternal), (0, _reduxSaga.takeEvery)('promo-tracker:recordInternal', recordInternal), (0, _reduxSaga.takeEvery)('user:logged-out', remove)]);
	
	                case 2:
	                    _context7.next = 4;
	                    return (0, _effects.call)(incrementAndExpire);
	
	                case 4:
	                    _context7.next = 6;
	                    return (0, _effects.call)(setUTM);
	
	                case 6:
	                case 'end':
	                    return _context7.stop();
	            }
	        }
	    }, _marked[6], this);
	}

/***/ },

/***/ "./app/sagas/raven.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.sendError = sendError;
	exports.createTag = createTag;
	exports.loadRaven = loadRaven;
	exports.root = root;
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _marked = [loadRaven, root].map(regeneratorRuntime.mark); /*global Raven */
	
	
	var tag = void 0;
	
	function sendError(exception, message) {
	    Raven.captureException(exception, { level: 'error', message: message });
	}
	
	function createTag() {
	    if (tag) {
	        return new Promise.resolve();
	    }
	    return new Promise(function (resolve) {
	        tag = document.createElement('script');
	        tag.setAttribute('crossorigin', 'anonymous');
	        tag.src = 'https://cdn.ravenjs.com/3.14.2/raven.min.js';
	        tag.async = true;
	        tag.onload = resolve;
	        document.body.appendChild(tag);
	    });
	}
	
	function loadRaven() {
	    var key;
	    return regeneratorRuntime.wrap(function loadRaven$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.sentry.key;
	                    });
	
	                case 2:
	                    key = _context.sent;
	
	                    Raven.config(key).install();
	                    Raven.setTransport(function (options) {
	                        return (0, _util.postJSON)('/api/sentry', options.data);
	                    });
	
	                case 5:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function root() {
	    var except, msg;
	    return regeneratorRuntime.wrap(function root$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    if (false) {
	                        _context2.next = 12;
	                        break;
	                    }
	
	                    _context2.next = 3;
	                    return (0, _effects.take)('raven:error');
	
	                case 3:
	                    except = _context2.sent;
	                    _context2.next = 6;
	                    return (0, _effects.call)(createTag);
	
	                case 6:
	                    _context2.next = 8;
	                    return (0, _effects.call)(loadRaven);
	
	                case 8:
	                    msg = except.payload.error.message || except.payload.message;
	
	                    sendError(except.payload.error, msg);
	                    _context2.next = 0;
	                    break;
	
	                case 12:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}

/***/ },

/***/ "./app/sagas/recaptcha.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.checkRecaptcha = checkRecaptcha;
	exports.root = root;
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _marked = [checkRecaptcha, root].map(regeneratorRuntime.mark);
	
	function checkRecaptcha(_ref) {
	    var response = _ref.payload.response;
	    var result;
	    return regeneratorRuntime.wrap(function checkRecaptcha$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.call)(_util.getJSON, '/api/recaptcha/check?response=' + response);
	
	                case 2:
	                    result = _context.sent;
	                    _context.next = 5;
	                    return (0, _effects.put)({ type: 'recaptcha:update', payload: result });
	
	                case 5:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    return _context2.delegateYield((0, _reduxSaga.takeEvery)('recaptcha:check', checkRecaptcha), 't0', 1);
	
	                case 1:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}

/***/ },

/***/ "./app/sagas/route.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.root = root;
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _marked = [to, watch, root].map(regeneratorRuntime.mark);
	
	// event.newURL support for IE
	if (!window.HashChangeEvent) {
	    (function () {
	        var lastURL = document.URL;
	        window.addEventListener('hashchange', function (event) {
	            Object.defineProperty(event, 'oldURL', { enumerable: true, configurable: true, value: lastURL });
	            Object.defineProperty(event, 'newURL', { enumerable: true, configurable: true, value: document.URL });
	            lastURL = document.URL;
	        });
	    })();
	}
	
	function to() {
	    var _ref, hash, newHash;
	
	    return regeneratorRuntime.wrap(function to$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    if (false) {
	                        _context.next = 11;
	                        break;
	                    }
	
	                    _context.next = 3;
	                    return (0, _effects.take)('route:to');
	
	                case 3:
	                    _ref = _context.sent;
	                    hash = _ref.payload;
	
	                    // clear the # if we can
	                    newHash = hash ? '#' + hash : '';
	                    // using pushState because it doesn't scroll the window on empty hashes
	                    // and because it'll prevent an extra route:hashchanged action
	
	                    _context.next = 8;
	                    return (0, _effects.call)([window.history, window.history.pushState], '', '', window.location.pathname + window.location.search + newHash);
	
	                case 8:
	                    // for redux-naive code
	                    if (hash === 'login' || hash === 'signup') {
	                        $(document).trigger('route:' + hash);
	                    }
	                    _context.next = 0;
	                    break;
	
	                case 11:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function hashChannel() {
	    return (0, _reduxSaga.eventChannel)(function (emit) {
	        window.addEventListener('hashchange', function (event) {
	            emit(event);
	        });
	        return function () {
	            window.removeEventLister('hashchange');
	        };
	    });
	}
	
	function watch() {
	    var channel, event, _hash;
	
	    return regeneratorRuntime.wrap(function watch$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    channel = hashChannel();
	
	                case 1:
	                    if (false) {
	                        _context2.next = 15;
	                        break;
	                    }
	
	                    _context2.next = 4;
	                    return (0, _effects.take)(channel);
	
	                case 4:
	                    event = _context2.sent;
	                    _hash = event.newURL.match(/#(.*)$/)[1];
	
	                    if (!(_hash === 'logout')) {
	                        _context2.next = 11;
	                        break;
	                    }
	
	                    _context2.next = 9;
	                    return (0, _effects.all)([(0, _effects.call)(_util.putJSON, '/api/user/logout'), (0, _effects.put)({
	                        type: 'user:update',
	                        payload: { logged_in: false }
	                    }), (0, _effects.put)({
	                        type: 'route:to',
	                        payload: ''
	                    })]);
	
	                case 9:
	                    _context2.next = 13;
	                    break;
	
	                case 11:
	                    _context2.next = 13;
	                    return (0, _effects.put)({
	                        type: 'route:hashchanged',
	                        payload: _hash
	                    });
	
	                case 13:
	                    _context2.next = 1;
	                    break;
	
	                case 15:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    _context3.next = 2;
	                    return (0, _effects.fork)(to);
	
	                case 2:
	                    _context3.next = 4;
	                    return (0, _effects.fork)(watch);
	
	                case 4:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _marked[2], this);
	}

/***/ },

/***/ "./app/sagas/subscription.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.init = init;
	exports.submit = submit;
	exports.root = root;
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _marked = [init, submit, root].map(regeneratorRuntime.mark);
	
	function init(upc) {
	    return regeneratorRuntime.wrap(function init$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.all)([(0, _effects.put)({ type: 'price:required', payload: upc }), (0, _effects.put)({ type: 'product:teeup' })]);
	
	                case 2:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function submit() {
	    var _ref, _ref2, upc, user, order;
	
	    return regeneratorRuntime.wrap(function submit$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _effects.all)([(0, _effects.select)(function (state) {
	                        return state.product.description.code;
	                    }), (0, _effects.select)(function (state) {
	                        return state.user;
	                    })]);
	
	                case 2:
	                    _ref = _context2.sent;
	                    _ref2 = _slicedToArray(_ref, 2);
	                    upc = _ref2[0];
	                    user = _ref2[1];
	
	                    if (user.logged_in) {
	                        _context2.next = 9;
	                        break;
	                    }
	
	                    _context2.next = 9;
	                    return (0, _effects.all)([(0, _effects.put)({
	                        type: 'route:to',
	                        payload: 'login'
	                    }), (0, _effects.take)('user:logged-in')]);
	
	                case 9:
	                    _context2.next = 11;
	                    return (0, _effects.put)({ type: 'product:submitting', payload: true });
	
	                case 11:
	                    _context2.prev = 11;
	                    _context2.next = 14;
	                    return (0, _effects.call)(_util.postJSON, '/api/product/submit/' + upc);
	
	                case 14:
	                    order = _context2.sent;
	                    _context2.next = 17;
	                    return (0, _effects.put)({ type: 'location:href', payload: order.forwarding_url });
	
	                case 17:
	                    _context2.next = 23;
	                    break;
	
	                case 19:
	                    _context2.prev = 19;
	                    _context2.t0 = _context2['catch'](11);
	                    _context2.next = 23;
	                    return (0, _effects.all)([(0, _effects.put)({ type: 'product:error', payload: 'Sorry, an error occurred' }), (0, _effects.put)({ type: 'product:submitting', payload: false })]);
	
	                case 23:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this, [[11, 19]]);
	}
	
	function root() {
	    var _ref3, upc;
	
	    return regeneratorRuntime.wrap(function root$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    _context3.next = 2;
	                    return (0, _effects.take)('subscription:init');
	
	                case 2:
	                    _ref3 = _context3.sent;
	                    upc = _ref3.payload;
	                    _context3.next = 6;
	                    return (0, _effects.call)(init, upc);
	
	                case 6:
	                    return _context3.delegateYield((0, _reduxSaga.takeEvery)('product:submit', submit), 't0', 7);
	
	                case 7:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _marked[2], this);
	}

/***/ },

/***/ "./app/sagas/tarot-ga.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.gaFormat = gaFormat;
	exports.watchPick = watchPick;
	exports.watchUpsell = watchUpsell;
	exports.watchReveal = watchReveal;
	exports.watchGaEvent = watchGaEvent;
	exports.root = root;
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _marked = [watchPick, watchUpsell, watchReveal, watchGaEvent, root].map(regeneratorRuntime.mark);
	
	function gaFormat(str) {
	    return str.replace(' ', '-').replace(/(\b\w)/g, function (m) {
	        return m.toUpperCase();
	    });
	}
	
	function watchPick() {
	    var _ref, source, pickedCards, positions, cardPosition;
	
	    return regeneratorRuntime.wrap(function watchPick$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    if (false) {
	                        _context.next = 22;
	                        break;
	                    }
	
	                    _context.next = 3;
	                    return (0, _effects.take)('tarot-reading:picked');
	
	                case 3:
	                    _ref = _context.sent;
	                    source = _ref.payload.source;
	                    _context.next = 7;
	                    return (0, _effects.select)(function (state) {
	                        return state['tarot-reading'].cards;
	                    });
	
	                case 7:
	                    pickedCards = _context.sent;
	                    _context.next = 10;
	                    return (0, _effects.select)(function (state) {
	                        return state['tarot-reading'].positions;
	                    });
	
	                case 10:
	                    positions = _context.sent;
	
	                    if (!(pickedCards.length > positions.length)) {
	                        _context.next = 17;
	                        break;
	                    }
	
	                    _context.next = 14;
	                    return (0, _effects.take)('tarot-reading:positions');
	
	                case 14:
	                    _context.next = 16;
	                    return (0, _effects.select)(function (state) {
	                        return state['tarot-reading'].positions;
	                    });
	
	                case 16:
	                    positions = _context.sent;
	
	                case 17:
	                    cardPosition = positions[pickedCards.length - 1].position;
	                    _context.next = 20;
	                    return (0, _effects.put)({
	                        type: 'tarot-ga:event',
	                        payload: 'Click-' + gaFormat(cardPosition) + '-in-' + source
	                    });
	
	                case 20:
	                    _context.next = 0;
	                    break;
	
	                case 22:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function watchUpsell() {
	    return regeneratorRuntime.wrap(function watchUpsell$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    if (false) {
	                        _context2.next = 7;
	                        break;
	                    }
	
	                    _context2.next = 3;
	                    return (0, _effects.take)('tarot-reading:upsell');
	
	                case 3:
	                    _context2.next = 5;
	                    return (0, _effects.put)({ type: 'tarot-ga:event', payload: 'Click-Upsell-Deck' });
	
	                case 5:
	                    _context2.next = 0;
	                    break;
	
	                case 7:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}
	
	function watchReveal() {
	    var action, upc, type;
	    return regeneratorRuntime.wrap(function watchReveal$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    if (false) {
	                        _context3.next = 18;
	                        break;
	                    }
	
	                    _context3.next = 3;
	                    return (0, _effects.take)('tarot-reading:fetch');
	
	                case 3:
	                    action = 'Click-Thru-to-Checkout';
	                    _context3.next = 6;
	                    return (0, _effects.select)(function (state) {
	                        return state.product.teeup.code;
	                    });
	
	                case 6:
	                    upc = _context3.sent;
	                    _context3.next = 9;
	                    return (0, _effects.select)(function (state) {
	                        return state['tarot-reading'].type;
	                    });
	
	                case 9:
	                    type = _context3.sent;
	
	                    if (!(/sample/.test(upc) && !type)) {
	                        _context3.next = 14;
	                        break;
	                    }
	
	                    action = 'Click-Thru-to-Interp';
	                    _context3.next = 14;
	                    return (0, _effects.put)({
	                        type: 'promo-tracker:recordInternal',
	                        payload: ['Tarot Reading Module', upc]
	                    });
	
	                case 14:
	                    _context3.next = 16;
	                    return (0, _effects.put)({ type: 'tarot-ga:event', payload: action });
	
	                case 16:
	                    _context3.next = 0;
	                    break;
	
	                case 18:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _marked[2], this);
	}
	
	function watchGaEvent() {
	    var _ref2, payload, upc;
	
	    return regeneratorRuntime.wrap(function watchGaEvent$(_context4) {
	        while (1) {
	            switch (_context4.prev = _context4.next) {
	                case 0:
	                    if (false) {
	                        _context4.next = 12;
	                        break;
	                    }
	
	                    _context4.next = 3;
	                    return (0, _effects.take)('tarot-ga:event');
	
	                case 3:
	                    _ref2 = _context4.sent;
	                    payload = _ref2.payload;
	                    _context4.next = 7;
	                    return (0, _effects.select)(function (state) {
	                        return state.product.teeup.code;
	                    });
	
	                case 7:
	                    upc = _context4.sent;
	                    _context4.next = 10;
	                    return (0, _effects.put)({ type: 'ga:event', payload: ['Tarot Readings', payload, upc] });
	
	                case 10:
	                    _context4.next = 0;
	                    break;
	
	                case 12:
	                case 'end':
	                    return _context4.stop();
	            }
	        }
	    }, _marked[3], this);
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context5) {
	        while (1) {
	            switch (_context5.prev = _context5.next) {
	                case 0:
	                    _context5.next = 2;
	                    return (0, _effects.all)([(0, _effects.fork)(watchPick), (0, _effects.fork)(watchUpsell), (0, _effects.fork)(watchReveal), (0, _effects.fork)(watchGaEvent)]);
	
	                case 2:
	                case 'end':
	                    return _context5.stop();
	            }
	        }
	    }, _marked[4], this);
	}

/***/ },

/***/ "./app/sagas/tarot-reading.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.getSaved = getSaved;
	exports.validateFetch = validateFetch;
	exports.getSubscription = getSubscription;
	exports.checkoutSubmit = checkoutSubmit;
	exports.fetchSample = fetchSample;
	exports.pickCards = pickCards;
	exports.fetch = fetch;
	exports.watchInit = watchInit;
	exports.watchOrient = watchOrient;
	exports.watchPick = watchPick;
	exports.setSubject = setSubject;
	exports.watchUpsell = watchUpsell;
	exports.watchFavoriteDeck = watchFavoriteDeck;
	exports.resetFetch = resetFetch;
	exports.watchShuffle = watchShuffle;
	exports.root = root;
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _config = __webpack_require__("./app/config.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _underscore = __webpack_require__("../node_modules/underscore/underscore.js");
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [getSaved, validateFetch, getSubscription, checkoutSubmit, fetchSample, fetch, watchInit, watchOrient, watchPick, setSubject, watchUpsell, watchFavoriteDeck, resetFetch, watchShuffle, root].map(regeneratorRuntime.mark);
	
	var report_slug = null; // TODO: move to state. something like state.product.report_slug.
	var submitting = false; // TODO: Why doesn't 'state.product.submitting' work?
	var cardsCookie = 'tarot-cards';
	var subjectCookie = 'tarot-subject';
	var cookieOpts = { expires: 30 };
	
	function getSaved(positions) {
	    var params, user, cards, subject;
	    return regeneratorRuntime.wrap(function getSaved$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state['query-params'];
	                    });
	
	                case 2:
	                    params = _context.sent;
	
	                    if (!params.report) {
	                        _context.next = 7;
	                        break;
	                    }
	
	                    _context.next = 6;
	                    return (0, _effects.call)(fetchSample, params.report);
	
	                case 6:
	                    return _context.abrupt('return');
	
	                case 7:
	                    _context.next = 9;
	                    return (0, _effects.select)(function (state) {
	                        return state.user;
	                    });
	
	                case 9:
	                    user = _context.sent;
	
	                    if (user.logged_in) {
	                        _context.next = 12;
	                        break;
	                    }
	
	                    return _context.abrupt('return');
	
	                case 12:
	                    _context.next = 14;
	                    return (0, _effects.select)(function (state) {
	                        return state.cookie[cardsCookie] || [];
	                    });
	
	                case 14:
	                    cards = _context.sent;
	                    _context.next = 17;
	                    return (0, _effects.select)(function (state) {
	                        return state.cookie[subjectCookie];
	                    });
	
	                case 17:
	                    subject = _context.sent;
	
	                    if (!(cards.length === positions.length)) {
	                        _context.next = 21;
	                        break;
	                    }
	
	                    _context.next = 21;
	                    return (0, _effects.all)([(0, _effects.put)({ type: 'tarot-reading:subject', payload: subject }), (0, _effects.put)({ type: 'tarot-reading:loadSaved', payload: cards }), (0, _effects.call)(fetch, cards)]);
	
	                case 21:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function validateFetch() {
	    var user, _ref, cards, positions, submitting_prod, config;
	
	    return regeneratorRuntime.wrap(function validateFetch$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.user;
	                    });
	
	                case 2:
	                    user = _context2.sent;
	                    _context2.next = 5;
	                    return (0, _effects.select)(function (state) {
	                        return state['tarot-reading'];
	                    });
	
	                case 5:
	                    _ref = _context2.sent;
	                    cards = _ref.cards;
	                    positions = _ref.positions;
	
	                    if (!(cards.length !== positions.length)) {
	                        _context2.next = 12;
	                        break;
	                    }
	
	                    _context2.next = 11;
	                    return (0, _effects.put)({
	                        type: 'tarot-reading:error',
	                        payload: { remaining: positions.length - cards.length }
	                    });
	
	                case 11:
	                    return _context2.abrupt('return');
	
	                case 12:
	                    if (user.logged_in) {
	                        _context2.next = 15;
	                        break;
	                    }
	
	                    _context2.next = 15;
	                    return (0, _effects.all)([(0, _effects.put)({ type: 'route:to', payload: 'login' }), (0, _effects.take)('user:logged-in')]);
	
	                case 15:
	                    _context2.next = 17;
	                    return (0, _effects.select)(function (state) {
	                        return state.product.submitting;
	                    });
	
	                case 17:
	                    submitting_prod = _context2.sent;
	
	                    if (!(submitting_prod || submitting)) {
	                        _context2.next = 20;
	                        break;
	                    }
	
	                    return _context2.abrupt('return');
	
	                case 20:
	                    submitting = true;
	                    _context2.next = 23;
	                    return (0, _effects.put)({ type: 'product:submitting', payload: true });
	
	                case 23:
	                    _context2.next = 25;
	                    return (0, _effects.select)(function (state) {
	                        return state.product.teeup;
	                    });
	
	                case 25:
	                    config = _context2.sent;
	
	                    if (!config.upsell_upc) {
	                        _context2.next = 30;
	                        break;
	                    }
	
	                    _context2.next = 29;
	                    return (0, _effects.call)(fetch, cards);
	
	                case 29:
	                    return _context2.abrupt('return');
	
	                case 30:
	                    _context2.next = 32;
	                    return (0, _effects.call)(checkoutSubmit, cards);
	
	                case 32:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}
	
	function getSubscription(upc, price) {
	    var sub_upc, _ref2, _ref3, api, params, desc;
	
	    return regeneratorRuntime.wrap(function getSubscription$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    if (!(upc != 'daily-reflection-tarot-redux' || price.usd && price.usd.billing_type == 'subscription')) {
	                        _context3.next = 2;
	                        break;
	                    }
	
	                    return _context3.abrupt('return');
	
	                case 2:
	                    sub_upc = 'drt-monthly-subscription';
	                    _context3.next = 5;
	                    return (0, _effects.all)([(0, _effects.select)(function (state) {
	                        return state.api.host;
	                    }), (0, _effects.select)(function (state) {
	                        return state.api.params;
	                    })]);
	
	                case 5:
	                    _ref2 = _context3.sent;
	                    _ref3 = _slicedToArray(_ref2, 2);
	                    api = _ref3[0];
	                    params = _ref3[1];
	                    _context3.next = 11;
	                    return (0, _effects.call)(_util.getJSON, api + '/product/description/' + sub_upc, params);
	
	                case 11:
	                    desc = _context3.sent;
	                    _context3.next = 14;
	                    return (0, _effects.put)({
	                        type: 'product:subscription',
	                        payload: { description: desc }
	                    });
	
	                case 14:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _marked[2], this);
	}
	
	function checkoutSubmit(cards) {
	    var deck, subject, upc, submit, positions, order;
	    return regeneratorRuntime.wrap(function checkoutSubmit$(_context4) {
	        while (1) {
	            switch (_context4.prev = _context4.next) {
	                case 0:
	                    _context4.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.deck.code;
	                    });
	
	                case 2:
	                    deck = _context4.sent;
	                    _context4.next = 5;
	                    return (0, _effects.select)(function (state) {
	                        return state['tarot-reading'].subject;
	                    });
	
	                case 5:
	                    subject = _context4.sent;
	                    _context4.next = 8;
	                    return (0, _effects.select)(function (state) {
	                        return state.product.teeup.code;
	                    });
	
	                case 8:
	                    upc = _context4.sent;
	                    submit = _config.READINGS.submit;
	
	                    if (!/mandala/.test(upc)) {
	                        _context4.next = 16;
	                        break;
	                    }
	
	                    _context4.next = 13;
	                    return (0, _effects.select)(function (state) {
	                        return state['tarot-reading'].positions;
	                    });
	
	                case 13:
	                    positions = _context4.sent;
	
	
	                    cards = cards.map(function (card, i) {
	                        return {
	                            card_id: card,
	                            orientation: positions[i].orientation,
	                            position: positions[i].position
	                        };
	                    });
	
	                    submit = _config.READINGS.submitMandala;
	
	                case 16:
	                    _context4.prev = 16;
	                    _context4.next = 19;
	                    return (0, _effects.call)(submit, cards, deck, subject, upc, report_slug);
	
	                case 19:
	                    order = _context4.sent;
	                    _context4.next = 22;
	                    return (0, _effects.put)({ type: 'location:href', payload: order.forwarding_url });
	
	                case 22:
	                    _context4.next = 28;
	                    break;
	
	                case 24:
	                    _context4.prev = 24;
	                    _context4.t0 = _context4['catch'](16);
	                    _context4.next = 28;
	                    return (0, _effects.put)({ type: 'tarot-reading:loaded', error: _context4.t0 });
	
	                case 28:
	                case 'end':
	                    return _context4.stop();
	            }
	        }
	    }, _marked[3], this, [[16, 24]]);
	}
	
	function fetchSample(product_result_uuid) {
	    var response, upc;
	    return regeneratorRuntime.wrap(function fetchSample$(_context5) {
	        while (1) {
	            switch (_context5.prev = _context5.next) {
	                case 0:
	                    response = void 0;
	                    _context5.prev = 1;
	                    _context5.next = 4;
	                    return (0, _effects.call)(_config.READINGS.fetchSampleInterps, product_result_uuid);
	
	                case 4:
	                    response = _context5.sent;
	
	                    if (!response.error) {
	                        _context5.next = 7;
	                        break;
	                    }
	
	                    return _context5.abrupt('return');
	
	                case 7:
	                    _context5.next = 14;
	                    break;
	
	                case 9:
	                    _context5.prev = 9;
	                    _context5.t0 = _context5['catch'](1);
	                    _context5.next = 13;
	                    return (0, _effects.put)({ type: 'tarot-reading:loaded', error: _context5.t0 });
	
	                case 13:
	                    return _context5.abrupt('return');
	
	                case 14:
	                    _context5.next = 16;
	                    return (0, _effects.select)(function (state) {
	                        return state.product.teeup.code;
	                    });
	
	                case 16:
	                    upc = _context5.sent;
	
	                    if (!(response.upc != upc)) {
	                        _context5.next = 19;
	                        break;
	                    }
	
	                    return _context5.abrupt('return');
	
	                case 19:
	                    report_slug = product_result_uuid;
	
	                    _context5.next = 22;
	                    return (0, _effects.call)(pickCards, response.interpretations.map(function (interp) {
	                        return interp.card;
	                    }));
	
	                case 22:
	                    _context5.next = 24;
	                    return (0, _effects.all)([(0, _effects.put)({
	                        type: 'tarot-reading:loadSaved',
	                        payload: response.interpretations.map(function (interp) {
	                            return interp.card;
	                        })
	                    }), (0, _effects.put)({
	                        type: 'deck:required',
	                        payload: response.deck_code
	                    }), (0, _effects.put)({
	                        type: 'tarot-reading:subject',
	                        payload: response.question
	                    }), (0, _effects.put)({
	                        type: 'tarot-reading:loaded',
	                        payload: response.interpretations
	                    }), (0, _effects.put)({
	                        type: 'route:to',
	                        payload: 'tarot-reading/self'
	                    })]);
	
	                case 24:
	                case 'end':
	                    return _context5.stop();
	            }
	        }
	    }, _marked[4], this, [[1, 9]]);
	}
	
	function pickCards(card_ids) {
	    var cards = document.querySelectorAll('deck-card');
	    var card = void 0;
	    for (var c = 0; c < cards.length; c++) {
	        card = cards[c]._tag;
	        if (card_ids.indexOf(card.card_id) > -1) {
	            card.pick();
	        }
	    }
	}
	
	function fetch(cards) {
	    var deck, subject, upc, response;
	    return regeneratorRuntime.wrap(function fetch$(_context6) {
	        while (1) {
	            switch (_context6.prev = _context6.next) {
	                case 0:
	                    _context6.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.deck.code;
	                    });
	
	                case 2:
	                    deck = _context6.sent;
	                    _context6.next = 5;
	                    return (0, _effects.select)(function (state) {
	                        return state['tarot-reading'].subject;
	                    });
	
	                case 5:
	                    subject = _context6.sent;
	                    _context6.next = 8;
	                    return (0, _effects.select)(function (state) {
	                        return state.product.teeup.code;
	                    });
	
	                case 8:
	                    upc = _context6.sent;
	                    response = void 0;
	                    _context6.prev = 10;
	                    _context6.next = 13;
	                    return (0, _effects.call)(_config.READINGS.submitSample, upc, cards, deck, subject);
	
	                case 13:
	                    response = _context6.sent;
	
	                    if (!response.error) {
	                        _context6.next = 16;
	                        break;
	                    }
	
	                    return _context6.abrupt('return');
	
	                case 16:
	                    _context6.next = 23;
	                    break;
	
	                case 18:
	                    _context6.prev = 18;
	                    _context6.t0 = _context6['catch'](10);
	                    _context6.next = 22;
	                    return (0, _effects.put)({
	                        type: 'tarot-reading:loaded',
	                        error: _context6.t0
	                    });
	
	                case 22:
	                    return _context6.abrupt('return');
	
	                case 23:
	                    report_slug = response.report_slug;
	                    _context6.next = 26;
	                    return (0, _effects.all)([(0, _effects.put)({ type: 'tarot-reading:loaded', payload: response.interpretations }), (0, _effects.put)({ type: 'route:to', payload: 'tarot-reading/self' }), (0, _effects.put)({ type: 'cookie:remove', payload: cardsCookie }), (0, _effects.put)({ type: 'cookie:remove', payload: subjectCookie })]);
	
	                case 26:
	                case 'end':
	                    return _context6.stop();
	            }
	        }
	    }, _marked[5], this, [[10, 18]]);
	}
	
	function watchInit() {
	    var _ref4, _ref4$payload, upc, type, config, price;
	
	    return regeneratorRuntime.wrap(function watchInit$(_context7) {
	        while (1) {
	            switch (_context7.prev = _context7.next) {
	                case 0:
	                    if (false) {
	                        _context7.next = 26;
	                        break;
	                    }
	
	                    _context7.next = 3;
	                    return (0, _effects.take)('tarot-reading:init');
	
	                case 3:
	                    _ref4 = _context7.sent;
	                    _ref4$payload = _ref4.payload;
	                    upc = _ref4$payload.upc;
	                    type = _ref4$payload.type;
	                    _context7.next = 9;
	                    return (0, _effects.call)(_util.getJSON, '/api/product/description/' + upc + '/teeup');
	
	                case 9:
	                    config = _context7.sent;
	
	
	                    config.positions = config.fields[2].positions;
	
	                    if (!(upc == 'yes-or-no-tarot-redux')) {
	                        _context7.next = 14;
	                        break;
	                    }
	
	                    _context7.next = 14;
	                    return (0, _effects.all)([(0, _effects.put)({
	                        type: 'tarot-reading:picked',
	                        payload: {
	                            card: 10,
	                            source: 'Pre-Selected'
	                        }
	                    }), (0, _effects.put)({
	                        type: 'deck:spread',
	                        payload: 10
	                    }), (0, _effects.put)({
	                        type: 'tarot-reading:button_text',
	                        payload: 'shuffle cards'
	                    })]);
	
	                case 14:
	                    _context7.next = 16;
	                    return (0, _effects.all)([(0, _effects.put)({
	                        type: 'tarot-reading:type',
	                        payload: type
	                    }), (0, _effects.put)({
	                        type: 'tarot-reading:positions',
	                        payload: config.positions
	                    }), (0, _effects.put)({
	                        type: 'product:teeup',
	                        payload: config
	                    }), (0, _effects.put)({ type: 'price:required', payload: config.upsell_upc || upc })]);
	
	                case 16:
	                    if (!config.upsell_upc) {
	                        _context7.next = 19;
	                        break;
	                    }
	
	                    _context7.next = 19;
	                    return (0, _effects.call)(getSaved, config.positions);
	
	                case 19:
	                    _context7.next = 21;
	                    return (0, _effects.take)('product:price');
	
	                case 21:
	                    price = _context7.sent;
	                    _context7.next = 24;
	                    return (0, _effects.call)(getSubscription, upc, price);
	
	                case 24:
	                    _context7.next = 0;
	                    break;
	
	                case 26:
	                case 'end':
	                    return _context7.stop();
	            }
	        }
	    }, _marked[6], this);
	}
	
	function watchOrient() {
	    var positions, newPositions;
	    return regeneratorRuntime.wrap(function watchOrient$(_context8) {
	        while (1) {
	            switch (_context8.prev = _context8.next) {
	                case 0:
	                    if (false) {
	                        _context8.next = 11;
	                        break;
	                    }
	
	                    _context8.next = 3;
	                    return (0, _effects.take)('tarot-reading:orient');
	
	                case 3:
	                    _context8.next = 5;
	                    return (0, _effects.select)(function (state) {
	                        return state['tarot-reading'].positions;
	                    });
	
	                case 5:
	                    positions = _context8.sent;
	                    newPositions = positions.map(function (position) {
	                        position.orientation = _underscore2.default.shuffle(['upright', 'right', 'left', 'reverse'])[0];
	
	                        return position;
	                    });
	                    _context8.next = 9;
	                    return (0, _effects.put)({ type: 'tarot-reading:positions', payload: newPositions });
	
	                case 9:
	                    _context8.next = 0;
	                    break;
	
	                case 11:
	                case 'end':
	                    return _context8.stop();
	            }
	        }
	    }, _marked[7], this);
	}
	
	function watchPick() {
	    var pickedCards;
	    return regeneratorRuntime.wrap(function watchPick$(_context9) {
	        while (1) {
	            switch (_context9.prev = _context9.next) {
	                case 0:
	                    if (false) {
	                        _context9.next = 13;
	                        break;
	                    }
	
	                    _context9.next = 3;
	                    return (0, _effects.take)('tarot-reading:picked');
	
	                case 3:
	                    _context9.next = 5;
	                    return (0, _effects.select)(function (state) {
	                        return state['tarot-reading'].cards;
	                    });
	
	                case 5:
	                    pickedCards = _context9.sent;
	
	                    if (!(pickedCards.length === 1)) {
	                        _context9.next = 9;
	                        break;
	                    }
	
	                    _context9.next = 9;
	                    return (0, _effects.put)({ type: 'product:type', payload: 'Reading' });
	
	                case 9:
	                    _context9.next = 11;
	                    return (0, _effects.all)([(0, _effects.put)({
	                        type: 'cookie:set',
	                        payload: {
	                            name: cardsCookie,
	                            value: pickedCards,
	                            opts: cookieOpts
	                        }
	                    }), (0, _effects.put)({
	                        type: 'tarot-reading:error',
	                        payload: null
	                    })]);
	
	                case 11:
	                    _context9.next = 0;
	                    break;
	
	                case 13:
	                case 'end':
	                    return _context9.stop();
	            }
	        }
	    }, _marked[8], this);
	}
	
	function setSubject() {
	    var action, question;
	    return regeneratorRuntime.wrap(function setSubject$(_context10) {
	        while (1) {
	            switch (_context10.prev = _context10.next) {
	                case 0:
	                    if (false) {
	                        _context10.next = 9;
	                        break;
	                    }
	
	                    _context10.next = 3;
	                    return (0, _effects.take)('tarot-reading:question');
	
	                case 3:
	                    action = _context10.sent;
	                    question = action.payload || '';
	                    _context10.next = 7;
	                    return (0, _effects.all)([(0, _effects.put)({
	                        type: 'cookie:set',
	                        payload: {
	                            name: subjectCookie,
	                            value: question,
	                            opts: cookieOpts
	                        }
	                    }), (0, _effects.put)({ type: 'tarot-reading:subject', payload: question })]);
	
	                case 7:
	                    _context10.next = 0;
	                    break;
	
	                case 9:
	                case 'end':
	                    return _context10.stop();
	            }
	        }
	    }, _marked[9], this);
	}
	
	function watchUpsell() {
	    var value, sample_interps, _upc, _type;
	
	    return regeneratorRuntime.wrap(function watchUpsell$(_context11) {
	        while (1) {
	            switch (_context11.prev = _context11.next) {
	                case 0:
	                    if (false) {
	                        _context11.next = 18;
	                        break;
	                    }
	
	                    _context11.next = 3;
	                    return (0, _effects.take)('tarot-reading:upsell');
	
	                case 3:
	                    value = 'Tarot Reading';
	                    _context11.next = 6;
	                    return (0, _effects.select)(function (state) {
	                        return state['tarot-reading'].interps;
	                    });
	
	                case 6:
	                    sample_interps = _context11.sent;
	                    _context11.next = 9;
	                    return (0, _effects.select)(function (state) {
	                        return state.product && state.product.teeup.code;
	                    });
	
	                case 9:
	                    _upc = _context11.sent;
	                    _context11.next = 12;
	                    return (0, _effects.select)(function (state) {
	                        return state['tarot-reading'].type;
	                    });
	
	                case 12:
	                    _type = _context11.sent;
	
	
	                    if (!_type) {
	                        value += ' Module';
	                    }
	
	                    _context11.next = 16;
	                    return (0, _effects.all)([(0, _effects.put)({ type: 'tarot-reading:sampleInterp', payload: sample_interps }), (0, _effects.put)({ type: 'tarot-reading:loaded', payload: null }), (0, _effects.put)({ type: 'route:to', payload: 'celtic-cross' }), (0, _effects.put)({ type: 'promo-tracker:recordInternal', payload: [value + ' Upsell', _upc] })]);
	
	                case 16:
	                    _context11.next = 0;
	                    break;
	
	                case 18:
	                case 'end':
	                    return _context11.stop();
	            }
	        }
	    }, _marked[10], this);
	}
	
	function watchFavoriteDeck() {
	    var _ref5, user, favorite_deck, deck, deck_code;
	
	    return regeneratorRuntime.wrap(function watchFavoriteDeck$(_context12) {
	        while (1) {
	            switch (_context12.prev = _context12.next) {
	                case 0:
	                    if (false) {
	                        _context12.next = 18;
	                        break;
	                    }
	
	                    _context12.next = 3;
	                    return (0, _effects.take)('user:update');
	
	                case 3:
	                    _ref5 = _context12.sent;
	                    user = _ref5.payload;
	                    _context12.next = 7;
	                    return (0, _effects.call)(_util.getFavoriteDeck, user);
	
	                case 7:
	                    favorite_deck = _context12.sent;
	                    _context12.next = 10;
	                    return (0, _effects.select)(function (state) {
	                        return state.deck;
	                    });
	
	                case 10:
	                    deck = _context12.sent;
	                    deck_code = null;
	
	
	                    if (deck && deck.code && deck.code != 'mandala') {
	                        if (favorite_deck && favorite_deck.code) {
	                            deck_code = favorite_deck.code;
	                        }
	                    }
	
	                    if (!deck_code) {
	                        _context12.next = 16;
	                        break;
	                    }
	
	                    _context12.next = 16;
	                    return (0, _effects.put)({ type: 'deck:required', payload: deck_code });
	
	                case 16:
	                    _context12.next = 0;
	                    break;
	
	                case 18:
	                case 'end':
	                    return _context12.stop();
	            }
	        }
	    }, _marked[11], this);
	}
	
	function resetFetch() {
	    return regeneratorRuntime.wrap(function resetFetch$(_context13) {
	        while (1) {
	            switch (_context13.prev = _context13.next) {
	                case 0:
	                    if (false) {
	                        _context13.next = 8;
	                        break;
	                    }
	
	                    _context13.next = 3;
	                    return (0, _effects.take)('tarot-reading:loaded');
	
	                case 3:
	                    submitting = false;
	                    _context13.next = 6;
	                    return (0, _effects.put)({ type: 'product:submitting', payload: false });
	
	                case 6:
	                    _context13.next = 0;
	                    break;
	
	                case 8:
	                case 'end':
	                    return _context13.stop();
	            }
	        }
	    }, _marked[12], this);
	}
	
	function watchShuffle() {
	    var _this = this;
	
	    var _loop;
	
	    return regeneratorRuntime.wrap(function watchShuffle$(_context15) {
	        while (1) {
	            switch (_context15.prev = _context15.next) {
	                case 0:
	                    _loop = regeneratorRuntime.mark(function _loop() {
	                        var spread, shuffled, new_spread;
	                        return regeneratorRuntime.wrap(function _loop$(_context14) {
	                            while (1) {
	                                switch (_context14.prev = _context14.next) {
	                                    case 0:
	                                        _context14.next = 2;
	                                        return (0, _effects.take)('tarot-reading:shuffle-deck');
	
	                                    case 2:
	                                        _context14.next = 4;
	                                        return (0, _effects.select)(function (state) {
	                                            return state.deck.spread;
	                                        });
	
	                                    case 4:
	                                        spread = _context14.sent;
	                                        shuffled = _underscore2.default.shuffle(spread.filter(function (card) {
	                                            return card != 'picked';
	                                        }));
	                                        new_spread = spread.map(function (card) {
	                                            if (card != 'picked') {
	                                                var rand = Math.floor(Math.random() * shuffled.length);
	                                                card = shuffled[rand];
	                                                shuffled.splice(rand, 1);
	                                            }
	
	                                            return card;
	                                        });
	                                        _context14.next = 9;
	                                        return (0, _effects.put)({ type: 'deck:update_spread', payload: new_spread });
	
	                                    case 9:
	                                    case 'end':
	                                        return _context14.stop();
	                                }
	                            }
	                        }, _loop, _this);
	                    });
	
	                case 1:
	                    if (false) {
	                        _context15.next = 5;
	                        break;
	                    }
	
	                    return _context15.delegateYield(_loop(), 't0', 3);
	
	                case 3:
	                    _context15.next = 1;
	                    break;
	
	                case 5:
	                case 'end':
	                    return _context15.stop();
	            }
	        }
	    }, _marked[13], this);
	}
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context16) {
	        while (1) {
	            switch (_context16.prev = _context16.next) {
	                case 0:
	                    _context16.next = 2;
	                    return (0, _effects.all)([(0, _effects.fork)(watchInit), (0, _effects.fork)(watchOrient), (0, _effects.fork)(watchPick), (0, _effects.fork)(setSubject), (0, _effects.fork)(watchUpsell), (0, _effects.fork)(resetFetch), (0, _effects.fork)(watchFavoriteDeck), (0, _effects.fork)(watchShuffle)]);
	
	                case 2:
	                    return _context16.delegateYield((0, _reduxSaga.takeEvery)('tarot-reading:fetch', validateFetch), 't0', 3);
	
	                case 3:
	                case 'end':
	                    return _context16.stop();
	            }
	        }
	    }, _marked[14], this);
	}

/***/ },

/***/ "./app/config.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.READINGS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _util = __webpack_require__("./app/util.js");
	
	var READINGS = exports.READINGS = {
	    fetchSampleInterps: function fetchSampleInterps(product_result_uuid) {
	        return (0, _util.getJSON)('/api/product/sample_reading/' + product_result_uuid, {});
	    },
	    submitSample: function submitSample(upc, cards, deck, subject) {
	        return (0, _util.postJSON)('/api/product/submit-sample/' + upc, {
	            cards: cards.map(function (card) {
	                return _extends({}, { card_id: card });
	            }),
	            deck_code: deck,
	            question: subject
	        });
	    },
	    submitMandala: function submitMandala(cards, deck, subject, upc, upgrade_slug) {
	        var orderInfo = {
	            cards: cards,
	            deck_code: deck,
	            question: subject,
	            upgrade_slug: upgrade_slug
	        };
	
	        return (0, _util.postJSON)('/api/product/submit/' + upc, JSON.stringify(orderInfo));
	    },
	    submit: function submit(cards, deck, subject, upc, upgrade_slug) {
	        var orderInfo = {
	            cards: cards.map(function (card) {
	                return _extends({}, { card_id: card });
	            }),
	            deck_code: deck,
	            question: subject,
	            upgrade_slug: upgrade_slug
	        };
	
	        return (0, _util.postJSON)('/api/product/submit/' + upc, JSON.stringify(orderInfo));
	    }
	};

/***/ },

/***/ "./app/sagas/tcod.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.root = root;
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [fetch, root].map(regeneratorRuntime.mark);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function fetch(date, user) {
	    var url, response, payload;
	    return regeneratorRuntime.wrap(function fetch$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    url = '/api/of-the-day/tarot-card';
	                    response = void 0;
	                    _context.prev = 2;
	                    _context.next = 5;
	                    return (0, _effects.call)(_util.getJSON, url,
	                    // date == Y-M-D format
	                    { date: date, birthdate: user.birth_date || undefined }, { cache: false });
	
	                case 5:
	                    response = _context.sent;
	                    _context.next = 11;
	                    break;
	
	                case 8:
	                    _context.prev = 8;
	                    _context.t0 = _context['catch'](2);
	                    return _context.abrupt('return');
	
	                case 11:
	                    payload = _defineProperty({}, user.logged_in ? 'you' : 'everyone', response.data);
	                    _context.next = 14;
	                    return (0, _effects.put)({ type: 'tcod:update', payload: payload });
	
	                case 14:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this, [[2, 8]]);
	}
	
	function root() {
	    var action, date, user, _action;
	
	    return regeneratorRuntime.wrap(function root$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _effects.take)('tcod:required');
	
	                case 2:
	                    action = _context2.sent;
	                    date = action.payload || (0, _moment2.default)().format('YYYY-MM-DD');
	                    _context2.next = 6;
	                    return (0, _effects.select)(function (state) {
	                        return state.user;
	                    });
	
	                case 6:
	                    user = _context2.sent;
	                    _context2.next = 9;
	                    return (0, _effects.fork)(fetch, date, user);
	
	                case 9:
	                    if (!user.logged_in) {
	                        _context2.next = 12;
	                        break;
	                    }
	
	                    _context2.next = 12;
	                    return (0, _effects.fork)(fetch, date, { logged_in: false });
	
	                case 12:
	                    if (false) {
	                        _context2.next = 20;
	                        break;
	                    }
	
	                    _context2.next = 15;
	                    return (0, _effects.take)('user:logged-in');
	
	                case 15:
	                    _action = _context2.sent;
	                    _context2.next = 18;
	                    return (0, _effects.fork)(fetch, date, _action.payload);
	
	                case 18:
	                    _context2.next = 12;
	                    break;
	
	                case 20:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}

/***/ },

/***/ "./app/sagas/user/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.watchRefresh = watchRefresh;
	exports.watchRouting = watchRouting;
	exports.watchUpdate = watchUpdate;
	exports.root = root;
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _login = __webpack_require__("./app/sagas/user/login.js");
	
	var _signupApi = __webpack_require__("./app/sagas/user/signup-api.js");
	
	var _marked = [watchRefresh, watchRouting, watchUpdate, root].map(regeneratorRuntime.mark);
	
	function watchRefresh() {
	    var data;
	    return regeneratorRuntime.wrap(function watchRefresh$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.next = 2;
	                    return (0, _effects.take)('user:refresh');
	
	                case 2:
	                    if (!_context.sent) {
	                        _context.next = 10;
	                        break;
	                    }
	
	                    _context.next = 5;
	                    return (0, _effects.call)(_util.getJSON, '/api/user/status');
	
	                case 5:
	                    data = _context.sent;
	                    _context.next = 8;
	                    return (0, _effects.put)({
	                        type: 'user:update',
	                        payload: data.user
	                    });
	
	                case 8:
	                    _context.next = 0;
	                    break;
	
	                case 10:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function watchRouting() {
	    var hash, user, _ref;
	
	    return regeneratorRuntime.wrap(function watchRouting$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.route;
	                    });
	
	                case 2:
	                    hash = _context2.sent;
	
	                case 3:
	                    if (false) {
	                        _context2.next = 28;
	                        break;
	                    }
	
	                    _context2.next = 6;
	                    return (0, _effects.select)(function (state) {
	                        return state.user;
	                    });
	
	                case 6:
	                    user = _context2.sent;
	
	                    if (!(hash === 'login')) {
	                        _context2.next = 13;
	                        break;
	                    }
	
	                    if (!user.logged_in) {
	                        _context2.next = 11;
	                        break;
	                    }
	
	                    _context2.next = 11;
	                    return (0, _effects.put)({
	                        type: 'route:to',
	                        payload: ''
	                    });
	
	                case 11:
	                    _context2.next = 22;
	                    break;
	
	                case 13:
	                    if (!(hash === 'signup')) {
	                        _context2.next = 22;
	                        break;
	                    }
	
	                    if (!user.logged_in) {
	                        _context2.next = 19;
	                        break;
	                    }
	
	                    _context2.next = 17;
	                    return (0, _effects.put)({
	                        type: 'route:to',
	                        payload: ''
	                    });
	
	                case 17:
	                    _context2.next = 22;
	                    break;
	
	                case 19:
	                    if (!(!user.email || !user.password)) {
	                        _context2.next = 22;
	                        break;
	                    }
	
	                    _context2.next = 22;
	                    return (0, _effects.put)({
	                        type: 'route:to',
	                        payload: 'login'
	                    });
	
	                case 22:
	                    _context2.next = 24;
	                    return (0, _effects.take)(['route:to', 'route:hashchange']);
	
	                case 24:
	                    _ref = _context2.sent;
	                    hash = _ref.payload;
	                    _context2.next = 3;
	                    break;
	
	                case 28:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}
	
	function watchUpdate() {
	    var oldUser, _ref2, user, route;
	
	    return regeneratorRuntime.wrap(function watchUpdate$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    _context3.next = 2;
	                    return (0, _effects.select)(function (state) {
	                        return state.user;
	                    });
	
	                case 2:
	                    oldUser = _context3.sent;
	
	                case 3:
	                    if (false) {
	                        _context3.next = 20;
	                        break;
	                    }
	
	                    _context3.next = 6;
	                    return (0, _effects.take)('user:update');
	
	                case 6:
	                    _ref2 = _context3.sent;
	                    user = _ref2.payload;
	
	                    if (!(!!user.logged_in !== !!oldUser.logged_in)) {
	                        _context3.next = 17;
	                        break;
	                    }
	
	                    _context3.next = 11;
	                    return (0, _effects.put)({
	                        type: user.logged_in ? 'user:logged-in' : 'user:logged-out',
	                        payload: user
	                    });
	
	                case 11:
	                    _context3.next = 13;
	                    return (0, _effects.select)(function (state) {
	                        return state.route;
	                    });
	
	                case 13:
	                    route = _context3.sent;
	
	                    if (!(route === 'login' || route === 'signup')) {
	                        _context3.next = 17;
	                        break;
	                    }
	
	                    _context3.next = 17;
	                    return (0, _effects.put)({ type: 'route:to', payload: '' });
	
	                case 17:
	                    oldUser = user;
	                    _context3.next = 3;
	                    break;
	
	                case 20:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _marked[2], this);
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context4) {
	        while (1) {
	            switch (_context4.prev = _context4.next) {
	                case 0:
	                    _context4.next = 2;
	                    return (0, _effects.all)([(0, _effects.fork)(_login.root), (0, _effects.fork)(_signupApi.root), (0, _effects.fork)(watchRefresh), (0, _effects.fork)(watchRouting), (0, _effects.fork)(watchUpdate)]);
	
	                case 2:
	                case 'end':
	                    return _context4.stop();
	            }
	        }
	    }, _marked[3], this);
	}

/***/ },

/***/ "./app/sagas/user/login.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.documentChannel = documentChannel;
	exports.watchDocumentEvents = watchDocumentEvents;
	exports.watchLogin = watchLogin;
	exports.watchLoggedIn = watchLoggedIn;
	exports.watchLoggedOut = watchLoggedOut;
	exports.root = root;
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _marked = [watchDocumentEvents, watchLogin, watchLoggedIn, watchLoggedOut, root].map(regeneratorRuntime.mark);
	
	function documentChannel() {
	    /* global $tarot */
	    return (0, _reduxSaga.eventChannel)(function (emit) {
	        $(document).on('logged-in logged-out', function () {
	            emit($tarot.user.getData());
	        });
	        return function () {
	            $(document).off('logged-in logged-out');
	        };
	    });
	}
	
	function watchDocumentEvents() {
	    var channel, user;
	    return regeneratorRuntime.wrap(function watchDocumentEvents$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    channel = documentChannel();
	
	                case 1:
	                    if (false) {
	                        _context.next = 9;
	                        break;
	                    }
	
	                    _context.next = 4;
	                    return (0, _effects.take)(channel);
	
	                case 4:
	                    user = _context.sent;
	                    _context.next = 7;
	                    return (0, _effects.put)({ type: 'user:update', payload: user });
	
	                case 7:
	                    _context.next = 1;
	                    break;
	
	                case 9:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this);
	}
	
	function watchLogin() {
	    var action, response;
	    return regeneratorRuntime.wrap(function watchLogin$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    if (false) {
	                        _context2.next = 30;
	                        break;
	                    }
	
	                    _context2.next = 3;
	                    return (0, _effects.take)('user:login');
	
	                case 3:
	                    action = _context2.sent;
	                    _context2.prev = 4;
	                    _context2.next = 7;
	                    return (0, _effects.call)(_util.putJSON, '/api/user/login', action.payload);
	
	                case 7:
	                    _context2.next = 26;
	                    break;
	
	                case 9:
	                    _context2.prev = 9;
	                    _context2.t0 = _context2['catch'](4);
	                    response = JSON.parse(_context2.t0.responseText);
	
	                    if (!(response.error_code === 'member not found')) {
	                        _context2.next = 18;
	                        break;
	                    }
	
	                    _context2.next = 15;
	                    return (0, _effects.all)([(0, _effects.put)({
	                        type: 'user:update',
	                        payload: {
	                            email: action.payload.email,
	                            password: action.payload.password
	                        }
	                    }), (0, _effects.put)({ type: 'route:to', payload: 'signup' })]);
	
	                case 15:
	                    return _context2.abrupt('continue', 0);
	
	                case 18:
	                    if (!(_context2.t0.status === 400)) {
	                        _context2.next = 24;
	                        break;
	                    }
	
	                    _context2.next = 21;
	                    return (0, _effects.put)({ type: 'user:update', payload: { passwordError: true } });
	
	                case 21:
	                    return _context2.abrupt('continue', 0);
	
	                case 24:
	                    _context2.next = 26;
	                    return (0, _effects.put)({ type: 'route:to', payload: '' });
	
	                case 26:
	                    _context2.next = 28;
	                    return (0, _effects.put)({ type: 'user:refresh' });
	
	                case 28:
	                    _context2.next = 0;
	                    break;
	
	                case 30:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this, [[4, 9]]);
	}
	
	function watchLoggedIn(path) {
	    var user, forums_url;
	    return regeneratorRuntime.wrap(function watchLoggedIn$(_context3) {
	        while (1) {
	            switch (_context3.prev = _context3.next) {
	                case 0:
	                    if (!(path === '/signup' || path === '/login')) {
	                        _context3.next = 7;
	                        break;
	                    }
	
	                    _context3.next = 3;
	                    return (0, _effects.take)('user:logged-in');
	
	                case 3:
	                    _context3.next = 5;
	                    return (0, _effects.put)({ type: 'location:href', payload: '/' });
	
	                case 5:
	                    _context3.next = 23;
	                    break;
	
	                case 7:
	                    if (!path.match(/^\/forums\//)) {
	                        _context3.next = 23;
	                        break;
	                    }
	
	                    _context3.next = 10;
	                    return (0, _effects.take)('user:logged-in');
	
	                case 10:
	                    _context3.next = 12;
	                    return (0, _effects.select)(function (state) {
	                        return state.user;
	                    });
	
	                case 12:
	                    user = _context3.sent;
	                    _context3.next = 15;
	                    return (0, _effects.select)(function (state) {
	                        return state.forums.host;
	                    });
	
	                case 15:
	                    forums_url = _context3.sent;
	
	                    if (!('forum_name' in user && user.forum_name)) {
	                        _context3.next = 21;
	                        break;
	                    }
	
	                    _context3.next = 19;
	                    return (0, _effects.put)({ type: 'location:href', payload: forums_url });
	
	                case 19:
	                    _context3.next = 23;
	                    break;
	
	                case 21:
	                    _context3.next = 23;
	                    return (0, _effects.put)({ type: 'location:href', payload: '/forums/register' });
	
	                case 23:
	                case 'end':
	                    return _context3.stop();
	            }
	        }
	    }, _marked[2], this);
	}
	
	function watchLoggedOut(path) {
	    return regeneratorRuntime.wrap(function watchLoggedOut$(_context4) {
	        while (1) {
	            switch (_context4.prev = _context4.next) {
	                case 0:
	                    if (!(path === '/checkout')) {
	                        _context4.next = 7;
	                        break;
	                    }
	
	                    _context4.next = 3;
	                    return (0, _effects.take)('user:logged-out');
	
	                case 3:
	                    _context4.next = 5;
	                    return (0, _effects.put)({ type: 'location:href', payload: '/readings-reports' });
	
	                case 5:
	                    _context4.next = 12;
	                    break;
	
	                case 7:
	                    if (!path.match(/^\/member\//)) {
	                        _context4.next = 12;
	                        break;
	                    }
	
	                    _context4.next = 10;
	                    return (0, _effects.take)('user:logged-out');
	
	                case 10:
	                    _context4.next = 12;
	                    return (0, _effects.put)({ type: 'location:href', payload: '/' });
	
	                case 12:
	                case 'end':
	                    return _context4.stop();
	            }
	        }
	    }, _marked[3], this);
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context5) {
	        while (1) {
	            switch (_context5.prev = _context5.next) {
	                case 0:
	                    _context5.next = 2;
	                    return (0, _effects.all)([(0, _effects.fork)(watchDocumentEvents), (0, _effects.fork)(watchLogin), (0, _effects.fork)(watchLoggedIn, window.location.pathname), (0, _effects.fork)(watchLoggedOut, window.location.pathname)]);
	
	                case 2:
	                case 'end':
	                    return _context5.stop();
	            }
	        }
	    }, _marked[4], this);
	}

/***/ },

/***/ "./app/sagas/user/signup-api.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.watchSignupApi = watchSignupApi;
	exports.root = root;
	
	var _effects = __webpack_require__("../node_modules/redux-saga/lib/effects.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _marked = [watchSignupApi, root].map(regeneratorRuntime.mark);
	
	function watchSignupApi() {
	    var action, api, extra_params, response;
	    return regeneratorRuntime.wrap(function watchSignupApi$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    if (false) {
	                        _context.next = 28;
	                        break;
	                    }
	
	                    _context.next = 3;
	                    return (0, _effects.take)('user:signup-api');
	
	                case 3:
	                    action = _context.sent;
	                    _context.next = 6;
	                    return (0, _effects.select)(function (state) {
	                        return state.api;
	                    });
	
	                case 6:
	                    api = _context.sent;
	                    _context.next = 9;
	                    return (0, _effects.select)(function (state) {
	                        var promo = state.cookie && state.cookie.promo || {};
	                        var external = promo.signup_promo_external && promo.signup_promo_external.value;
	                        var internal = promo.signup_promo_internal && promo.signup_promo_internal.value;
	                        return {
	                            signup_promo_external: external || null,
	                            signup_promo_internal: internal || null,
	                            signup_property_id: state.property_id
	                        };
	                    });
	
	                case 9:
	                    extra_params = _context.sent;
	                    _context.prev = 10;
	                    _context.next = 13;
	                    return (0, _effects.call)(_util.postJSON, api.host + '/member/signup?' + (0, _util.params)(api.params), _extends({}, action.payload, extra_params));
	
	                case 13:
	                    _context.next = 15;
	                    return (0, _effects.put)({ type: 'user:refresh' });
	
	                case 15:
	                    if (!action.payload.privacy_policy) {
	                        _context.next = 18;
	                        break;
	                    }
	
	                    _context.next = 18;
	                    return (0, _effects.all)([(0, _effects.put)({ type: 'cookie:set', payload: { name: 'PRIVACY_POLICY_CONSENT', value: 1 } }), (0, _effects.put)({ type: 'cookie:set', payload: { name: 'POLICY_CONSENT_SHOWN', value: 1 } }), (0, _effects.put)({ type: 'member:privacy-policy-consent' })]);
	
	                case 18:
	                    _context.next = 26;
	                    break;
	
	                case 20:
	                    _context.prev = 20;
	                    _context.t0 = _context['catch'](10);
	                    response = null;
	
	                    try {
	                        response = JSON.parse(_context.t0.responseText);
	                    } catch (e2) {
	                        response = { detail: { message: _context.t0.responseText } };
	                    }
	                    _context.next = 26;
	                    return (0, _effects.put)({
	                        type: 'user:update',
	                        payload: get_error_messages(response.detail)
	                    });
	
	                case 26:
	                    _context.next = 0;
	                    break;
	
	                case 28:
	                case 'end':
	                    return _context.stop();
	            }
	        }
	    }, _marked[0], this, [[10, 20]]);
	}
	
	function get_error_messages(detail) {
	    var user_error_updates = {};
	    if (detail.fields) {
	        if (detail.fields.forum_name) {
	            user_error_updates.forumNameError = detail.fields.forum_name[0];
	        }
	        if (detail.fields.birth_date) {
	            user_error_updates.birthDateError = 'Please check your Birth Date.';
	        }
	        if (detail.fields.email) {
	            user_error_updates.emailError = detail.fields.email[0];
	        }
	        if (detail.fields.password) {
	            user_error_updates.passwordError = detail.fields.password[0];
	        }
	        user_error_updates.generalError = 'Please fill out required fields.';
	    } else {
	        user_error_updates.generalError = detail.message;
	    }
	    return user_error_updates;
	}
	
	function root() {
	    return regeneratorRuntime.wrap(function root$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return (0, _effects.fork)(watchSignupApi);
	
	                case 2:
	                case 'end':
	                    return _context2.stop();
	            }
	        }
	    }, _marked[1], this);
	}

/***/ },

/***/ "./app/preact/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _mount = __webpack_require__("./app/preact/mount.js");
	
	var components = {
	    // "css selector": "path/to/component.js",
	    'astrology-compatibility': 'compatibility/astrology',
	    'birthday-select': 'responsive/birthday-select',
	    'catalog-content': 'catalog/content',
	    'catalog-inputs': 'catalog/inputs',
	    'compatibility-chooser': 'compatibility/chooser',
	    'cosmic-profile': 'cosmic-profile',
	    'daily-hexagram': 'daily/hexagram/index',
	    'daily-horoscope': 'daily/horoscope',
	    'daily-number': 'daily/number/index',
	    'daily-tarot-card': 'daily/tarot-card/index',
	    'date-picker': 'date-picker',
	    'date-select': 'fields/date',
	    'desktop-nav-dropdown': 'responsive/desktop-nav-dropdown',
	    'discount-message': 'karmacoin-store/discount-message',
	    'email-unsub': 'member/email-unsub',
	    'eyeota': 'eyeota',
	    'feedback-tab': 'feedback/tab',
	    'feedback-form': 'feedback/form',
	    'ga-events': 'ga-events',
	    'gdpr-cmp-sortable': 'gdpr-cmp-sortable',
	    'hexagram-content': 'content/hexagram',
	    'input-validation': 'form/input-validation',
	    'i-ching-reading': 'i-ching-reading',
	    'karmacoin-header': 'karmacoin-store/karmacoin-header',
	    'karmacoin-submit': 'karmacoin-store/karmacoin-submit',
	    'light-box': 'light-box',
	    'logged-in': 'logged-in',
	    'logged-out': 'logged-out',
	    'login-modal': 'user/login-modal',
	    'member-email-preferences': 'member/email-preferences',
	    'mini-horoscope': 'mini-horoscope',
	    'mini-tcod': 'mini-tcod',
	    'mobile-daily-links': 'mobile-daily-links',
	    'mobile-nav-dropdown': 'mobile-nav-dropdown',
	    'moon-phase': 'moon-phase',
	    'more-scopes-menu': 'more-scopes-menu',
	    'more-today': 'more-today',
	    'nav-bar': 'nav-bar',
	    'nav-bar-mobile': 'nav-bar-mobile',
	    'oranum-psychics': 'oranum-psychics',
	    'oranum-psychics-responsive': 'responsive/oranum-psychics',
	    'planet-tracker': 'planet-tracker',
	    'policy-consent': 'policy-consent',
	    'power-package': 'karmacoin-store/power-package',
	    'product-message': 'product-message',
	    'promo-message': 'promo-message',
	    'promoted-content': 'content/promoted',
	    'report-teeup': 'report-teeup',
	    'sale-message': 'sale-message',
	    'signup-forums': 'user/signup-forums',
	    'signup-modal': 'user/signup-modal',
	    'signup-modal-desktop': 'user/signup-modal-desktop',
	    'a[data-is=smooth-scroll]': 'smooth-scroll',
	    'div[data-is=page-accordion]': 'page-accordion',
	    'raw': 'raw',
	    'responsive-login-modal': 'responsive/login-modal',
	    'responsive-planet-tracker': 'responsive/planet-tracker',
	    'responsive-promoted-content': 'responsive/promoted-content',
	    'responsive-signup-modal': 'responsive/signup-modal',
	    'show-details': 'show-details',
	    'standard-package': 'karmacoin-store/standard-package',
	    'standard-packages': 'karmacoin-store/standard-packages',
	    'subscription-teeup': 'subscription-teeup',
	    'tarot-card-browser': 'tarot-card-browser',
	    'tarot-reading': 'tarot-readings/tarot-reading',
	    'tarot-top-bar': 'tarot-top-bar',
	    'today-module-nav': 'today-module-nav',
	    'top-bar': 'responsive/top-bar',
	    'user-menu': 'user/menu',
	    'weekly-love-horoscope': 'weekly/love-horoscope',
	    'zodiac-sign-picker': 'zodiac-sign-picker'
	};
	
	Object.keys(components).forEach(function (tag) {
	    var path = components[tag];
	
	    var _require = __webpack_require__(4)("./" + path),
	        Component = _require.default;
	
	    (0, _mount.register)(tag, Component);
	});

/***/ },

/***/ "./app/preact/mount.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.register = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _redux = __webpack_require__("./app/redux.js");
	
	var mount = function mount(node, Component) {
	    if (node._componentConstructor) {
	        return;
	    }
	    (0, _preact.render)((0, _preact.h)(
	        _preactRedux.Provider,
	        { store: _redux.store },
	        (0, _preact.h)(Component, _extends({ innerHTML: node.innerHTML }, (0, _util.attributesToObject)(node.attributes)))
	    ), node.parentNode, node);
	    node._component = Component;
	};
	
	var forEachNode = function forEachNode(selector, iterator) {
	    var nodes = document.querySelectorAll(selector);
	    Array.prototype.forEach.call(nodes, iterator);
	};
	
	var mountEachNode = function mountEachNode(tag, Component) {
	    return forEachNode(tag, function (node) {
	        return mount(node, Component);
	    });
	};
	
	var register = exports.register = function register(tag, Component) {
	    // mount to existing elements
	    mountEachNode(tag, Component);
	
	    // watch for new elements
	    var observer = new MutationObserver(function () {
	        mountEachNode(tag, Component);
	    });
	    observer.observe(document.body, {
	        childList: true,
	        subtree: true
	    });
	};

/***/ },

/***/ "../node_modules/preact/dist/preact.js":
/***/ function(module, exports, __webpack_require__) {

	!function() {
	    'use strict';
	    function VNode() {}
	    function h(nodeName, attributes) {
	        var lastSimple, child, simple, i, children = EMPTY_CHILDREN;
	        for (i = arguments.length; i-- > 2; ) stack.push(arguments[i]);
	        if (attributes && null != attributes.children) {
	            if (!stack.length) stack.push(attributes.children);
	            delete attributes.children;
	        }
	        while (stack.length) if ((child = stack.pop()) && void 0 !== child.pop) for (i = child.length; i--; ) stack.push(child[i]); else {
	            if (child === !0 || child === !1) child = null;
	            if (simple = 'function' != typeof nodeName) if (null == child) child = ''; else if ('number' == typeof child) child = String(child); else if ('string' != typeof child) simple = !1;
	            if (simple && lastSimple) children[children.length - 1] += child; else if (children === EMPTY_CHILDREN) children = [ child ]; else children.push(child);
	            lastSimple = simple;
	        }
	        var p = new VNode();
	        p.nodeName = nodeName;
	        p.children = children;
	        p.attributes = null == attributes ? void 0 : attributes;
	        p.key = null == attributes ? void 0 : attributes.key;
	        if (void 0 !== options.vnode) options.vnode(p);
	        return p;
	    }
	    function extend(obj, props) {
	        for (var i in props) obj[i] = props[i];
	        return obj;
	    }
	    function cloneElement(vnode, props) {
	        return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
	    }
	    function enqueueRender(component) {
	        if (!component.__d && (component.__d = !0) && 1 == items.push(component)) (options.debounceRendering || setTimeout)(rerender);
	    }
	    function rerender() {
	        var p, list = items;
	        items = [];
	        while (p = list.pop()) if (p.__d) renderComponent(p);
	    }
	    function isSameNodeType(node, vnode, hydrating) {
	        if ('string' == typeof vnode || 'number' == typeof vnode) return void 0 !== node.splitText;
	        if ('string' == typeof vnode.nodeName) return !node._componentConstructor && isNamedNode(node, vnode.nodeName); else return hydrating || node._componentConstructor === vnode.nodeName;
	    }
	    function isNamedNode(node, nodeName) {
	        return node.__n === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
	    }
	    function getNodeProps(vnode) {
	        var props = extend({}, vnode.attributes);
	        props.children = vnode.children;
	        var defaultProps = vnode.nodeName.defaultProps;
	        if (void 0 !== defaultProps) for (var i in defaultProps) if (void 0 === props[i]) props[i] = defaultProps[i];
	        return props;
	    }
	    function createNode(nodeName, isSvg) {
	        var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
	        node.__n = nodeName;
	        return node;
	    }
	    function removeNode(node) {
	        if (node.parentNode) node.parentNode.removeChild(node);
	    }
	    function setAccessor(node, name, old, value, isSvg) {
	        if ('className' === name) name = 'class';
	        if ('key' === name) ; else if ('ref' === name) {
	            if (old) old(null);
	            if (value) value(node);
	        } else if ('class' === name && !isSvg) node.className = value || ''; else if ('style' === name) {
	            if (!value || 'string' == typeof value || 'string' == typeof old) node.style.cssText = value || '';
	            if (value && 'object' == typeof value) {
	                if ('string' != typeof old) for (var i in old) if (!(i in value)) node.style[i] = '';
	                for (var i in value) node.style[i] = 'number' == typeof value[i] && IS_NON_DIMENSIONAL.test(i) === !1 ? value[i] + 'px' : value[i];
	            }
	        } else if ('dangerouslySetInnerHTML' === name) {
	            if (value) node.innerHTML = value.__html || '';
	        } else if ('o' == name[0] && 'n' == name[1]) {
	            var useCapture = name !== (name = name.replace(/Capture$/, ''));
	            name = name.toLowerCase().substring(2);
	            if (value) {
	                if (!old) node.addEventListener(name, eventProxy, useCapture);
	            } else node.removeEventListener(name, eventProxy, useCapture);
	            (node.__l || (node.__l = {}))[name] = value;
	        } else if ('list' !== name && 'type' !== name && !isSvg && name in node) {
	            setProperty(node, name, null == value ? '' : value);
	            if (null == value || value === !1) node.removeAttribute(name);
	        } else {
	            var ns = isSvg && name !== (name = name.replace(/^xlink\:?/, ''));
	            if (null == value || value === !1) if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase()); else node.removeAttribute(name); else if ('function' != typeof value) if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value); else node.setAttribute(name, value);
	        }
	    }
	    function setProperty(node, name, value) {
	        try {
	            node[name] = value;
	        } catch (e) {}
	    }
	    function eventProxy(e) {
	        return this.__l[e.type](options.event && options.event(e) || e);
	    }
	    function flushMounts() {
	        var c;
	        while (c = mounts.pop()) {
	            if (options.afterMount) options.afterMount(c);
	            if (c.componentDidMount) c.componentDidMount();
	        }
	    }
	    function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	        if (!diffLevel++) {
	            isSvgMode = null != parent && void 0 !== parent.ownerSVGElement;
	            hydrating = null != dom && !('__preactattr_' in dom);
	        }
	        var ret = idiff(dom, vnode, context, mountAll, componentRoot);
	        if (parent && ret.parentNode !== parent) parent.appendChild(ret);
	        if (!--diffLevel) {
	            hydrating = !1;
	            if (!componentRoot) flushMounts();
	        }
	        return ret;
	    }
	    function idiff(dom, vnode, context, mountAll, componentRoot) {
	        var out = dom, prevSvgMode = isSvgMode;
	        if (null == vnode) vnode = '';
	        if ('string' == typeof vnode) {
	            if (dom && void 0 !== dom.splitText && dom.parentNode && (!dom._component || componentRoot)) {
	                if (dom.nodeValue != vnode) dom.nodeValue = vnode;
	            } else {
	                out = document.createTextNode(vnode);
	                if (dom) {
	                    if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
	                    recollectNodeTree(dom, !0);
	                }
	            }
	            out.__preactattr_ = !0;
	            return out;
	        }
	        if ('function' == typeof vnode.nodeName) return buildComponentFromVNode(dom, vnode, context, mountAll);
	        isSvgMode = 'svg' === vnode.nodeName ? !0 : 'foreignObject' === vnode.nodeName ? !1 : isSvgMode;
	        if (!dom || !isNamedNode(dom, String(vnode.nodeName))) {
	            out = createNode(String(vnode.nodeName), isSvgMode);
	            if (dom) {
	                while (dom.firstChild) out.appendChild(dom.firstChild);
	                if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
	                recollectNodeTree(dom, !0);
	            }
	        }
	        var fc = out.firstChild, props = out.__preactattr_ || (out.__preactattr_ = {}), vchildren = vnode.children;
	        if (!hydrating && vchildren && 1 === vchildren.length && 'string' == typeof vchildren[0] && null != fc && void 0 !== fc.splitText && null == fc.nextSibling) {
	            if (fc.nodeValue != vchildren[0]) fc.nodeValue = vchildren[0];
	        } else if (vchildren && vchildren.length || null != fc) innerDiffNode(out, vchildren, context, mountAll, hydrating || null != props.dangerouslySetInnerHTML);
	        diffAttributes(out, vnode.attributes, props);
	        isSvgMode = prevSvgMode;
	        return out;
	    }
	    function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
	        var j, c, vchild, child, originalChildren = dom.childNodes, children = [], keyed = {}, keyedLen = 0, min = 0, len = originalChildren.length, childrenLen = 0, vlen = vchildren ? vchildren.length : 0;
	        if (0 !== len) for (var i = 0; i < len; i++) {
	            var _child = originalChildren[i], props = _child.__preactattr_, key = vlen && props ? _child._component ? _child._component.__k : props.key : null;
	            if (null != key) {
	                keyedLen++;
	                keyed[key] = _child;
	            } else if (props || (void 0 !== _child.splitText ? isHydrating ? _child.nodeValue.trim() : !0 : isHydrating)) children[childrenLen++] = _child;
	        }
	        if (0 !== vlen) for (var i = 0; i < vlen; i++) {
	            vchild = vchildren[i];
	            child = null;
	            var key = vchild.key;
	            if (null != key) {
	                if (keyedLen && void 0 !== keyed[key]) {
	                    child = keyed[key];
	                    keyed[key] = void 0;
	                    keyedLen--;
	                }
	            } else if (!child && min < childrenLen) for (j = min; j < childrenLen; j++) if (void 0 !== children[j] && isSameNodeType(c = children[j], vchild, isHydrating)) {
	                child = c;
	                children[j] = void 0;
	                if (j === childrenLen - 1) childrenLen--;
	                if (j === min) min++;
	                break;
	            }
	            child = idiff(child, vchild, context, mountAll);
	            if (child && child !== dom) if (i >= len) dom.appendChild(child); else if (child !== originalChildren[i]) if (child === originalChildren[i + 1]) removeNode(originalChildren[i]); else dom.insertBefore(child, originalChildren[i] || null);
	        }
	        if (keyedLen) for (var i in keyed) if (void 0 !== keyed[i]) recollectNodeTree(keyed[i], !1);
	        while (min <= childrenLen) if (void 0 !== (child = children[childrenLen--])) recollectNodeTree(child, !1);
	    }
	    function recollectNodeTree(node, unmountOnly) {
	        var component = node._component;
	        if (component) unmountComponent(component); else {
	            if (null != node.__preactattr_ && node.__preactattr_.ref) node.__preactattr_.ref(null);
	            if (unmountOnly === !1 || null == node.__preactattr_) removeNode(node);
	            removeChildren(node);
	        }
	    }
	    function removeChildren(node) {
	        node = node.lastChild;
	        while (node) {
	            var next = node.previousSibling;
	            recollectNodeTree(node, !0);
	            node = next;
	        }
	    }
	    function diffAttributes(dom, attrs, old) {
	        var name;
	        for (name in old) if ((!attrs || null == attrs[name]) && null != old[name]) setAccessor(dom, name, old[name], old[name] = void 0, isSvgMode);
	        for (name in attrs) if (!('children' === name || 'innerHTML' === name || name in old && attrs[name] === ('value' === name || 'checked' === name ? dom[name] : old[name]))) setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
	    }
	    function collectComponent(component) {
	        var name = component.constructor.name;
	        (components[name] || (components[name] = [])).push(component);
	    }
	    function createComponent(Ctor, props, context) {
	        var inst, list = components[Ctor.name];
	        if (Ctor.prototype && Ctor.prototype.render) {
	            inst = new Ctor(props, context);
	            Component.call(inst, props, context);
	        } else {
	            inst = new Component(props, context);
	            inst.constructor = Ctor;
	            inst.render = doRender;
	        }
	        if (list) for (var i = list.length; i--; ) if (list[i].constructor === Ctor) {
	            inst.__b = list[i].__b;
	            list.splice(i, 1);
	            break;
	        }
	        return inst;
	    }
	    function doRender(props, state, context) {
	        return this.constructor(props, context);
	    }
	    function setComponentProps(component, props, opts, context, mountAll) {
	        if (!component.__x) {
	            component.__x = !0;
	            if (component.__r = props.ref) delete props.ref;
	            if (component.__k = props.key) delete props.key;
	            if (!component.base || mountAll) {
	                if (component.componentWillMount) component.componentWillMount();
	            } else if (component.componentWillReceiveProps) component.componentWillReceiveProps(props, context);
	            if (context && context !== component.context) {
	                if (!component.__c) component.__c = component.context;
	                component.context = context;
	            }
	            if (!component.__p) component.__p = component.props;
	            component.props = props;
	            component.__x = !1;
	            if (0 !== opts) if (1 === opts || options.syncComponentUpdates !== !1 || !component.base) renderComponent(component, 1, mountAll); else enqueueRender(component);
	            if (component.__r) component.__r(component);
	        }
	    }
	    function renderComponent(component, opts, mountAll, isChild) {
	        if (!component.__x) {
	            var rendered, inst, cbase, props = component.props, state = component.state, context = component.context, previousProps = component.__p || props, previousState = component.__s || state, previousContext = component.__c || context, isUpdate = component.base, nextBase = component.__b, initialBase = isUpdate || nextBase, initialChildComponent = component._component, skip = !1;
	            if (isUpdate) {
	                component.props = previousProps;
	                component.state = previousState;
	                component.context = previousContext;
	                if (2 !== opts && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === !1) skip = !0; else if (component.componentWillUpdate) component.componentWillUpdate(props, state, context);
	                component.props = props;
	                component.state = state;
	                component.context = context;
	            }
	            component.__p = component.__s = component.__c = component.__b = null;
	            component.__d = !1;
	            if (!skip) {
	                rendered = component.render(props, state, context);
	                if (component.getChildContext) context = extend(extend({}, context), component.getChildContext());
	                var toUnmount, base, childComponent = rendered && rendered.nodeName;
	                if ('function' == typeof childComponent) {
	                    var childProps = getNodeProps(rendered);
	                    inst = initialChildComponent;
	                    if (inst && inst.constructor === childComponent && childProps.key == inst.__k) setComponentProps(inst, childProps, 1, context, !1); else {
	                        toUnmount = inst;
	                        component._component = inst = createComponent(childComponent, childProps, context);
	                        inst.__b = inst.__b || nextBase;
	                        inst.__u = component;
	                        setComponentProps(inst, childProps, 0, context, !1);
	                        renderComponent(inst, 1, mountAll, !0);
	                    }
	                    base = inst.base;
	                } else {
	                    cbase = initialBase;
	                    toUnmount = initialChildComponent;
	                    if (toUnmount) cbase = component._component = null;
	                    if (initialBase || 1 === opts) {
	                        if (cbase) cbase._component = null;
	                        base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, !0);
	                    }
	                }
	                if (initialBase && base !== initialBase && inst !== initialChildComponent) {
	                    var baseParent = initialBase.parentNode;
	                    if (baseParent && base !== baseParent) {
	                        baseParent.replaceChild(base, initialBase);
	                        if (!toUnmount) {
	                            initialBase._component = null;
	                            recollectNodeTree(initialBase, !1);
	                        }
	                    }
	                }
	                if (toUnmount) unmountComponent(toUnmount);
	                component.base = base;
	                if (base && !isChild) {
	                    var componentRef = component, t = component;
	                    while (t = t.__u) (componentRef = t).base = base;
	                    base._component = componentRef;
	                    base._componentConstructor = componentRef.constructor;
	                }
	            }
	            if (!isUpdate || mountAll) mounts.unshift(component); else if (!skip) {
	                flushMounts();
	                if (component.componentDidUpdate) component.componentDidUpdate(previousProps, previousState, previousContext);
	                if (options.afterUpdate) options.afterUpdate(component);
	            }
	            if (null != component.__h) while (component.__h.length) component.__h.pop().call(component);
	            if (!diffLevel && !isChild) flushMounts();
	        }
	    }
	    function buildComponentFromVNode(dom, vnode, context, mountAll) {
	        var c = dom && dom._component, originalComponent = c, oldDom = dom, isDirectOwner = c && dom._componentConstructor === vnode.nodeName, isOwner = isDirectOwner, props = getNodeProps(vnode);
	        while (c && !isOwner && (c = c.__u)) isOwner = c.constructor === vnode.nodeName;
	        if (c && isOwner && (!mountAll || c._component)) {
	            setComponentProps(c, props, 3, context, mountAll);
	            dom = c.base;
	        } else {
	            if (originalComponent && !isDirectOwner) {
	                unmountComponent(originalComponent);
	                dom = oldDom = null;
	            }
	            c = createComponent(vnode.nodeName, props, context);
	            if (dom && !c.__b) {
	                c.__b = dom;
	                oldDom = null;
	            }
	            setComponentProps(c, props, 1, context, mountAll);
	            dom = c.base;
	            if (oldDom && dom !== oldDom) {
	                oldDom._component = null;
	                recollectNodeTree(oldDom, !1);
	            }
	        }
	        return dom;
	    }
	    function unmountComponent(component) {
	        if (options.beforeUnmount) options.beforeUnmount(component);
	        var base = component.base;
	        component.__x = !0;
	        if (component.componentWillUnmount) component.componentWillUnmount();
	        component.base = null;
	        var inner = component._component;
	        if (inner) unmountComponent(inner); else if (base) {
	            if (base.__preactattr_ && base.__preactattr_.ref) base.__preactattr_.ref(null);
	            component.__b = base;
	            removeNode(base);
	            collectComponent(component);
	            removeChildren(base);
	        }
	        if (component.__r) component.__r(null);
	    }
	    function Component(props, context) {
	        this.__d = !0;
	        this.context = context;
	        this.props = props;
	        this.state = this.state || {};
	    }
	    function render(vnode, parent, merge) {
	        return diff(merge, vnode, {}, !1, parent, !1);
	    }
	    var options = {};
	    var stack = [];
	    var EMPTY_CHILDREN = [];
	    var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;
	    var items = [];
	    var mounts = [];
	    var diffLevel = 0;
	    var isSvgMode = !1;
	    var hydrating = !1;
	    var components = {};
	    extend(Component.prototype, {
	        setState: function(state, callback) {
	            var s = this.state;
	            if (!this.__s) this.__s = extend({}, s);
	            extend(s, 'function' == typeof state ? state(s, this.props) : state);
	            if (callback) (this.__h = this.__h || []).push(callback);
	            enqueueRender(this);
	        },
	        forceUpdate: function(callback) {
	            if (callback) (this.__h = this.__h || []).push(callback);
	            renderComponent(this, 2);
	        },
	        render: function() {}
	    });
	    var preact = {
	        h: h,
	        createElement: h,
	        cloneElement: cloneElement,
	        Component: Component,
	        render: render,
	        rerender: rerender,
	        options: options
	    };
	    if (true) module.exports = preact; else self.preact = preact;
	}();
	//# sourceMappingURL=preact.js.map

/***/ },

/***/ "../node_modules/preact-redux/dist/preact-redux.js":
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? module.exports = factory(__webpack_require__("../node_modules/preact/dist/preact.js"), __webpack_require__("../node_modules/redux/lib/index.js")) :
		typeof define === 'function' && define.amd ? define(['preact', 'redux'], factory) :
		(global.preactRedux = factory(global.preact,global.Redux));
	}(this, (function (preact,redux) {
	
	var Children = {
		only: function only(children) {
			return children && children[0] || null;
		}
	};
	
	function proptype() {}
	proptype.isRequired = proptype;
	
	var PropTypes = {
		element: proptype,
		func: proptype,
		shape: function shape() {
			return proptype;
		},
		instanceOf: function instanceOf() {
			return proptype;
		}
	};
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	};
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	
	
	
	
	
	
	
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var get = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	
	
	var set = function set(object, property, value, receiver) {
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent !== null) {
	      set(parent, property, value, receiver);
	    }
	  } else if ("value" in desc && desc.writable) {
	    desc.value = value;
	  } else {
	    var setter = desc.set;
	
	    if (setter !== undefined) {
	      setter.call(receiver, value);
	    }
	  }
	
	  return value;
	};
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub) {
	    classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      // this.onStateChange is set by connectAdvanced.initSubscription()
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	var storeShape = PropTypes.shape({
	  subscribe: PropTypes.func.isRequired,
	  dispatch: PropTypes.func.isRequired,
	  getState: PropTypes.func.isRequired
	});
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  warning('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store, storeSubscription: null };
	  };
	
	  function Provider(props, context) {
	    classCallCheck(this, Provider);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return Children.only(this.props.children);
	  };
	
	  return Provider;
	}(preact.Component);
	
	{
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.childContextTypes = {
	  store: storeShape.isRequired,
	  storeSubscription: PropTypes.instanceOf(Subscription)
	};
	Provider.displayName = 'Provider';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	var index = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') {
	        // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {}
	            }
	        }
	    }
	
	    return targetComponent;
	};
	
	var invariant = function () {}
	
	var hotReloadingVersion = 0;
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  var _ref$getDisplayName = _ref.getDisplayName;
	  var getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName;
	  var _ref$methodName = _ref.methodName;
	  var methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName;
	  var _ref$renderCountProp = _ref.renderCountProp;
	  var renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp;
	  var _ref$shouldHandleStat = _ref.shouldHandleStateChanges;
	  var shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat;
	  var _ref$storeKey = _ref.storeKey;
	  var storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey;
	  var _ref$withRef = _ref.withRef;
	  var withRef = _ref$withRef === undefined ? false : _ref$withRef;
	  var connectOptions = objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = storeShape, _contextTypes[subscriptionKey] = PropTypes.instanceOf(Subscription), _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = PropTypes.instanceOf(Subscription), _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    invariant(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + WrappedComponent));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        classCallCheck(this, Connect);
	
	        var _this = possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = _this.props[storeKey] || _this.context[storeKey];
	        _this.parentSub = props[subscriptionKey] || context[subscriptionKey];
	
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        invariant(_this.store, 'Could not find "' + storeKey + '" in either the context or ' + ('props of "' + displayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        // make sure `getState` is properly bound in order to avoid breaking
	        // custom store implementations that rely on the store's context
	        _this.getState = _this.store.getState.bind(_this.store);
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        return _ref2 = {}, _ref2[subscriptionKey] = this.subscription || this.parentSub, _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        // these are just to guard against extra memory leakage if a parent element doesn't
	        // dereference this instance properly, such as an async callback that never finishes
	        this.subscription = null;
	        this.store = null;
	        this.parentSub = null;
	        this.selector.run = function () {};
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        invariant(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var dispatch = this.store.dispatch;
	        var getState = this.getState;
	
	        var sourceSelector = selectorFactory(dispatch, selectorFactoryOptions);
	
	        // wrap the selector in an object that tracks its results between runs
	        var selector = this.selector = {
	          shouldComponentUpdate: true,
	          props: sourceSelector(getState(), this.props),
	          run: function runComponentSelector(props) {
	            try {
	              var nextProps = sourceSelector(getState(), props);
	              if (selector.error || nextProps !== selector.props) {
	                selector.shouldComponentUpdate = true;
	                selector.props = nextProps;
	                selector.error = null;
	              }
	            } catch (error) {
	              selector.shouldComponentUpdate = true;
	              selector.error = error;
	            }
	          }
	        };
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        var _this2 = this;
	
	        if (shouldHandleStateChanges) {
	          (function () {
	            var subscription = _this2.subscription = new Subscription(_this2.store, _this2.parentSub);
	            var dummyState = {};
	
	            subscription.onStateChange = function onStateChange() {
	              this.selector.run(this.props);
	
	              if (!this.selector.shouldComponentUpdate) {
	                subscription.notifyNestedSubs();
	              } else {
	                this.componentDidUpdate = function componentDidUpdate() {
	                  this.componentDidUpdate = undefined;
	                  subscription.notifyNestedSubs();
	                };
	
	                this.setState(dummyState);
	              }
	            }.bind(_this2);
	          })();
	        }
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return preact.h(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(preact.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	
	
	    {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          if (this.subscription) this.subscription.tryUnsubscribe();
	          this.initSubscription();
	          if (shouldHandleStateChanges) this.subscription.trySubscribe();
	        }
	      };
	    }
	
	    return index(Connect, WrappedComponent);
	  };
	}
	
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function shallowEqual(a, b) {
	  if (a === b) return true;
	
	  var countA = 0;
	  var countB = 0;
	
	  for (var key in a) {
	    if (hasOwn.call(a, key) && a[key] !== b[key]) return false;
	    countA++;
	  }
	
	  for (var _key in b) {
	    if (hasOwn.call(b, _key)) countB++;
	  }
	
	  return countA === countB;
	}
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetPrototype = Object.getPrototypeOf;
	
	/**
	 * Gets the `[[Prototype]]` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {null|Object} Returns the `[[Prototype]]`.
	 */
	function getPrototype(value) {
	  return nativeGetPrototype(Object(value));
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
	}
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object,
	 *  else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
	}
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!isPlainObject(value)) {
	    warning(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      verifyPlainObject(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && (typeof mapDispatchToProps === 'undefined' ? 'undefined' : _typeof(mapDispatchToProps)) === 'object' ? wrapMapToPropsConstant(function (dispatch) {
	    return redux.bindActionCreators(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	var defaultMapDispatchToPropsFactories = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? wrapMapToPropsConstant(function () {
	    return {};
	  }) : undefined;
	}
	
	var defaultMapStateToPropsFactories = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName;
	    var pure = _ref.pure;
	    var areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        verifyPlainObject(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	var defaultMergePropsFactories = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      warning('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual;
	  var areOwnPropsEqual = _ref.areOwnPropsEqual;
	  var areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps;
	  var initMapDispatchToProps = _ref2.initMapDispatchToProps;
	  var initMergeProps = _ref2.initMergeProps;
	  var options = objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  {
	    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  var _ref$connectHOC = _ref.connectHOC;
	  var connectHOC = _ref$connectHOC === undefined ? connectAdvanced : _ref$connectHOC;
	  var _ref$mapStateToPropsF = _ref.mapStateToPropsFactories;
	  var mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? defaultMapStateToPropsFactories : _ref$mapStateToPropsF;
	  var _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories;
	  var mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? defaultMapDispatchToPropsFactories : _ref$mapDispatchToPro;
	  var _ref$mergePropsFactor = _ref.mergePropsFactories;
	  var mergePropsFactories = _ref$mergePropsFactor === undefined ? defaultMergePropsFactories : _ref$mergePropsFactor;
	  var _ref$selectorFactory = _ref.selectorFactory;
	  var selectorFactory = _ref$selectorFactory === undefined ? finalPropsSelectorFactory : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	    var _ref2$pure = _ref2.pure;
	    var pure = _ref2$pure === undefined ? true : _ref2$pure;
	    var _ref2$areStatesEqual = _ref2.areStatesEqual;
	    var areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual;
	    var _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual;
	    var areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? shallowEqual : _ref2$areOwnPropsEqua;
	    var _ref2$areStatePropsEq = _ref2.areStatePropsEqual;
	    var areStatePropsEqual = _ref2$areStatePropsEq === undefined ? shallowEqual : _ref2$areStatePropsEq;
	    var _ref2$areMergedPropsE = _ref2.areMergedPropsEqual;
	    var areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? shallowEqual : _ref2$areMergedPropsE;
	    var extraOptions = objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	var connect$1 = createConnect();
	
	
	
	var lib$1 = {
		Provider: Provider,
		connect: connect$1,
		connectAdvanced: connectAdvanced
	};
	
	return lib$1;
	
	})));
	//# sourceMappingURL=preact-redux.js.map


/***/ },

/***/ 4:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./catalog/content": "./app/components/catalog/content.js",
		"./catalog/content.js": "./app/components/catalog/content.js",
		"./catalog/input": "./app/components/catalog/input.js",
		"./catalog/input.js": "./app/components/catalog/input.js",
		"./catalog/inputs": "./app/components/catalog/inputs.js",
		"./catalog/inputs.js": "./app/components/catalog/inputs.js",
		"./catalog/item": "./app/components/catalog/item.js",
		"./catalog/item.js": "./app/components/catalog/item.js",
		"./catalog/product": "./app/components/catalog/product.js",
		"./catalog/product.js": "./app/components/catalog/product.js",
		"./compatibility/astrology": "./app/components/compatibility/astrology.js",
		"./compatibility/astrology.js": "./app/components/compatibility/astrology.js",
		"./compatibility/chooser": "./app/components/compatibility/chooser.js",
		"./compatibility/chooser.js": "./app/components/compatibility/chooser.js",
		"./compatibility/item": "./app/components/compatibility/item.js",
		"./compatibility/item.js": "./app/components/compatibility/item.js",
		"./compatibility/types/chinese": "./app/components/compatibility/types/chinese.js",
		"./compatibility/types/chinese.js": "./app/components/compatibility/types/chinese.js",
		"./compatibility/types/zodiac": "./app/components/compatibility/types/zodiac.js",
		"./compatibility/types/zodiac.js": "./app/components/compatibility/types/zodiac.js",
		"./content/hexagram": "./app/components/content/hexagram.js",
		"./content/hexagram.js": "./app/components/content/hexagram.js",
		"./content/promoted": "./app/components/content/promoted.js",
		"./content/promoted-story": "./app/components/content/promoted-story.js",
		"./content/promoted-story.js": "./app/components/content/promoted-story.js",
		"./content/promoted.js": "./app/components/content/promoted.js",
		"./cosmic-profile": "./app/components/cosmic-profile.js",
		"./cosmic-profile.js": "./app/components/cosmic-profile.js",
		"./daily/hexagram/index": "./app/components/daily/hexagram/index.js",
		"./daily/hexagram/index.js": "./app/components/daily/hexagram/index.js",
		"./daily/hexagram/mobile": "./app/components/daily/hexagram/mobile.js",
		"./daily/hexagram/mobile.js": "./app/components/daily/hexagram/mobile.js",
		"./daily/hexagram/non-mobile": "./app/components/daily/hexagram/non-mobile.js",
		"./daily/hexagram/non-mobile.js": "./app/components/daily/hexagram/non-mobile.js",
		"./daily/horoscope": "./app/components/daily/horoscope.js",
		"./daily/horoscope.js": "./app/components/daily/horoscope.js",
		"./daily/number/index": "./app/components/daily/number/index.js",
		"./daily/number/index.js": "./app/components/daily/number/index.js",
		"./daily/number/mobile": "./app/components/daily/number/mobile.js",
		"./daily/number/mobile.js": "./app/components/daily/number/mobile.js",
		"./daily/number/non-mobile": "./app/components/daily/number/non-mobile.js",
		"./daily/number/non-mobile.js": "./app/components/daily/number/non-mobile.js",
		"./daily/tarot-card/index": "./app/components/daily/tarot-card/index.js",
		"./daily/tarot-card/index.js": "./app/components/daily/tarot-card/index.js",
		"./daily/tarot-card/mobile": "./app/components/daily/tarot-card/mobile.js",
		"./daily/tarot-card/mobile.js": "./app/components/daily/tarot-card/mobile.js",
		"./daily/tarot-card/non-mobile": "./app/components/daily/tarot-card/non-mobile.js",
		"./daily/tarot-card/non-mobile.js": "./app/components/daily/tarot-card/non-mobile.js",
		"./date-picker": "./app/components/date-picker.js",
		"./date-picker.js": "./app/components/date-picker.js",
		"./eyeota": "./app/components/eyeota.js",
		"./eyeota.js": "./app/components/eyeota.js",
		"./feedback/form": "./app/components/feedback/form.js",
		"./feedback/form.js": "./app/components/feedback/form.js",
		"./feedback/tab": "./app/components/feedback/tab.js",
		"./feedback/tab.js": "./app/components/feedback/tab.js",
		"./fields/date": "./app/components/fields/date.js",
		"./fields/date.js": "./app/components/fields/date.js",
		"./fields/gender": "./app/components/fields/gender.js",
		"./fields/gender.js": "./app/components/fields/gender.js",
		"./fields/name": "./app/components/fields/name.js",
		"./fields/name.js": "./app/components/fields/name.js",
		"./fields/time": "./app/components/fields/time.js",
		"./fields/time.js": "./app/components/fields/time.js",
		"./form/birthdate": "./app/components/form/birthdate.js",
		"./form/birthdate.js": "./app/components/form/birthdate.js",
		"./form/input-validation": "./app/components/form/input-validation.js",
		"./form/input-validation.js": "./app/components/form/input-validation.js",
		"./form/inputs/date-select": "./app/components/form/inputs/date-select.js",
		"./form/inputs/date-select.js": "./app/components/form/inputs/date-select.js",
		"./ga-events": "./app/components/ga-events.js",
		"./ga-events.js": "./app/components/ga-events.js",
		"./gdpr-cmp-sortable": "./app/components/gdpr-cmp-sortable.js",
		"./gdpr-cmp-sortable.js": "./app/components/gdpr-cmp-sortable.js",
		"./i-ching-reading": "./app/components/i-ching-reading.js",
		"./i-ching-reading.js": "./app/components/i-ching-reading.js",
		"./invisible-recaptcha": "./app/components/invisible-recaptcha.js",
		"./invisible-recaptcha.js": "./app/components/invisible-recaptcha.js",
		"./karmacoin-store/discount-message": "./app/components/karmacoin-store/discount-message.js",
		"./karmacoin-store/discount-message.js": "./app/components/karmacoin-store/discount-message.js",
		"./karmacoin-store/karmacoin-header": "./app/components/karmacoin-store/karmacoin-header.js",
		"./karmacoin-store/karmacoin-header.js": "./app/components/karmacoin-store/karmacoin-header.js",
		"./karmacoin-store/karmacoin-submit": "./app/components/karmacoin-store/karmacoin-submit.js",
		"./karmacoin-store/karmacoin-submit.js": "./app/components/karmacoin-store/karmacoin-submit.js",
		"./karmacoin-store/power-package": "./app/components/karmacoin-store/power-package.js",
		"./karmacoin-store/power-package.js": "./app/components/karmacoin-store/power-package.js",
		"./karmacoin-store/pseudo-select": "./app/components/karmacoin-store/pseudo-select.js",
		"./karmacoin-store/pseudo-select.js": "./app/components/karmacoin-store/pseudo-select.js",
		"./karmacoin-store/standard-package": "./app/components/karmacoin-store/standard-package.js",
		"./karmacoin-store/standard-package.js": "./app/components/karmacoin-store/standard-package.js",
		"./karmacoin-store/standard-packages": "./app/components/karmacoin-store/standard-packages.js",
		"./karmacoin-store/standard-packages.js": "./app/components/karmacoin-store/standard-packages.js",
		"./light-box": "./app/components/light-box.js",
		"./light-box.js": "./app/components/light-box.js",
		"./logged-in": "./app/components/logged-in.js",
		"./logged-in.js": "./app/components/logged-in.js",
		"./logged-out": "./app/components/logged-out.js",
		"./logged-out.js": "./app/components/logged-out.js",
		"./media-query": "./app/components/media-query.js",
		"./media-query.js": "./app/components/media-query.js",
		"./member/email-preference-list": "./app/components/member/email-preference-list.js",
		"./member/email-preference-list.js": "./app/components/member/email-preference-list.js",
		"./member/email-preferences": "./app/components/member/email-preferences.js",
		"./member/email-preferences.js": "./app/components/member/email-preferences.js",
		"./member/email-unsub": "./app/components/member/email-unsub.js",
		"./member/email-unsub-landing": "./app/components/member/email-unsub-landing.js",
		"./member/email-unsub-landing.js": "./app/components/member/email-unsub-landing.js",
		"./member/email-unsub-opt-in": "./app/components/member/email-unsub-opt-in.js",
		"./member/email-unsub-opt-in.js": "./app/components/member/email-unsub-opt-in.js",
		"./member/email-unsub-opt-out": "./app/components/member/email-unsub-opt-out.js",
		"./member/email-unsub-opt-out.js": "./app/components/member/email-unsub-opt-out.js",
		"./member/email-unsub.js": "./app/components/member/email-unsub.js",
		"./mini-horoscope": "./app/components/mini-horoscope.js",
		"./mini-horoscope.js": "./app/components/mini-horoscope.js",
		"./mini-tcod": "./app/components/mini-tcod.js",
		"./mini-tcod.js": "./app/components/mini-tcod.js",
		"./mobile-daily-links": "./app/components/mobile-daily-links.js",
		"./mobile-daily-links.js": "./app/components/mobile-daily-links.js",
		"./mobile-nav-dropdown": "./app/components/mobile-nav-dropdown.js",
		"./mobile-nav-dropdown.js": "./app/components/mobile-nav-dropdown.js",
		"./moon-phase": "./app/components/moon-phase.js",
		"./moon-phase.js": "./app/components/moon-phase.js",
		"./more-scopes-menu": "./app/components/more-scopes-menu.js",
		"./more-scopes-menu.js": "./app/components/more-scopes-menu.js",
		"./more-today": "./app/components/more-today.js",
		"./more-today.js": "./app/components/more-today.js",
		"./nav-articles": "./app/components/nav-articles.js",
		"./nav-articles.js": "./app/components/nav-articles.js",
		"./nav-bar": "./app/components/nav-bar.js",
		"./nav-bar-mobile": "./app/components/nav-bar-mobile.js",
		"./nav-bar-mobile.js": "./app/components/nav-bar-mobile.js",
		"./nav-bar.js": "./app/components/nav-bar.js",
		"./oranum-psychics": "./app/components/oranum-psychics.js",
		"./oranum-psychics.js": "./app/components/oranum-psychics.js",
		"./page-accordion": "./app/components/page-accordion.js",
		"./page-accordion.js": "./app/components/page-accordion.js",
		"./planet-tracker": "./app/components/planet-tracker.js",
		"./planet-tracker.js": "./app/components/planet-tracker.js",
		"./policy-consent": "./app/components/policy-consent.js",
		"./policy-consent.js": "./app/components/policy-consent.js",
		"./product-details": "./app/components/product-details.js",
		"./product-details.js": "./app/components/product-details.js",
		"./product-message": "./app/components/product-message.js",
		"./product-message.js": "./app/components/product-message.js",
		"./promo-message": "./app/components/promo-message.js",
		"./promo-message.js": "./app/components/promo-message.js",
		"./raw": "./app/components/raw.js",
		"./raw.js": "./app/components/raw.js",
		"./reading-header-price": "./app/components/reading-header-price.js",
		"./reading-header-price.js": "./app/components/reading-header-price.js",
		"./recaptcha": "./app/components/recaptcha.js",
		"./recaptcha.js": "./app/components/recaptcha.js",
		"./report-teeup": "./app/components/report-teeup.js",
		"./report-teeup.js": "./app/components/report-teeup.js",
		"./responsive/birthday-select": "./app/components/responsive/birthday-select.js",
		"./responsive/birthday-select.js": "./app/components/responsive/birthday-select.js",
		"./responsive/desktop-nav-dropdown": "./app/components/responsive/desktop-nav-dropdown.js",
		"./responsive/desktop-nav-dropdown.js": "./app/components/responsive/desktop-nav-dropdown.js",
		"./responsive/login-modal": "./app/components/responsive/login-modal.js",
		"./responsive/login-modal.js": "./app/components/responsive/login-modal.js",
		"./responsive/oranum-psychics": "./app/components/responsive/oranum-psychics.js",
		"./responsive/oranum-psychics.js": "./app/components/responsive/oranum-psychics.js",
		"./responsive/planet-tracker": "./app/components/responsive/planet-tracker.js",
		"./responsive/planet-tracker.js": "./app/components/responsive/planet-tracker.js",
		"./responsive/promoted-content": "./app/components/responsive/promoted-content.js",
		"./responsive/promoted-content-story": "./app/components/responsive/promoted-content-story.js",
		"./responsive/promoted-content-story.js": "./app/components/responsive/promoted-content-story.js",
		"./responsive/promoted-content.js": "./app/components/responsive/promoted-content.js",
		"./responsive/signup-modal": "./app/components/responsive/signup-modal.js",
		"./responsive/signup-modal.js": "./app/components/responsive/signup-modal.js",
		"./responsive/top-bar": "./app/components/responsive/top-bar.js",
		"./responsive/top-bar.js": "./app/components/responsive/top-bar.js",
		"./responsive/user-menu": "./app/components/responsive/user-menu.js",
		"./responsive/user-menu.js": "./app/components/responsive/user-menu.js",
		"./sale-message": "./app/components/sale-message.js",
		"./sale-message.js": "./app/components/sale-message.js",
		"./show-details": "./app/components/show-details.js",
		"./show-details.js": "./app/components/show-details.js",
		"./smooth-scroll": "./app/components/smooth-scroll.js",
		"./smooth-scroll.js": "./app/components/smooth-scroll.js",
		"./subscription-teeup": "./app/components/subscription-teeup.js",
		"./subscription-teeup.js": "./app/components/subscription-teeup.js",
		"./tarot-card-browser": "./app/components/tarot-card-browser.js",
		"./tarot-card-browser.js": "./app/components/tarot-card-browser.js",
		"./tarot-readings/spread-card": "./app/components/tarot-readings/spread-card.js",
		"./tarot-readings/spread-card.js": "./app/components/tarot-readings/spread-card.js",
		"./tarot-readings/spread-partial": "./app/components/tarot-readings/spread-partial.js",
		"./tarot-readings/spread-partial.js": "./app/components/tarot-readings/spread-partial.js",
		"./tarot-readings/spreads/analysis": "./app/components/tarot-readings/spreads/analysis.js",
		"./tarot-readings/spreads/analysis.js": "./app/components/tarot-readings/spreads/analysis.js",
		"./tarot-readings/spreads/bottom-line": "./app/components/tarot-readings/spreads/bottom-line.js",
		"./tarot-readings/spreads/bottom-line.js": "./app/components/tarot-readings/spreads/bottom-line.js",
		"./tarot-readings/spreads/celtic-cross": "./app/components/tarot-readings/spreads/celtic-cross.js",
		"./tarot-readings/spreads/celtic-cross-sample": "./app/components/tarot-readings/spreads/celtic-cross-sample.js",
		"./tarot-readings/spreads/celtic-cross-sample.js": "./app/components/tarot-readings/spreads/celtic-cross-sample.js",
		"./tarot-readings/spreads/celtic-cross.js": "./app/components/tarot-readings/spreads/celtic-cross.js",
		"./tarot-readings/spreads/heartbreak": "./app/components/tarot-readings/spreads/heartbreak.js",
		"./tarot-readings/spreads/heartbreak.js": "./app/components/tarot-readings/spreads/heartbreak.js",
		"./tarot-readings/spreads/horoscope-tarot": "./app/components/tarot-readings/spreads/horoscope-tarot.js",
		"./tarot-readings/spreads/horoscope-tarot.js": "./app/components/tarot-readings/spreads/horoscope-tarot.js",
		"./tarot-readings/spreads/karma": "./app/components/tarot-readings/spreads/karma.js",
		"./tarot-readings/spreads/karma.js": "./app/components/tarot-readings/spreads/karma.js",
		"./tarot-readings/spreads/life-cycle": "./app/components/tarot-readings/spreads/life-cycle.js",
		"./tarot-readings/spreads/life-cycle.js": "./app/components/tarot-readings/spreads/life-cycle.js",
		"./tarot-readings/spreads/mandala": "./app/components/tarot-readings/spreads/mandala.js",
		"./tarot-readings/spreads/mandala.js": "./app/components/tarot-readings/spreads/mandala.js",
		"./tarot-readings/spreads/potentials": "./app/components/tarot-readings/spreads/potentials.js",
		"./tarot-readings/spreads/potentials.js": "./app/components/tarot-readings/spreads/potentials.js",
		"./tarot-readings/spreads/reconciliation": "./app/components/tarot-readings/spreads/reconciliation.js",
		"./tarot-readings/spreads/reconciliation.js": "./app/components/tarot-readings/spreads/reconciliation.js",
		"./tarot-readings/spreads/revelation": "./app/components/tarot-readings/spreads/revelation.js",
		"./tarot-readings/spreads/revelation.js": "./app/components/tarot-readings/spreads/revelation.js",
		"./tarot-readings/spreads/soulmate": "./app/components/tarot-readings/spreads/soulmate.js",
		"./tarot-readings/spreads/soulmate.js": "./app/components/tarot-readings/spreads/soulmate.js",
		"./tarot-readings/spreads/star-of-david": "./app/components/tarot-readings/spreads/star-of-david.js",
		"./tarot-readings/spreads/star-of-david.js": "./app/components/tarot-readings/spreads/star-of-david.js",
		"./tarot-readings/spreads/timeline": "./app/components/tarot-readings/spreads/timeline.js",
		"./tarot-readings/spreads/timeline.js": "./app/components/tarot-readings/spreads/timeline.js",
		"./tarot-readings/spreads/tree-of-life": "./app/components/tarot-readings/spreads/tree-of-life.js",
		"./tarot-readings/spreads/tree-of-life.js": "./app/components/tarot-readings/spreads/tree-of-life.js",
		"./tarot-readings/spreads/yes-or-no": "./app/components/tarot-readings/spreads/yes-or-no.js",
		"./tarot-readings/spreads/yes-or-no.js": "./app/components/tarot-readings/spreads/yes-or-no.js",
		"./tarot-readings/tarot-reading": "./app/components/tarot-readings/tarot-reading.js",
		"./tarot-readings/tarot-reading.js": "./app/components/tarot-readings/tarot-reading.js",
		"./tarot-readings/tarot-reading/deck": "./app/components/tarot-readings/tarot-reading/deck.js",
		"./tarot-readings/tarot-reading/deck-card": "./app/components/tarot-readings/tarot-reading/deck-card.js",
		"./tarot-readings/tarot-reading/deck-card.js": "./app/components/tarot-readings/tarot-reading/deck-card.js",
		"./tarot-readings/tarot-reading/deck.js": "./app/components/tarot-readings/tarot-reading/deck.js",
		"./tarot-readings/tarot-reading/question": "./app/components/tarot-readings/tarot-reading/question.js",
		"./tarot-readings/tarot-reading/question.js": "./app/components/tarot-readings/tarot-reading/question.js",
		"./tarot-readings/tarot-reading/sample-interp": "./app/components/tarot-readings/tarot-reading/sample-interp.js",
		"./tarot-readings/tarot-reading/sample-interp-item": "./app/components/tarot-readings/tarot-reading/sample-interp-item.js",
		"./tarot-readings/tarot-reading/sample-interp-item.js": "./app/components/tarot-readings/tarot-reading/sample-interp-item.js",
		"./tarot-readings/tarot-reading/sample-interp.js": "./app/components/tarot-readings/tarot-reading/sample-interp.js",
		"./tarot-readings/tarot-reading/shuffle": "./app/components/tarot-readings/tarot-reading/shuffle.js",
		"./tarot-readings/tarot-reading/shuffle.js": "./app/components/tarot-readings/tarot-reading/shuffle.js",
		"./tarot-readings/tarot-reading/teeup": "./app/components/tarot-readings/tarot-reading/teeup.js",
		"./tarot-readings/tarot-reading/teeup.js": "./app/components/tarot-readings/tarot-reading/teeup.js",
		"./tarot-readings/tarot-spread": "./app/components/tarot-readings/tarot-spread.js",
		"./tarot-readings/tarot-spread.js": "./app/components/tarot-readings/tarot-spread.js",
		"./tarot-top-bar": "./app/components/tarot-top-bar.js",
		"./tarot-top-bar.js": "./app/components/tarot-top-bar.js",
		"./today-module-nav": "./app/components/today-module-nav.js",
		"./today-module-nav.js": "./app/components/today-module-nav.js",
		"./today-user-nav": "./app/components/today-user-nav.js",
		"./today-user-nav.js": "./app/components/today-user-nav.js",
		"./user/login-modal": "./app/components/user/login-modal.js",
		"./user/login-modal.js": "./app/components/user/login-modal.js",
		"./user/menu": "./app/components/user/menu.js",
		"./user/menu-mobile": "./app/components/user/menu-mobile.js",
		"./user/menu-mobile.js": "./app/components/user/menu-mobile.js",
		"./user/menu.js": "./app/components/user/menu.js",
		"./user/signup-forums": "./app/components/user/signup-forums.js",
		"./user/signup-forums.js": "./app/components/user/signup-forums.js",
		"./user/signup-modal": "./app/components/user/signup-modal.js",
		"./user/signup-modal-desktop": "./app/components/user/signup-modal-desktop.js",
		"./user/signup-modal-desktop.js": "./app/components/user/signup-modal-desktop.js",
		"./user/signup-modal.js": "./app/components/user/signup-modal.js",
		"./weekly/love-horoscope": "./app/components/weekly/love-horoscope.js",
		"./weekly/love-horoscope.js": "./app/components/weekly/love-horoscope.js",
		"./zodiac-sign-picker": "./app/components/zodiac-sign-picker.js",
		"./zodiac-sign-picker.js": "./app/components/zodiac-sign-picker.js"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 4;


/***/ },

/***/ "./app/components/catalog/content.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _product = __webpack_require__("./app/components/catalog/product.js");
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.getPrices({
	                search: this.props.filters.search,
	                price: this.props.filters.price
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref) {
	            var _this2 = this;
	
	            var products = _ref.products,
	                filters = _ref.filters;
	
	            var count = products ? products.length : 0;
	
	            if (products && count) {
	                return (0, _preact.h)(
	                    'catalog-content',
	                    null,
	                    this.renderHeader(),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'product-list' },
	                        products.map(function (product) {
	                            return _this2.renderProduct(product);
	                        })
	                    )
	                );
	            } else if (!products && !filters.length) {
	                //initial page load, no products or filters
	                return (0, _preact.h)(
	                    'catalog-content',
	                    null,
	                    this.renderHeader(),
	                    (0, _preact.h)(
	                        'h2',
	                        null,
	                        'Retrieving products...'
	                    )
	                );
	            }
	
	            // no products with filters,
	            return (0, _preact.h)(
	                'catalog-content',
	                null,
	                this.renderHeader(),
	                (0, _preact.h)(
	                    'h2',
	                    null,
	                    'No results found.'
	                )
	            );
	        }
	    }, {
	        key: 'renderHeader',
	        value: function renderHeader() {
	            return (0, _preact.h)(
	                'header',
	                null,
	                (0, _preact.h)(
	                    'h1',
	                    null,
	                    'Readings & Reports'
	                ),
	                this.renderSubheader()
	            );
	        }
	    }, {
	        key: 'renderSubheader',
	        value: function renderSubheader() {
	            if (this.props.user.logged_in) {
	                var total_kcs = this.props.user.kcs.total.toLocaleString();
	                return (0, _preact.h)(
	                    'p',
	                    null,
	                    this.props.user.username,
	                    ', you have ',
	                    (0, _preact.h)(
	                        'a',
	                        { href: '/store/karma-coins' },
	                        total_kcs,
	                        ' KARMA COINS'
	                    ),
	                    ' to use towards your purchase.',
	                    (0, _preact.h)('br', null),
	                    'Browse our products below or ',
	                    (0, _preact.h)(
	                        'a',
	                        { href: '/store/karma-coins' },
	                        'GET MORE KARMA COINS'
	                    ),
	                    '.'
	                );
	            }
	
	            return (0, _preact.h)(
	                'p',
	                null,
	                'Choose from our authentic collection of readings and reports to get the insight you need.'
	            );
	        }
	    }, {
	        key: 'renderProduct',
	        value: function renderProduct(product) {
	            return (0, _preact.h)(_product2.default, { product: product });
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        products: state.catalog && state.catalog.filteredProducts,
	        filters: state.catalog && state.catalog.filter,
	        user: state.user
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        getPrices: function getPrices(payload) {
	            return dispatch({ type: 'catalog:get-prices', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/catalog/product.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.trackClick = function (label) {
	            var action = _this.props.logged_in ? 'LI Click' : 'LO Click';
	
	            _this.props.trackEvent(['Catalog', action, label]);
	            _this.props.trackPromo(['Catalog', label]);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref2) {
	            var _this2 = this;
	
	            var product = _ref2.product;
	
	            var url = product.product_url.replace(/^https:\/\/www\.tarot\.com/, '');
	            var label = product.product_name;
	
	            return (0, _preact.h)(
	                'catalog-product',
	                null,
	                (0, _preact.h)(
	                    'a',
	                    {
	                        onClick: function onClick() {
	                            return _this2.trackClick(label);
	                        },
	                        href: url
	                    },
	                    (0, _preact.h)('img', { alt: product.product_name, src: product.catalog_image, 'class': 'product-image' }),
	                    this.renderPrice(product),
	                    (0, _preact.h)(
	                        'h3',
	                        null,
	                        (0, _preact.h)(
	                            'span',
	                            null,
	                            product.product_name
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderPrice',
	        value: function renderPrice(product) {
	            if (product.on_sale !== null) {
	                var price = 'FREE';
	
	                var special_products_price_map = {
	                    'karma-coin-package': 'SELECT PACKAGE'
	                };
	
	                if (product.code in special_products_price_map) {
	                    price = special_products_price_map[product.code];
	                } else if (product.kc) {
	                    price = product.kc + ' KARMA COINS';
	                }
	
	                return (0, _preact.h)(
	                    'p',
	                    null,
	                    (0, _preact.h)('img', {
	                        alt: 'Karma Coins',
	                        src: 'https://gfx.tarot.com/images/site/tarot/karma-coin-store/coin.svg'
	                    }),
	                    price
	                );
	            }
	
	            return (0, _preact.h)(
	                'p',
	                null,
	                '\xA0'
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        logged_in: state.user && state.user.logged_in
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        trackEvent: function trackEvent(payload) {
	            return dispatch({ type: 'ga:event', payload: payload });
	        },
	        trackPromo: function trackPromo(data) {
	            return dispatch({ type: 'promo-tracker:recordInternal', payload: data });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/catalog/input.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _item = __webpack_require__("./app/components/catalog/item.js");
	
	var _item2 = _interopRequireDefault(_item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.update = function () {
	            var count = _this.props.input.items.reduce(function (total, item) {
	                if (item.checked) {
	                    total++;
	                }
	
	                return total;
	            }, 0);
	            _this.setState({ count: count });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref2) {
	            var _this2 = this;
	
	            var input = _ref2.input;
	
	            return (0, _preact.h)(
	                'catalog-input',
	                null,
	                (0, _preact.h)(
	                    'h5',
	                    null,
	                    'Filter by ',
	                    input.name,
	                    this.renderCount(input.count),
	                    (0, _preact.h)('img', { src: 'https://gfx.tarot.com/images/catalog/update/catalog-arrow.svg', alt: 'white down arrow' })
	                ),
	                input.items.map(function (item) {
	                    return _this2.renderItem(item);
	                })
	            );
	        }
	    }, {
	        key: 'renderCount',
	        value: function renderCount(count) {
	            if (count) {
	                return (0, _preact.h)(
	                    'span',
	                    null,
	                    '( ',
	                    count,
	                    ' )'
	                );
	            }
	
	            return null;
	        }
	    }, {
	        key: 'renderItem',
	        value: function renderItem(item) {
	            return (0, _preact.h)(_item2.default, { item: item, callback: this.update });
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps() {
	    return {};
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/redux.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.store = undefined;
	
	var _redux = __webpack_require__("../node_modules/redux/lib/index.js");
	
	__webpack_require__("../node_modules/babel-regenerator-runtime/runtime.js");
	
	var _reduxSaga = __webpack_require__("../node_modules/redux-saga/lib/index.js");
	
	var _reduxSaga2 = _interopRequireDefault(_reduxSaga);
	
	var _reducers = __webpack_require__("./app/reducers/index.js");
	
	var _sagas = __webpack_require__("./app/sagas/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = window.appState || {}; // necessary before redux-saga
	
	var sagaMiddleware = (0, _reduxSaga2.default)();
	// https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd?hl=en
	var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
	var store = exports.store = (0, _redux.createStore)(_reducers.rootReducer, initialState, composeEnhancers((0, _redux.applyMiddleware)(sagaMiddleware)));
	_sagas.rootSagas.map(function (saga) {
	    return sagaMiddleware.run(saga);
	});

/***/ },

/***/ "./app/components/catalog/inputs.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _input = __webpack_require__("./app/components/catalog/input.js");
	
	var _input2 = _interopRequireDefault(_input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.handleKeyUp = function (e) {
	            _this.props.getFilter({ search: e.target.value });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref2) {
	            var inputs = _ref2.inputs;
	
	            if (inputs) {
	                if (window.innerWidth > 576) {
	                    // tablet and desktop
	                    return (0, _preact.h)(
	                        'catalog-inputs',
	                        null,
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'row container main_wrapper' },
	                            (0, _preact.h)(
	                                'div',
	                                { 'class': 'small-12 medium-6 columns' },
	                                (0, _preact.h)(
	                                    'div',
	                                    { 'class': 'small-6 columns' },
	                                    (0, _preact.h)(_input2.default, { input: inputs[0] })
	                                ),
	                                (0, _preact.h)(
	                                    'div',
	                                    { 'class': 'small-6 columns' },
	                                    (0, _preact.h)(_input2.default, { input: inputs[1] })
	                                )
	                            ),
	                            (0, _preact.h)(
	                                'div',
	                                { 'class': 'small-12 medium-6 columns' },
	                                this.renderSearch()
	                            )
	                        )
	                    );
	                }
	
	                return (0, _preact.h)(
	                    'catalog-inputs',
	                    null,
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'filters' },
	                        (0, _preact.h)(_input2.default, { input: inputs[0] }),
	                        (0, _preact.h)(_input2.default, { input: inputs[1] })
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'row' },
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'small-12 columns' },
	                            this.renderSearch()
	                        )
	                    )
	                );
	            }
	
	            return (0, _preact.h)('catalog-inputs', null);
	        }
	    }, {
	        key: 'renderSearch',
	        value: function renderSearch() {
	            return (0, _preact.h)('input', {
	                type: 'search',
	                name: 'search',
	                placeholder: 'Search Products',
	                onKeyUp: this.handleKeyUp
	            });
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        inputs: state.catalog && state.catalog.inputs,
	        filters: state.catalog && state.catalog.filter
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        getFilter: function getFilter(payload) {
	            return dispatch({ type: 'catalog:get-filter', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/compatibility/astrology.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _chooser = __webpack_require__("./app/components/compatibility/chooser.js");
	
	var _chooser2 = _interopRequireDefault(_chooser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this));
	
	        _this.toggleDetails = function () {
	            _this.setState({ isOpen: !_this.state.isOpen });
	        };
	
	        _this.renderDetails = function () {
	            if (_this.state.isOpen) {
	                return (0, _preact.h)('p', { 'class': 'learn-more', dangerouslySetInnerHTML: { __html: _this.props.description } });
	            }
	
	            return null;
	        };
	
	        _this.setState({ isOpen: false });
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var title = _ref.title,
	                short_description = _ref.short_description,
	                slant = _ref.slant,
	                type = _ref.type;
	
	            return (0, _preact.h)(
	                'astrology-compatibility',
	                null,
	                (0, _preact.h)(
	                    'h1',
	                    null,
	                    title
	                ),
	                (0, _preact.h)(
	                    'p',
	                    null,
	                    (0, _preact.h)('span', { 'class': 'short-description', dangerouslySetInnerHTML: { __html: short_description } }),
	                    (0, _preact.h)(
	                        'a',
	                        { onClick: this.toggleDetails },
	                        'Learn More'
	                    )
	                ),
	                this.renderDetails(),
	                (0, _preact.h)(_chooser2.default, { slant: slant, type: type })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        title: state.compatibility && state.compatibility.title,
	        description: state.compatibility && state.compatibility.description,
	        short_description: state.compatibility && state.compatibility.meta && state.compatibility.meta.description
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/compatibility/chooser.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _zodiac = __webpack_require__("./app/components/compatibility/types/zodiac.js");
	
	var _zodiac2 = _interopRequireDefault(_zodiac);
	
	var _chinese = __webpack_require__("./app/components/compatibility/types/chinese.js");
	
	var _chinese2 = _interopRequireDefault(_chinese);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.getReport = function () {
	            var signup_gateway = document.querySelector('input[name="signup_gateway"]');
	
	            if (signup_gateway) {
	                signup_gateway.value = 'compat-tag-' + _this.props.slant;
	            }
	
	            if (_this.props.path && _this.props.hash) {
	                _this.props.report(_this.state);
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref2) {
	            var type = _ref2.type,
	                slant = _ref2.slant,
	                path = _ref2.path,
	                hash = _ref2.hash,
	                button_text = _ref2.button_text;
	
	            var ChooserType = null;
	            if (type == 'zodiac') {
	                ChooserType = _zodiac2.default;
	            } else if (type == 'chinese') {
	                ChooserType = _chinese2.default;
	            }
	
	            if (ChooserType) {
	                return (0, _preact.h)(
	                    'compatibility-chooser',
	                    null,
	                    (0, _preact.h)(ChooserType, { slant: slant }),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'button-wrapper' },
	                        (0, _preact.h)(
	                            'button',
	                            {
	                                'class': 'button-warning' + (path && hash ? '' : ' disabled'),
	                                onClick: this.getReport
	                            },
	                            button_text
	                        )
	                    )
	                );
	            }
	
	            return null;
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        path: state['compatibility-chooser'] && state['compatibility-chooser'].path,
	        hash: state['compatibility-chooser'] && state['compatibility-chooser'].hash,
	        button_text: state['compatibility-chooser'] && state['compatibility-chooser'].submitting ? 'submitting…' : 'GET YOUR REPORT'
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        report: function report(payload) {
	            return dispatch({ type: 'compatibility-chooser:report', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/compatibility/types/zodiac.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _item = __webpack_require__("./app/components/compatibility/item.js");
	
	var _item2 = _interopRequireDefault(_item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderH2Text = function (sign, num) {
	            if (sign) {
	                return _this.renderItemText(sign);
	            }
	
	            return (0, _preact.h)(
	                'span',
	                null,
	                'Choose Sign ',
	                num
	            );
	        }, _this.renderItem = function (sign, which) {
	            return (0, _preact.h)(_item2.default, {
	                value: sign.name,
	                action: function action() {
	                    return _this.setSign(sign, which);
	                },
	                content: function content() {
	                    return _this.renderItemText(sign);
	                }
	            });
	        }, _this.renderItemText = function (sign) {
	            if (sign) {
	                return [(0, _preact.h)(
	                    'span',
	                    null,
	                    sign.name.charAt(0).toUpperCase() + sign.name.slice(1)
	                ), (0, _preact.h)(
	                    'small',
	                    null,
	                    sign.start,
	                    ' - ',
	                    sign.end
	                )];
	            }
	
	            return null;
	        }, _this.setSign = function (sign, which) {
	            var value = which == 'path' ? { path: sign } : { hash: sign };
	            _this.props.set(value);
	
	            _this.showDropdown(which, false);
	        }, _this.showDropdown = function (which, show) {
	            if (which == 'path') {
	                _this.setState({
	                    showPathDropdown: show
	                });
	            } else if (which == 'hash') {
	                _this.setState({
	                    showHashDropdown: show
	                });
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({
	                showPathDropdown: false,
	                showHashDropdown: false
	            });
	
	            this.props.set({
	                type: 'zodiac',
	                slant: this.props.slant,
	                base_url: '/astrology/compatibility/' + this.props.slant + '/'
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var _this2 = this;
	
	            var slant = _ref2.slant,
	                path = _ref2.path,
	                hash = _ref2.hash;
	
	            return (0, _preact.h)(
	                'compatibility-chooser-zodiac',
	                { slant: slant },
	                (0, _preact.h)(
	                    'div',
	                    {
	                        'class': 'compatibility-chooser' + (path ? '' : ' chosen'),
	                        name: 'path',
	                        onMouseLeave: function onMouseLeave() {
	                            return _this2.showDropdown('path', false);
	                        },
	                        onMouseOver: function onMouseOver() {
	                            return _this2.showDropdown('path', true);
	                        }
	                    },
	                    (0, _preact.h)(
	                        'h2',
	                        { value: path ? path.name : null },
	                        this.renderH2Text(path, 1)
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        {
	                            'class': 'compatibility-chooser-dropdown',
	                            style: 'display: ' + (this.state.showPathDropdown ? 'block' : 'none')
	                        },
	                        this.props.signs.map(function (sign) {
	                            return _this2.renderItem(sign, 'path');
	                        })
	                    )
	                ),
	                (0, _preact.h)(
	                    'div',
	                    {
	                        'class': 'compatibility-chooser',
	                        name: 'hash',
	                        onMouseLeave: function onMouseLeave() {
	                            return _this2.showDropdown('hash', false);
	                        },
	                        onMouseOver: function onMouseOver() {
	                            return _this2.showDropdown('hash', true);
	                        }
	                    },
	                    (0, _preact.h)(
	                        'h2',
	                        { value: hash ? hash.name : null },
	                        this.renderH2Text(hash, 2)
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        {
	                            'class': 'compatibility-chooser-dropdown',
	                            style: 'display: ' + (this.state.showHashDropdown ? 'block' : 'none')
	                        },
	                        this.props.signs.map(function (sign) {
	                            return _this2.renderItem(sign, 'hash');
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        path: state['compatibility-chooser'] && state['compatibility-chooser'].path,
	        hash: state['compatibility-chooser'] && state['compatibility-chooser'].hash,
	        signs: state.zodiac && state.zodiac.signs
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        set: function set(payload) {
	            return dispatch({ type: 'compatibility-chooser:set', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/compatibility/item.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var value = _ref.value,
	                action = _ref.action,
	                content = _ref.content;
	
	            return (0, _preact.h)(
	                'compatibility-chooser-dropdown-item',
	                {
	                    value: value,
	                    onclick: action
	                },
	                content()
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps() {
	    return {};
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/compatibility/types/chinese.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _dateSelect = __webpack_require__("./app/components/form/inputs/date-select.js");
	
	var _dateSelect2 = _interopRequireDefault(_dateSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.change = function (which, value) {
	            _this.props.setSign({
	                which: which,
	                date: value
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.set({
	                type: 'chinese',
	                slant: this.props.slant,
	                base_url: '/astrology/compatibility/chinese/'
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var slant = _ref2.slant,
	                path = _ref2.path;
	
	            return (0, _preact.h)(
	                'compatibility-chooser-chinese',
	                { slant: slant },
	                (0, _preact.h)(_dateSelect2.default, {
	                    group_label: 'YOUR BIRTH DATE',
	                    name: 'path',
	                    direction: 'past',
	                    product: 'Chinese Compatibility',
	                    'class': 'chosen',
	                    change: this.change
	                }),
	                (0, _preact.h)(_dateSelect2.default, {
	                    group_label: 'THEIR BIRTH DATE',
	                    name: 'hash',
	                    direction: 'past',
	                    product: 'Chinese Compatibility',
	                    'class': path ? 'chosen' : null,
	                    change: this.change
	                })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        path: state['compatibility-chooser'] && state['compatibility-chooser'].path,
	        hash: state['compatibility-chooser'] && state['compatibility-chooser'].hash
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        set: function set(payload) {
	            return dispatch({ type: 'compatibility-chooser:set', payload: payload });
	        },
	        setSign: function setSign(payload) {
	            return dispatch({ type: 'compatibility-chooser:setChineseSign', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/form/inputs/date-select.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _underscore = __webpack_require__("../node_modules/underscore/underscore.js");
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _mediaQuery = __webpack_require__("./app/media-query.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderSelects = function () {
	            if (_mediaQuery.MediaQuery.isMobile()) {
	                return (0, _preact.h)(
	                    'label',
	                    { htmlFor: _this.props.name, 'class': 'date-input ' + (_this.props.class ? _this.props.class : '') },
	                    _this.props.group_label,
	                    _this.renderGroupInput()
	                );
	            }
	
	            return (0, _preact.h)(
	                'fieldset',
	                { 'class': _this.props.class },
	                (0, _preact.h)(
	                    'legend',
	                    null,
	                    _this.props.group_label
	                ),
	                (0, _preact.h)(
	                    'label',
	                    { htmlFor: 'month' },
	                    (0, _preact.h)(
	                        'select',
	                        {
	                            'data-action': 'Select-Month',
	                            'data-category': _this.props.group_label,
	                            'data-ga-event': true,
	                            'data-label': _this.props.product,
	                            onChange: _this.setMonth,
	                            name: 'month',
	                            required: true
	                        },
	                        (0, _preact.h)(
	                            'option',
	                            { selected: true, disabled: true },
	                            'month'
	                        ),
	                        _this.state.months.map(function (month) {
	                            return (0, _preact.h)(
	                                'option',
	                                { value: (0, _moment2.default)().month(month).format('MM') },
	                                (0, _moment2.default)().month(month).format('MMMM')
	                            );
	                        })
	                    ),
	                    (0, _preact.h)('span', { 'class': 'error-msg' })
	                ),
	                _this.renderDaySelect(),
	                (0, _preact.h)(
	                    'label',
	                    { htmlFor: 'year' },
	                    (0, _preact.h)(
	                        'select',
	                        {
	                            'data-action': 'Select-Year',
	                            'data-category': _this.props.group_label,
	                            'data-ga-event': true,
	                            'data-label': _this.props.product,
	                            onChange: _this.setYear,
	                            name: 'year',
	                            required: true
	                        },
	                        (0, _preact.h)(
	                            'option',
	                            { selected: true, disabled: true },
	                            'year'
	                        ),
	                        _this.state.years.map(function (year) {
	                            return (0, _preact.h)(
	                                'option',
	                                { value: year },
	                                year
	                            );
	                        })
	                    ),
	                    (0, _preact.h)('span', { 'class': 'error-msg' })
	                )
	            );
	        }, _this.renderDaySelect = function () {
	            if (!_this.props.month_only) {
	                return (0, _preact.h)(
	                    'label',
	                    { htmlFor: 'day' },
	                    (0, _preact.h)(
	                        'select',
	                        {
	                            'data-action': 'Select-Day',
	                            'data-category': _this.props.group_label,
	                            'data-ga-event': true,
	                            'data-label': _this.props.product,
	                            onChange: _this.setDay,
	                            name: 'day',
	                            required: true
	                        },
	                        (0, _preact.h)(
	                            'option',
	                            { selected: true, disabled: true },
	                            'day'
	                        ),
	                        _this.state.days.map(function (day) {
	                            return (0, _preact.h)(
	                                'option',
	                                { value: ('0' + (day + 1)).substr(-2) },
	                                day + 1
	                            );
	                        })
	                    ),
	                    (0, _preact.h)('span', { 'class': 'error-msg' })
	                );
	            }
	
	            return null;
	        }, _this.renderGroupInput = function () {
	            if (_this.props.month_only) {
	                return [(0, _preact.h)('input', {
	                    type: 'month',
	                    name: _this.props.name,
	                    onChange: _this.setFullDate
	                }), (0, _preact.h)('span', { 'class': 'error-msg' })];
	            }
	
	            return [(0, _preact.h)('input', {
	                type: 'date',
	                max: (0, _moment2.default)().format('YYYY-MM-DD'),
	                min: (0, _moment2.default)().subtract(100, 'years').format('YYYY-MM-DD'),
	                name: _this.props.name,
	                onChange: _this.setFullDate
	            }), (0, _preact.h)('span', { 'class': 'error-msg' })];
	        }, _this.setMonth = function (e) {
	            _this.setState({ month: e.target.value });
	            _this.getDays();
	            _this.propagate();
	        }, _this.setDay = function (e) {
	            _this.setState({ day: e.target.value });
	            _this.propagate();
	        }, _this.setYear = function (e) {
	            _this.setState({ year: e.target.value });
	            _this.getDays();
	            _this.propagate();
	        }, _this.setFullDate = function (e) {
	            var fullDate = (0, _moment2.default)(e.target.value);
	
	            _this.setState({
	                month: fullDate.format('MM'),
	                day: fullDate.format('DD'),
	                year: fullDate.format('YYYY')
	            });
	
	            _this.propagate();
	        }, _this.getDays = function () {
	            if (!_this.props.month_only) {
	                var year = _this.state.year ? _this.state.year : _this.state.years[0];
	                var month = _this.state.month ? _this.state.month : 1;
	                var daysInMonth = (0, _moment2.default)(year + '-' + month, 'YYYY-MM').daysInMonth();
	                var days = _underscore2.default.range(daysInMonth);
	
	                _this.setState({
	                    days: days
	                });
	            }
	        }, _this.propagate = function () {
	            if (_this.state.month && _this.state.day && _this.state.year && _this.props.change) {
	                _this.props.change(_this.props.name, (0, _moment2.default)(_this.state.year + '-' + _this.state.month + '-' + _this.state.day).format('YYYY-MM-DD'));
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var months = _underscore2.default.range(12);
	            var days = _underscore2.default.range(31);
	            var years = this.props.direction == 'future' ? _underscore2.default.range((0, _moment2.default)().year() - 1, (0, _moment2.default)().year() + 10) : _underscore2.default.range((0, _moment2.default)().year(), (0, _moment2.default)().year() - 100, -1);
	
	            this.setState({
	                month: null,
	                months: months,
	                day: null,
	                days: days,
	                year: null,
	                years: years
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var name = _ref2.name;
	
	            return (0, _preact.h)(
	                'date-select',
	                { name: name },
	                this.renderSelects()
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	exports.default = (0, _preactRedux.connect)()(Component);

/***/ },

/***/ "./app/media-query.js":
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MQ = function () {
	    function MQ() {
	        _classCallCheck(this, MQ);
	
	        this.breakpoints = {
	            tiny: 370,
	            before_mobile: 575,
	            mobile: 576,
	            before_large: 1024,
	            large: 1025
	        };
	    }
	
	    _createClass(MQ, [{
	        key: 'isTiny',
	        value: function isTiny() {
	            return window.matchMedia('(max-width: ' + this.breakpoints.tiny + 'px)').matches;
	        }
	    }, {
	        key: 'isMobile',
	        value: function isMobile() {
	            return window.matchMedia('(max-width: ' + this.breakpoints.before_mobile + 'px)').matches;
	        }
	    }, {
	        key: 'isTablet',
	        value: function isTablet() {
	            return window.matchMedia('(min-width: ' + this.breakpoints.mobile + 'px)').matches && window.matchMedia('(max-width: ' + this.breakpoints.before_large + 'px)').matches;
	        }
	    }, {
	        key: 'isLarge',
	        value: function isLarge() {
	            return window.matchMedia('(min-width: ' + this.breakpoints.large + 'px)').matches;
	        }
	    }, {
	        key: 'isPortrait',
	        value: function isPortrait() {
	            return window.matchMedia('(orientation: portrait)').matches;
	        }
	    }, {
	        key: 'isLandscape',
	        value: function isLandscape() {
	            return window.matchMedia('(orientation: landscape)').matches;
	        }
	    }]);
	
	    return MQ;
	}();
	
	var MediaQuery = exports.MediaQuery = new MQ();

/***/ },

/***/ "./app/components/content/hexagram.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderStory = function (story) {
	            if (story) {
	                var alt = story.image_alt || story.title;
	                var src = 'https://gfx.tarot.com/images/feeds/' + _this.props.img_size + '/' + story.picture_frag + '-' + _this.props.img_size + '.jpg';
	
	                return (0, _preact.h)(
	                    'hexagram-content-story',
	                    { 'class': 'small-12 medium-6 columns text-link-undecorated' },
	                    (0, _preact.h)(
	                        'a',
	                        {
	                            'class': 'text-link-undecorated promoted_content_link',
	                            onClick: function onClick() {
	                                return _this.trackClick(story.title);
	                            },
	                            href: story.url,
	                            title: story.title
	                        },
	                        (0, _preact.h)('img', { alt: alt, 'class': 'promoted_content_img', src: src }),
	                        (0, _preact.h)('p', { 'class': 'text-center', dangerouslySetInnerHTML: { __html: story.title } })
	                    )
	                );
	            }
	
	            return null;
	        }, _this.trackClick = function (label) {
	            var action = _this.props.logged_in ? 'LI Click' : 'LO Click';
	
	            _this.props.trackEvent(['Hexagram Stories', action, label]);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.requireState(this.props.limit);
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var stories = _ref2.stories;
	
	            if (!stories) {
	                return (0, _preact.h)('hexagram-content', null);
	            }
	
	            return (0, _preact.h)(
	                'hexagram-content',
	                { 'class': 'container' },
	                (0, _preact.h)(
	                    'h1',
	                    null,
	                    'More About I Ching Hexagrams'
	                ),
	                stories.map(this.renderStory)
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        stories: state.content && state.content.hexagram,
	        logged_in: state.user && state.user.logged_in
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        requireState: function requireState(limit) {
	            return dispatch({ type: 'content:fetchHexagram', payload: limit });
	        },
	        trackEvent: function trackEvent(payload) {
	            return dispatch({ type: 'ga:event', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/content/promoted.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _promotedStory = __webpack_require__("./app/components/content/promoted-story.js");
	
	var _promotedStory2 = _interopRequireDefault(_promotedStory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.rowLength = 2, _this.renderStory = function (story, index) {
	            return (0, _preact.h)(_promotedStory2.default, { story: story, index: index, img_size: _this.props.img_size });
	        }, _this.groupRows = function (rows, story) {
	            if (rows.length) {
	                var lastRow = rows[rows.length - 1];
	                if (lastRow.length < _this.rowLength) {
	                    lastRow.push(story);
	                    return rows;
	                }
	            }
	            rows.push([story]);
	            return rows;
	        }, _this.wrapRows = function (row) {
	            return (0, _preact.h)(
	                'div',
	                { 'class': 'row' },
	                row
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	    // necessary for desktop to handle 2 line headlines.
	    // mobile doesn't care either way.
	
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.requireState(this.props.limit);
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var stories = _ref2.stories,
	                title = _ref2.title;
	
	            if (!stories) {
	                return (0, _preact.h)('promoted-content', null);
	            }
	
	            return (0, _preact.h)(
	                'promoted-content',
	                { 'class': 'container' },
	                (0, _preact.h)(
	                    'header',
	                    { 'class': 'promoted_content_header' },
	                    (0, _preact.h)(
	                        'h1',
	                        { 'class': 'text-header-2' },
	                        title || 'The Latest',
	                        (0, _preact.h)(
	                            'span',
	                            { 'class': 'text-header-6' },
	                            ' FROM TAROT.COM'
	                        )
	                    )
	                ),
	                stories.map(this.renderStory).reduce(this.groupRows, []).map(this.wrapRows)
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        stories: state.content && state.content.promoted
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        requireState: function requireState(limit) {
	            return dispatch({ type: 'content:fetchPromoted', payload: limit });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/content/promoted-story.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.trackClick = function (label, number) {
	            var action = _this.props.logged_in ? 'LI Click-' : 'LO Click-';
	
	            _this.props.trackEvent(['Top Stories', action + number, label]);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var number = this.props.index + 1;
	
	            if (this.props.story && this.props.story.title) {
	                var action = this.props.logged_in ? 'LI Impression-' : 'LO Impression-';
	
	                this.props.trackEvent(['Top Stories', action + number, this.props.story.title]);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var _this2 = this;
	
	            var story = _ref2.story,
	                index = _ref2.index,
	                img_size = _ref2.img_size;
	
	            if (!story) {
	                return (0, _preact.h)('top-story', null);
	            }
	
	            var number = index + 1;
	            var alt = story.image_alt || story.title;
	            var src = 'https://gfx.tarot.com/images/feeds/' + img_size + '/' + story.picture_frag + '-' + img_size + '.jpg';
	
	            return (0, _preact.h)(
	                'promoted-content-story',
	                { 'class': 'small-12 medium-6 columns text-link-undecorated' },
	                (0, _preact.h)(
	                    'a',
	                    {
	                        'class': 'text-link-undecorated promoted_content_link',
	                        onClick: function onClick() {
	                            return _this2.trackClick(story.title, number);
	                        },
	                        href: story.url,
	                        title: story.title
	                    },
	                    (0, _preact.h)('img', { alt: alt, 'class': 'promoted_content_img', src: src }),
	                    (0, _preact.h)(
	                        'h2',
	                        { 'class': 'text-header-4 promoted_content_headline' },
	                        story.title
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        logged_in: state.user && state.user.logged_in
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        trackEvent: function trackEvent(payload) {
	            return dispatch({ type: 'ga:event', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/cosmic-profile.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render() {
	            this.props.init('cosmic-profile-report');
	            return (0, _preact.h)('cosmic-profile', null);
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        init: function init(upc) {
	            return dispatch({ type: 'i-ching-reading:init', payload: { upc: upc } });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(null, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/daily/hexagram/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mediaQuery = __webpack_require__("./app/media-query.js");
	
	var _mobile = __webpack_require__("./app/components/daily/hexagram/mobile.js");
	
	var _mobile2 = _interopRequireDefault(_mobile);
	
	var _nonMobile = __webpack_require__("./app/components/daily/hexagram/non-mobile.js");
	
	var _nonMobile2 = _interopRequireDefault(_nonMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var date = this.props.date || (0, _moment2.default)().format('YYYY-MM-DD');
	
	            this.setState({ date: date });
	
	            this.props.requireHexagram(date);
	
	            if (!this.props.route || this.props.route != 'everyone') {
	                this.props.routeTo('you');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref) {
	            var hexagram = _ref.hexagram;
	
	            if (hexagram) {
	                if (_mediaQuery.MediaQuery.isMobile()) {
	                    return (0, _preact.h)(
	                        'daily-hexagram',
	                        null,
	                        (0, _preact.h)(_mobile2.default, { date: this.props.date })
	                    );
	                }
	
	                return (0, _preact.h)(
	                    'daily-hexagram',
	                    null,
	                    (0, _preact.h)(_nonMobile2.default, { date: this.props.date })
	                );
	            }
	
	            return (0, _preact.h)('daily-hexagram', null);
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        hexagram: state.hexagram,
	        logged_in: state.user && state.user.logged_in,
	        route: state.route
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        requireHexagram: function requireHexagram(date) {
	            return dispatch({ type: 'hexagram:required', payload: date });
	        },
	        routeTo: function routeTo(hash) {
	            return dispatch({ type: 'route:to', payload: hash });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/daily/hexagram/mobile.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _raw = __webpack_require__("./app/components/raw.js");
	
	var _raw2 = _interopRequireDefault(_raw);
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _promoMessage = __webpack_require__("./app/components/promo-message.js");
	
	var _promoMessage2 = _interopRequireDefault(_promoMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderForYou = function () {
	            if (_this.props.logged_in && _this.props.hexagram && _this.props.hexagram.you) {
	                return (0, _preact.h)(
	                    'daily-hexagram-mobile',
	                    null,
	                    _this.renderDailyLinks(),
	                    (0, _preact.h)(
	                        'h1',
	                        null,
	                        'Hexagram of the Day'
	                    ),
	                    _this.renderHexagram(_this.props.hexagram.you)
	                );
	            }
	
	            return (0, _preact.h)(
	                'daily-hexagram-mobile',
	                null,
	                _this.renderDailyLinks(),
	                (0, _preact.h)(
	                    'h1',
	                    null,
	                    'Hexagram of the Day'
	                ),
	                (0, _preact.h)('img', {
	                    src: 'https://gfx.tarot.com/images/daily-pages/daily-icons/hexagram.svg',
	                    alt: 'Unknown Hexagram'
	                }),
	                (0, _preact.h)(
	                    'h2',
	                    null,
	                    'Create Your Profile To Find Out!'
	                ),
	                (0, _preact.h)(
	                    'p',
	                    null,
	                    'Looking for your Hexagram of the Day? Create your profile to receive a Hexagram that\'s personalized to YOU every day!'
	                ),
	                (0, _preact.h)(
	                    'a',
	                    { href: '/signup?return', 'class': 'button' },
	                    'CREATE MY PROFILE'
	                ),
	                (0, _preact.h)(
	                    'p',
	                    { 'class': 'signup_promo_text' },
	                    'Already a Tarot.com member? ',
	                    (0, _preact.h)(
	                        'a',
	                        { href: '/login' },
	                        'Login Now'
	                    )
	                )
	            );
	        }, _this.renderForEveryone = function () {
	            if (_this.props.hexagram && _this.props.hexagram.everyone) {
	                return (0, _preact.h)(
	                    'daily-hexagram-mobile',
	                    null,
	                    _this.renderDailyLinks(),
	                    (0, _preact.h)(
	                        'h1',
	                        null,
	                        'Hexagram of the Day'
	                    ),
	                    _this.renderHexagram(_this.props.hexagram.everyone)
	                );
	            }
	
	            return (0, _preact.h)('daily-hexagram-mobile', null);
	        }, _this.renderHexagram = function (hexagram) {
	            if (hexagram) {
	                return (0, _preact.h)(
	                    'div',
	                    null,
	                    (0, _preact.h)(
	                        'a',
	                        { href: '/i-ching/hexagrams/' + hexagram.title.toLowerCase().replace(/\s+/g, '-') },
	                        '#',
	                        hexagram.id,
	                        ': ',
	                        hexagram.title
	                    ),
	                    (0, _preact.h)(
	                        'a',
	                        { href: '/i-ching/hexagrams/' + hexagram.title.toLowerCase().replace(/\s+/g, '-') },
	                        (0, _preact.h)('img', {
	                            src: 'https://gfx.tarot.com/images/iching/iching-general/' + hexagram.id + '.jpg',
	                            alt: hexagram.title
	                        })
	                    ),
	                    (0, _preact.h)(
	                        'p',
	                        null,
	                        (0, _preact.h)(
	                            'b',
	                            null,
	                            (0, _moment2.default)(hexagram.date).format('M.D.YY'),
	                            ':'
	                        ),
	                        ' ',
	                        (0, _preact.h)(_raw2.default, { content: hexagram.main_text })
	                    ),
	                    (0, _preact.h)(
	                        'p',
	                        null,
	                        (0, _preact.h)(_promoMessage2.default, { placement: 'text-hexagram' })
	                    )
	                );
	            }
	
	            return null;
	        }, _this.renderDailyLinks = function () {
	            return (0, _preact.h)(
	                'div',
	                { 'class': 'daily-links' },
	                (0, _preact.h)(
	                    'a',
	                    {
	                        href: '#everyone',
	                        'class': _this.props.route == 'everyone' ? 'selected' : ''
	                    },
	                    'FOR EVERYONE'
	                ),
	                (0, _preact.h)(
	                    'a',
	                    {
	                        href: '#you',
	                        'class': _this.props.route != 'everyone' ? 'selected' : ''
	                    },
	                    'FOR YOU'
	                )
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref2) {
	            var route = _ref2.route;
	
	            if (route != 'everyone') {
	                return this.renderForYou();
	            }
	
	            return this.renderForEveryone();
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        hexagram: state.hexagram,
	        logged_in: state.user && state.user.logged_in,
	        route: state.route
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/raw.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var content = _ref.content;
	
	            if (content) {
	                return (0, _preact.h)('raw', { dangerouslySetInnerHTML: { __html: content } });
	            }
	
	            return (0, _preact.h)('raw', null);
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	exports.default = (0, _preactRedux.connect)()(Component);

/***/ },

/***/ "./app/components/promo-message.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _mediaQuery = __webpack_require__("./app/media-query.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PromoMessage = function (_Component) {
	    _inherits(PromoMessage, _Component);
	
	    function PromoMessage() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PromoMessage);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PromoMessage.__proto__ || Object.getPrototypeOf(PromoMessage)).call.apply(_ref, [this].concat(args))), _this), _this.trackClick = function () {
	            var category = _this.props.placement + ' promo message';
	            var action = _this.props.logged_in ? 'LI Click' : 'LO Click';
	
	            _this.props.trackEvent([category, action, _this.props.code]);
	            _this.props.trackPromo([category, _this.props.code]);
	        }, _this.handleScroll = function () {
	            if (_mediaQuery.MediaQuery.isMobile() && _this.props.placement == 'topbar' && typeof _this.promoMessage != 'undefined') {
	                var top = window.pageYOffset;
	
	                if (top >= 315 && top > _this.state.last_top) {
	                    _this.promoMessage.classList.add('shown');
	                } else if (top < _this.state.last_top) {
	                    _this.promoMessage.classList.remove('shown');
	                }
	
	                _this.setState({ last_top: top });
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PromoMessage, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.requirePromoMessage(this.props.placement);
	            this.setState({
	                shown: false,
	                last_top: 0
	            });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('scroll', this.handleScroll);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('scroll', this.handleScroll);
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var _this2 = this;
	
	            var message = _ref2.message,
	                placement = _ref2.placement;
	
	            if (message) {
	                return (0, _preact.h)('promo-message', {
	                    dangerouslySetInnerHTML: { __html: message },
	                    onClick: this.trackClick,
	                    placement: placement,
	                    ref: function ref(elem) {
	                        _this2.promoMessage = elem;
	                    }
	                });
	            }
	
	            return null;
	        }
	    }]);
	
	    return PromoMessage;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state, _ref3) {
	    var placement = _ref3.placement;
	    return {
	        logged_in: state.user && state.user.logged_in,
	        message: state['promo-message'] && state['promo-message'][placement] && state['promo-message'][placement].message,
	        code: state['promo-message'] && state['promo-message'][placement] && state['promo-message'][placement].code
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        requirePromoMessage: function requirePromoMessage(placement) {
	            return dispatch({ type: 'promo-message:require', payload: placement });
	        },
	        trackEvent: function trackEvent(payload) {
	            return dispatch({ type: 'ga:event', payload: payload });
	        },
	        trackPromo: function trackPromo(payload) {
	            return dispatch({ type: 'promo-tracker:recordInternal', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(PromoMessage);

/***/ },

/***/ "./app/components/daily/hexagram/non-mobile.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _raw = __webpack_require__("./app/components/raw.js");
	
	var _raw2 = _interopRequireDefault(_raw);
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _datePicker = __webpack_require__("./app/components/date-picker.js");
	
	var _datePicker2 = _interopRequireDefault(_datePicker);
	
	var _promoMessage = __webpack_require__("./app/components/promo-message.js");
	
	var _promoMessage2 = _interopRequireDefault(_promoMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderForYou = function () {
	            if (_this.props.logged_in && _this.props.hexagram && _this.props.hexagram.you) {
	                return (0, _preact.h)(
	                    'daily-hexagram-non-mobile',
	                    null,
	                    _this.renderHexagram(_this.props.hexagram.you)
	                );
	            }
	
	            return (0, _preact.h)(
	                'daily-hexagram-non-mobile',
	                null,
	                (0, _preact.h)(
	                    'div',
	                    { 'class': 'daily-hexagram' },
	                    (0, _preact.h)('img', {
	                        src: 'https://gfx.tarot.com/images/daily-pages/daily-icons/hexagram.svg',
	                        'class': 'hexagram-unknown',
	                        alt: 'Unknown Hexagram'
	                    })
	                ),
	                _this.renderDailyLinks(),
	                (0, _preact.h)(
	                    'h1',
	                    null,
	                    'Hexagram of',
	                    (0, _preact.h)('br', null),
	                    'the Day'
	                ),
	                _this.renderSubLinks(),
	                (0, _preact.h)('br', null),
	                (0, _preact.h)(
	                    'h2',
	                    null,
	                    'Your FREE I Ching Hexagram Awaits!'
	                ),
	                (0, _preact.h)('br', null),
	                (0, _preact.h)(
	                    'p',
	                    null,
	                    'Looking for your Hexagram of the Day? Create your profile to receive a Hexagram that\'s personalized to YOU every day!'
	                ),
	                (0, _preact.h)(
	                    'p',
	                    null,
	                    (0, _preact.h)(
	                        'a',
	                        { href: '#login', 'class': 'button' },
	                        'GET MY DAILY HEXAGRAM'
	                    )
	                )
	            );
	        }, _this.renderForEveryone = function () {
	            if (_this.props.hexagram && _this.props.hexagram.everyone) {
	                return (0, _preact.h)(
	                    'daily-hexagram-non-mobile',
	                    null,
	                    _this.renderHexagram(_this.props.hexagram.everyone)
	                );
	            }
	
	            return (0, _preact.h)('daily-hexagram-non-mobile', null);
	        }, _this.renderHexagram = function (hexagram) {
	            if (hexagram) {
	                return (0, _preact.h)(
	                    'div',
	                    null,
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'daily-hexagram' },
	                        (0, _preact.h)(
	                            'a',
	                            { href: '/i-ching/hexagrams/' + hexagram.title.toLowerCase().replace(/\s+/g, '-') },
	                            (0, _preact.h)('img', {
	                                src: 'https://gfx.tarot.com/images/iching/iching-general/' + hexagram.id + '.jpg',
	                                alt: hexagram.title
	                            })
	                        ),
	                        (0, _preact.h)(
	                            'small',
	                            null,
	                            (0, _preact.h)(
	                                'a',
	                                { href: '/i-ching/hexagrams/' + hexagram.title.toLowerCase().replace(/\s+/g, '-') },
	                                '#',
	                                hexagram.id,
	                                ': ',
	                                hexagram.title
	                            )
	                        )
	                    ),
	                    (0, _preact.h)(_datePicker2.default, { 'class': 'icon-24x23-calendar js-datepicker', url: '/daily-hexagram/:date' }),
	                    _this.renderDailyLinks(),
	                    (0, _preact.h)(
	                        'h1',
	                        null,
	                        'Hexagram of',
	                        (0, _preact.h)('br', null),
	                        'the Day'
	                    ),
	                    _this.renderSubLinks(),
	                    (0, _preact.h)('br', null),
	                    (0, _preact.h)(
	                        'p',
	                        null,
	                        (0, _preact.h)(
	                            'b',
	                            null,
	                            (0, _moment2.default)(hexagram.date).format('M.D.YY'),
	                            ':'
	                        ),
	                        ' ',
	                        (0, _preact.h)(_raw2.default, { content: hexagram.main_text })
	                    ),
	                    (0, _preact.h)(
	                        'p',
	                        null,
	                        (0, _preact.h)(_promoMessage2.default, { placement: 'text-hexagram' })
	                    )
	                );
	            }
	
	            return null;
	        }, _this.renderDailyLinks = function () {
	            var yesterday = (0, _moment2.default)().subtract(1, 'days').format('YYYY-MM-DD');
	            var today = (0, _moment2.default)().format('YYYY-MM-DD');
	            var tomorrow = (0, _moment2.default)().add(1, 'days').format('YYYY-MM-DD');
	
	            return (0, _preact.h)(
	                'div',
	                { 'class': 'daily-links' },
	                (0, _preact.h)(
	                    'a',
	                    {
	                        href: '/daily-hexagram/' + yesterday + '#' + _this.props.route,
	                        'class': _this.props.date == yesterday ? 'selected' : ''
	                    },
	                    'Yesterday'
	                ),
	                (0, _preact.h)(
	                    'a',
	                    {
	                        href: '/daily-hexagram/' + today + '#' + _this.props.route,
	                        'class': _this.props.date == today ? 'selected' : ''
	                    },
	                    'Today'
	                ),
	                (0, _preact.h)(
	                    'a',
	                    {
	                        href: '/daily-hexagram/' + tomorrow + '#' + _this.props.route,
	                        'class': _this.props.date == tomorrow ? 'selected' : ''
	                    },
	                    'Tomorrow'
	                )
	            );
	        }, _this.renderSubLinks = function () {
	            return (0, _preact.h)(
	                'div',
	                { 'class': 'daily-links' },
	                (0, _preact.h)(
	                    'a',
	                    { href: _this.props.route == 'everyone' ? '#you' : '#everyone' },
	                    _this.props.route == 'everyone' ? 'For You' : 'For Everyone'
	                ),
	                (0, _preact.h)(
	                    'a',
	                    {
	                        href: 'http://t4dev60.tarot.com/readings-reports/i-ching/free',
	                        onClick: function onClick() {
	                            return _this.props.trackPromo(['HOD', 'I-Ching']);
	                        }
	                    },
	                    'Get Your Daily I Ching Reading'
	                )
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref2) {
	            var route = _ref2.route;
	
	            if (route != 'everyone') {
	                return this.renderForYou();
	            }
	
	            return this.renderForEveryone();
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        hexagram: state.hexagram,
	        logged_in: state.user && state.user.logged_in,
	        route: state.route
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        trackPromo: function trackPromo(payload) {
	            return dispatch({ type: 'promo-tracker:recordInternal', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/date-picker.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var className = _ref.class,
	                url = _ref.url;
	
	            return (0, _preact.h)(
	                'date-picker',
	                null,
	                (0, _preact.h)('input', {
	                    'class': className,
	                    url: url
	                })
	            );
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var selector = 'input.' + this.props.class.replace(' ', '.');
	            var url = this.props.url;
	
	            $(selector).datepicker({
	                dateFormat: 'yy-mm-dd',
	                minDate: (0, _moment2.default)().subtract(30, 'days').format('YY-MM-DD'),
	                maxDate: (0, _moment2.default)().add(2, 'days').format('YY-MM-DD'),
	                onSelect: function onSelect(date) {
	                    window.location = url.replace(':date', date);
	                }
	            });
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	exports.default = (0, _preactRedux.connect)()(Component);

/***/ },

/***/ "./app/components/daily/horoscope.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _promoMessage = __webpack_require__("./app/components/promo-message.js");
	
	var _promoMessage2 = _interopRequireDefault(_promoMessage);
	
	var _datePicker = __webpack_require__("./app/components/date-picker.js");
	
	var _datePicker2 = _interopRequireDefault(_datePicker);
	
	var _mediaQuery = __webpack_require__("./app/media-query.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderDatePicker = function () {
	            if (!_mediaQuery.MediaQuery.isMobile()) {
	                return (0, _preact.h)(_datePicker2.default, {
	                    'class': 'icon-24x23-calendar js-datepicker',
	                    url: _this.state.base_url + '/' + _this.props.horoscope.sign + '/:date'
	                });
	            }
	
	            return null;
	        }, _this.renderLinks = function () {
	            if (_this.props.horoscope && _this.props.horoscope.date_sel) {
	                var links = _this.props.horoscope.date_sel.links;
	
	                return (0, _preact.h)(
	                    'div',
	                    { 'class': 'daily-links' },
	                    Object.keys(links).map(function (link) {
	                        return (0, _preact.h)(
	                            'a',
	                            {
	                                href: _this.state.base_url + '/' + _this.props.horoscope.sign + '/' + links[link].query,
	                                'class': links[link].selected ? 'selected' : ''
	                            },
	                            links[link].title
	                        );
	                    })
	                );
	            }
	
	            return null;
	        }, _this.renderHoroscope = function () {
	            if (_this.props.horoscope && _this.props.horoscope.scope_txt) {
	                return _this.props.horoscope.scope_txt.split('\n').map(function (p, key) {
	                    if (key === 0) {
	                        return (0, _preact.h)(
	                            'p',
	                            null,
	                            (0, _preact.h)(
	                                'b',
	                                null,
	                                _this.props.horoscope.date,
	                                ':'
	                            ),
	                            '\xA0',
	                            p,
	                            _this.renderContinue()
	                        );
	                    }
	
	                    return (0, _preact.h)(
	                        'p',
	                        null,
	                        p
	                    );
	                });
	            }
	
	            return null;
	        }, _this.renderContinue = function () {
	            if (_this.props.horoscope && _this.props.horoscope.continue) {
	                return (0, _preact.h)(
	                    'a',
	                    { href: _this.props.horoscope.continue },
	                    'Continue'
	                );
	            }
	
	            return null;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            if (this.props.slant) {
	                this.props.requireHoroscope(this.props.date, this.props.sign, this.props.slant + '_daily');
	                this.setState({ base_url: '/daily-' + this.props.slant + '-horoscope' });
	            } else {
	                this.props.requireHoroscope(this.props.date, this.props.sign, 'horoscopes_daily');
	                this.setState({ base_url: '/daily-horoscope' });
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            if (nextProps.user.logged_in != this.props.user.logged_in) {
	                if (this.props.slant) {
	                    this.props.requireHoroscope(this.props.date, this.props.sign, this.props.slant + '_daily');
	                } else {
	                    this.props.requireHoroscope(this.props.date, this.props.sign, 'horoscopes_daily');
	                }
	            }
	
	            return true;
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var horoscope = _ref2.horoscope;
	
	            if (horoscope) {
	                return (0, _preact.h)(
	                    'daily-horoscope',
	                    null,
	                    this.renderDatePicker(),
	                    this.renderLinks(),
	                    (0, _preact.h)(
	                        'h1',
	                        null,
	                        horoscope.h2_text
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'daily-links' },
	                        (0, _preact.h)(
	                            'a',
	                            { href: '/bios/' + horoscope.author_slug },
	                            'by ',
	                            horoscope.author
	                        )
	                    ),
	                    (0, _preact.h)('br', null),
	                    this.renderHoroscope(),
	                    (0, _preact.h)(
	                        'p',
	                        null,
	                        (0, _preact.h)(_promoMessage2.default, {
	                            placement: this.props.slant ? 'text-' + this.props.slant + '-horoscope' : 'text-horoscope'
	                        })
	                    )
	                );
	            }
	
	            return (0, _preact.h)('daily-horoscope', null);
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        horoscope: state.horoscope,
	        user: state.user
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        requireHoroscope: function requireHoroscope(date, sign, type) {
	            return dispatch({
	                type: 'horoscope:require',
	                payload: {
	                    date: date,
	                    sign: sign,
	                    type: type
	                }
	            });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/daily/number/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _mediaQuery = __webpack_require__("./app/media-query.js");
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mobile = __webpack_require__("./app/components/daily/number/mobile.js");
	
	var _mobile2 = _interopRequireDefault(_mobile);
	
	var _nonMobile = __webpack_require__("./app/components/daily/number/non-mobile.js");
	
	var _nonMobile2 = _interopRequireDefault(_nonMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var date = this.props.date || (0, _moment2.default)().format('YYYY-MM-DD');
	
	            this.setState({ date: date });
	            this.props.requireNumber(date);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (_mediaQuery.MediaQuery.isMobile()) {
	                return (0, _preact.h)(
	                    'daily-number',
	                    null,
	                    (0, _preact.h)(_mobile2.default, null)
	                );
	            }
	
	            return (0, _preact.h)(
	                'daily-number',
	                null,
	                (0, _preact.h)(_nonMobile2.default, { date: this.state.date })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        logged_in: state.user && state.user.logged_in
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        requireNumber: function requireNumber(date) {
	            return dispatch({ type: 'number:required', payload: date });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/daily/number/mobile.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _promoMessage = __webpack_require__("./app/components/promo-message.js");
	
	var _promoMessage2 = _interopRequireDefault(_promoMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderContent = function () {
	            if (_this.props.number) {
	                var number = _this.props.number;
	
	                return [(0, _preact.h)(
	                    'h1',
	                    null,
	                    'Number of the Day'
	                ), (0, _preact.h)(
	                    'a',
	                    { 'class': 'nod-attribution', href: '/bios/hans-decoz', rel: 'author' },
	                    'by Hans Decoz'
	                ), (0, _preact.h)('div', { 'class': 'today-number nod-' + number.number }), (0, _preact.h)(
	                    'div',
	                    null,
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'todays-numbers' },
	                        'Today\'s numbers are: ',
	                        number.numbers.join(', ')
	                    ),
	                    (0, _preact.h)(
	                        'h2',
	                        null,
	                        'Your Daily Number: ',
	                        number.number
	                    ),
	                    (0, _preact.h)(
	                        'h5',
	                        null,
	                        number.title
	                    ),
	                    number.body.map(function (p) {
	                        return (0, _preact.h)(
	                            'p',
	                            null,
	                            p
	                        );
	                    }),
	                    (0, _preact.h)(
	                        'p',
	                        null,
	                        (0, _preact.h)(_promoMessage2.default, { placement: 'text-number' })
	                    )
	                )];
	            }
	
	            return [(0, _preact.h)(
	                'h1',
	                null,
	                'Number of the Day'
	            ), (0, _preact.h)('img', { src: 'https://gfx.tarot.com/images/daily-pages/daily-icons/number.svg', alt: 'Daily Number' }), (0, _preact.h)(
	                'h2',
	                null,
	                'Create Your Profile To Find Out!'
	            ), (0, _preact.h)(
	                'p',
	                null,
	                'Looking for your Number of the Day? Create your profile to receive a number that\'s personalized to YOU every day!'
	            ), (0, _preact.h)(
	                'a',
	                { href: '/signup?return', 'class': 'button' },
	                'CREATE MY PROFILE'
	            ), (0, _preact.h)(
	                'p',
	                { 'class': 'signup_promo_text' },
	                'Already a Tarot.com member? ',
	                (0, _preact.h)(
	                    'a',
	                    { href: '/login' },
	                    'Login Now'
	                )
	            )];
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render() {
	            return (0, _preact.h)(
	                'daily-number-mobile',
	                null,
	                this.renderContent()
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        number: state.number
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/daily/number/non-mobile.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _datePicker = __webpack_require__("./app/components/date-picker.js");
	
	var _datePicker2 = _interopRequireDefault(_datePicker);
	
	var _promoMessage = __webpack_require__("./app/components/promo-message.js");
	
	var _promoMessage2 = _interopRequireDefault(_promoMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderDailyLinks = function () {
	            var yesterday = (0, _moment2.default)().subtract(1, 'days').format('YYYY-MM-DD');
	            var today = (0, _moment2.default)().format('YYYY-MM-DD');
	            var tomorrow = (0, _moment2.default)().add(1, 'days').format('YYYY-MM-DD');
	
	            return (0, _preact.h)(
	                'div',
	                { 'class': 'daily-links' },
	                (0, _preact.h)(
	                    'a',
	                    { href: '/daily-number/' + yesterday, 'class': _this.props.date == yesterday ? 'selected' : '' },
	                    'Yesterday'
	                ),
	                (0, _preact.h)(
	                    'a',
	                    { href: '/daily-number/' + today, 'class': _this.props.date == today ? 'selected' : '' },
	                    'Today'
	                ),
	                (0, _preact.h)(
	                    'a',
	                    { href: '/daily-number/' + tomorrow, 'class': _this.props.date == tomorrow ? 'selected' : '' },
	                    'Tomorrow'
	                )
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref2) {
	            var number = _ref2.number,
	                date = _ref2.date;
	
	            if (number) {
	                return (0, _preact.h)(
	                    'daily-number-non-mobile',
	                    null,
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'daily-number' },
	                        (0, _preact.h)('img', {
	                            src: 'https://gfx.tarot.com/images/numerology/daily/' + number.number + '.jpg',
	                            alt: 'Daily Number'
	                        }),
	                        (0, _preact.h)(
	                            'small',
	                            null,
	                            'Today\'s Numbers:\xA0',
	                            number.numbers.map(function (num, key) {
	                                if (key == 0) {
	                                    return num;
	                                }
	
	                                return ', ' + num;
	                            })
	                        )
	                    ),
	                    (0, _preact.h)(_datePicker2.default, { 'class': 'icon-24x23-calendar js-datepicker', url: '/daily-number/:date' }),
	                    this.renderDailyLinks(),
	                    (0, _preact.h)(
	                        'h1',
	                        null,
	                        'Number of',
	                        (0, _preact.h)('br', null),
	                        'the Day'
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'daily-links' },
	                        (0, _preact.h)(
	                            'a',
	                            { href: '/bios/hans-decoz' },
	                            'By Hanz Decoz'
	                        ),
	                        (0, _preact.h)(
	                            'a',
	                            { href: '/readings-reports/numerology' },
	                            'View All Numerology Reports'
	                        )
	                    ),
	                    (0, _preact.h)('br', null),
	                    number.body.map(function (p, key) {
	                        if (key == 0) {
	                            return (0, _preact.h)(
	                                'p',
	                                null,
	                                (0, _preact.h)(
	                                    'b',
	                                    null,
	                                    (0, _moment2.default)(date).format('M.D.YY'),
	                                    ': '
	                                ),
	                                number.title,
	                                ': ',
	                                p
	                            );
	                        }
	                        return (0, _preact.h)(
	                            'p',
	                            null,
	                            p
	                        );
	                    }),
	                    (0, _preact.h)(
	                        'p',
	                        null,
	                        (0, _preact.h)(_promoMessage2.default, { placement: 'text-number' })
	                    )
	                );
	            }
	
	            return (0, _preact.h)(
	                'daily-number-non-mobile',
	                null,
	                (0, _preact.h)(
	                    'div',
	                    { 'class': 'daily-number' },
	                    (0, _preact.h)('img', {
	                        src: 'https://gfx.tarot.com/images/daily-pages/daily-icons/number.svg',
	                        alt: 'Daily Number',
	                        'class': 'number-unknown'
	                    })
	                ),
	                (0, _preact.h)(_datePicker2.default, { 'class': 'icon-24x23-calendar js-datepicker', url: '/daily-number/:date' }),
	                this.renderDailyLinks(),
	                (0, _preact.h)(
	                    'h1',
	                    null,
	                    'Number of',
	                    (0, _preact.h)('br', null),
	                    'the Day'
	                ),
	                (0, _preact.h)(
	                    'div',
	                    { 'class': 'daily-links' },
	                    (0, _preact.h)(
	                        'a',
	                        { href: '/bios/hans-decoz' },
	                        'By Hanz Decoz'
	                    ),
	                    (0, _preact.h)(
	                        'a',
	                        { href: '/readings-reports/numerology' },
	                        'View All Numerology Reports'
	                    )
	                ),
	                (0, _preact.h)('br', null),
	                (0, _preact.h)('br', null),
	                (0, _preact.h)(
	                    'h2',
	                    null,
	                    'Your FREE Daily Number Awaits!'
	                ),
	                (0, _preact.h)('br', null),
	                (0, _preact.h)(
	                    'p',
	                    null,
	                    'Looking for your Number of the Day? Create your profile to receive a number that\'s personalized to YOU every day!'
	                ),
	                (0, _preact.h)(
	                    'p',
	                    null,
	                    (0, _preact.h)(
	                        'a',
	                        { href: '#login', 'class': 'button' },
	                        'GET MY DAILY NUMBER'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        number: state.number
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/daily/tarot-card/index.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mediaQuery = __webpack_require__("./app/media-query.js");
	
	var _mobile = __webpack_require__("./app/components/daily/tarot-card/mobile.js");
	
	var _mobile2 = _interopRequireDefault(_mobile);
	
	var _nonMobile = __webpack_require__("./app/components/daily/tarot-card/non-mobile.js");
	
	var _nonMobile2 = _interopRequireDefault(_nonMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var date = this.props.date || (0, _moment2.default)().format('YYYY-MM-DD');
	
	            this.setState({ date: date });
	
	            this.props.requireTCOD(date);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (_mediaQuery.MediaQuery.isMobile()) {
	                return (0, _preact.h)(
	                    'daily-tarot-card',
	                    null,
	                    (0, _preact.h)(_mobile2.default, { date: this.state.date })
	                );
	            }
	
	            return (0, _preact.h)(
	                'daily-tarot-card',
	                null,
	                (0, _preact.h)(_nonMobile2.default, { date: this.state.date })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        logged_in: state.user && state.user.logged_in
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        requireTCOD: function requireTCOD(date) {
	            return dispatch({ type: 'tcod:required', payload: date });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/daily/tarot-card/mobile.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _promoMessage = __webpack_require__("./app/components/promo-message.js");
	
	var _promoMessage2 = _interopRequireDefault(_promoMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderForYou = function () {
	            if (_this.props.logged_in && _this.props.tcod && _this.props.tcod.you) {
	                return (0, _preact.h)(
	                    'daily-tarot-card-mobile',
	                    null,
	                    _this.renderDailyLinks(),
	                    (0, _preact.h)(
	                        'h1',
	                        null,
	                        'Tarot Card of the Day'
	                    ),
	                    _this.renderTCOD(_this.props.tcod.you)
	                );
	            }
	
	            return (0, _preact.h)(
	                'daily-tarot-card-mobile',
	                null,
	                _this.renderDailyLinks(),
	                (0, _preact.h)(
	                    'h1',
	                    null,
	                    'Tarot Card of the Day'
	                ),
	                (0, _preact.h)(
	                    'a',
	                    { href: '/signup?return' },
	                    (0, _preact.h)('img', {
	                        src: 'https://gfx.tarot.com/images/daily-pages/daily-icons/tarot.svg',
	                        alt: 'Unknown Tarot Card'
	                    })
	                ),
	                (0, _preact.h)(
	                    'h2',
	                    null,
	                    'Create Your Profile To Find Out!'
	                ),
	                (0, _preact.h)(
	                    'p',
	                    null,
	                    'Looking for your Tarot Card of the Day? Create your profile to receive a Tarot card that\'s personalized to YOU every day!'
	                ),
	                (0, _preact.h)(
	                    'a',
	                    { href: '/signup?return', 'class': 'button' },
	                    'CREATE MY PROFILE'
	                ),
	                (0, _preact.h)(
	                    'p',
	                    null,
	                    'Already a Tarot.com member? ',
	                    (0, _preact.h)(
	                        'a',
	                        { href: '/login' },
	                        'Login Now'
	                    )
	                )
	            );
	        }, _this.renderForEveryone = function () {
	            if (_this.props.tcod && _this.props.tcod.everyone) {
	                return (0, _preact.h)(
	                    'daily-tarot-card-mobile',
	                    null,
	                    _this.renderDailyLinks(),
	                    (0, _preact.h)(
	                        'h1',
	                        null,
	                        'Tarot Card of the Day'
	                    ),
	                    _this.renderTCOD(_this.props.tcod.everyone)
	                );
	            }
	
	            return (0, _preact.h)('daily-tarot-card-mobile', null);
	        }, _this.renderDailyLinks = function () {
	            return (0, _preact.h)(
	                'div',
	                { 'class': 'daily-links' },
	                (0, _preact.h)(
	                    'a',
	                    { href: '#everyone', 'class': _this.props.route == 'everyone' ? 'selected' : '' },
	                    'FOR EVERYONE'
	                ),
	                (0, _preact.h)(
	                    'a',
	                    { href: '#you', 'class': _this.props.route != 'everyone' ? 'selected' : '' },
	                    'FOR YOU'
	                )
	            );
	        }, _this.renderTCOD = function (tcod) {
	            if (tcod) {
	                var img_url = 'https://gfx.tarot.com/images/site/decks/' + tcod.deck_code + '/full_size/' + tcod.card_id + '.jpg';
	
	                return (0, _preact.h)(
	                    'div',
	                    null,
	                    (0, _preact.h)(
	                        'p',
	                        { 'class': 'has-text-centered' },
	                        (0, _preact.h)(
	                            'a',
	                            { href: '/tarot/cards/' + tcod.card.canonical_rank + '/' + tcod.deck_code, target: '_blank' },
	                            (0, _preact.h)('img', { src: img_url, alt: tcod.card.name })
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'small',
	                        null,
	                        (0, _preact.h)(
	                            'a',
	                            { href: '/tarot/decks/' + tcod.deck_code },
	                            tcod.deck.name
	                        ),
	                        ' deck \xA9 U.S. Games Systems, Inc.'
	                    ),
	                    (0, _preact.h)('br', null),
	                    tcod.interp_body.map(function (p, key) {
	                        if (key == 0) {
	                            return (0, _preact.h)(
	                                'p',
	                                null,
	                                (0, _preact.h)(
	                                    'b',
	                                    null,
	                                    (0, _moment2.default)(_this.props.date).format('M.D.YY'),
	                                    ' ',
	                                    tcod.card.name,
	                                    ': '
	                                ),
	                                p
	                            );
	                        }
	                        return (0, _preact.h)(
	                            'p',
	                            null,
	                            p
	                        );
	                    }),
	                    (0, _preact.h)(
	                        'p',
	                        null,
	                        (0, _preact.h)(_promoMessage2.default, { placement: 'text-tarot' })
	                    )
	                );
	            }
	
	            return null;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref2) {
	            var route = _ref2.route;
	
	            if (route != 'everyone') {
	                return this.renderForYou();
	            }
	
	            return this.renderForEveryone();
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        tcod: state.tcod,
	        logged_in: state.user && state.user.logged_in,
	        route: state.route
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/daily/tarot-card/non-mobile.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _datePicker = __webpack_require__("./app/components/date-picker.js");
	
	var _datePicker2 = _interopRequireDefault(_datePicker);
	
	var _promoMessage = __webpack_require__("./app/components/promo-message.js");
	
	var _promoMessage2 = _interopRequireDefault(_promoMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderForYou = function () {
	            if (_this.props.logged_in && _this.props.tcod && _this.props.tcod.you) {
	                return _this.renderTCOD(_this.props.tcod.you);
	            }
	
	            return (0, _preact.h)(
	                'daily-tarot-card-non-mobile',
	                null,
	                (0, _preact.h)(
	                    'div',
	                    { 'class': 'daily-tarot-card' },
	                    (0, _preact.h)('img', {
	                        src: 'https://gfx.tarot.com/images/daily-pages/daily-icons/tarot.svg',
	                        'class': 'tarot-card-unknown',
	                        alt: 'Unknown Tarot Card'
	                    })
	                ),
	                (0, _preact.h)(_datePicker2.default, { 'class': 'icon-24x23-calendar js-datepicker', url: '/daily-tarot-card/:date' }),
	                _this.renderDailyLinks(),
	                (0, _preact.h)(
	                    'h1',
	                    null,
	                    'Tarot Card of',
	                    (0, _preact.h)('br', null),
	                    'the Day'
	                ),
	                _this.renderSubLinks(),
	                (0, _preact.h)('br', null),
	                (0, _preact.h)('br', null),
	                (0, _preact.h)(
	                    'h2',
	                    null,
	                    'Your FREE Tarot Card Awaits!'
	                ),
	                (0, _preact.h)('br', null),
	                (0, _preact.h)(
	                    'p',
	                    null,
	                    'Looking for your Tarot Card of the Day? Create your profile to receive a Tarot card that\'s personalized to YOU every day!'
	                ),
	                (0, _preact.h)(
	                    'p',
	                    null,
	                    (0, _preact.h)(
	                        'a',
	                        { href: '#login', 'class': 'button' },
	                        'GET MY DAILY TAROT CARD'
	                    )
	                )
	            );
	        }, _this.renderForEveryone = function () {
	            if (_this.props.tcod && _this.props.tcod.everyone) {
	                return _this.renderTCOD(_this.props.tcod.everyone);
	            }
	
	            return (0, _preact.h)('daily-tarot-card-non-mobile', null);
	        }, _this.renderDailyLinks = function () {
	            var yesterday = (0, _moment2.default)().subtract(1, 'days').format('YYYY-MM-DD');
	            var today = (0, _moment2.default)().format('YYYY-MM-DD');
	            var tomorrow = (0, _moment2.default)().add(1, 'days').format('YYYY-MM-DD');
	
	            return (0, _preact.h)(
	                'div',
	                { 'class': 'daily-links' },
	                (0, _preact.h)(
	                    'a',
	                    {
	                        href: '/daily-tarot-card/' + yesterday + '#' + _this.props.route,
	                        'class': _this.props.date == yesterday ? 'selected' : ''
	                    },
	                    'Yesterday'
	                ),
	                (0, _preact.h)(
	                    'a',
	                    {
	                        href: '/daily-tarot-card/' + today + '#' + _this.props.route,
	                        'class': _this.props.date == today ? 'selected' : ''
	                    },
	                    'Today'
	                ),
	                (0, _preact.h)(
	                    'a',
	                    {
	                        href: '/daily-tarot-card/' + tomorrow + '#' + _this.props.route,
	                        'class': _this.props.date == tomorrow ? 'selected' : ''
	                    },
	                    'Tomorrow'
	                )
	            );
	        }, _this.renderSubLinks = function () {
	            return (0, _preact.h)(
	                'div',
	                { 'class': 'daily-links' },
	                (0, _preact.h)(
	                    'a',
	                    { href: _this.props.route == 'everyone' ? '#you' : '#everyone' },
	                    _this.props.route == 'everyone' ? 'Your' : "Everyone's",
	                    ' Tarot Card'
	                ),
	                (0, _preact.h)(
	                    'a',
	                    {
	                        href: '/readings-reports/tarot-readings/daily-reflection',
	                        onClick: function onClick() {
	                            return _this.props.trackPromo(['TCOD', 'DRT']);
	                        }
	                    },
	                    'Get Your Daily Tarot Reading'
	                )
	            );
	        }, _this.renderTCOD = function (tcod) {
	            if (tcod) {
	                var img_url = 'https://gfx.tarot.com/images/site/decks/' + tcod.deck_code + '/full_size/' + tcod.card_id + '.jpg';
	
	                return (0, _preact.h)(
	                    'daily-tarot-card-non-mobile',
	                    null,
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'daily-tarot-card' },
	                        (0, _preact.h)(
	                            'a',
	                            { href: '/tarot/cards/' + tcod.card.canonical_rank + '/' + tcod.deck_code, target: '_blank' },
	                            (0, _preact.h)('img', {
	                                src: img_url,
	                                alt: tcod.card.name
	                            })
	                        ),
	                        (0, _preact.h)(
	                            'small',
	                            null,
	                            (0, _preact.h)(
	                                'a',
	                                { href: '/tarot/decks/' + tcod.deck_code },
	                                tcod.deck.name
	                            ),
	                            ' deck',
	                            (0, _preact.h)('br', null),
	                            '\xA9 U.S. Games Systems, Inc.'
	                        )
	                    ),
	                    (0, _preact.h)(_datePicker2.default, { 'class': 'icon-24x23-calendar js-datepicker', url: '/daily-tarot-card/:date' }),
	                    _this.renderDailyLinks(),
	                    (0, _preact.h)(
	                        'h1',
	                        null,
	                        'Tarot Card of',
	                        (0, _preact.h)('br', null),
	                        'the Day'
	                    ),
	                    _this.renderSubLinks(),
	                    (0, _preact.h)('br', null),
	                    tcod.interp_body.map(function (p, key) {
	                        if (key == 0) {
	                            return (0, _preact.h)(
	                                'p',
	                                null,
	                                (0, _preact.h)(
	                                    'b',
	                                    null,
	                                    (0, _moment2.default)(_this.props.date).format('M.D.YY'),
	                                    ' ',
	                                    tcod.card.name,
	                                    ': '
	                                ),
	                                p
	                            );
	                        }
	                        return (0, _preact.h)(
	                            'p',
	                            null,
	                            p
	                        );
	                    }),
	                    (0, _preact.h)(
	                        'p',
	                        null,
	                        (0, _preact.h)(_promoMessage2.default, { placement: 'text-tarot' })
	                    )
	                );
	            }
	
	            return null;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref2) {
	            var route = _ref2.route;
	
	            if (route != 'everyone') {
	                return this.renderForYou();
	            }
	
	            return this.renderForEveryone();
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        tcod: state.tcod,
	        logged_in: state.user && state.user.logged_in,
	        route: state.route
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        trackPromo: function trackPromo(payload) {
	            return dispatch({ type: 'promo-tracker:recordInternal', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/eyeota.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.get_age = function () {
	            if (!_this.props.user.birth_date) {
	                return null;
	            }
	            var bd = new Date(_this.props.user.birth_date);
	            var currentTime = new Date();
	            return Math.floor((currentTime - bd) / (365 * 86400000));
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref2) {
	            var user = _ref2.user,
	                site = _ref2.site;
	
	            if (user.logged_in) {
	                var age = this.get_age();
	                var url = 'https://ps.eyeota.net/pixel?pid=ioi0rgu&t=ajs&sid=' + site + '&age=' + age + '&gender=' + user.sex;
	                return (0, _preact.h)('script', { type: 'text/javascript', async: true, defer: true, src: url });
	            }
	
	            return (0, _preact.h)('eyeota', null);
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        site: state.property_id == 17 ? 'mtarot' : 'tarot',
	        user: state.user
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/feedback/form.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.submit = function (e) {
	            e.preventDefault();
	
	            var $button = $('[type=submit]', 'feedback-form').text('Submitting…').attr('disabled', 'disabled');
	
	            var form_json = _this.validateAndSerialize($('form', 'feedback-form'));
	
	            if (form_json) {
	                $.ajax({
	                    url: '/service/feedback/submit',
	                    type: 'POST',
	                    dataType: 'json',
	                    data: JSON.stringify(form_json)
	                }).then(function (data) {
	                    $('#tab-feedback').html(data.html);
	
	                    $('html, body').animate({ scrollTop: $('.container-main_content').offset().top }, 200);
	                }, function () {
	                    $button.text('Send Feedback').removeAttr('disabled');
	                });
	            } else {
	                $button.text('Send Feedback').removeAttr('disabled');
	            }
	        }, _this.clear = function () {
	            var error_classes = _this.props.error_classes;
	
	            $('input, textarea, select', 'feedback-form').val('');
	            $('.control-group', 'feedback-form').removeClass(error_classes.join(' '));
	        }, _this.validateAndSerialize = function ($form) {
	            var Cookies = __webpack_require__("../node_modules/js-cookie/src/js.cookie.js");
	
	            var $email_field = $form.find('input[name=email]', 'feedback-form');
	            var $tag_field = $form.find('select[name=tag]', 'feedback-form');
	            var subject = $tag_field.find('option:selected').text();
	            var tag = $tag_field.find('option:selected').val();
	
	            var valid_email = _this.validateEmail($email_field);
	            var valid_tag = _this.validateTag($tag_field);
	
	            if (valid_email && valid_tag) {
	                return { ticket: {
	                        email: $email_field.val(),
	                        subject: subject + ' (key:' + tag + ')',
	                        name: $('input[name=name]', 'feedback-form').val(),
	                        page: Cookies.get('feedback-url'),
	                        phone: $('input[name=phone]', 'feedback-form').val(),
	                        description: $('textarea[name=comment]', 'feedback-form').val()
	                    } };
	            }
	
	            $('html, body').animate({ scrollTop: $form.offset().top }, 200);
	
	            return null;
	        }, _this.validateTag = function ($select) {
	            var error_classes = _this.props.error_classes;
	            var tag = $select.val();
	            var $control_group = $select.closest('.control-group');
	
	            $control_group.removeClass(error_classes.join(' '));
	
	            if (!tag) {
	                $control_group.addClass('error-input error-invalid');
	                return false;
	            }
	
	            return true;
	        }, _this.validateEmail = function ($field) {
	            var error_classes = _this.props.error_classes;
	            var email = $field.val();
	            var $control_group = $field.closest('.control-group');
	
	            $control_group.removeClass(error_classes.join(' '));
	
	            if (email.length === 0) {
	                $control_group.addClass('error-input error-empty');
	                return false;
	            }
	
	            if (!/\S+@\S+\.\S+/.test(email)) {
	                $control_group.addClass('error-input error-invalid');
	                return false;
	            }
	
	            return true;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref2) {
	            var email = _ref2.email,
	                fullname = _ref2.fullname;
	
	            return (0, _preact.h)(
	                'feedback-form',
	                null,
	                (0, _preact.h)(
	                    'form',
	                    { onSubmit: this.submit },
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'control-group' },
	                        (0, _preact.h)(
	                            'label',
	                            null,
	                            'Please select a subject:'
	                        ),
	                        (0, _preact.h)(
	                            'select',
	                            { 'class': 'span6', name: 'tag' },
	                            (0, _preact.h)(
	                                'option',
	                                { selected: true, disabled: true },
	                                'Select One'
	                            ),
	                            (0, _preact.h)(
	                                'option',
	                                { value: 'unsub' },
	                                'Please unsubscribe me from emails'
	                            ),
	                            (0, _preact.h)(
	                                'option',
	                                { value: 'journal' },
	                                'Can\'t find the reading/report I purchased'
	                            ),
	                            (0, _preact.h)(
	                                'option',
	                                { value: 'keen' },
	                                'Can\'t find my KEEN Psychic'
	                            ),
	                            (0, _preact.h)(
	                                'option',
	                                { value: 'kcgc' },
	                                'Where are my Karma Coins\xAE tokens?'
	                            ),
	                            (0, _preact.h)(
	                                'option',
	                                { value: 'bday' },
	                                'Where is my birthday gift?'
	                            ),
	                            (0, _preact.h)(
	                                'option',
	                                { value: 'tp' },
	                                'I can\'t redeem my TrialPay order'
	                            ),
	                            (0, _preact.h)(
	                                'option',
	                                { value: 'fix' },
	                                'I need to update my purchased report with the correct birth info'
	                            ),
	                            (0, _preact.h)(
	                                'option',
	                                { value: 'wrs' },
	                                'My report is advising the wrong Sun and/or Rising sign'
	                            ),
	                            (0, _preact.h)(
	                                'option',
	                                { value: 'purchase' },
	                                'I have a question regarding a purchase'
	                            ),
	                            (0, _preact.h)(
	                                'option',
	                                { value: 'twitta' },
	                                'I have a Twittascope.com issue'
	                            ),
	                            (0, _preact.h)(
	                                'option',
	                                { value: 'app' },
	                                'I have a question about one of your apps'
	                            ),
	                            (0, _preact.h)(
	                                'option',
	                                { value: 'thanks' },
	                                'Nothing! I just wanted to say thanks'
	                            ),
	                            (0, _preact.h)(
	                                'option',
	                                { value: 'ads' },
	                                'Comments regarding advertisement buttons on the site'
	                            ),
	                            (0, _preact.h)(
	                                'option',
	                                { value: 'dislike' },
	                                'Unsatisfied commentary'
	                            ),
	                            (0, _preact.h)(
	                                'option',
	                                { value: 'mac' },
	                                'Macintosh related issues'
	                            ),
	                            (0, _preact.h)(
	                                'option',
	                                { value: 'crowley' },
	                                'Crowley Tarot Deck Inquiries'
	                            ),
	                            (0, _preact.h)(
	                                'option',
	                                { value: 'nancy' },
	                                'Personal Numerology Session Requests'
	                            ),
	                            (0, _preact.h)(
	                                'option',
	                                { value: 'close' },
	                                'Close Member Account'
	                            ),
	                            (0, _preact.h)(
	                                'option',
	                                { value: 'other' },
	                                'Other (Please tell us more below)'
	                            )
	                        ),
	                        (0, _preact.h)(
	                            'span',
	                            { 'class': 'help-block error-message error-message-invalid' },
	                            'Please select a subject.'
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'control-group' },
	                        (0, _preact.h)(
	                            'label',
	                            { htmlFor: 'email' },
	                            'Email:'
	                        ),
	                        (0, _preact.h)('input', { id: 'email', type: 'text', name: 'email', placeholder: 'jane@example.com', value: email }),
	                        (0, _preact.h)(
	                            'span',
	                            { 'class': 'help-block error-message error-message-empty' },
	                            'Please enter your email address'
	                        ),
	                        (0, _preact.h)(
	                            'span',
	                            { 'class': 'help-block error-message error-message-invalid' },
	                            'Please enter a valid email address'
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'label',
	                        { htmlFor: 'phone' },
	                        'Phone:'
	                    ),
	                    (0, _preact.h)('input', { id: 'phone', type: 'text', name: 'phone', placeholder: '555-555-5555' }),
	                    (0, _preact.h)(
	                        'label',
	                        { htmlFor: 'name' },
	                        'Name:'
	                    ),
	                    (0, _preact.h)('input', { id: 'name', type: 'text', name: 'name', placeholder: 'Jane Doe', value: fullname }),
	                    (0, _preact.h)(
	                        'p',
	                        null,
	                        'Please fill out the form below, providing us with as many details as possible so we can help you better'
	                    ),
	                    (0, _preact.h)(
	                        'label',
	                        null,
	                        'Comments:'
	                    ),
	                    (0, _preact.h)('textarea', { rows: '5', name: 'comment' }),
	                    (0, _preact.h)(
	                        'button',
	                        { type: 'submit' },
	                        'Send Feedback'
	                    ),
	                    (0, _preact.h)(
	                        'button',
	                        { type: 'button', onClick: this.clear },
	                        'Clear Form'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        error_classes: ['error-input', 'error-empty', 'error-invalid'],
	        email: state.user && state.user.email,
	        fullname: state.user && state.user.fullname
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/feedback/tab.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.reveal = function () {
	            _this.setState({ revealed: true });
	        }, _this.redirect = function () {
	            _this.props.setCookie();
	            window.location = '/service/feedback';
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'comonentWillMount',
	        value: function comonentWillMount() {
	            var blacklisted = ['/service', '/service/faq', '/service/feedback'].indexOf(window.location.pathname) >= 0;
	
	            this.setState({
	                blacklisted: blacklisted,
	                revealed: false
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.state.blacklisted) {
	                if (!this.state.revealed) {
	                    setTimeout(this.reveal, 30000);
	
	                    return null;
	                }
	
	                return (0, _preact.h)('feedback-tab', { 'class': 'revealed', onclick: this.redirect });
	            }
	
	            return null;
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        setCookie: function setCookie() {
	            return dispatch({
	                type: 'cookie:set',
	                payload: {
	                    name: 'feedback-url',
	                    value: window.location.href
	                }
	            });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(null, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/fields/date.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _underscore = __webpack_require__("../node_modules/underscore/underscore.js");
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _mediaQuery = __webpack_require__("./app/media-query.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderSelects = function (className) {
	            if (_mediaQuery.MediaQuery.isMobile()) {
	                return (0, _preact.h)(
	                    'label',
	                    {
	                        htmlFor: _this.props.label,
	                        'class': 'date-input ' + (_this.props.dirty && _this.props.error ? 'error' : '') + ' ' + className
	                    },
	                    _this.props.label,
	                    _this.renderGroupInput(),
	                    _this.renderError()
	                );
	            }
	
	            return (0, _preact.h)(
	                'fieldset',
	                { 'class': className },
	                (0, _preact.h)(
	                    'legend',
	                    null,
	                    _this.props.label
	                ),
	                (0, _preact.h)(
	                    'label',
	                    { htmlFor: 'month', 'class': _this.props.dirty && _this.props.error ? 'error' : '' },
	                    (0, _preact.h)(
	                        'select',
	                        {
	                            'data-action': 'Select-Month',
	                            'data-category': _this.props.category,
	                            'data-ga-event': true,
	                            'data-label': _this.props.label,
	                            onChange: _this.setMonth,
	                            name: 'month',
	                            required: true
	                        },
	                        (0, _preact.h)(
	                            'option',
	                            { selected: !_this.props.month, disabled: true },
	                            'month'
	                        ),
	                        _this.state.months.map(function (month) {
	                            return (0, _preact.h)(
	                                'option',
	                                {
	                                    value: (0, _moment2.default)().month(month).format('MM'),
	                                    selected: _this.props.month == (0, _moment2.default)().month(month).format('MM')
	                                },
	                                (0, _moment2.default)().month(month).format('MMMM')
	                            );
	                        })
	                    )
	                ),
	                _this.renderDaySelect(),
	                (0, _preact.h)(
	                    'label',
	                    { htmlFor: 'year', 'class': _this.props.dirty && _this.props.error ? 'error' : '' },
	                    (0, _preact.h)(
	                        'select',
	                        {
	                            'data-action': 'Select-Year',
	                            'data-category': _this.props.category,
	                            'data-ga-event': true,
	                            'data-label': _this.props.label,
	                            onChange: _this.setYear,
	                            name: 'year',
	                            required: true
	                        },
	                        (0, _preact.h)(
	                            'option',
	                            { selected: !_this.props.year, disabled: true },
	                            'year'
	                        ),
	                        _this.state.years.map(function (year) {
	                            return (0, _preact.h)(
	                                'option',
	                                {
	                                    value: year,
	                                    selected: _this.props.year == year
	                                },
	                                year
	                            );
	                        })
	                    )
	                ),
	                _this.renderError()
	            );
	        }, _this.renderDaySelect = function () {
	            if (!_this.props.month_only) {
	                return (0, _preact.h)(
	                    'label',
	                    { htmlFor: 'day', 'class': _this.props.dirty && _this.props.error ? 'error' : '' },
	                    (0, _preact.h)(
	                        'select',
	                        {
	                            'data-action': 'Select-Day',
	                            'data-category': _this.props.category,
	                            'data-ga-event': true,
	                            'data-label': _this.props.label,
	                            onChange: _this.setDay,
	                            name: 'day',
	                            required: true
	                        },
	                        (0, _preact.h)(
	                            'option',
	                            { selected: !_this.props.day, disabled: true },
	                            'day'
	                        ),
	                        _this.state.days.map(function (day) {
	                            return (0, _preact.h)(
	                                'option',
	                                {
	                                    value: ('0' + (day + 1)).substr(-2),
	                                    selected: _this.props.day == day + 1
	                                },
	                                day + 1
	                            );
	                        })
	                    )
	                );
	            }
	
	            return null;
	        }, _this.renderGroupInput = function () {
	            if (_this.props.month_only) {
	                return (0, _preact.h)('input', {
	                    type: 'month',
	                    name: _this.props.name,
	                    value: _this.props.month && _this.props.year ? (0, _moment2.default)(_this.props.year + '-' + _this.props.month).format('YYYY-MM') : null,
	                    onChange: _this.validateInput,
	                    onBlur: _this.validateInput
	                });
	            }
	
	            return (0, _preact.h)('input', {
	                type: 'date',
	                max: (0, _moment2.default)().format('YYYY-MM-DD'),
	                min: (0, _moment2.default)().subtract(100, 'years').format('YYYY-MM-DD'),
	                name: _this.props.name,
	                value: _this.props.month && _this.props.day && _this.props.year ? (0, _moment2.default)(_this.props.year + '-' + _this.props.month + '-' + _this.props.day).format('YYYY-MM-DD') : null,
	                onChange: _this.validateInput,
	                onBlur: _this.validateInput
	            });
	        }, _this.renderError = function () {
	            if (_this.props.dirty && _this.props.error) {
	                return (0, _preact.h)(
	                    'p',
	                    { 'class': 'error-msg' },
	                    _this.props.error
	                );
	            }
	
	            return (0, _preact.h)('p', { 'class': 'error-msg' });
	        }, _this.validateInput = function (e) {
	            var value = e.target.value;
	            var error = null;
	
	            if (_this.props.month_only && !/^[0-9]{4}\-[0-9]{2}$/.test(value)) {
	                error = 'Invalid date';
	            } else if (!_this.props.month_only && !/^[0-9]{4}\-[0-9]{2}\-[0-9]{2}$/.test(value)) {
	                error = 'Invalid date';
	            }
	
	            _this.props.reportInput(_this.props.name, value, error);
	        }, _this.validateSelects = function () {
	            var value = null;
	
	            if (_this.props.month_only && _this.state.year && _this.state.month) {
	                value = _this.state.year + '-' + _this.state.month;
	            } else if (_this.state.year && _this.state.month && _this.state.day) {
	                value = _this.state.year + '-' + _this.state.month + '-' + _this.state.day;
	            }
	
	            if (value) {
	                _this.props.reportInput(_this.props.name, value, null);
	            }
	        }, _this.setMonth = function (e) {
	            _this.setState({ month: e.target.value });
	            _this.getDays();
	            _this.validateSelects();
	        }, _this.setDay = function (e) {
	            _this.setState({ day: e.target.value });
	            _this.validateSelects();
	        }, _this.setYear = function (e) {
	            _this.setState({ year: e.target.value });
	            _this.getDays();
	            _this.validateSelects();
	        }, _this.getDays = function () {
	            if (!_this.props.month_only && _this.state.year && _this.state.month) {
	                var daysInMonth = (0, _moment2.default)(_this.state.year + '-' + _this.state.month, 'YYYY-MM').daysInMonth();
	                var days = _underscore2.default.range(daysInMonth);
	
	                _this.setState({
	                    days: days
	                });
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var months = _underscore2.default.range(12);
	            var days = _underscore2.default.range(31);
	            var years = this.props.direction == 'future' ? _underscore2.default.range((0, _moment2.default)().year() - 1, (0, _moment2.default)().year() + 10) : _underscore2.default.range((0, _moment2.default)().year(), (0, _moment2.default)().year() - 100, -1);
	
	            this.setState({
	                month: this.props.month,
	                months: months,
	                day: this.props.day,
	                days: days,
	                year: this.props.year,
	                years: years
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var name = _ref2.name,
	                className = _ref2.class;
	
	            return (0, _preact.h)(
	                'date-select',
	                { name: name },
	                this.renderSelects(className)
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	exports.default = (0, _preactRedux.connect)()(Component);

/***/ },

/***/ "./app/components/fields/gender.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var _this2 = this;
	
	            var name = _ref.name,
	                value = _ref.value;
	
	            return (0, _preact.h)(
	                'gender-field',
	                { 'class': 'radio-input' },
	                (0, _preact.h)(
	                    'legend',
	                    null,
	                    'Gender:'
	                ),
	                (0, _preact.h)(
	                    'label',
	                    null,
	                    'Female',
	                    (0, _preact.h)('input', {
	                        checked: value == 'female',
	                        id: 'female',
	                        name: name,
	                        type: 'radio',
	                        value: 'female',
	                        onClick: function onClick() {
	                            return _this2.props.reportInput(name, 'female', null);
	                        }
	                    })
	                ),
	                (0, _preact.h)(
	                    'label',
	                    null,
	                    'Male',
	                    (0, _preact.h)('input', {
	                        checked: value == 'male',
	                        id: 'male',
	                        name: name,
	                        type: 'radio',
	                        value: 'male',
	                        onClick: function onClick() {
	                            return _this2.props.reportInput(name, 'male', null);
	                        }
	                    })
	                ),
	                (0, _preact.h)(
	                    'p',
	                    { 'class': 'error-msg' },
	                    this.props.error
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	exports.default = (0, _preactRedux.connect)()(Component);

/***/ },

/***/ "./app/components/fields/name.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderInfo = function () {
	            if (_this.props.info) {
	                return (0, _preact.h)(
	                    'span',
	                    { 'class': 'more-info text-link' },
	                    'More info',
	                    (0, _preact.h)(
	                        'span',
	                        { 'class': 'form-tooltip' },
	                        _this.props.info
	                    )
	                );
	            }
	
	            return null;
	        }, _this.renderError = function () {
	            if (_this.props.dirty && _this.props.error) {
	                return (0, _preact.h)(
	                    'p',
	                    { 'class': 'error-msg' },
	                    _this.props.error
	                );
	            }
	
	            return (0, _preact.h)('p', { 'class': 'error-msg' });
	        }, _this.validate = function (e) {
	            var value = e.target.value;
	            var name = e.target.getAttribute('name');
	            var number_of_values = value.replace(/[^\s]+/g, '').length + 1;
	            var error = null;
	
	            if (number_of_values == 0) {
	                error = "This field can't be empty.";
	            } else if (number_of_values == 1) {
	                error = 'This field requires at least first and last names.';
	            } else if (number_of_values > 3) {
	                error = 'This field requires first and last name. Middle name is optional';
	            }
	
	            _this.props.reportInput(name, value, error);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref2) {
	            var name = _ref2.name,
	                label = _ref2.label,
	                value = _ref2.value,
	                dirty = _ref2.dirty,
	                error = _ref2.error;
	
	            return (0, _preact.h)(
	                'name-field',
	                null,
	                (0, _preact.h)(
	                    'label',
	                    { htmlFor: label, 'class': dirty && error ? 'error' : '' },
	                    label,
	                    this.renderInfo(),
	                    (0, _preact.h)('input', {
	                        maxLength: '40',
	                        type: 'text',
	                        name: name,
	                        value: value,
	                        onKeyUp: this.validate,
	                        required: true
	                    }),
	                    this.renderError()
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	exports.default = (0, _preactRedux.connect)()(Component);

/***/ },

/***/ "./app/components/fields/time.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _underscore = __webpack_require__("../node_modules/underscore/underscore.js");
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this));
	
	        _this.renderTimeInput = function () {
	            if (window.Modernizr.inputtypes.time) {
	                (0, _preact.h)('input', {
	                    type: 'time',
	                    'class': 'js-autofill-user-birth-time',
	                    'data-action': 'Input-Birth-Time',
	                    'data-category': _this.props.ga_category,
	                    'data-ga-event': true,
	                    'data-label': _this.props.upc,
	                    name: 'birth_time',
	                    value: '12:00'
	                });
	            }
	
	            return (0, _preact.h)(
	                'fieldset',
	                null,
	                (0, _preact.h)(
	                    'select',
	                    {
	                        'class': 'js-autofill-user-birth-hour',
	                        'data-action': 'Select-Birth-Hour',
	                        'data-category': _this.props.ga_category,
	                        'data-ga-event': true,
	                        'data-label': _this.props.upc
	                    },
	                    (0, _preact.h)(
	                        'option',
	                        { selected: true, disabled: true },
	                        'Hour'
	                    ),
	                    _underscore2.default.range(1, 13).map(function (hour) {
	                        return (0, _preact.h)(
	                            'option',
	                            { value: hour },
	                            hour
	                        );
	                    })
	                ),
	                (0, _preact.h)(
	                    'select',
	                    {
	                        'class': 'js-autofill-user-birth-minute',
	                        'data-action': 'Select-Birth-Minute',
	                        'data-category': _this.props.ga_category,
	                        'data-ga-event': true,
	                        'data-label': _this.props.upc
	                    },
	                    (0, _preact.h)(
	                        'option',
	                        { selected: true, disabled: true },
	                        'Minute'
	                    ),
	                    _underscore2.default.range(60).map(function (minute) {
	                        return (0, _preact.h)(
	                            'option',
	                            { value: minute },
	                            minute
	                        );
	                    })
	                ),
	                (0, _preact.h)(
	                    'button',
	                    { onClick: _this.toggle, 'class': _this.state.pm ? '' : 'active', 'data-value': 'am' },
	                    'AM'
	                ),
	                (0, _preact.h)(
	                    'button',
	                    { onClick: _this.toggle, 'class': _this.state.pm ? 'active' : '', 'data-value': 'pm' },
	                    'PM'
	                )
	            );
	        };
	
	        _this.toggle = function () {
	            _this.setState({ pm: !_this.state.pm });
	        };
	
	        _this.setState({ pm: false });
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var group_label = _ref.group_label;
	
	            return (0, _preact.h)(
	                'time-select',
	                null,
	                (0, _preact.h)(
	                    'legend',
	                    null,
	                    group_label
	                ),
	                this.renderTimeInput(),
	                (0, _preact.h)('input', {
	                    type: 'checkbox',
	                    'data-action': 'Select-Birth-Time-Unknown',
	                    'data-category': this.props.ga_category,
	                    'data-ga-event': true,
	                    'data-label': this.props.upc,
	                    name: 'dontknow'
	                }),
	                (0, _preact.h)(
	                    'label',
	                    { htmlFor: 'dontknow' },
	                    'Birth time unknown',
	                    (0, _preact.h)(
	                        'span',
	                        { 'class': 'detail' },
	                        '(this is used to calculate rising and moon signs)'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	exports.default = (0, _preactRedux.connect)()(Component);

/***/ },

/***/ "./app/components/form/birthdate.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _mediaQuery = __webpack_require__("./app/media-query.js");
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component(props) {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this, props));
	
	        _this.renderMonthSelect = function () {
	            return (0, _preact.h)(
	                'select',
	                _extends({}, _this.state.attrs, {
	                    'data-action': _this.state.action + '-Month',
	                    onChange: function onChange(e) {
	                        return _this.setMonth(e);
	                    }
	                }),
	                (0, _preact.h)(
	                    'option',
	                    null,
	                    'Month'
	                ),
	                _this.renderMonthOptions()
	            );
	        };
	
	        _this.renderMonthOptions = function () {
	            return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(function (m) {
	                var month = m + 1;
	
	                return (0, _preact.h)(
	                    'option',
	                    {
	                        value: month.toString().padStart(2, 0),
	                        selected: _this.state.month == month
	                    },
	                    (0, _moment2.default)().month(m).format('MMMM')
	                );
	            });
	        };
	
	        _this.setMonth = function (e) {
	            _this.setState({
	                month: e.target.value,
	                day: null
	            });
	        };
	
	        _this.renderDaySelect = function () {
	            return (0, _preact.h)(
	                'select',
	                _extends({}, _this.state.attrs, {
	                    'data-action': _this.state.action + '-Day',
	                    onChange: function onChange(e) {
	                        return _this.setDay(e);
	                    },
	                    disabled: !_this.state.month
	                }),
	                (0, _preact.h)(
	                    'option',
	                    null,
	                    'Day'
	                ),
	                _this.renderDayOptions()
	            );
	        };
	
	        _this.renderDayOptions = function () {
	            if (_this.state.month) {
	                var year = _this.state.year || (0, _moment2.default)().year();
	                var days = (0, _moment2.default)(year + '-' + _this.state.month, 'YYYY-MM').daysInMonth();
	
	                var daysArray = [];
	                for (var i = 1; i <= days; i++) {
	                    daysArray.push(i);
	                }
	
	                return daysArray.map(function (day) {
	                    return (0, _preact.h)(
	                        'option',
	                        {
	                            value: day.toString().padStart(2, 0),
	                            selected: _this.state.day == day
	                        },
	                        day
	                    );
	                });
	            }
	
	            return null;
	        };
	
	        _this.setDay = function (e) {
	            _this.setState({
	                day: e.target.value
	            });
	        };
	
	        _this.renderYearSelect = function () {
	            return (0, _preact.h)(
	                'select',
	                _extends({}, _this.state.attrs, {
	                    'data-action': _this.state.action + '-Year',
	                    onChange: function onChange(e) {
	                        return _this.setYear(e);
	                    }
	                }),
	                (0, _preact.h)(
	                    'option',
	                    null,
	                    'Year'
	                ),
	                _this.renderYearOptions()
	            );
	        };
	
	        _this.renderYearOptions = function () {
	            var yearsArray = [];
	            for (var i = (0, _moment2.default)().year(); i > 1904; i--) {
	                yearsArray.push(i);
	            }
	
	            return yearsArray.map(function (year) {
	                return (0, _preact.h)(
	                    'option',
	                    {
	                        value: year,
	                        selected: _this.state.year == year
	                    },
	                    year
	                );
	            });
	        };
	
	        _this.setYear = function (e) {
	            _this.setState({
	                year: e.target.value
	            });
	        };
	
	        _this.renderHiddenInput = function () {
	            var value = _this.state.year && _this.state.month && _this.state.day ? _this.state.year + '-' + _this.state.month + '-' + _this.state.day : null;
	
	            _this.state.change({
	                target: {
	                    name: 'birth_date',
	                    type: null,
	                    value: value
	                }
	            });
	
	            return (0, _preact.h)('input', {
	                type: 'hidden',
	                name: _this.state.name,
	                value: value
	            });
	        };
	
	        var attrs = _extends({}, props); // html attributes, without any weird routeTo etc
	
	        if (!_mediaQuery.MediaQuery.isMobile()) {
	            _this.setState({
	                name: attrs.name,
	                action: attrs['data-action'],
	                month: null,
	                day: null,
	                year: null,
	                change: attrs.onChange
	            });
	
	            delete attrs.max;
	            delete attrs.min;
	            delete attrs.type;
	            delete attrs.name;
	            delete attrs['data-action'];
	            delete attrs.onChange;
	        }
	
	        _this.setState({ attrs: attrs });
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render() {
	            if (_mediaQuery.MediaQuery.isMobile()) {
	                return (0, _preact.h)(
	                    'form-birthdate',
	                    null,
	                    (0, _preact.h)('input', this.state.attrs)
	                );
	            }
	
	            return (0, _preact.h)(
	                'form-birthdate',
	                null,
	                (0, _preact.h)(
	                    'div',
	                    { 'class': 'select-month' },
	                    this.renderMonthSelect()
	                ),
	                (0, _preact.h)(
	                    'div',
	                    { 'class': 'select-day' },
	                    this.renderDaySelect()
	                ),
	                (0, _preact.h)(
	                    'div',
	                    { 'class': 'select-year' },
	                    this.renderYearSelect()
	                ),
	                this.renderHiddenInput()
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	exports.default = (0, _preactRedux.connect)()(Component);

/***/ },

/***/ "./app/components/form/input-validation.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this));
	
	        _this.validate = function (e) {
	            _this.setState({ valid: e.target.checkValidity() });
	        };
	
	        _this.clear = function () {
	            _this.setState({ valid: true });
	        };
	
	        _this.setState({ valid: true });
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(props) {
	            return (0, _preact.h)(
	                'input-validation',
	                null,
	                (0, _preact.h)('input', _extends({}, props, {
	                    onBlur: this.validate,
	                    onFocus: this.clear,
	                    'class': this.state.valid ? 'valid' : 'error'
	                }))
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	exports.default = (0, _preactRedux.connect)()(Component);

/***/ },

/***/ "./app/components/ga-events.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render() {
	            return (0, _preact.h)('ga-events', null);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var component = this;
	
	            $(document).on('click', ['a[data-ga-event]', '[data-ga-event][class^="button"]', '[data-ga-event][data-action^="Click"]'].join(', '), function () {
	                component.trackDynamicClick(this);
	            });
	
	            $(document).on('click', '.over-shadow.dim:not(.js-mobile_nav)', function () {
	                component.props.trackEvent(['Navigation', 'Close', 'Background']);
	            });
	
	            $(document).on('input', '[data-ga-event][data-action^="Type"], [data-ga-event][data-action^="Input"]', function () {
	                component.trackOneTimeEvent($(this));
	            });
	
	            $(document).on('change', '[data-ga-event][data-action^="Select"]', function () {
	                component.trackOneTimeEvent($(this));
	            });
	
	            $(document).on('click', '.js-footer-links a', function () {
	                component.props.trackEvent(['Footer', 'Click', $(this).text()]);
	            });
	
	            $(document).on('click', '.js-trackable_nav a', function () {
	                component.trackBubbledLink($(this), 'Navigation', 'Click');
	            });
	        }
	    }, {
	        key: 'trackDynamicClick',
	        value: function trackDynamicClick(el) {
	            var category = $(el).data('category');
	            var action = $(el).data('action');
	            var label = $(el).data('label');
	
	            if (category && label) {
	                this.props.trackPromo([category, label]);
	
	                if (action) {
	                    this.props.trackEvent([category, action, label]);
	                }
	            }
	        }
	    }, {
	        key: 'trackOneTimeEvent',
	        value: function trackOneTimeEvent($el) {
	            this.props.trackEvent([$el.data('category'), $el.data('action'), $el.data('label')]);
	
	            // both must be removed for .data() to stop returning values
	            $el.removeAttr('data-ga-event data-action data-category data-label');
	            $el.removeData('ga-event action category label');
	        }
	    }, {
	        key: 'trackBubbledLink',
	        value: function trackBubbledLink($a, category, action) {
	            if ($a.is('a[data-ga-event]')) {
	                return;
	            }
	
	            var label_parts = [];
	            var label_prefix = $a.parents('[data-ga-event]').data('label-prefix');
	            if (label_prefix) {
	                label_parts.push(label_prefix);
	            }
	
	            label_parts.push($a.text().trim().replace(/\s+/g, ' '));
	
	            var label_suffix = $a.parents('[data-ga-event]').data('label-suffix');
	            if (label_suffix) {
	                label_parts.push(label_suffix);
	            }
	
	            var label = label_parts.join(' - ');
	
	            this.props.trackPromo([category, label]);
	            this.props.trackEvent([category, action, label]);
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        trackEvent: function trackEvent(data) {
	            return dispatch({ type: 'ga:event', payload: data });
	        },
	        trackPromo: function trackPromo(payload) {
	            return dispatch({ type: 'promo-tracker:recordInternal', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(null, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/gdpr-cmp-sortable.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var that = this;
	            setTimeout(function () {
	                that.applies().then(function (gdpr_applies) {
	                    if (gdpr_applies) {
	                        $('.footer-tarot-links').addClass('change');
	                    }
	                });
	            }, 5000); // TODO: move to saga
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return (0, _preact.h)(
	                'gdpr-cmp-sortable',
	                null,
	                (0, _preact.h)(
	                    'li',
	                    { 'class': 'sortable-consent', style: 'display:none' },
	                    (0, _preact.h)(
	                        'a',
	                        { onClick: function onClick(e) {
	                                return _this2.handleOpenCMP(e);
	                            } },
	                        'Your Privacy Settings'
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'applies',
	        value: function applies() {
	            return new Promise(function (resolve) {
	                try {
	                    window.__cmp('getConsentData', null, function (d) {
	                        resolve(d.gdprApplies);
	                    });
	                } catch (error) {
	                    resolve(false); // Pages without ads
	                }
	            });
	        }
	    }, {
	        key: 'handleOpenCMP',
	        value: function handleOpenCMP(e) {
	            e.preventDefault();
	            e.stopPropagation();
	            window.deployads.showConsentTool();
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	exports.default = (0, _preactRedux.connect)()(Component);

/***/ },

/***/ "./app/components/i-ching-reading.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _question = __webpack_require__("./app/components/tarot-readings/tarot-reading/question.js");
	
	var _question2 = _interopRequireDefault(_question);
	
	var _mediaQuery = __webpack_require__("./app/media-query.js");
	
	var _scroll = __webpack_require__("./app/scroll.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderCoinImages = function (coin) {
	            return Array.apply(null, { length: 23 }).map(Function.call, Number).map(function (n) {
	                return (0, _preact.h)('img', {
	                    src: 'https://gfx.tarot.com/images/iching/iching-' + _this.slant + '/coin/' + (n + 1) + '.gif',
	                    style: '\n                  transform: rotate(' + _this.state.coins[coin].rotation + 'deg);\n                  opacity: ' + (_this.state.coins[coin].frame == n + 1 ? 1 : 0) + ';\n              '
	                });
	            });
	        }, _this.setRotationAndSpeed = function () {
	            var state = _this.state;
	
	            state.coins[0].speed = Math.floor(Math.random() * (30 - 20 + 1)) + 20;
	            state.coins[0].rotation = Math.floor(Math.random() * 360 + 1);
	            state.coins[1].speed = Math.floor(Math.random() * (30 - 20 + 1)) + 20;
	            state.coins[1].rotation = Math.floor(Math.random() * 360 + 1);
	            state.coins[2].speed = Math.floor(Math.random() * (30 - 20 + 1)) + 20;
	            state.coins[2].rotation = Math.floor(Math.random() * 360 + 1);
	
	            _this.setState(state);
	        }, _this.shakeHappened = function () {
	            if (_this.state.lines.length < 6) {
	                _this.track('Shake Coins');
	                _this.toss();
	                setTimeout(_this.toss, 1000);
	            }
	        }, _this.toss = function () {
	            if (!_this.state.done) {
	                if (!_this.state.isPlaying && !_this.state.isStopping) {
	                    var state = _this.state;
	
	                    (0, _scroll.smoothScrollToElement)(document.querySelector('.i-ching-reading-coins'));
	
	                    _this.track('Toss Coins');
	                    _this.setRotationAndSpeed();
	
	                    var start = performance.now();
	                    var timer0 = setInterval(function () {
	                        _this.rotate(0);
	                    }, state.coins[0].speed);
	                    var timer1 = setInterval(function () {
	                        _this.rotate(1);
	                    }, state.coins[1].speed);
	                    var timer2 = setInterval(function () {
	                        _this.rotate(2);
	                    }, state.coins[2].speed);
	
	                    state.isPlaying = true;
	                    state.start = start;
	                    state.started = true;
	                    state.value = 0;
	                    state.coins[0].timer = timer0;
	                    state.coins[1].timer = timer1;
	                    state.coins[2].timer = timer2;
	
	                    _this.setState(state);
	                } else if (!_this.state.isStopping) {
	                    var stop = performance.now();
	                    var wheel_start = Math.floor(Math.random() * 16) + 1;
	                    var positions_moved = parseInt(stop - _this.state.start);
	                    var wheel_end = (positions_moved + wheel_start) % 16 + 1;
	                    var result = _this.positions[wheel_end];
	                    var frames = [];
	
	                    //heads = frame 6, tails = frame 18
	                    if (result.value == 6) {
	                        // all tails
	                        frames = _this.randomizeCoins([18, 18, 18]);
	                    } else if (result.value == 7) {
	                        // one heads, two tails
	                        frames = _this.randomizeCoins([6, 18, 18]);
	                    } else if (result.value == 8) {
	                        // two heads, one tails
	                        frames = _this.randomizeCoins([6, 6, 18]);
	                    } else if (result.value == 9) {
	                        // all heads
	                        frames = _this.randomizeCoins([6, 6, 6]);
	                    }
	
	                    var stopTimer = setInterval(function () {
	                        _this.stop(frames, result);
	                    }, 10);
	
	                    _this.setState({
	                        isPlaying: false,
	                        isStopping: true,
	                        stopTimer: stopTimer
	                    });
	                }
	            } else {
	                _this.submit();
	            }
	        }, _this.rotate = function (coin) {
	            var state = _this.state;
	            var nextFrame = state.coins[coin].frame < state.length ? state.coins[coin].frame + 1 : 1;
	
	            state.coins[coin].frame = nextFrame;
	
	            _this.setState(state);
	        }, _this.stop = function (frames, result) {
	            var state = _this.state;
	
	            if (state.coins[0].frame == frames[0]) {
	                clearInterval(state.coins[0].timer);
	                state.coins[0].timer = null;
	            }
	
	            if (state.coins[1].frame == frames[1]) {
	                clearInterval(state.coins[1].timer);
	                state.coins[1].timer = null;
	            }
	
	            if (state.coins[2].frame == frames[2]) {
	                clearInterval(state.coins[2].timer);
	                state.coins[2].timer = null;
	            }
	
	            if (state.coins[0].frame == frames[0] && state.coins[1].frame == frames[1] && state.coins[2].frame == frames[2]) {
	                clearInterval(state.stopTimer);
	
	                state.isStopping = false;
	                state.stopTimer = null;
	                state.lines.push(result.value);
	
	                if (state.lines.length == 6) {
	                    state.done = true;
	                }
	            }
	
	            _this.setState(state);
	        }, _this.toggleAccordion = function (e) {
	            e.preventDefault();
	            _this.setState({ accordionOpen: !_this.state.accordionOpen });
	        }, _this.renderAside = function () {
	            if (_this.state.accordionOpen) {
	                return (0, _preact.h)(
	                    'aside',
	                    { 'class': 'details' },
	                    (0, _preact.h)(
	                        'a',
	                        { 'class': 'button', onClick: _this.toggleAccordion },
	                        '\u2715'
	                    ),
	                    (0, _preact.h)(
	                        'h3',
	                        null,
	                        _this.props.product.product_name,
	                        ' description'
	                    ),
	                    (0, _preact.h)(
	                        'summary',
	                        null,
	                        _this.props.product.long_description.split('\n').map(function (p) {
	                            return (0, _preact.h)(
	                                'p',
	                                null,
	                                p
	                            );
	                        })
	                    )
	                );
	            }
	
	            return null;
	        }, _this.renderH3Text = function () {
	            var text = 'TAP';
	
	            if (!_this.state.done) {
	                if (_mediaQuery.MediaQuery.isMobile()) {
	                    text += ' OR SHAKE';
	                }
	
	                text += ' TO TOSS COINS';
	
	                if (!_this.state.lines.length) {
	                    text += ' 6 TIMES';
	                } else {
	                    text += ' ' + (6 - _this.state.lines.length) + ' MORE TIME';
	
	                    if (_this.state.lines.length < 5) {
	                        text += 'S';
	                    }
	                }
	            } else {
	                text += ' TO REVEAL MEANING';
	            }
	
	            return text;
	        }, _this.renderLines = function () {
	            return [0, 1, 2, 3, 4, 5].map(function (toss) {
	                var img_path = 'https://gfx.tarot.com/images/iching/iching-' + _this.slant + '/hexagram-lines/';
	                var img_filename = 'ghost-line.svg';
	
	                if (typeof _this.state.lines[toss] !== 'undefined') {
	                    if (_this.state.lines[toss] == 6) {
	                        // all heads: changes from -- -- to -----
	                        img_filename = 'broken-changing.svg';
	                    } else if (_this.state.lines[toss] == 7) {
	                        // two heads, one tails: non-changing
	                        img_filename = 'solid-line.svg';
	                    } else if (_this.state.lines[toss] == 8) {
	                        // one heads, two tails: non-changing
	                        img_filename = 'broken-line.svg';
	                    } else if (_this.state.lines[toss] == 9) {
	                        // all tails: changes from ----- to -- --
	                        img_filename = 'solid-changing.svg';
	                    }
	                }
	
	                return (0, _preact.h)(
	                    'div',
	                    { 'class': 'i-ching-reading-line' },
	                    (0, _preact.h)('img', { src: '' + img_path + img_filename })
	                );
	            });
	        }, _this.submit = function () {
	            if (_this.state.done) {
	                _this.track('Reveal Meaning');
	
	                _this.props.submit({
	                    question: _this.props.subject,
	                    lines: _this.state.lines
	                });
	            }
	
	            return false;
	        }, _this.track = function (action) {
	            var category = 'I-Ching';
	            var gaAction = _this.props.logged_in ? 'LI ' + action : 'LO ' + action;
	            var label = _this.props.slant;
	
	            _this.props.trackEvent([category, gaAction, label]);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.slant = this.props.slant == 'free' ? 'general' : this.props.slant;
	
	            if (_mediaQuery.MediaQuery.isMobile() && typeof window.Shake !== 'undefined') {
	                this.shakeEvent = new window.Shake({ threshold: 5 });
	                this.shakeEvent.start();
	                window.addEventListener('shake', this.shakeHappened, false);
	            }
	
	            this.props.init(this.props.product.code);
	
	            this.setState({
	                accordionOpen: false,
	                coins: [{
	                    speed: 0,
	                    rotation: 180,
	                    frame: 18,
	                    timer: null
	                }, {
	                    speed: 0,
	                    rotation: 180,
	                    frame: 18,
	                    timer: null
	                }, {
	                    speed: 0,
	                    rotation: 180,
	                    frame: 18,
	                    timer: null
	                }],
	                done: false,
	                isPlaying: false,
	                isStopping: false,
	                length: 23,
	                lines: [],
	                start: 0,
	                started: false,
	                stopTimer: null,
	                value: 0
	            });
	
	            var icon_url = 'https://gfx.tarot.com/images/iching/iching-' + this.slant + '/icon.svg';
	            var style_sheet = document.createElement('style');
	            var style_rules = ['i-ching-reading .icon-teeup { background-image: url(' + icon_url + '); }'];
	
	            style_rules.forEach(function (rule) {
	                style_sheet.appendChild(document.createTextNode(rule));
	            });
	
	            document.head.appendChild(style_sheet);
	
	            this.positions = {
	                1: { heads: 0, tails: 3, value: 6 },
	                2: { heads: 2, tails: 1, value: 8 },
	                3: { heads: 1, tails: 2, value: 7 },
	                4: { heads: 3, tails: 0, value: 9 },
	                5: { heads: 2, tails: 1, value: 8 },
	                6: { heads: 1, tails: 2, value: 7 },
	                7: { heads: 2, tails: 1, value: 8 },
	                8: { heads: 1, tails: 2, value: 7 },
	                9: { heads: 3, tails: 0, value: 9 },
	                10: { heads: 2, tails: 1, value: 8 },
	                11: { heads: 1, tails: 2, value: 7 },
	                12: { heads: 2, tails: 1, value: 8 },
	                13: { heads: 3, tails: 0, value: 9 },
	                14: { heads: 2, tails: 1, value: 8 },
	                15: { heads: 1, tails: 2, value: 7 },
	                16: { heads: 2, tails: 1, value: 8 }
	            };
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (typeof Shake !== 'undefined') {
	                window.removeEventListener('shake', this.shakeHappened, false);
	                this.shakeEvent.stop();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var product = _ref2.product,
	                submitting = _ref2.submitting;
	
	            return (0, _preact.h)(
	                'i-ching-reading',
	                { slant: this.slant },
	                (0, _preact.h)(
	                    'header',
	                    null,
	                    (0, _preact.h)('div', { 'class': 'icon-teeup' }),
	                    (0, _preact.h)(
	                        'h1',
	                        { 'class': 'reading-header i-ching-' + this.slant },
	                        product.product_name.replace('Sample ', '').replace(' Reading', '')
	                    ),
	                    (0, _preact.h)(
	                        'p',
	                        null,
	                        this.props.product.medium_description,
	                        '\xA0',
	                        (0, _preact.h)(
	                            'a',
	                            { href: '#', onClick: this.toggleAccordion, 'data-action': 'Click-Learn-More' },
	                            'Learn More'
	                        )
	                    )
	                ),
	                this.renderAside(),
	                (0, _preact.h)(_question2.default, { placeholder: 'To help you focus, enter a Subject here' }),
	                (0, _preact.h)(
	                    'section',
	                    {
	                        'class': 'i-ching-reading-coins ' + (this.state.started && !this.state.done ? 'started' : ''),
	                        onClick: this.toss
	                    },
	                    (0, _preact.h)(
	                        'h3',
	                        { 'class': 'i-ching-' + this.slant + ' ' + (this.state.done ? 'done' : '') },
	                        this.renderH3Text()
	                    ),
	                    (0, _preact.h)(
	                        'i-ching-coin',
	                        null,
	                        this.renderCoinImages(0)
	                    ),
	                    (0, _preact.h)(
	                        'i-ching-coin',
	                        null,
	                        this.renderCoinImages(1)
	                    ),
	                    (0, _preact.h)(
	                        'i-ching-coin',
	                        null,
	                        this.renderCoinImages(2)
	                    )
	                ),
	                (0, _preact.h)(
	                    'section',
	                    { 'class': 'i-ching-reading-lines', onClick: this.toss },
	                    this.renderLines()
	                ),
	                (0, _preact.h)(
	                    'div',
	                    { 'class': 'button-wrapper' },
	                    (0, _preact.h)(
	                        'button',
	                        {
	                            'class': 'button ' + (this.state.done ? '' : 'disabled') + ' i-ching-' + this.slant,
	                            action: 'Click-Reveal-Meaning-Button',
	                            onClick: this.submit
	                        },
	                        submitting ? 'SUBMITTING…' : 'REVEAL THE MEANING'
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'randomizeCoins',
	        value: function randomizeCoins(results) {
	            var m = results.length;
	            var t = void 0;
	            var i = void 0;
	
	            while (m) {
	                i = Math.floor(Math.random() * m--);
	
	                t = results[m];
	                results[m] = results[i];
	                results[i] = t;
	            }
	
	            return results;
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        product: state.product && state.product.description,
	        price: state.product && state.product.price,
	        submitting: state.product && state.product.submitting,
	        subject: state['tarot-reading'] && state['tarot-reading'].subject || '( your current focus )',
	        logged_in: state.user && state.user.logged_in
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        init: function init(upc) {
	            return dispatch({ type: 'i-ching-reading:init', payload: { upc: upc } });
	        },
	        submit: function submit(payload) {
	            return dispatch({ type: 'i-ching-reading:submit', payload: payload });
	        },
	        trackEvent: function trackEvent(payload) {
	            return dispatch({ type: 'ga:event', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/tarot-reading/question.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderInputOrQuestion = function () {
	            if (_this.props.sample_interps) {
	                return (0, _preact.h)(
	                    'p',
	                    { 'class': 'subject-set' },
	                    'Your Question: ',
	                    _this.props.subject || 'Unspoken'
	                );
	            }
	
	            return (0, _preact.h)('input', {
	                onFocus: _this.clearQuestion,
	                onBlur: _this.captureQuestion,
	                name: 'question',
	                type: 'text',
	                maxLength: '140',
	                placeholder: _this.props.placeholder || 'Enter your question or subject here',
	                'data-action': 'Type-Question',
	                'class': _this.props.subject ? 'has-subject' : ''
	            });
	        }, _this.captureQuestion = function (e) {
	            var question = e.target.value;
	            _this.props.captureQuestion(question);
	        }, _this.clearQuestion = function (e) {
	            e.target.value = '';
	            e.target.classList.remove('subject');
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render() {
	            return (0, _preact.h)(
	                'tarot-question',
	                null,
	                this.renderInputOrQuestion()
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        subject: state['tarot-reading'].subject,
	        sample_interps: state['tarot-reading'].sample_interps
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        captureQuestion: function captureQuestion(question) {
	            return dispatch({ type: 'tarot-reading:question', payload: question });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/invisible-recaptcha.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global grecaptcha, ___grecaptcha_cfg */
	
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this));
	
	        _this.initializeRecaptcha = function () {
	            if (_this.isRecaptchaLoaded()) {
	                _this.clearTimer();
	                _this.renderRecaptcha();
	            } else if (!_this.isRecaptchaJSLibInjected()) {
	                var script = document.createElement('script');
	
	                window.recaptchaLoaded = _this.initializeRecaptcha.bind(_this);
	
	                script.src = _this.recaptcha_url;
	                script.async = 1;
	                script.defer = 1;
	
	                script.onerror = function () {
	                    console.log('Error loading google recaptcha!'); //eslint-disable-line no-console
	                };
	
	                document.body.appendChild(script);
	            } else {
	                _this.startTimer();
	            }
	        };
	
	        _this.renderRecaptcha = function () {
	            _this.recaptcha_id = grecaptcha.render(_this.element, {
	                'sitekey': '6LctH00UAAAAAPXEJwIiS8GQ8x3XUmyAZg4QgY-P',
	                'callback': _this.handleChange,
	                'theme': 'light',
	                'type': 'image',
	                'tabindex': 0,
	                'expired-callback': _this.handleExpired,
	                'size': 'invisible',
	                'stoken': null,
	                'badge': 'inline'
	            });
	        };
	
	        _this.removeRecaptcha = function () {
	            grecaptcha.reset(_this.recaptcha_id);
	        };
	
	        _this.clearTimer = function () {
	            if (_this.waitingTimer !== null) {
	                clearTimeout(_this.timer);
	            }
	        };
	
	        _this.startTimer = function () {
	            _this.timer = setTimeout(_this.initializeRecaptcha, 200);
	        };
	
	        _this.isRecaptchaJSLibInjected = function () {
	            if (typeof window === 'undefined') {
	                return false;
	            }
	
	            if (!document.scripts || document.scripts.length === 0) {
	                return false;
	            }
	
	            var scripts = _extends([], document.scripts);
	
	            return scripts.filter(function (script) {
	                return script.src.match(/((http|https):)?\/\/(www\.)?google\.com\/recaptcha\/(.*)/i) !== null;
	            }).length > 0;
	        };
	
	        _this.handleChange = function (response) {
	            if (_this.props.onChange && typeof _this.props.onChange === 'function') {
	                _this.props.onChange(response);
	            }
	        };
	
	        _this.handleExpired = function () {
	            if (_this.props.onExpired && typeof _this.props.onExpired === 'function') {
	                _this.props.onExpired();
	            }
	        };
	
	        _this.execute = function () {
	            if (_this.isRecaptchaLoaded() && _this.element && _this.recaptcha_id !== null) {
	                grecaptcha.execute(_this.recaptcha_id);
	                return true;
	            }
	
	            return false;
	        };
	
	        _this.reset = function () {
	            if (_this.isRecaptchaLoaded() && _this.element && _this.recaptcha_id !== null) {
	                grecaptcha.reset(_this.recaptcha_id);
	                return true;
	            }
	
	            return false;
	        };
	
	        _this.captureRef = function (element) {
	            _this.element = element;
	        };
	
	        _this.timer = null;
	        _this.element = null;
	        _this.recaptcha_id = null;
	        _this.recaptcha_url = 'https://www.google.com/recaptcha/api.js?&onload=recaptchaLoaded&render=explicit';
	
	        _this.isRecaptchaLoaded = function () {
	            return typeof window !== 'undefined' && typeof window.grecaptcha !== 'undefined';
	        };
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.initializeRecaptcha();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.clearTimer();
	
	            if (this.isRecaptchaLoaded() && this.element && this.recaptcha_id !== null) {
	                this.removeRecaptcha();
	            }
	
	            if (window.___grecaptcha_cfg) {
	                delete ___grecaptcha_cfg.clients[this.recaptcha_id];
	                ___grecaptcha_cfg.count--;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return (0, _preact.h)('invisible-recaptcha', { ref: this.captureRef, 'class': 'is-hidden' });
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	exports.default = (0, _preactRedux.connect)()(Component);

/***/ },

/***/ "./app/components/karmacoin-store/discount-message.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var logged_in = _ref.logged_in,
	                sale_price_code = _ref.sale_price_code;
	
	            if (logged_in && sale_price_code == 'first-time-buyer') {
	                return (0, _preact.h)(
	                    'discount-message',
	                    null,
	                    (0, _preact.h)(
	                        'p',
	                        { 'class': 'sale-msg' },
	                        'You\u2019re eligible for a first-time Karma Coin purchase discount! Buy today and receive an additional 10% off your selected package!'
	                    )
	                );
	            }
	
	            return (0, _preact.h)('discount-message', null);
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        logged_in: state.user && state.user.logged_in,
	        sale_price_code: state['karmacoin-store'].packages && state['karmacoin-store'].packages.standard[0].sale_price_code
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/karmacoin-store/karmacoin-header.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this));
	
	        _this.setState({ isOpen: false });
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var _this2 = this;
	
	            var logged_in = _ref.logged_in,
	                sale_price_code = _ref.sale_price_code,
	                kc_sale = _ref.kc_sale;
	
	            var image_class = kc_sale ? ' kc-sale' : '';
	            var ga_label = 'logged-out';
	
	            if (logged_in) {
	                ga_label = sale_price_code == 'first-time-buyer' ? '1st-kc-package' : '2nd-or-more-kc-package';
	            }
	
	            return (0, _preact.h)(
	                'karmacoin-header',
	                null,
	                (0, _preact.h)(
	                    'header',
	                    null,
	                    (0, _preact.h)('div', { 'class': 'icon-teeup icon-karma-coin-store' + image_class }),
	                    (0, _preact.h)(
	                        'h1',
	                        null,
	                        'Karma Coins',
	                        (0, _preact.h)(
	                            'sup',
	                            null,
	                            '\xAE'
	                        ),
	                        ' Store'
	                    ),
	                    (0, _preact.h)(
	                        'p',
	                        null,
	                        'Buy in bulk and get your favorite Tarot readings, Astrology reports, Numerology reports, and I Ching readings for up to 50% off!',
	                        (0, _preact.h)(
	                            'a',
	                            { onClick: function onClick() {
	                                    return _this2.toggleAside(ga_label);
	                                } },
	                            'Learn More'
	                        )
	                    )
	                ),
	                this.renderAside(ga_label)
	            );
	        }
	    }, {
	        key: 'renderAside',
	        value: function renderAside(ga_label) {
	            var _this3 = this;
	
	            if (this.state.isOpen) {
	                return (0, _preact.h)(
	                    'aside',
	                    { 'class': 'details' },
	                    (0, _preact.h)(
	                        'a',
	                        { 'class': 'learn-more-close-button', onClick: function onClick() {
	                                return _this3.toggleAside(ga_label);
	                            } },
	                        'x'
	                    ),
	                    (0, _preact.h)(
	                        'h3',
	                        null,
	                        'What are Karma Coins?'
	                    ),
	                    (0, _preact.h)(
	                        'summary',
	                        null,
	                        (0, _preact.h)(
	                            'p',
	                            null,
	                            'Karma Coins',
	                            (0, _preact.h)(
	                                'sup',
	                                null,
	                                '\xAE'
	                            ),
	                            ' (KCs for short) are digital credits used to purchase Tarot.com products. What is the benefit of using KCs instead of cash? You receive a discount on everything you purchase!'
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'h3',
	                        null,
	                        'Why Should I Use Karma Coins?'
	                    ),
	                    (0, _preact.h)(
	                        'summary',
	                        null,
	                        (0, _preact.h)(
	                            'ul',
	                            null,
	                            (0, _preact.h)(
	                                'li',
	                                null,
	                                'Big Savings: Receive up to 50% OFF all your purchases when you buy in bulk'
	                            ),
	                            (0, _preact.h)(
	                                'li',
	                                null,
	                                'One-Click: Skip the tedious credit card form and get right to your personalized insight!'
	                            ),
	                            (0, _preact.h)(
	                                'li',
	                                null,
	                                'Easy Tracking: Your KC balance is displayed at the top of each Tarot.com page for your convenience'
	                            )
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'h3',
	                        null,
	                        'New To Karma Coins?'
	                    ),
	                    (0, _preact.h)(
	                        'summary',
	                        null,
	                        (0, _preact.h)(
	                            'p',
	                            null,
	                            'As a first-time purchaser you will receive an additional 10% off your selected KC package.'
	                        )
	                    )
	                );
	            }
	
	            return null;
	        }
	    }, {
	        key: 'toggleAside',
	        value: function toggleAside(label) {
	            this.props.trackEvent(label);
	            this.setState({ isOpen: !this.state.isOpen });
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        logged_in: state.user && state.user.logged_in,
	        sale_price_code: state['karmacoin-store'].packages && state['karmacoin-store'].packages.standard[0].sale_price_code,
	        kc_sale: state['karmacoin-store'].kc_sale
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        trackEvent: function trackEvent(label) {
	            return dispatch({ type: 'ga:event', payload: ['kc-store', 'Click-Learn-More', label] });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/karmacoin-store/karmacoin-submit.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var _this2 = this;
	
	            var logged_in = _ref.logged_in,
	                submitting = _ref.submitting,
	                sale_price_code = _ref.sale_price_code;
	
	            var button_text = submitting ? 'submitting…' : 'purchase coins';
	
	            var label = 'logged-out';
	            if (logged_in) {
	                label = sale_price_code == 'first-time-buyer' ? '1st-kc-package' : '2nd-or-more-kc-package';
	            }
	
	            return (0, _preact.h)(
	                'karmacoin-submit',
	                null,
	                (0, _preact.h)(
	                    'button',
	                    {
	                        onClick: function onClick(e) {
	                            return _this2.trackClick(e, submitting, label);
	                        },
	                        'class': 'button-warning'
	                    },
	                    button_text
	                )
	            );
	        }
	    }, {
	        key: 'trackClick',
	        value: function trackClick(e, submitting, label) {
	            e.preventDefault();
	
	            if (!submitting) {
	                this.props.trackEvent(label);
	                this.props.purchase();
	            }
	
	            return false;
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        logged_in: state.user && state.user.logged_in,
	        submitting: state.product.submitting,
	        sale_price_code: state['karmacoin-store'].packages && state['karmacoin-store'].packages.standard[0].sale_price_code
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        purchase: function purchase() {
	            return dispatch({ type: 'karmacoin-store:purchase' });
	        },
	        trackEvent: function trackEvent(label) {
	            return dispatch({ type: 'ga:event', payload: ['kc-store', 'Click-Purchase-Button', label] });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/karmacoin-store/power-package.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _pseudoSelect = __webpack_require__("./app/components/karmacoin-store/pseudo-select.js");
	
	var _pseudoSelect2 = _interopRequireDefault(_pseudoSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var _this2 = this;
	
	            var logged_in = _ref.logged_in,
	                state_upc = _ref.state_upc,
	                upc = _ref.upc,
	                packages = _ref.packages,
	                sale_price_code = _ref.sale_price_code;
	
	            var ga_label = 'logged-out';
	            if (logged_in) {
	                ga_label = sale_price_code == 'first-time-buyer' ? '1st-kc-package' : '2nd-or-more-kc-package';
	            }
	
	            if (packages) {
	                return (0, _preact.h)(
	                    'power-package',
	                    null,
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'small-2 columns' },
	                        (0, _preact.h)('input', {
	                            type: 'radio',
	                            name: 'upc',
	                            value: upc,
	                            onClick: function onClick(e) {
	                                return _this2.trackChange(e, ga_label);
	                            },
	                            checked: state_upc == upc
	                        }),
	                        (0, _preact.h)('div', { 'class': 'pseudo-radio' })
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'small-10 medium-9 columns' },
	                        (0, _preact.h)(
	                            'label',
	                            null,
	                            (0, _preact.h)(
	                                'select',
	                                {
	                                    active: state_upc == upc,
	                                    onChange: function onChange(e) {
	                                        return _this2.trackChange(e, ga_label);
	                                    },
	                                    onFocus: function onFocus(e) {
	                                        return _this2.trackFocus(e, ga_label);
	                                    }
	                                },
	                                packages.map(function (pkg) {
	                                    return _this2.renderOption(pkg, state_upc, upc);
	                                })
	                            ),
	                            (0, _preact.h)(_pseudoSelect2.default, null)
	                        )
	                    )
	                );
	            }
	
	            return (0, _preact.h)('power-package', null);
	        }
	    }, {
	        key: 'renderOption',
	        value: function renderOption(pkg, state_upc, upc) {
	            return (0, _preact.h)(
	                'option',
	                { value: pkg.upc, selected: pkg.upc == upc },
	                pkg.free_kcs + pkg.paid_kcs,
	                ' Karma Coins - $',
	                pkg.usd.current
	            );
	        }
	    }, {
	        key: 'trackChange',
	        value: function trackChange(e, ga_label) {
	            this.props.trackChange(e.target.value, ga_label);
	            this.props.setPowerUPC(e.target.value);
	        }
	    }, {
	        key: 'trackFocus',
	        value: function trackFocus(e, ga_label) {
	            this.props.trackFocus(ga_label);
	            this.props.setPowerUPC(e.target.value);
	        }
	    }, {
	        key: 'setPowerValue',
	        value: function setPowerValue(e) {
	            this.props.setPowerUPC(e.target.value);
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        logged_in: state.user && state.user.logged_in,
	        state_upc: state['karmacoin-store'].upc,
	        upc: state['karmacoin-store'].power_upc,
	        packages: state['karmacoin-store'].packages && state['karmacoin-store'].packages.power,
	        sale_price_code: state['karmacoin-store'].packages && state['karmacoin-store'].packages.standard[0].sale_price_code
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        trackChange: function trackChange(upc, ga_label) {
	            return dispatch({
	                type: 'ga:event',
	                payload: ['kc-store', 'Click-' + upc, ga_label]
	            });
	        },
	        trackFocus: function trackFocus(ga_label) {
	            return dispatch({
	                type: 'ga:event',
	                payload: ['kc-store', 'Reveal-Power-Packages', ga_label]
	            });
	        },
	        setPowerUPC: function setPowerUPC(upc) {
	            return dispatch({ type: 'karmacoin-store:power_upc', payload: upc });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/karmacoin-store/pseudo-select.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this));
	
	        _this.setState({ active: false });
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref, _ref2) {
	            var _this2 = this;
	
	            var logged_in = _ref.logged_in,
	                state_upc = _ref.state_upc,
	                power_upc = _ref.power_upc,
	                packages = _ref.packages,
	                sale_price_code = _ref.sale_price_code;
	            var active = _ref2.active;
	
	            var className = state_upc == power_upc ? 'active' : null;
	            var selected_package = packages.filter(function (pkg) {
	                return pkg.upc == power_upc;
	            })[0] || packages[0];
	            var coins = selected_package.paid_kcs + selected_package.free_kcs;
	            var price = selected_package.usd.current;
	
	            var ga_label = 'logged-out';
	            if (logged_in) {
	                ga_label = sale_price_code == 'first-time-buyer' ? '1st-kc-package' : '2nd-or-more-kc-package';
	            }
	
	            return (0, _preact.h)(
	                'pseudo-select',
	                { 'class': className, active: active, onclick: function onclick(e) {
	                        return _this2.trackFocus(e, ga_label);
	                    } },
	                (0, _preact.h)(
	                    'h4',
	                    null,
	                    coins,
	                    ' ',
	                    (0, _preact.h)(
	                        'span',
	                        null,
	                        'Karma Coins'
	                    )
	                ),
	                (0, _preact.h)(
	                    'h6',
	                    null,
	                    '$',
	                    price
	                ),
	                (0, _preact.h)(
	                    'ul',
	                    { active: active },
	                    packages.map(function (pkg) {
	                        return _this2.renderListItem(pkg, ga_label);
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'renderListItem',
	        value: function renderListItem(pkg, ga_label) {
	            var _this3 = this;
	
	            return (0, _preact.h)(
	                'li',
	                { onClick: function onClick(e) {
	                        return _this3.trackChange(e, pkg.upc, ga_label);
	                    } },
	                (0, _preact.h)(
	                    'h4',
	                    null,
	                    pkg.paid_kcs + pkg.free_kcs,
	                    ' ',
	                    (0, _preact.h)(
	                        'span',
	                        null,
	                        'Karma Coins'
	                    )
	                ),
	                (0, _preact.h)(
	                    'h6',
	                    null,
	                    '$',
	                    pkg.usd.current
	                )
	            );
	        }
	    }, {
	        key: 'trackChange',
	        value: function trackChange(e, upc, ga_label) {
	            e.stopPropagation();
	            this.setState({ active: false });
	            this.props.trackChange(upc, ga_label);
	            this.props.setPowerUPC(upc);
	        }
	    }, {
	        key: 'trackFocus',
	        value: function trackFocus(e, ga_label) {
	            if (!this.state.active) {
	                this.props.trackFocus(ga_label);
	            }
	
	            this.setState({ active: !this.state.active });
	        }
	    }, {
	        key: 'setPowerValue',
	        value: function setPowerValue(upc) {
	            this.props.setPowerUPC(upc);
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        logged_in: state.user && state.user.logged_in,
	        state_upc: state['karmacoin-store'].upc,
	        power_upc: state['karmacoin-store'].power_upc,
	        packages: state['karmacoin-store'].packages.power,
	        sale_price_code: state['karmacoin-store'].packages && state['karmacoin-store'].packages.standard[0].sale_price_code
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        trackChange: function trackChange(power_upc, ga_label) {
	            return dispatch({
	                type: 'ga:event',
	                payload: ['kc-store', 'Click-' + power_upc, ga_label]
	            });
	        },
	        trackFocus: function trackFocus(ga_label) {
	            return dispatch({
	                type: 'ga:event',
	                payload: ['kc-store', 'Reveal-Power-Packages', ga_label]
	            });
	        },
	        setPowerUPC: function setPowerUPC(power_upc) {
	            return dispatch({ type: 'karmacoin-store:power_upc', payload: power_upc });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/karmacoin-store/standard-package.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var _this2 = this;
	
	            var logged_in = _ref.logged_in,
	                state_upc = _ref.state_upc,
	                sale_price_code = _ref.sale_price_code,
	                coins = _ref.coins,
	                price = _ref.price,
	                percent = _ref.percent,
	                upc = _ref.upc;
	
	            var className = 'row container';
	            if (state_upc == upc) className += ' selected';
	
	            var ga_label = 'logged-out';
	            if (logged_in) {
	                ga_label = sale_price_code == 'first-time-buyer' ? '1st-kc-package' : '2nd-or-more-kc-package';
	            }
	
	            return (0, _preact.h)(
	                'standard-package',
	                { 'class': className },
	                (0, _preact.h)(
	                    'label',
	                    null,
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'small-2 columns' },
	                        (0, _preact.h)('input', {
	                            type: 'radio',
	                            name: 'upc',
	                            value: upc,
	                            checked: state_upc == upc,
	                            onChange: function onChange() {
	                                return _this2.trackChange(upc, ga_label);
	                            }
	                        }),
	                        (0, _preact.h)('div', { 'class': 'pseudo-radio' })
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'small-1 columns' },
	                        (0, _preact.h)('div', { 'class': 'icon-teeup icon-karma-coin' })
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'small-6 columns' },
	                        (0, _preact.h)(
	                            'h4',
	                            null,
	                            coins,
	                            ' ',
	                            (0, _preact.h)(
	                                'span',
	                                null,
	                                'Karma Coins'
	                            )
	                        ),
	                        (0, _preact.h)(
	                            'h6',
	                            null,
	                            '$',
	                            price
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'small-3 columns' },
	                        this.renderDiscountAmount(percent)
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderDiscountAmount',
	        value: function renderDiscountAmount(percent) {
	            if (parseInt(percent, 10) > 0) {
	                return (0, _preact.h)(
	                    'h5',
	                    null,
	                    (0, _preact.h)(
	                        'b',
	                        null,
	                        percent
	                    ),
	                    (0, _preact.h)('br', null),
	                    'OFF'
	                );
	            }
	
	            return null;
	        }
	    }, {
	        key: 'trackChange',
	        value: function trackChange(upc, ga_label) {
	            this.props.trackChange(upc, ga_label);
	            this.props.setUPC(upc);
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        logged_in: state.user && state.user.logged_in,
	        state_upc: state['karmacoin-store'] && state['karmacoin-store'].upc,
	        sale_price_code: state['karmacoin-store'].packages && state['karmacoin-store'].packages.standard[0].sale_price_code
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        trackChange: function trackChange(upc, ga_label) {
	            return dispatch({ type: 'ga:event', payload: ['kc-store', 'Click-' + upc, ga_label] });
	        },
	        setUPC: function setUPC(upc) {
	            return dispatch({ type: 'karmacoin-store:upc', payload: upc });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/karmacoin-store/standard-packages.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var _this2 = this;
	
	            var packages = _ref.packages;
	
	            if (packages) {
	                return (0, _preact.h)(
	                    'standard-packages',
	                    null,
	                    packages.map(function (pkg) {
	                        return _this2.renderPackage(pkg);
	                    })
	                );
	            }
	
	            return (0, _preact.h)('standard-packages', null);
	        }
	    }, {
	        key: 'renderPackage',
	        value: function renderPackage(pkg) {
	            return (0, _preact.h)('standard-package', {
	                upc: pkg.upc,
	                coins: pkg.paid_kcs + pkg.free_kcs,
	                price: pkg.usd.current,
	                percent: pkg.percent
	            });
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        packages: state['karmacoin-store'].packages && state['karmacoin-store'].packages.standard
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/light-box.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.show = function () {
	            var lbb = document.createElement('div');
	            lbb.classList.add('light-box-backdrop');
	            lbb.addEventListener('click', _this.remove, true);
	            document.body.appendChild(lbb);
	
	            var lbi = document.createElement('img');
	            lbi.classList.add('light-box-image');
	            lbi.setAttribute('src', _this.props.src);
	            lbi.addEventListener('click', _this.remove, true);
	            document.body.appendChild(lbi);
	
	            _this.setState({
	                lbi: lbi,
	                lbb: lbb
	            });
	
	            _this.resize();
	        }, _this.resize = function () {
	            var lbi = _this.state.lbi;
	
	            if (lbi) {
	                lbi.style.top = (window.innerHeight - lbi.outerHeight()) / 2 + 'px';
	                lbi.style.left = (window.innerWidth - lbi.outerWidth()) / 2 + 'px';
	            }
	        }, _this.keyup = function (e) {
	            if (_this.state.lbi && e.which == 27) {
	                _this.remove();
	            }
	        }, _this.remove = function () {
	            document.body.removeChild(_this.state.lbi);
	            document.body.removeChild(_this.state.lbb);
	
	            _this.setState({ lbi: null, lbb: null });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            window.addEventListener('resize', this.resize, true);
	            window.addEventListener('keyup', this.keyup, true);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.resize, true);
	            window.removeEventListener('keyup', this.keyup, true);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return (0, _preact.h)('light-box', { onClick: this.show });
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	exports.default = (0, _preactRedux.connect)()(Component);

/***/ },

/***/ "./app/components/logged-in.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var innerHTML = _ref.innerHTML,
	                logged_in = _ref.logged_in;
	
	            if (logged_in) {
	                return (0, _preact.h)('logged-in', { dangerouslySetInnerHTML: { __html: innerHTML || '' } });
	            }
	
	            return null;
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        logged_in: state.user && state.user.logged_in
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/logged-out.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            if (this.props.mode == 'keep' && !this.props.logged_in) {
	                this.setState({
	                    show: true
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref) {
	            var mode = _ref.mode,
	                innerHTML = _ref.innerHTML,
	                logged_in = _ref.logged_in;
	
	            if (!logged_in || this.state.show) {
	                return (0, _preact.h)('logged-out', { mode: mode, dangerouslySetInnerHTML: { __html: innerHTML || '' } });
	            }
	
	            return null;
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        logged_in: state.user && state.user.logged_in
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/media-query.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _mediaQuery = __webpack_require__("./app/media-query.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.updateDimensions = function () {
	            _this.setState({ width: window.innerWidth });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.updateDimensions();
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.updateDimensions);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.updateDimensions);
	        }
	
	        /* eslint-disable complexity */
	
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var breakpoint = _ref2.breakpoint,
	                orientation = _ref2.orientation,
	                innerHTML = _ref2.innerHTML;
	
	            var doRender = false;
	
	            if (breakpoint) {
	                // these set doRender to true when media type matches MediaQuery
	                if (breakpoint == 'is-tiny' && _mediaQuery.MediaQuery.isTiny()) {
	                    // 370px or below
	                    doRender = true;
	                } else if (breakpoint == 'is-mobile' && _mediaQuery.MediaQuery.isMobile()) {
	                    // portrait: up to 576px, landscape: up to 767px
	                    doRender = true;
	                } else if (breakpoint == 'is-not-mobile' && !_mediaQuery.MediaQuery.isMobile()) {
	                    // portrait: >= 577px , landscape: >= 768px
	                    doRender = true;
	                } else if (breakpoint == 'is-tablet' && _mediaQuery.MediaQuery.isTablet()) {
	                    // min 577px, max 1024px
	                    doRender = true;
	                } else if (breakpoint == 'is-large' && _mediaQuery.MediaQuery.isLarge()) {
	                    // 1025px or above
	                    doRender = true;
	                }
	            }
	
	            if (doRender && orientation) {
	                // these do the reverse, negate doRender if they don't match
	                if (orientation == 'portrait' && !_mediaQuery.MediaQuery.isPortrait()) {
	                    doRender = false;
	                } else if (orientation == 'landscape' && !_mediaQuery.MediaQuery.isLandscape()) {
	                    doRender = false;
	                }
	            }
	
	            if (doRender) {
	                // finally, render if orientation and/or breakpoint match
	                return (0, _preact.h)('media-query', {
	                    breakpoint: breakpoint,
	                    orientation: orientation,
	                    dangerouslySetInnerHTML: { __html: innerHTML || '' }
	                });
	            }
	
	            return null;
	        }
	        /* eslint-enable complexity */
	
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	exports.default = (0, _preactRedux.connect)()(Component);

/***/ },

/***/ "./app/components/member/email-preference-list.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this));
	
	        _this.setState({
	            learn_more_active: false
	        });
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var _this2 = this;
	
	            var lists = _ref.lists,
	                code = _ref.code;
	
	            var list = lists.filter(function (list) {
	                return list.code === code;
	            })[0];
	
	            var status = 'not-subscribed';
	            if (list.subscribed) {
	                status = list.intent ? 'unsubscribe' : 'subscribed';
	            } else if (list.intent) {
	                status = 'subscribe';
	            }
	
	            var list_button_class = 'email-button ' + status;
	
	            var list_button_text = status.replace('-', ' ');
	
	            var wrapper_class = list.subscribed || list.intent != list.subscribed ? 'checkbox-wrapper checked' : 'checkbox-wrapper';
	
	            return (0, _preact.h)(
	                'member-email-preference-list',
	                { 'class': 'row' },
	                (0, _preact.h)(
	                    'div',
	                    { 'class': 'small-1 columns' },
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': wrapper_class, onClick: function onClick() {
	                                return _this2.toggleListStatus(list);
	                            } },
	                        (0, _preact.h)('input', {
	                            type: 'checkbox',
	                            name: list.code,
	                            value: list.subscribed,
	                            checked: list.subscribed || list.intent
	                        })
	                    )
	                ),
	                (0, _preact.h)(
	                    'div',
	                    { 'class': 'small-7 medium-8 columns text-left' },
	                    (0, _preact.h)(
	                        'h3',
	                        null,
	                        list.name,
	                        (0, _preact.h)(
	                            'small',
	                            null,
	                            (0, _preact.h)(
	                                'a',
	                                { href: '#', onClick: function onClick(e) {
	                                        return _this2.toggleListLearnMore(list, e);
	                                    } },
	                                'Learn More'
	                            )
	                        )
	                    )
	                ),
	                (0, _preact.h)(
	                    'div',
	                    { 'class': 'small-4 medium-3 columns' },
	                    (0, _preact.h)(
	                        'a',
	                        { href: '#', onClick: function onClick(e) {
	                                return _this2.toggleListStatus(list, e);
	                            }, 'class': list_button_class },
	                        (0, _preact.h)(
	                            'span',
	                            null,
	                            list_button_text
	                        )
	                    )
	                ),
	                (0, _preact.h)(
	                    'div',
	                    { 'class': 'small-11 small-offset-1 columns text-left' },
	                    this.renderListLearnMore(list)
	                )
	            );
	        }
	    }, {
	        key: 'renderListLearnMore',
	        value: function renderListLearnMore(list) {
	            if (this.state.learn_more_active) {
	                return (0, _preact.h)(
	                    'p',
	                    null,
	                    list.description
	                );
	            }
	
	            return null;
	        }
	    }, {
	        key: 'toggleListStatus',
	        value: function toggleListStatus(list, e) {
	            if (e) {
	                e.preventDefault();
	            }
	
	            this.props.toggleIntention(list.code);
	        }
	    }, {
	        key: 'toggleListLearnMore',
	        value: function toggleListLearnMore(list, e) {
	            e.preventDefault();
	
	            this.setState({ learn_more_active: !this.state.learn_more_active });
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        lists: state['mail-lists'] && state['mail-lists'].lists
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        toggleIntention: function toggleIntention(code) {
	            return dispatch({ type: 'mail-lists:toggle_intention', payload: code });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/member/email-preferences.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _emailPreferenceList = __webpack_require__("./app/components/member/email-preference-list.js");
	
	var _emailPreferenceList2 = _interopRequireDefault(_emailPreferenceList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this));
	
	        _this.setState({
	            message: null
	        });
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var _this2 = this;
	
	            var submitting = _ref.submitting,
	                lists = _ref.lists,
	                dirty = _ref.dirty;
	
	            var button_class = dirty && !submitting ? 'button-warning' : 'button-warning disabled';
	            var button_text = submitting ? 'submitting…' : 'save settings';
	
	            if (lists) {
	                return (0, _preact.h)(
	                    'member-email-preferences',
	                    { 'class': 'small-12 text-center' },
	                    (0, _preact.h)(
	                        'form',
	                        null,
	                        lists.map(function (list) {
	                            return _this2.renderList(list);
	                        }),
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'row' },
	                            (0, _preact.h)(
	                                'div',
	                                { 'class': 'small-12 columns' },
	                                this.renderMessage(),
	                                (0, _preact.h)(
	                                    'button',
	                                    {
	                                        'class': button_class,
	                                        onClick: function onClick(e) {
	                                            return _this2.saveSettings(e);
	                                        },
	                                        disabled: submitting
	                                    },
	                                    button_text
	                                )
	                            )
	                        )
	                    )
	                );
	            }
	
	            return (0, _preact.h)('member-email-preferences', null);
	        }
	    }, {
	        key: 'renderList',
	        value: function renderList(list) {
	            return (0, _preact.h)(_emailPreferenceList2.default, { code: list.code });
	        }
	    }, {
	        key: 'renderMessage',
	        value: function renderMessage() {
	            if (this.props.error && !this.props.dirty) {
	                return (0, _preact.h)(
	                    'p',
	                    { 'class': 'form-message' },
	                    'Unable to save one or more of your preferences. (',
	                    this.props.error,
	                    ')'
	                );
	            } else if (this.state.message && !this.props.submitting) {
	                return (0, _preact.h)(
	                    'p',
	                    { 'class': 'form-message' },
	                    this.state.message
	                );
	            }
	
	            return (0, _preact.h)(
	                'p',
	                { 'class': 'form-message' },
	                '\xA0'
	            );
	        }
	    }, {
	        key: 'saveSettings',
	        value: function saveSettings(e) {
	            e.preventDefault();
	
	            if (!this.props.submitting) {
	                if (!this.props.dirty) {
	                    this.setState({
	                        message: 'Please select an email to subscribe or unsubscribe to above.'
	                    });
	                } else {
	                    this.props.save(this.props.lists);
	                    this.setState({
	                        message: 'You have successfully updated your email preferences. Please allow up to 48 hours for ' + 'this to take effect.'
	                    });
	                }
	            }
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        submitting: state.product.submitting,
	        lists: state['mail-lists'] && state['mail-lists'].lists,
	        error: state['mail-lists'] && state['mail-lists'].error,
	        dirty: state['mail-lists'] && state['mail-lists'].dirty
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        save: function save(data) {
	            return dispatch({ type: 'mail-lists:save', lists: data });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/member/email-unsub.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _emailUnsubLanding = __webpack_require__("./app/components/member/email-unsub-landing.js");
	
	var _emailUnsubLanding2 = _interopRequireDefault(_emailUnsubLanding);
	
	var _emailUnsubOptIn = __webpack_require__("./app/components/member/email-unsub-opt-in.js");
	
	var _emailUnsubOptIn2 = _interopRequireDefault(_emailUnsubOptIn);
	
	var _emailUnsubOptOut = __webpack_require__("./app/components/member/email-unsub-opt-out.js");
	
	var _emailUnsubOptOut2 = _interopRequireDefault(_emailUnsubOptOut);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render() {
	            return (0, _preact.h)(
	                'email-unsub',
	                null,
	                this.renderFunction()
	            );
	        }
	    }, {
	        key: 'renderFunction',
	        value: function renderFunction() {
	            if (this.props.route == 'opt-out' || !this.props.list_status) {
	                return (0, _preact.h)(_emailUnsubOptOut2.default, null);
	            } else if (this.props.route == 'opt-in' || this.props.route == 'keep') {
	                return (0, _preact.h)(_emailUnsubOptIn2.default, null);
	            }
	            return (0, _preact.h)(_emailUnsubLanding2.default, null);
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        route: state.route,
	        list_status: state['email-unsub'] && state['email-unsub'].list_status
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/member/email-unsub-landing.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var name = _ref.name;
	
	            return (0, _preact.h)(
	                'email-unsub-landing',
	                null,
	                (0, _preact.h)(
	                    'aside',
	                    { 'class': 'small-12 medium-6 medium-push-6 columns' },
	                    (0, _preact.h)('img', { src: 'https://gfx.tarot.com/images/site/tarot/unsub/fool.gif', alt: 'The Fool' })
	                ),
	                (0, _preact.h)(
	                    'main',
	                    { 'class': 'small-12 medium-6 medium-pull-6 columns' },
	                    (0, _preact.h)(
	                        'header',
	                        null,
	                        (0, _preact.h)(
	                            'h1',
	                            null,
	                            'SAY IT AIN\'T SO!'
	                        ),
	                        (0, _preact.h)(
	                            'h2',
	                            null,
	                            'Is This Really Goodbye?'
	                        ),
	                        (0, _preact.h)('hr', null),
	                        (0, _preact.h)(
	                            'h3',
	                            null,
	                            'Are you sure you want to stop receiving ',
	                            (0, _preact.h)(
	                                'b',
	                                null,
	                                name
	                            ),
	                            ' emails?'
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'row' },
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'small-12 medium-10 end columns' },
	                            (0, _preact.h)(
	                                'a',
	                                { href: '#opt-out', 'class': 'button-warning-alternate' },
	                                'YES, UNSUBSCRIBE ME'
	                            )
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'row' },
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'small-12 medium-10 end columns' },
	                            (0, _preact.h)(
	                                'a',
	                                { href: '#keep', 'class': 'button-warning' },
	                                'NO, KEEP \'EM COMING'
	                            )
	                        )
	                    ),
	                    (0, _preact.h)('br', null),
	                    (0, _preact.h)(
	                        'a',
	                        { href: '/member/emails', 'class': 'manage' },
	                        'Manage your email preferences'
	                    ),
	                    (0, _preact.h)('br', null)
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        name: state['email-unsub'] && state['email-unsub'].name
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/member/email-unsub-opt-in.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var name = _ref.name;
	
	            return (0, _preact.h)(
	                'email-unsub-opt-in',
	                null,
	                (0, _preact.h)(
	                    'aside',
	                    { 'class': 'small-12 medium-6 medium-push-6 columns' },
	                    (0, _preact.h)('img', { src: 'https://gfx.tarot.com/images/site/tarot/unsub/3cups.gif', alt: '3 of Cups' })
	                ),
	                (0, _preact.h)(
	                    'main',
	                    { 'class': 'small-12 medium-6 medium-pull-6 columns' },
	                    (0, _preact.h)(
	                        'header',
	                        null,
	                        (0, _preact.h)(
	                            'h1',
	                            null,
	                            'WELCOME BACK'
	                        ),
	                        (0, _preact.h)(
	                            'h2',
	                            null,
	                            'This Calls for A Celebration!'
	                        ),
	                        (0, _preact.h)('hr', null),
	                        (0, _preact.h)(
	                            'h3',
	                            null,
	                            'You will continue receiving ',
	                            (0, _preact.h)(
	                                'b',
	                                null,
	                                name
	                            ),
	                            ' emails.'
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'row' },
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'small-12 medium-10 end columns' },
	                            (0, _preact.h)(
	                                'a',
	                                { href: '/daily-horoscope', 'class': 'button-warning-alternate' },
	                                'GET TODAY\'S INSIGHT'
	                            )
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'row' },
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'small-12 medium-10 end columns' },
	                            (0, _preact.h)(
	                                'a',
	                                { href: '#opt-out', 'class': 'button-warning' },
	                                'OOPS! UNSUBSCRIBE ME'
	                            )
	                        )
	                    ),
	                    (0, _preact.h)('br', null),
	                    (0, _preact.h)(
	                        'a',
	                        { href: '/member/emails', 'class': 'manage' },
	                        'Manage your email preferences'
	                    ),
	                    (0, _preact.h)('br', null)
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        name: state['email-unsub'] && state['email-unsub'].name
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/member/email-unsub-opt-out.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var name = _ref.name;
	
	            return (0, _preact.h)(
	                'email-unsub-opt-out',
	                null,
	                (0, _preact.h)(
	                    'aside',
	                    { 'class': 'small-12 medium-6 medium-push-6 columns' },
	                    (0, _preact.h)('img', { src: 'https://gfx.tarot.com/images/site/tarot/unsub/magician.gif', alt: 'The Magician' })
	                ),
	                (0, _preact.h)(
	                    'main',
	                    { 'class': 'small-12 medium-6 medium-pull-6 columns' },
	                    (0, _preact.h)(
	                        'header',
	                        null,
	                        (0, _preact.h)(
	                            'h1',
	                            null,
	                            'YOU\'LL BE MISSED.'
	                        ),
	                        (0, _preact.h)(
	                            'h2',
	                            null,
	                            'You\'ve Been Unsubscribed'
	                        ),
	                        (0, _preact.h)('hr', null),
	                        (0, _preact.h)(
	                            'h3',
	                            null,
	                            'We will no longer send you ',
	                            (0, _preact.h)(
	                                'b',
	                                null,
	                                name
	                            ),
	                            ' emails.'
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'row' },
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'small-12 medium-10 end columns' },
	                            (0, _preact.h)(
	                                'a',
	                                { href: '/daily-horoscope', 'class': 'button-warning-alternate' },
	                                'GET TODAY\'S INSIGHT'
	                            )
	                        )
	                    ),
	                    this.renderOptInLink(),
	                    (0, _preact.h)('br', null),
	                    (0, _preact.h)(
	                        'a',
	                        { href: '/member/emails', 'class': 'manage' },
	                        'Manage your email preferences'
	                    ),
	                    (0, _preact.h)('br', null)
	                )
	            );
	        }
	    }, {
	        key: 'renderOptInLink',
	        value: function renderOptInLink() {
	            if (this.props.code == 'reengage' && !this.props.list_status) {
	                return null;
	            }
	
	            return (0, _preact.h)(
	                'div',
	                { 'class': 'row' },
	                (0, _preact.h)(
	                    'div',
	                    { 'class': 'small-12 medium-10 end columns' },
	                    (0, _preact.h)(
	                        'a',
	                        { href: '#opt-in', 'class': 'button-warning' },
	                        'OPT BACK IN'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        name: state['email-unsub'] && state['email-unsub'].name,
	        code: state['email-unsub'] && state['email-unsub'].code,
	        list_status: state['email-unsub'] && state['email-unsub'].list_status
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/mini-horoscope.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MiniHoroscope = function (_Component) {
	    _inherits(MiniHoroscope, _Component);
	
	    function MiniHoroscope() {
	        _classCallCheck(this, MiniHoroscope);
	
	        return _possibleConstructorReturn(this, (MiniHoroscope.__proto__ || Object.getPrototypeOf(MiniHoroscope)).apply(this, arguments));
	    }
	
	    _createClass(MiniHoroscope, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.requireDailyUpdates();
	        }
	    }, {
	        key: 'render',
	        value: function render(props) {
	            if (!props.horoscope || !props.horoscope.interp) {
	                return (0, _preact.h)(
	                    'mini-horoscope',
	                    { 'class': props.class },
	                    (0, _preact.h)(
	                        'h1',
	                        { 'class': 'widget-header' },
	                        'Loading\u2026'
	                    )
	                );
	            }
	            return (0, _preact.h)(
	                'mini-horoscope',
	                { 'class': props.class },
	                (0, _preact.h)(
	                    'h1',
	                    { 'class': 'widget-header' },
	                    'Today\u2019s Horoscope'
	                ),
	                (0, _preact.h)('hr', null),
	                (0, _preact.h)(
	                    'div',
	                    null,
	                    (0, _preact.h)(
	                        'a',
	                        { 'class': 'text-link-undecorated', href: '/daily-horoscope/' + props.horoscope.sign_slug },
	                        (0, _preact.h)(
	                            'p',
	                            null,
	                            (0, _preact.h)(
	                                'span',
	                                { 'class': 'widget-header' },
	                                props.scope_type,
	                                ': '
	                            ),
	                            (0, _util.truncate)(props.horoscope.interp, 130),
	                            (0, _preact.h)(
	                                'span',
	                                { 'class': 'text-link' },
	                                'read more'
	                            )
	                        )
	                    ),
	                    (0, _preact.h)('br', null),
	                    (0, _preact.h)(
	                        'a',
	                        { 'class': 'button-today', 'data-action': 'Click', href: props.href },
	                        props.button
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MiniHoroscope;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    if (state.user.logged_in) {
	        return {
	            button: 'Today\'s tarot reading',
	            horoscope: state['daily-updates'] && state['daily-updates'].horoscope,
	            href: '/readings-reports/tarot-readings/daily-reflection',
	            scope_type: 'For You'
	        };
	    }
	    return {
	        button: 'Get Your Daily Horoscope',
	        horoscope: state['daily-updates'] && state['daily-updates'].horoscope,
	        href: '#signup',
	        scope_type: 'For Everyone'
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        requireDailyUpdates: function requireDailyUpdates() {
	            return dispatch({ type: 'daily-updates:required' });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(MiniHoroscope);

/***/ },

/***/ "./app/components/mini-tcod.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderFigure = function () {
	            var tcod = _this.props.tcod;
	
	            if (tcod && tcod.card && tcod.card.name && tcod.card.images && tcod.card.images.full) {
	                return (0, _preact.h)(
	                    'figure',
	                    null,
	                    (0, _preact.h)('img', { src: tcod.card.images.full, alt: tcod.card.name })
	                );
	            }
	
	            return null;
	        }, _this.renderCard = function (tcod_body) {
	            var tcod = _this.props.tcod;
	
	            if (tcod_body && tcod && tcod.card) {
	                return (0, _preact.h)(
	                    'div',
	                    { 'class': 'tarot-otd-content' },
	                    (0, _preact.h)(
	                        'section',
	                        null,
	                        (0, _preact.h)(
	                            'time',
	                            { dateTime: Date() },
	                            _this.props.pretty_date + ', ' + new Date().getFullYear()
	                        ),
	                        (0, _preact.h)(
	                            'a',
	                            { 'class': 'text-link-undecorated widget-link', href: '/daily-tarot-card' },
	                            (0, _preact.h)(
	                                'h2',
	                                null,
	                                'Tarot Card of the Day'
	                            ),
	                            (0, _preact.h)(
	                                'h3',
	                                null,
	                                tcod.card.name,
	                                ': '
	                            ),
	                            (0, _preact.h)(
	                                'p',
	                                null,
	                                tcod_body
	                            ),
	                            (0, _preact.h)(
	                                'span',
	                                { 'class': 'text-link' },
	                                'read more'
	                            ),
	                            (0, _preact.h)(
	                                'p',
	                                { 'class': 'caption' },
	                                tcod.deck.name,
	                                ' deck ',
	                                tcod.deck.deck_vendor_copyright
	                            )
	                        )
	                    )
	                );
	            }
	
	            return null;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.requireDaily();
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var tcod = _ref2.tcod,
	                logged_in = _ref2.logged_in;
	
	            var tcod_body = tcod && tcod.interp_body ? (0, _util.truncate)(tcod.interp_body, 185) : null;
	
	            var user_link = !/m\./.test(location.href) && !this.props.logged_in ? '#signup' : '/daily-tarot-card';
	
	            if (tcod) {
	                return (0, _preact.h)(
	                    'mini-tcod',
	                    null,
	                    (0, _preact.h)(
	                        'h1',
	                        null,
	                        'Tarot Card of the Day'
	                    ),
	                    (0, _preact.h)(
	                        'ul',
	                        null,
	                        (0, _preact.h)(
	                            'li',
	                            { 'class': !logged_in ? 'active' : '' },
	                            (0, _preact.h)(
	                                'a',
	                                { href: '/daily-tarot-card' },
	                                'FOR EVERYONE'
	                            )
	                        ),
	                        (0, _preact.h)(
	                            'li',
	                            { 'class': logged_in ? 'active' : '' },
	                            (0, _preact.h)(
	                                'a',
	                                { href: user_link },
	                                'FOR YOU'
	                            )
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'tcod-main' },
	                        this.renderFigure(),
	                        (0, _preact.h)(
	                            'figcaption',
	                            null,
	                            (0, _preact.h)(
	                                'a',
	                                { href: '/tarot/decks/' + tcod.deck.slug },
	                                tcod.deck.name
	                            ),
	                            ' deck',
	                            tcod.deck.deck_vendor_copyright
	                        ),
	                        this.renderCard(tcod_body)
	                    )
	                );
	            }
	
	            return (0, _preact.h)('mini-tcod', null);
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        logged_in: state['daily-updates'] && state['daily-updates'].logged_in,
	        pretty_date: state['daily-updates'] && state['daily-updates'].pretty_date,
	        tcod: state['daily-updates'] && state['daily-updates'].tcod
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        requireDaily: function requireDaily() {
	            return dispatch({ type: 'daily-updates:required' });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/mobile-daily-links.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _mediaQuery = __webpack_require__("./app/media-query.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this));
	
	        _this.renderLink = function (_ref) {
	            var href = _ref.href,
	                label = _ref.label,
	                slug = _ref.slug;
	
	            if (_mediaQuery.MediaQuery.isMobile() && slug == 'psychic') {
	                return null;
	            }
	
	            _this.trackImpression(label);
	
	            return (0, _preact.h)(
	                'a',
	                {
	                    'class': 'mobile-daily-links',
	                    href: href,
	                    onClick: function onClick() {
	                        return _this.trackClick(label);
	                    }
	                },
	                (0, _preact.h)('img', {
	                    src: 'https://gfx.tarot.com/images/daily-pages/daily-icons/' + slug + '.svg',
	                    alt: label
	                }),
	                label
	            );
	        };
	
	        _this.trackImpression = function (label) {
	            _this.props.trackEvent(['Daily Page Mini Nav', (_this.props.logged_in ? 'LI' : 'LO') + ' Impression', label]);
	        };
	
	        _this.trackClick = function (label) {
	            _this.props.trackEvent(['Daily Page Mini Nav', (_this.props.logged_in ? 'LI' : 'LO') + ' Click', label]);
	        };
	
	        _this.setState({
	            links: [{
	                href: '/daily-horoscope',
	                label: 'Daily Horoscope',
	                slug: 'horoscope'
	            }, {
	                href: '/daily-love-horoscope',
	                label: 'Daily Love Horoscope',
	                slug: 'love'
	            }, {
	                href: '/daily-tarot-card',
	                label: 'Tarot Card of the Day',
	                slug: 'tarot'
	            }, {
	                href: '/daily-hexagram',
	                label: 'Hexagram of the Day',
	                slug: 'hexagram'
	            }, {
	                href: '/daily-number',
	                label: 'Number of the Day',
	                slug: 'number'
	            }, {
	                href: '/daily-psychic-tip',
	                label: 'Psychic Tip of the Day',
	                slug: 'psychic'
	            }]
	        });
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render() {
	            return (0, _preact.h)(
	                'mobile-daily-links',
	                null,
	                this.state.links.map(this.renderLink)
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        logged_in: state.user && state.user.logged_in
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        trackEvent: function trackEvent(payload) {
	            return dispatch({ type: 'ga:event', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/mobile-nav-dropdown.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.toggle = function () {
	            _this.setState({ isOpen: !_this.state.isOpen });
	        }, _this.renderLink = function (_ref2) {
	            var label = _ref2.label,
	                url = _ref2.url;
	
	            if (_this.state.isOpen) {
	                var impression_label = _this.props.page_name ? _this.props.page_name + ':' + label : label;
	                _this.trackImpression(impression_label);
	
	                return (0, _preact.h)(
	                    'a',
	                    { 'class': 'mobile-nav-dropdown', href: url, onClick: function onClick() {
	                            return _this.trackClick(label);
	                        } },
	                    label
	                );
	            }
	
	            return null;
	        }, _this.trackImpression = function (label) {
	            _this.props.trackEvent(['Dropdown', (_this.props.logged_in ? 'LI' : 'LO') + ' Impression', label]);
	        }, _this.trackClick = function (label) {
	            var click_label = _this.props.page_name ? _this.props.page_name + ':' + label : label;
	            _this.props.trackEvent(['Dropdown', (_this.props.logged_in ? 'LI' : 'LO') + ' Click', click_label]);
	            _this.props.trackPromo(['Dropdown', label]);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({ isOpen: false });
	            this.props.requireState();
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref3) {
	            var logged_in = _ref3.logged_in;
	
	            if (this.props.links) {
	                var links = this.props.links.map(function (link) {
	                    return link.logged_in && logged_in ? link.logged_in : link;
	                });
	
	                return (0, _preact.h)(
	                    'mobile-nav-dropdown',
	                    null,
	                    (0, _preact.h)(
	                        'span',
	                        { onClick: this.toggle, 'class': 'mobile-nav-dropdown ' + (this.state.isOpen ? 'active' : '') },
	                        'More For Today'
	                    ),
	                    links.map(this.renderLink)
	                );
	            }
	
	            return null;
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        logged_in: state.user && state.user.logged_in,
	        links: state['mobile-nav-dropdown']
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        requireState: function requireState() {
	            return dispatch({ type: 'mobile-nav-dropdown:init' });
	        },
	        trackEvent: function trackEvent(payload) {
	            return dispatch({ type: 'ga:event', payload: payload });
	        },
	        trackPromo: function trackPromo(payload) {
	            return dispatch({ type: 'promo-tracker:recordInternal', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/moon-phase.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.requireState();
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref) {
	            var phase = _ref.phase;
	
	            if (!phase) {
	                return (0, _preact.h)('moon-phase', null);
	            }
	
	            var img_src = 'https://gfx.tarot.com/images/moon-phases/' + phase.slug + '.svg';
	            return (0, _preact.h)(
	                'moon-phase',
	                { 'class': 'row section' },
	                (0, _preact.h)(
	                    'div',
	                    { 'class': 'row section' },
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'large-2 small-4 columns' },
	                        (0, _preact.h)('img', { src: img_src, alt: phase.phase_name })
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'large-10 small-12 columns' },
	                        (0, _preact.h)(
	                            'h3',
	                            null,
	                            'Current Moon Phase: ',
	                            phase.phase_name
	                        ),
	                        (0, _preact.h)(
	                            'h4',
	                            null,
	                            phase.illum,
	                            '% Illumination'
	                        )
	                    )
	                ),
	                (0, _preact.h)(
	                    'div',
	                    { 'class': 'row section' },
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'large-11 small-12 columns' },
	                        (0, _preact.h)(
	                            'p',
	                            null,
	                            phase.date,
	                            ' \u2014 ',
	                            phase.interp
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        phase: state['moon-phase']
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        requireState: function requireState() {
	            return dispatch({ type: 'moon-phase:init' });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/more-scopes-menu.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.trackImpression = function (text) {
	            var action = _this.props.logged_in ? 'LI Impression' : 'LO Impression';
	            var label = _this.props.page + ':' + text;
	
	            _this.props.trackEvent(['Horoscope Dropdown', action, label]);
	        }, _this.trackClick = function (e) {
	            var action = _this.props.logged_in ? 'LI Click' : 'LO Click';
	            var label = _this.props.page + ':' + e.target.text;
	
	            _this.props.trackEvent(['Horoscope Dropdown', action, label]);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref2) {
	            var _this2 = this;
	
	            var title = _ref2.title,
	                links = _ref2.links;
	
	            return (0, _preact.h)(
	                'more-scopes-menu',
	                null,
	                (0, _preact.h)(
	                    'h1',
	                    { 'class': 'more-scopes-header' },
	                    title
	                ),
	                (0, _preact.h)(
	                    'ul',
	                    { 'class': 'more-scopes-links' },
	                    links.map(function (link) {
	                        _this2.trackImpression(link.title);
	
	                        return (0, _preact.h)(
	                            'li',
	                            { 'class': 'more-scopes-list-item' },
	                            (0, _preact.h)(
	                                'a',
	                                {
	                                    'class': 'more-scopes-list-link text-center',
	                                    href: link.url,
	                                    onClick: _this2.trackClick
	                                },
	                                link.title
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        title: state['more-scopes-menu'] && state['more-scopes-menu'].title,
	        links: state['more-scopes-menu'] && state['more-scopes-menu'].links,
	        page: state['more-scopes-menu'] && state['more-scopes-menu'].page,
	        logged_in: state.user && state.user.logged_in
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        trackEvent: function trackEvent(payload) {
	            return dispatch({ type: 'ga:event', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/more-today.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderLoveScope = function () {
	            if (_this.love_scope) {
	                return (0, _preact.h)(
	                    'li',
	                    null,
	                    (0, _preact.h)(
	                        'a',
	                        { href: '/daily-love-horoscope/' + _this.props.sign_slug, 'class': 'text-link-undecorated widget-link' },
	                        (0, _preact.h)('div', { 'class': 'icon-daily-love' }),
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'interp-preview' },
	                            (0, _preact.h)(
	                                'h2',
	                                null,
	                                'Daily Love Horoscope'
	                            ),
	                            (0, _preact.h)(
	                                'p',
	                                null,
	                                (0, _preact.h)('raw', { content: (0, _util.truncate)(_this.love_scope, 75) }),
	                                (0, _preact.h)(
	                                    'span',
	                                    { 'class': 'text-link' },
	                                    'read more'
	                                )
	                            )
	                        )
	                    )
	                );
	            }
	
	            return null;
	        }, _this.renderNumber = function () {
	            if (_this.props.number && _this.props.number[0]) {
	                return (0, _preact.h)(
	                    'p',
	                    null,
	                    (0, _preact.h)('raw', { content: (0, _util.truncate)(_this.props.number[0], 75) }),
	                    (0, _preact.h)(
	                        'span',
	                        { 'class': 'text-link' },
	                        'continue'
	                    )
	                );
	            }
	
	            return (0, _preact.h)(
	                'p',
	                null,
	                'Whoops! We can\u2019t calculate your personal daily number without your birthdate.\xA0',
	                (0, _preact.h)(
	                    'span',
	                    { 'class': 'text-link' },
	                    'Sign up'
	                ),
	                ' to get your number!'
	            );
	        }, _this.renderHexagram = function () {
	            if (_this.props.hexagram) {
	                return (0, _preact.h)(
	                    'li',
	                    null,
	                    (0, _preact.h)(
	                        'a',
	                        { href: '/daily-hexagram', 'class': 'text-link-undecorated widget-link' },
	                        (0, _preact.h)('div', { 'class': 'icon-hexagram-otd' }),
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'interp-preview' },
	                            (0, _preact.h)(
	                                'h2',
	                                null,
	                                'Hexagram of the Day'
	                            ),
	                            (0, _preact.h)(
	                                'p',
	                                null,
	                                (0, _preact.h)('raw', { content: (0, _util.truncate)(_this.props.hexagram.main_text, 75) }),
	                                (0, _preact.h)(
	                                    'span',
	                                    { 'class': 'text-link' },
	                                    'continue'
	                                )
	                            )
	                        )
	                    )
	                );
	            }
	
	            return null;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.requireDaily();
	            this.props.requireHexagram();
	            this.props.requireNumber();
	
	            this.love_scopes = JSON.parse(this.props.scope);
	            this.love_scope = this.love_scopes[this.props.sign_int];
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var logged_in = _ref2.logged_in,
	                psychic = _ref2.psychic;
	
	            return (0, _preact.h)(
	                'more-today',
	                null,
	                (0, _preact.h)(
	                    'h1',
	                    { 'class': 'widget-header' },
	                    'More for' + (logged_in ? ' You' : '') + ' Today'
	                ),
	                (0, _preact.h)('hr', null),
	                (0, _preact.h)(
	                    'ul',
	                    null,
	                    this.renderLoveScope(),
	                    (0, _preact.h)(
	                        'li',
	                        null,
	                        (0, _preact.h)(
	                            'a',
	                            { href: logged_in ? '/daily-number' : '#signup', 'class': 'text-link-undecorated widget-link' },
	                            (0, _preact.h)('div', { 'class': 'icon-number-otd' }),
	                            (0, _preact.h)(
	                                'div',
	                                { 'class': 'interp-preview' },
	                                (0, _preact.h)(
	                                    'h2',
	                                    null,
	                                    'Daily Number'
	                                ),
	                                this.renderNumber()
	                            )
	                        )
	                    ),
	                    this.renderHexagram(),
	                    (0, _preact.h)(
	                        'li',
	                        null,
	                        (0, _preact.h)(
	                            'a',
	                            { href: '/daily-psychic-tip', 'class': 'text-link-undecorated widget-link' },
	                            (0, _preact.h)('div', { 'class': 'icon-psychic-otd' }),
	                            (0, _preact.h)(
	                                'div',
	                                { 'class': 'interp-preview' },
	                                (0, _preact.h)(
	                                    'h2',
	                                    null,
	                                    'Psychic Tip of the Day'
	                                ),
	                                (0, _preact.h)(
	                                    'p',
	                                    null,
	                                    (0, _preact.h)('raw', { content: psychic, 'class': 'widget-unformat' }),
	                                    (0, _preact.h)(
	                                        'span',
	                                        { 'class': 'text-link' },
	                                        'read more'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        logged_in: state.user && state.user.logged_in,
	        number: state.number && state.number.body,
	        sign_slug: state['daily-updates'] && state['daily-updates'].horoscope && state['daily-updates'].horoscope.sign_slug,
	        sign_int: state.user && state.user.default_sign || 0,
	        hexagram: state.user.logged_in ? state.hexagram && state.hexagram.you : state.hexagram && state.hexagram.everyone
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        requireDaily: function requireDaily() {
	            return dispatch({ type: 'daily-updates:required' });
	        },
	        requireHexagram: function requireHexagram() {
	            return dispatch({ type: 'hexagram:required' });
	        },
	        requireNumber: function requireNumber() {
	            return dispatch({ type: 'number:required' });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/nav-articles.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderNode = function (node, i) {
	            var image_src = node.picture_frag ? 'https://gfx.tarot.com/images/feeds/380x235/' + node.picture_frag + '-380x235.jpg' : '';
	
	            return (0, _preact.h)(
	                'li',
	                null,
	                (0, _preact.h)(
	                    'a',
	                    {
	                        href: node.url,
	                        onClick: function onClick() {
	                            return _this.trackClick(_this.props.category + ' - Featured Article #' + (i + 1));
	                        }
	                    },
	                    (0, _preact.h)(
	                        'figure',
	                        null,
	                        (0, _preact.h)('img', {
	                            src: image_src,
	                            alt: node.image_alt
	                        })
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        null,
	                        (0, _preact.h)(
	                            'h3',
	                            null,
	                            node.title
	                        ),
	                        (0, _preact.h)(
	                            'p',
	                            null,
	                            node.subtitle,
	                            (0, _preact.h)(
	                                'span',
	                                null,
	                                ' \u2026 Read More'
	                            )
	                        )
	                    )
	                )
	            );
	        }, _this.trackClick = function (label) {
	            var action = _this.props.logged_in ? 'LI Click' : 'LO Click';
	
	            _this.props.trackEvent(['Navigation', action, label]);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.requireContent(this.props.tag);
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var header = _ref2.header,
	                nodes = _ref2.nodes,
	                url = _ref2.url;
	
	            return (0, _preact.h)(
	                'nav-articles',
	                null,
	                (0, _preact.h)(
	                    'a',
	                    { href: url },
	                    (0, _preact.h)(
	                        'h2',
	                        null,
	                        header
	                    )
	                ),
	                (0, _preact.h)(
	                    'ul',
	                    null,
	                    (nodes || []).map(this.renderNode)
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state, _ref3) {
	    var tag = _ref3.tag;
	    return {
	        nodes: state.content && state.content.nav && state.content.nav[tag],
	        logged_in: state.user && state.user.logged_in
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        requireContent: function requireContent(tag) {
	            return dispatch({ type: 'content:fetchNav', payload: tag });
	        },
	        trackEvent: function trackEvent(payload) {
	            return dispatch({ type: 'ga:event', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/nav-bar.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _navConfig = __webpack_require__("./app/nav-config.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	var _navArticles = __webpack_require__("./app/components/nav-articles.js");
	
	var _navArticles2 = _interopRequireDefault(_navArticles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderSection = function (item) {
	            return (0, _preact.h)(
	                'section',
	                { 'class': 'header-section' },
	                (0, _preact.h)(
	                    'a',
	                    {
	                        'class': 'header',
	                        href: _util.hasTouchEvents && item.submenu ? '#nav-bar' + item.link : item.link,
	                        target: !item.submenu && item.target ? item.target : '',
	                        onClick: function onClick() {
	                            return _this.trackClick(item.name);
	                        }
	                    },
	                    (0, _preact.h)(
	                        'h1',
	                        null,
	                        item.name
	                    )
	                ),
	                _this.renderSubmenus(item)
	            );
	        }, _this.renderSubmenus = function (item) {
	            if (item.submenu) {
	                return (0, _preact.h)(
	                    'div',
	                    { 'class': 'submenu' },
	                    item.submenu.map(function (subitem) {
	                        return _this.renderSubmenu(item, subitem);
	                    }),
	                    _this.renderNavArticles(item)
	                );
	            }
	
	            return null;
	        }, _this.renderSubmenu = function (item, subitem) {
	            var label = item.name + ' - ' + subitem.name;
	
	            return (0, _preact.h)(
	                'div',
	                { 'class': 'submenu-category' },
	                (0, _preact.h)(
	                    'a',
	                    { href: subitem.link, onClick: function onClick() {
	                            return _this.trackClick(label);
	                        } },
	                    (0, _preact.h)(
	                        'h2',
	                        null,
	                        subitem.name
	                    ),
	                    (0, _preact.h)(
	                        'ul',
	                        null,
	                        subitem.links.map(function (link) {
	                            return _this.renderSubmenuList(item, subitem, link);
	                        })
	                    )
	                )
	            );
	        }, _this.renderSubmenuList = function (item, subitem, destination) {
	            var lo_label = item.name + ' - ' + destination.name;
	
	            if (destination.logged_in && _this.props.logged_in) {
	                var li_label = item.name + ' - ' + destination.logged_in.name;
	
	                return (0, _preact.h)(
	                    'li',
	                    null,
	                    (0, _preact.h)(
	                        'a',
	                        {
	                            href: destination.logged_in.link,
	                            'class': 'nav-link',
	                            onClick: function onClick() {
	                                return _this.trackClick(li_label);
	                            }
	                        },
	                        destination.logged_in.name
	                    )
	                );
	            }
	
	            return (0, _preact.h)(
	                'li',
	                null,
	                (0, _preact.h)(
	                    'a',
	                    {
	                        href: destination.link,
	                        'class': 'nav-link',
	                        onClick: function onClick() {
	                            return _this.trackClick(lo_label);
	                        }
	                    },
	                    destination.name
	                )
	            );
	        }, _this.renderNavArticles = function (item) {
	            if (item.articles) {
	                return (0, _preact.h)(_navArticles2.default, {
	                    category: item.name,
	                    header: item.articles.name,
	                    tag: item.articles.tag,
	                    url: item.articles.url
	                });
	            }
	
	            return null;
	        }, _this.trackClick = function (label) {
	            var category = 'Navigation';
	            var action = _this.props.logged_in ? 'LI Click' : 'LO Click';
	
	            _this.props.trackEvent([category, action, label]);
	            _this.props.trackPromo([category, label]);
	
	            return true;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return (0, _preact.h)(
	                'nav-bar',
	                null,
	                _navConfig.navigation.map(function (item) {
	                    return _this2.renderSection(item);
	                })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        logged_in: state.user && state.user.logged_in
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        trackEvent: function trackEvent(payload) {
	            return dispatch({ type: 'ga:event', payload: payload });
	        },
	        trackPromo: function trackPromo(payload) {
	            return dispatch({ type: 'promo-tracker:recordInternal', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/nav-config.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.navigation = undefined;
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var currentYear = (0, _moment2.default)().year();
	var displayMonday = (0, _moment2.default)().locale('us').weekday(1).format('M.D');
	var displayMonth = (0, _moment2.default)().date() < 27 ? (0, _moment2.default)().format('MMMM') : (0, _moment2.default)().add(1, 'months').format('MMMM');
	
	var navigation = exports.navigation = [{
	    name: 'Tarot',
	    link: '/tarot',
	    submenu: [{
	        name: 'Tarot Readings',
	        link: '/readings-reports/tarot',
	        links: [{
	            name: 'FREE 3-Card Tarot Reading',
	            link: '/readings-reports/tarot-readings/free',
	            logged_in: {
	                name: 'Soulmate Tarot Reading',
	                link: '/readings-reports/tarot-readings/soulmate'
	            }
	        }, {
	            name: 'FREE Love Tarot Reading',
	            link: '/readings-reports/tarot-readings/free/love',
	            logged_in: {
	                name: 'Horoscope Tarot Reading',
	                link: '/readings-reports/tarot-readings/horoscope-tarot'
	            }
	        }, {
	            name: 'Yes or No Tarot Reading',
	            link: '/readings-reports/tarot-readings/yes-no',
	            logged_in: {
	                name: 'Relationship Analysis Tarot Reading',
	                link: '/readings-reports/tarot-readings/analysis/relationship'
	            }
	        }, {
	            name: 'Daily Reflection Tarot Reading',
	            link: '/readings-reports/tarot-readings/daily-reflection',
	            logged_in: {
	                name: 'Tree of Life Tarot Reading',
	                link: '/readings-reports/tarot-readings/tree-of-life'
	            }
	        }, {
	            name: 'All Tarot Readings',
	            link: '/readings-reports/tarot'
	        }]
	    }, {
	        name: 'Learn Tarot',
	        link: '/tarot',
	        links: [{
	            name: 'Tarot Card of the Day',
	            link: '/daily-tarot-card'
	        }, {
	            name: 'Browse Tarot Decks',
	            link: '/tarot/decks'
	        }, {
	            name: 'Browse Tarot Cards',
	            link: '/tarot/cards'
	        }, {
	            name: currentYear + ' Tarot Forecast',
	            link: '/tarot/reading-' + currentYear
	        }, {
	            name: 'More About Tarot',
	            link: '/tarot'
	        }]
	    }],
	    articles: {
	        name: 'Explore Tarot',
	        tag: 'tarot',
	        url: '/news/tarot'
	    }
	}, {
	    name: 'Readings',
	    link: '/readings-reports',
	    submenu: [{
	        name: 'Tarot Readings',
	        link: '/readings-reports/tarot',
	        links: [{
	            name: 'FREE Tarot Reading',
	            link: '/readings-reports/tarot-readings/free',
	            logged_in: {
	                name: 'Yes or No Tarot Reading',
	                link: '/readings-reports/tarot-readings/yes-no'
	            }
	        }, {
	            name: 'Relationship Bottom Line',
	            link: '/readings-reports/tarot-readings/bottom-line/relationship',
	            logged_in: {
	                name: 'Revelation Tarot Reading',
	                link: '/readings-reports/tarot-readings/revelation'
	            }
	        }, {
	            name: 'Self-Healing Bottom Line',
	            link: '/readings-reports/tarot-readings/bottom-line/self-healing',
	            logged_in: {
	                name: 'Love Celtic Cross Tarot Reading',
	                link: '/readings-reports/tarot-readings/celtic-cross/love'
	            }
	        }, {
	            name: 'Career Bottom Line',
	            link: '/readings-reports/tarot-readings/bottom-line/career',
	            logged_in: {
	                name: 'Star of David Tarot Reading',
	                link: '/readings-reports/tarot-readings/star-of-david'
	            }
	        }, {
	            name: 'Explore All Tarot Readings',
	            link: '/readings-reports/tarot',
	            logged_in: {
	                name: 'View All Tarot Readings',
	                link: '/readings-reports/tarot'
	            }
	        }]
	    }, {
	        name: 'More Readings',
	        link: '/readings-reports',
	        links: [{
	            name: 'FREE Cosmic Profile',
	            link: '/cosmic-profile',
	            logged_in: {
	                name: 'Essential Birth Report',
	                link: 'https://product.tarot.com/product/input/?id=85600'
	            }
	        }, {
	            name: 'FREE Love Compatibility',
	            link: '/astrology/compatibility/love',
	            logged_in: {
	                name: 'Jupiter\'s Promises Report',
	                link: 'https://product.tarot.com/product/input/?id=85300'
	            }
	        }, {
	            name: 'FREE I Ching Reading',
	            link: '/readings-reports/i-ching/free',
	            logged_in: {
	                name: 'Personalized Astrology Forecast',
	                link: 'https://product.tarot.com/astrology/getreport.php?state=ENTRY&chart_ID=35'
	            }
	        }, {
	            name: 'FREE I Ching Love Reading',
	            link: '/readings-reports/i-ching/free/love',
	            logged_in: {
	                name: 'I Ching Reading',
	                link: '/readings-reports/i-ching/free'
	            }
	        }, {
	            name: 'Explore All Free Readings',
	            link: '/readings-reports/free',
	            logged_in: {
	                name: 'Explore All Readings',
	                link: '/readings-reports'
	            }
	        }]
	    }],
	    articles: {
	        name: 'Explore All Readings & Reports',
	        tag: 'catalog',
	        url: '/readings-reports'
	    }
	}, {
	    name: 'Horoscopes',
	    link: '/horoscopes',
	    submenu: [{
	        name: 'General Horoscopes',
	        link: '/horoscopes',
	        links: [{
	            name: 'Daily Horoscope',
	            link: '/daily-horoscope'
	        }, {
	            name: displayMonth + ' Horoscope',
	            link: '/horoscopes/monthly'
	        }, {
	            name: currentYear + ' Yearly Horoscope',
	            link: '/horoscopes/' + currentYear
	        }, {
	            name: currentYear + ' Chinese Horoscope',
	            link: '/horoscopes/chinese-' + currentYear
	        }, {
	            name: 'View All Horoscopes',
	            link: '/horoscopes'
	        }]
	    }, {
	        name: 'Love Horoscopes',
	        link: '/love-and-compatibility',
	        links: [{
	            name: 'Daily Love Horoscope',
	            link: '/daily-love-horoscope'
	        }, {
	            name: 'Week of ' + displayMonday + ' Love Horoscope',
	            link: '/astrology/weekly-love-horoscopes'
	        }, {
	            name: displayMonth + ' Love Horoscope',
	            link: '/horoscopes/monthly-love'
	        }, {
	            name: currentYear + ' Yearly Love Horoscope',
	            link: '/horoscopes/' + currentYear + '-love'
	        }, {
	            name: 'More Love & Compatibility Articles',
	            link: '/news/love'
	        }]
	    }],
	    articles: {
	        name: 'Featured Horoscopes',
	        tag: 'horoscopes',
	        url: '/news/horoscopes'
	    }
	}, {
	    name: 'Astrology',
	    link: '/astrology',
	    submenu: [{
	        name: 'Astrology Reports',
	        link: '/readings-reports/astrology',
	        links: [{
	            name: 'FREE Cosmic Profile',
	            link: '/cosmic-profile',
	            logged_in: {
	                name: 'Essential Birth Report',
	                link: 'https://product.tarot.com/product/input/?id=85600'
	            }
	        }, {
	            name: 'FREE Love Compatibility',
	            link: '/astrology/compatibility/love',
	            logged_in: {
	                name: 'Big Picture Forecast',
	                link: 'https://product.tarot.com/astrology/getreport.php?state=ENTRY&chart_ID=27'
	            }
	        }, {
	            name: 'FREE Birth Report',
	            link: 'https://product.tarot.com/product/input/?id=85600&sample=1',
	            logged_in: {
	                name: 'Romantic Compatibility',
	                link: 'https://product.tarot.com/astrology/getreport.php?state=ENTRY&chart_ID=16'
	            }
	        }, {
	            name: 'FREE Personal Moon Report',
	            link: 'https://product.tarot.com/product/input/?id=85400&sample=2',
	            logged_in: {
	                name: 'Personal Moon Report',
	                link: 'https://product.tarot.com/product/input/?id=85400'
	            }
	        }, {
	            name: 'All Astrology Reports',
	            link: '/readings-reports/astrology'
	        }]
	    }, {
	        name: 'Learn Astrology',
	        link: '/astrology',
	        links: [{
	            name: 'Zodiac Sign Traits',
	            link: '/astrology/zodiac'
	        }, {
	            name: 'Born on the Cusp',
	            link: '/articles/astrology/born-on-the-zodiac-cusp'
	        }, {
	            name: 'Current Planetary Positions',
	            link: '/astrology'
	        }, {
	            name: 'Astrology Articles & Videos',
	            link: '/news/astrology'
	        }, {
	            name: 'More About Astrology',
	            link: '/astrology'
	        }]
	    }],
	    articles: {
	        name: 'Explore Astrology',
	        tag: 'astrology',
	        url: '/news/astrology'
	    }
	}, {
	    name: 'Numerology',
	    link: '/numerology',
	    submenu: [{
	        name: 'Numerology Reports',
	        link: '/numerology',
	        links: [{
	            name: 'Numerology Forecast',
	            link: '/readings-reports/numerology-reports/1-year-forecast/sample',
	            logged_in: {
	                name: '1-Year Numerology Report',
	                link: '/readings-reports/numerology-reports/1-year-forecast'
	            }
	        }, {
	            name: 'FREE Numerology Compatibility',
	            link: 'https://product.tarot.com/numerology/getreport.php?state=ENTRY&chartId=4',
	            logged_in: {
	                name: 'Numerology Compatibility Report',
	                link: 'https://product.tarot.com/numerology/getreport.php?state=ENTRY&chartId=2'
	            }
	        }, {
	            name: 'Personality Report',
	            link: 'https://product.tarot.com/numerology/getreport.php?state=ENTRY&chartId=1'
	        }, {
	            name: 'Calculate Your Sun Number',
	            link: '/numerology/sun-numbers'
	        }, {
	            name: 'All Numerology Reports',
	            link: '/readings-reports/numerology'
	        }]
	    }, {
	        name: 'Learn Numerology',
	        link: '/numerology',
	        links: [{
	            name: 'Daily Number',
	            link: '/daily-number'
	        }, {
	            name: currentYear + ' Numerology Predictions',
	            link: '/numerology/' + currentYear + '-predictions'
	        }, {
	            name: 'Birthday Numerology',
	            link: '/numerology/birthday'
	        }, {
	            name: 'Numerology Articles & Videos',
	            link: '/news/numerology'
	        }, {
	            name: 'More About Numerology',
	            link: '/numerology'
	        }]
	    }],
	    articles: {
	        name: 'Explore Numerology',
	        tag: 'numerology',
	        url: '/news/numerology'
	    }
	}, {
	    name: 'Psychics',
	    link: '/psychics',
	    target: '_blank'
	}, {
	    name: 'I Ching',
	    link: '/eastern-wisdom',
	    submenu: [{
	        name: 'I Ching Readings',
	        link: '/readings-reports/feng-shui',
	        links: [{
	            name: 'Daily Hexagram',
	            link: '/daily-hexagram'
	        }, {
	            name: 'FREE I Ching Reading',
	            link: '/readings-reports/i-ching/free'
	        }, {
	            name: 'FREE Love I Ching Reading',
	            link: '/readings-reports/i-ching/free/love'
	        }, {
	            name: 'FREE Personalized Feng Shui Report',
	            link: 'https://product.tarot.com/astrology/getreport.php?state=ENTRY&chart_ID=23&sample=1',
	            logged_in: {
	                name: 'Personalized Feng Shui Report',
	                link: 'https://product.tarot.com/astrology/getreport.php?state=ENTRY&chart_ID=23'
	            }
	        }, {
	            name: 'All I Ching Readings',
	            link: '/readings-reports/feng-shui'
	        }]
	    }, {
	        name: 'Learn I Ching',
	        link: '/eastern-wisdom',
	        links: [{
	            name: 'FREE Chinese Compatibility',
	            link: '/astrology/compatibility/chinese',
	            logged_in: {
	                name: 'Chinese Zodiac Signs',
	                link: '/eastern-wisdom#chinese-astro'
	            }
	        }, {
	            name: 'Chinese Zodiac Signs',
	            link: '/eastern-wisdom#chinese-astro',
	            logged_in: {
	                name: 'Browse All I Ching Hexagrams',
	                link: '/i-ching/hexagrams'
	            }
	        }, {
	            name: 'Browse All I Ching Hexagrams',
	            link: '/i-ching/hexagrams',
	            logged_in: {
	                name: 'I Ching Articles & Videos',
	                link: '/news/i-ching'
	            }
	        }, {
	            name: 'I Ching Articles & Videos',
	            link: '/news/i-ching',
	            logged_in: {
	                name: 'Feng Shui Articles & Videos',
	                link: '/news/feng-shui'
	            }
	        }, {
	            name: 'More About I CHING',
	            link: '/eastern-wisdom'
	        }]
	    }],
	    articles: {
	        name: 'Explore I Ching',
	        tag: 'feng-shui',
	        url: '/news/chinese'
	    }
	}];

/***/ },

/***/ "./app/components/nav-bar-mobile.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _navConfig = __webpack_require__("./app/nav-config.js");
	
	var _menuMobile = __webpack_require__("./app/components/user/menu-mobile.js");
	
	var _menuMobile2 = _interopRequireDefault(_menuMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderUserActions = function () {
	            if (_this.props.logged_in) {
	                return (0, _preact.h)(
	                    'li',
	                    { 'class': 'mobile-nav-category' },
	                    (0, _preact.h)(_menuMobile2.default, null)
	                );
	            }
	
	            return (0, _preact.h)(
	                'li',
	                { 'class': 'mobile-nav-category' },
	                (0, _preact.h)(
	                    'div',
	                    { 'class': 'login_signup_bar-side_menu' },
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'login_signup_bar' },
	                        (0, _preact.h)(
	                            'a',
	                            {
	                                'class': 'login_signup_bar_login_link',
	                                'data-label': 'Log In',
	                                href: '/login',
	                                onClick: _this.track
	                            },
	                            (0, _preact.h)('i', { 'class': 'login_signup_bar_icon' }),
	                            (0, _preact.h)(
	                                'span',
	                                { 'class': 'login_signup_bar_login_text' },
	                                'Log In'
	                            )
	                        ),
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'or_text' },
	                            'OR'
	                        ),
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'login_signup_bar_signup_button' },
	                            (0, _preact.h)(
	                                'a',
	                                {
	                                    'class': 'gen-button-signup',
	                                    'data-label': 'Sign Up',
	                                    href: '/signup',
	                                    onClick: _this.track
	                                },
	                                'Sign up!'
	                            )
	                        )
	                    )
	                )
	            );
	        }, _this.renderSection = function (item) {
	            if (item) {
	                var liClassName = 'mobile-nav-category';
	                if (!item.submenu) {
	                    liClassName += ' nav-direct-link';
	                }
	
	                var h3ClassName = item.submenu ? 'category-header' : '';
	                if (_this.props.currentOpen == item.name) {
	                    h3ClassName += ' nav-accordion-expanded';
	                }
	
	                return (0, _preact.h)(
	                    'li',
	                    {
	                        'class': liClassName,
	                        onClick: function onClick(e) {
	                            return _this.toggle(e, item.name);
	                        }
	                    },
	                    (0, _preact.h)(
	                        'h3',
	                        {
	                            'class': h3ClassName.trim()
	                        },
	                        _this.renderItem(item)
	                    ),
	                    _this.renderSubmenus(item)
	                );
	            }
	            return null;
	        }, _this.renderItem = function (item) {
	            if (item.submenu) {
	                return item.name;
	            }
	
	            var logged_in = _this.props.logged_in && item.logged_in;
	
	            return (0, _preact.h)(
	                'a',
	                {
	                    href: logged_in ? item.logged_in.link : item.link,
	                    target: item.target ? item.target : ''
	                },
	                item.name
	            );
	        }, _this.renderSubmenus = function (item) {
	            if (item.submenu) {
	                var className = 'mobile-nav-submenu';
	                if (_this.props.currentOpen == item.name) {
	                    className += ' nav-accordion-expanded';
	                }
	
	                return (0, _preact.h)(
	                    'div',
	                    { 'class': className },
	                    item.submenu.map(function (subitem) {
	                        return _this.renderSubmenu(item, subitem);
	                    })
	                );
	            }
	
	            return null;
	        }, _this.renderSubmenu = function (item, subitem) {
	            if (subitem) {
	                return (0, _preact.h)(
	                    'ul',
	                    null,
	                    subitem.links.map(function (dest) {
	                        return _this.renderLink(item, subitem, dest);
	                    })
	                );
	            }
	
	            return null;
	        }, _this.renderLink = function (item, subitem, dest) {
	            if (dest) {
	                var logged_in = _this.props.logged_in && dest.logged_in;
	                var label = item.name + ' - ' + (logged_in ? dest.logged_in.name : dest.name);
	
	                return (0, _preact.h)(
	                    'li',
	                    null,
	                    (0, _preact.h)(
	                        'a',
	                        {
	                            href: logged_in ? dest.logged_in.link : dest.link,
	                            target: item.target ? item.target : '',
	                            onClick: function onClick() {
	                                return _this.trackClick(label);
	                            }
	                        },
	                        logged_in ? dest.logged_in.name : dest.name
	                    )
	                );
	            }
	
	            return null;
	        }, _this.toggle = function (e, label) {
	            if (e.target.localName == 'h3' && e.target.classList.contains('category-header')) {
	                var action = _this.props.currentOpen == label ? 'Close' : 'Open';
	
	                var currentOpen = _this.props.currentOpen == label ? null : label;
	
	                _this.props.updateOpen(currentOpen);
	                _this.props.trackPromo(['Navigation', label]);
	                _this.props.trackEvent(['Navigation', action, label]);
	            }
	        }, _this.trackClick = function (label) {
	            var category = 'Navigation';
	            var action = _this.props.logged_in ? 'LI Click' : 'LO Click';
	
	            _this.props.trackEvent([category, action, label]);
	            _this.props.trackPromo([category, label]);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return (0, _preact.h)(
	                'nav-bar-mobile',
	                null,
	                (0, _preact.h)(
	                    'ul',
	                    null,
	                    this.renderUserActions(),
	                    _navConfig.navigation.map(function (item) {
	                        return _this2.renderSection(item);
	                    })
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        logged_in: state.user && state.user.logged_in,
	        currentOpen: state['nav-bar-mobile'] && state['nav-bar-mobile'].currentOpen
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        trackEvent: function trackEvent(payload) {
	            return dispatch({ type: 'ga:event', payload: payload });
	        },
	        trackPromo: function trackPromo(payload) {
	            return dispatch({ type: 'promo-tracker:recordInternal', payload: payload });
	        },
	        updateOpen: function updateOpen(payload) {
	            return dispatch({ type: 'nav-bar-mobile:update', payload: { currentOpen: payload } });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/user/menu-mobile.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.toggle = function () {
	            var action = _this.props.currentOpen == _this.label ? 'Close' : 'Open';
	            var currentOpen = _this.props.currentOpen == _this.label ? null : _this.label;
	
	            _this.props.updateOpen(currentOpen);
	            _this.props.trackPromo(['Navigation', _this.label]);
	            _this.props.trackEvent(['Navigation', action, _this.label]);
	        }, _this.trackClick = function (label) {
	            _this.props.trackPromo(['Navigation', label]);
	            _this.props.trackPromo(['Navigation', 'LI Click', label]);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.label = 'My Account - Karma Coins©';
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var _this2 = this;
	
	            var user = _ref2.user;
	
	            var avatar = this.props.user.avatar_url || 'https://gfx.tarot.com/images/site/tarot/ui/avatar-unknown.jpg';
	
	            if (user.logged_in) {
	                var total_kcs = user.kcs.total.toLocaleString();
	
	                return (0, _preact.h)(
	                    'user-menu-mobile',
	                    null,
	                    (0, _preact.h)(
	                        'section',
	                        {
	                            'class': 'category-header ' + (this.props.currentOpen == this.label ? 'nav-accordion-expanded' : ''),
	                            onClick: this.toggle
	                        },
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'avatar-mask' },
	                            (0, _preact.h)('img', { src: avatar, alt: 'User profile picture', 'class': 'avatar' })
	                        ),
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'account-details my-account' },
	                            (0, _preact.h)(
	                                'h5',
	                                null,
	                                'My Account'
	                            ),
	                            (0, _preact.h)(
	                                'p',
	                                null,
	                                total_kcs,
	                                ' Karma Coins',
	                                (0, _preact.h)(
	                                    'sup',
	                                    null,
	                                    '\xA9'
	                                )
	                            )
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'section',
	                        {
	                            'class': 'user-details ' + (this.props.currentOpen == this.label ? 'nav-accordion-expanded' : '')
	                        },
	                        (0, _preact.h)(
	                            'ul',
	                            null,
	                            (0, _preact.h)(
	                                'li',
	                                { 'class': 'ub-journal no-detail-link' },
	                                (0, _preact.h)(
	                                    'a',
	                                    {
	                                        href: 'https://product.tarot.com/about-you/journal',
	                                        'class': 'subcategory',
	                                        onClick: function onClick() {
	                                            return _this2.trackClick('My Journal');
	                                        }
	                                    },
	                                    (0, _preact.h)(
	                                        'h5',
	                                        null,
	                                        'My Journal'
	                                    )
	                                )
	                            ),
	                            (0, _preact.h)(
	                                'li',
	                                { 'class': 'ub-karma-coins my-kcs' },
	                                (0, _preact.h)(
	                                    'a',
	                                    {
	                                        href: '/store/karma-coins',
	                                        'class': 'subcategory',
	                                        onClick: function onClick() {
	                                            return _this2.trackClick('My Account - Karma Coins© Balance');
	                                        }
	                                    },
	                                    (0, _preact.h)('span', null),
	                                    (0, _preact.h)(
	                                        'div',
	                                        { 'class': 'account-details' },
	                                        (0, _preact.h)(
	                                            'h5',
	                                            null,
	                                            'Karma Coins',
	                                            (0, _preact.h)(
	                                                'sup',
	                                                null,
	                                                '\xA9'
	                                            )
	                                        ),
	                                        (0, _preact.h)(
	                                            'p',
	                                            null,
	                                            total_kcs,
	                                            ' Balance'
	                                        )
	                                    )
	                                )
	                            ),
	                            (0, _preact.h)(
	                                'li',
	                                { 'class': 'ub-gear no-detail-link' },
	                                (0, _preact.h)(
	                                    'a',
	                                    {
	                                        href: 'https://tarot.com/member/settings',
	                                        'class': 'subcategory',
	                                        onClick: function onClick() {
	                                            return _this2.trackClick('My Account - Settings');
	                                        }
	                                    },
	                                    (0, _preact.h)(
	                                        'h5',
	                                        null,
	                                        'Account Settings'
	                                    )
	                                )
	                            ),
	                            (0, _preact.h)(
	                                'li',
	                                { 'class': 'ub-logout no-detail-link' },
	                                (0, _preact.h)(
	                                    'a',
	                                    {
	                                        href: '/login/logout',
	                                        'class': 'subcategory',
	                                        onClick: function onClick() {
	                                            return _this2.trackClick('Log Out');
	                                        }
	                                    },
	                                    (0, _preact.h)(
	                                        'h5',
	                                        null,
	                                        'Log Out'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                );
	            }
	
	            return null;
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        user: state.user,
	        currentOpen: state['nav-bar-mobile'] && state['nav-bar-mobile'].currentOpen
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        trackEvent: function trackEvent(payload) {
	            return dispatch({ type: 'ga:event', payload: payload });
	        },
	        trackPromo: function trackPromo(payload) {
	            return dispatch({ type: 'promo-tracker:recordInternal', payload: payload });
	        },
	        updateOpen: function updateOpen(payload) {
	            return dispatch({ type: 'nav-bar-mobile:update', payload: { currentOpen: payload } });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/oranum-psychics.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this));
	
	        (0, _util.bind)(_this, ['renderPsychic']);
	        _this.setState({
	            limit: /^m[.-]/.test(window.location.hostname) ? 1 : 2,
	            psychics: []
	        });
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            // TODO: move to a saga
	            // can't use their api directly, because they don't support CORS
	            Promise.resolve($.get('/api/psychics')).then(function (response) {
	                var psychics = response && response.querySelectorAll && response.querySelectorAll('psychic');
	                return psychics && psychics.length ? psychics : [];
	            }).then(function (psychics) {
	                return Array.prototype.slice.call(psychics, 0, _this2.state.limit);
	            }
	            // psychics is now an array
	            ).then(function (psychics) {
	                return psychics.map(function (psychic) {
	                    return ['likes', 'link', 'performerid', 'thumb'].reduce(function (obj, key) {
	                        obj[key] = psychic.querySelector(key).textContent;
	                        return obj;
	                    }, {});
	                });
	            }).then(function (psychics) {
	                return _this2.setState({ psychics: psychics });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render(_, _ref) {
	            var psychics = _ref.psychics;
	
	            if (!psychics || !psychics.length) {
	                return (0, _preact.h)('oranum-psychics', null);
	            }
	            return (0, _preact.h)(
	                'oranum-psychics',
	                null,
	                (0, _preact.h)(
	                    'div',
	                    { 'class': 'row' },
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'small-12 columns' },
	                        (0, _preact.h)(
	                            'h1',
	                            { 'class': 'text-header-2' },
	                            'Online Spiritual Advisors',
	                            (0, _preact.h)(
	                                'span',
	                                { 'class': 'text-header-6' },
	                                'Chat now for up to 10 minutes free!'
	                            )
	                        )
	                    )
	                ),
	                (0, _preact.h)(
	                    'div',
	                    { 'class': 'row' },
	                    psychics.map(this.renderPsychic)
	                )
	            );
	        }
	    }, {
	        key: 'renderPsychic',
	        value: function renderPsychic(psychic) {
	            var last = psychic.likes.lastIndexOf(' ');
	            var truncated_likes = psychic.likes.substring(0, last);
	            var likes = psychic.likes != truncated_likes ? truncated_likes + '…' : psychic.likes;
	            return (0, _preact.h)(
	                'div',
	                { 'class': 'small-12 medium-6 columns' },
	                (0, _preact.h)(
	                    'a',
	                    { href: psychic.link, target: '_blank' },
	                    (0, _preact.h)('img', { src: psychic.thumb, alt: psychic.performerid }),
	                    (0, _preact.h)(
	                        'h3',
	                        null,
	                        psychic.performerid
	                    )
	                ),
	                (0, _preact.h)(
	                    'p',
	                    null,
	                    likes
	                ),
	                (0, _preact.h)(
	                    'a',
	                    { 'class': 'arrow', href: psychic.link, target: '_blank' },
	                    'ENTER MY FREE CHAT ROOM'
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	exports.default = Component;

/***/ },

/***/ "./app/components/page-accordion.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _scroll = __webpack_require__("./app/scroll.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component(props) {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this, props));
	
	        _this.openClass = 'accordion-open';
	
	        _this.click = function () {
	            var opening = !_this.state.isOpen;
	
	            if (_this.state.attrs.id) {
	                _this.props.routeTo(opening ? _this.state.attrs.id : '');
	            }
	
	            if (opening) {
	                (0, _scroll.smoothScrollToElement)(_this.el);
	            }
	
	            _this.setState({ isOpen: opening });
	        };
	
	        var attrs = _extends({}, props, {
	            class: props.class ? props.class.replace(_this.openClass, '').trim() : ''
	        });
	        delete attrs.children;
	        delete attrs.hash;
	        delete attrs.innerHTML;
	        delete attrs.routeTo;
	
	        var openedByDefault = new RegExp('\\b' + _this.openClass + '\\b').test(props.class);
	        var openedByHash = props.id && props.hash == props.id;
	        _this.setState({
	            attrs: attrs,
	            isOpen: openedByHash || openedByDefault
	        });
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref, _ref2) {
	            var _this2 = this;
	
	            var innerHTML = _ref.innerHTML,
	                hash = _ref.hash;
	            var attrs = _ref2.attrs,
	                isOpen = _ref2.isOpen;
	
	            if (!isOpen) {
	                isOpen = hash == attrs.id;
	            }
	
	            return (0, _preact.h)('div', _extends({}, attrs, {
	                'class': (attrs.class + (isOpen ? ' ' + this.openClass : '')).trim(),
	                dangerouslySetInnerHTML: { __html: innerHTML || '' },
	                onClick: this.click,
	                ref: function ref(el) {
	                    return _this2.el = el;
	                }
	            }));
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	Component.mapStateToProps = function (state) {
	    return {
	        hash: state.route
	    };
	};
	
	Component.mapDispatchToProps = function (dispatch) {
	    return {
	        routeTo: function routeTo(hash) {
	            return dispatch({ type: 'route:to', payload: hash });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(Component.mapStateToProps, Component.mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/planet-tracker.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.requireState();
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref) {
	            var transits = _ref.transits;
	
	            if (!transits) {
	                return (0, _preact.h)('planet-tracker', null);
	            }
	
	            return (0, _preact.h)(
	                'planet-tracker',
	                null,
	                (0, _preact.h)(
	                    'header',
	                    null,
	                    (0, _preact.h)(
	                        'h1',
	                        { 'class': 'widget-header' },
	                        'Planet Tracker'
	                    ),
	                    (0, _preact.h)('hr', { 'class': 'widget-only' }),
	                    (0, _preact.h)(
	                        'h2',
	                        { 'class': 'widget-header' },
	                        'Your daily guide to the changing sky'
	                    ),
	                    (0, _preact.h)('hr', { 'class': 'full-only' }),
	                    (0, _preact.h)(
	                        'h3',
	                        { 'class': 'text-header-3' },
	                        'Your sky for ',
	                        (0, _preact.h)(
	                            'time',
	                            null,
	                            (0, _moment2.default)().format('MMMM D, YYYY')
	                        )
	                    )
	                ),
	                (0, _preact.h)(
	                    'ul',
	                    null,
	                    transits.map(this.renderTransit)
	                )
	            );
	        }
	    }, {
	        key: 'renderTransit',
	        value: function renderTransit(_ref2) {
	            var planet = _ref2.planet,
	                sign = _ref2.sign,
	                date_range = _ref2.date_range;
	
	            // planet and sign are title-cased
	            var href = ('/astrology/planets/' + planet + '-in-' + sign).toLowerCase();
	            var classes = ('icon-planet icon-planet-' + planet).toLowerCase();
	            return (0, _preact.h)(
	                'li',
	                null,
	                (0, _preact.h)(
	                    'a',
	                    { href: href },
	                    (0, _preact.h)('div', { 'class': classes }),
	                    (0, _preact.h)(
	                        'dl',
	                        null,
	                        (0, _preact.h)(
	                            'dd',
	                            null,
	                            planet,
	                            ' in ',
	                            sign
	                        ),
	                        (0, _preact.h)(
	                            'dt',
	                            null,
	                            date_range
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	Component.mapStateToProps = function (state) {
	    return state['planet-tracker'] ? state['planet-tracker'].data : {};
	};
	
	Component.mapDispatchToProps = function (dispatch) {
	    return {
	        requireState: function requireState() {
	            return dispatch({ type: 'planet-tracker:init' });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(Component.mapStateToProps, Component.mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/policy-consent.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.accept = function () {
	            _this.props.trackEvent(['Policy Consent', (_this.props.logged_in ? 'LI' : 'LO') + ' Click', 'Accept']);
	
	            _this.props.updateMemberPrivacyPolicy();
	
	            _this.props.setCookie({
	                name: 'PRIVACY_POLICY_CONSENT',
	                value: 1
	            });
	
	            _this.props.setCookie({
	                name: 'POLICY_CONSENT_SHOWN',
	                value: 1
	            });
	
	            _this.setState({ show: false });
	        }, _this.decline = function () {
	            _this.props.trackEvent(['Policy Consent', (_this.props.logged_in ? 'LI' : 'LO') + ' Click', 'Decline/Close']);
	
	            _this.props.setCookie({
	                name: 'POLICY_CONSENT_SHOWN',
	                value: 1,
	                opts: {
	                    expires: (0, _moment2.default)().add(24, 'hours').toDate()
	                }
	            });
	
	            _this.setState({ show: false });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var show = this.props.shown || this.props.hide_policy_consent ? false : true;
	
	            this.setState({ show: show });
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            if (this.props.ppc != nextProps.ppc) {
	                this.setState({ show: false });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var logged_in = _ref2.logged_in,
	                ppc = _ref2.ppc;
	
	            if (this.state.show) {
	                this.props.trackEvent(['Policy Consent', (logged_in ? 'LI' : 'LO') + ' Impression']);
	
	                if (ppc) {
	                    this.props.setCookie({
	                        name: 'POLICY_CONSENT_SHOWN',
	                        value: 1
	                    });
	                }
	
	                return (0, _preact.h)(
	                    'policy-consent',
	                    null,
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'policy-consent-content' },
	                        (0, _preact.h)(
	                            'p',
	                            null,
	                            'We use cookies to improve your browsing experience, analyze our traffic, and offer personalized content and advertising. By continuing to use this site, you agree to the usage of cookies as outlined ',
	                            (0, _preact.h)(
	                                'a',
	                                { href: '/cookie-policy', target: '_blank' },
	                                'here'
	                            ),
	                            ', as well as our updated ',
	                            (0, _preact.h)(
	                                'a',
	                                { href: '/privacy-policy', target: '_blank' },
	                                'Privacy Policy'
	                            ),
	                            ' and\xA0',
	                            (0, _preact.h)(
	                                'a',
	                                { href: '/terms-of-use', target: '_blank' },
	                                'Terms of Use'
	                            ),
	                            '.'
	                        ),
	                        (0, _preact.h)(
	                            'a',
	                            { 'class': 'close', onClick: this.decline },
	                            '\xD7'
	                        ),
	                        (0, _preact.h)(
	                            'a',
	                            { 'class': 'button', onClick: this.accept },
	                            'I ACCEPT'
	                        )
	                    )
	                );
	            }
	
	            return null;
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        ppc: state.cookie && state.cookie.PRIVACY_POLICY_CONSENT,
	        logged_in: state.user && state.user.logged_in,
	        shown: state.cookie && state.cookie.POLICY_CONSENT_SHOWN,
	        hide_policy_consent: state.hide_policy_consent
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        trackEvent: function trackEvent(payload) {
	            return dispatch({
	                type: 'ga:event',
	                payload: payload
	            });
	        },
	        setCookie: function setCookie(payload) {
	            return dispatch({
	                type: 'cookie:set',
	                payload: payload
	            });
	        },
	        updateMemberPrivacyPolicy: function updateMemberPrivacyPolicy() {
	            return dispatch({
	                type: 'member:privacy-policy-consent'
	            });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/product-details.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component(props) {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this, props));
	
	        _this.state = { showDetails: false };
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'createMarkup',
	        value: function createMarkup(details) {
	            return { __html: details };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            if (!this.props.details) {
	                return (0, _preact.h)('product-details', null);
	            }
	
	            return (0, _preact.h)(
	                'product-details',
	                { onclick: function onclick() {
	                        return _this2.handleToggleClick();
	                    } },
	                (0, _preact.h)(
	                    'p',
	                    null,
	                    this.props.summary,
	                    ' ',
	                    (0, _preact.h)(
	                        'a',
	                        null,
	                        this.state.showDetails ? 'Show Less' : 'Learn More'
	                    )
	                ),
	                this.state.showDetails && (0, _preact.h)('p', { 'class': 'details', dangerouslySetInnerHTML: this.createMarkup(this.props.details) })
	            );
	        }
	    }, {
	        key: 'handleToggleClick',
	        value: function handleToggleClick() {
	            this.setState({
	                showDetails: !this.state.showDetails
	            });
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	exports.default = Component;

/***/ },

/***/ "./app/components/product-message.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PromoMessage = function (_Component) {
	    _inherits(PromoMessage, _Component);
	
	    function PromoMessage() {
	        _classCallCheck(this, PromoMessage);
	
	        return _possibleConstructorReturn(this, (PromoMessage.__proto__ || Object.getPrototypeOf(PromoMessage)).apply(this, arguments));
	    }
	
	    _createClass(PromoMessage, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.requireProductMessage(this.props.placement, this.props.product_result_slug);
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref) {
	            var message = _ref.message,
	                placement = _ref.placement,
	                product_result_slug = _ref.product_result_slug;
	
	            if (message) {
	                return (0, _preact.h)(
	                    'product-message',
	                    {
	                        placement: placement,
	                        product_result_slug: product_result_slug
	                    },
	                    (0, _preact.h)('p', { 'class': 'result-msg', dangerouslySetInnerHTML: { __html: message } })
	                );
	            }
	
	            return (0, _preact.h)('product-message', { placement: placement, product_result_slug: product_result_slug });
	        }
	    }]);
	
	    return PromoMessage;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state, _ref2) {
	    var placement = _ref2.placement;
	    return {
	        logged_in: state.user && state.user.logged_in,
	        message: state['product-message'] && state['product-message'][placement] && state['product-message'][placement].message
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        requireProductMessage: function requireProductMessage(placement, product_result_slug) {
	            return dispatch({
	                type: 'product-message:require', payload: { placement: placement, product_result_slug: product_result_slug }
	            });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(PromoMessage);

/***/ },

/***/ "./app/components/reading-header-price.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReadingHeaderPrice = function (_Component) {
	    _inherits(ReadingHeaderPrice, _Component);
	
	    function ReadingHeaderPrice() {
	        _classCallCheck(this, ReadingHeaderPrice);
	
	        var _this = _possibleConstructorReturn(this, (ReadingHeaderPrice.__proto__ || Object.getPrototypeOf(ReadingHeaderPrice)).call(this));
	
	        _this.renderOnSale = function () {
	            var price = _this.props.price;
	
	            if (_this.on_sale) {
	                return (0, _preact.h)(
	                    's',
	                    null,
	                    '$',
	                    price.usd.original.toFixed(2),
	                    ' or ',
	                    price.kc.original,
	                    ' KCs'
	                );
	            }
	
	            return null;
	        };
	
	        _this.renderPrice = function () {
	            if (_this.props.price) {
	                var price = _this.props.price;
	                var subscription = _this.props.subscription;
	                var text = '';
	
	                if (price.usd && price.usd.current !== null) {
	                    text = '$' + price.usd.current.toFixed(2);
	
	                    if (price.kc) {
	                        text = text + (' or ' + price.kc.current + ' KCs');
	                    }
	                } else {
	                    text = price.kc.current + ' KCs';
	
	                    if (subscription) {
	                        text = text + (' OR <a href="' + subscription.description.product_url + '">SUBSCRIBE</a>');
	                    }
	                }
	
	                return (0, _preact.h)(
	                    'p',
	                    { 'class': 'pre-header reading-price' },
	                    (0, _preact.h)('span', { 'class': _this.on_sale ? 'sale' : '', dangerouslySetInnerHTML: { __html: text } })
	                );
	            }
	
	            return null;
	        };
	
	        _this.on_sale = false;
	        return _this;
	    }
	
	    _createClass(ReadingHeaderPrice, [{
	        key: 'render',
	        value: function render(_ref) {
	            var price = _ref.price,
	                teeup = _ref.teeup,
	                subscription = _ref.subscription;
	
	            var render = false;
	
	            if (price) {
	                if (price.usd && price.usd.original && price.usd.current) {
	                    this.on_sale = price.usd.original - price.usd.current > 0;
	                }
	
	                render = price.usd && price.usd.current !== 0;
	
	                if (teeup && teeup.upsell_upc) {
	                    render = false;
	                }
	
	                if (subscription) {
	                    render = true;
	                }
	            }
	
	            if (render) {
	                return (0, _preact.h)(
	                    'reading-header-price',
	                    null,
	                    this.renderOnSale(),
	                    this.renderPrice()
	                );
	            }
	
	            return (0, _preact.h)('reading-header-price', null);
	        }
	    }]);
	
	    return ReadingHeaderPrice;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        price: state.product.price,
	        subscription: state.product.subscription,
	        teeup: state.product.teeup
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(ReadingHeaderPrice);

/***/ },

/***/ "./app/components/recaptcha.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this));
	
	        _this.isLoaded = function () {
	            return typeof window !== 'undefined' && typeof window.grecaptcha !== 'undefined';
	        };
	
	        _this.isInjected = function () {
	            if (typeof window === 'undefined') {
	                return false;
	            }
	
	            if (!document.scripts || document.scripts.length === 0) {
	                return false;
	            }
	
	            var scripts = _extends([], document.scripts).filter(function (script) {
	                return script.src.match(/http(s)?:\/\/(www\.)?google\.com\/recaptcha\/api.js.*/i) !== null;
	            });
	
	            return scripts.length > 0;
	        };
	
	        _this.capture = function (elem) {
	            _this.recaptcha.element = elem;
	        };
	
	        _this.initialize = function () {
	            if (_this.isLoaded()) {
	                _this.recaptcha.loaded = true;
	                _this.clearTimer();
	                _this.renderRecaptcha();
	            } else if (!_this.isInjected()) {
	                var script = document.createElement('script');
	
	                window.recaptchaLoaded = _this.initialize;
	
	                script.src = _this.recaptcha.src;
	                script.async = 1;
	                script.defer = 1;
	
	                document.body.appendChild(script);
	            } else {
	                _this.startTimer();
	            }
	        };
	
	        _this.renderRecaptcha = function () {
	            if (_this.props.size === 'invisible') {
	                _this.recaptcha.id = window.grecaptcha.render(_this.recaptcha.element, {
	                    sitekey: _this.recaptcha.sitekey,
	                    callback: _this.handleChange,
	                    size: 'invisible'
	                });
	            } else {
	                _this.recaptcha.id = window.grecaptcha.render(_this.recaptcha.element, {
	                    'sitekey': _this.recaptcha.sitekey,
	                    'callback': _this.handleChange,
	                    'expired-callback': _this.handleExpired
	                });
	            }
	        };
	
	        _this.remove = function () {
	            window.grecaptcha.reset(_this.recaptcha.id);
	        };
	
	        _this.execute = function () {
	            if (_this.recaptcha.loaded && _this.recaptcha.element && _this.recaptcha.id !== null) {
	                window.grecaptcha.execute(_this.recaptcha.id);
	                return true;
	            }
	
	            return false;
	        };
	
	        _this.reset = function () {
	            if (_this.recaptcha.loaded && _this.recaptcha.element && _this.recaptcha.id !== null) {
	                window.grecaptcha.reset(_this.recaptcha.id);
	                return true;
	            }
	
	            return false;
	        };
	
	        _this.handleExpired = function () {
	            if (_this.props.onExpired) {
	                _this.props.onExpired();
	            }
	        };
	
	        _this.handleChange = function (response) {
	            if (_this.props.onChange) {
	                _this.props.onChange(response);
	            }
	        };
	
	        _this.startTimer = function () {
	            _this.timer = setTimeout(_this.initialize, 200000);
	        };
	
	        _this.clearTimer = function () {
	            if (_this.timer !== null) {
	                clearInterval(_this.timer);
	            }
	        };
	
	        _this.getResponse = function () {
	            if (_this.recaptcha.loaded && _this.recaptcha.element && _this.recaptcha.id !== null) {
	                return window.grecaptcha.getResponse(_this.recaptcha.id);
	            }
	
	            return null;
	        };
	
	        _this.timer = null;
	
	        _this.recaptcha = {
	            src: 'https://www.google.com/recaptcha/api.js?&onload=recaptchaLoaded&render=explicit',
	            element: null,
	            id: null,
	            sitekey: '6Lel5kwUAAAAAAdP-4POyS9jTX8FaSiMUsxdOQRP',
	            loaded: false
	        };
	
	        _this.baseProps = {
	            theme: 'light',
	            type: 'image',
	            tabindex: 0,
	            size: 'normal',
	            badge: 'bottomright'
	        };
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.initialize();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.clearTimer();
	
	            if (this.recaptcha.loaded && this.recaptcha.element && this.recaptcha.id !== null) {
	                this.remove();
	            }
	
	            window.___grecaptcha_cfg.count = 0;
	            window.___grecaptcha_cfg.clients = {};
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var props = _extends({}, this.props, this.baseProps);
	
	            return (0, _preact.h)(
	                'recaptcha',
	                null,
	                (0, _preact.h)('div', _extends({}, props, { sitekey: this.recaptcha.sitekey, ref: this.capture }))
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	exports.default = (0, _preactRedux.connect)()(Component);

/***/ },

/***/ "./app/components/report-teeup.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _date = __webpack_require__("./app/components/fields/date.js");
	
	var _date2 = _interopRequireDefault(_date);
	
	var _gender = __webpack_require__("./app/components/fields/gender.js");
	
	var _gender2 = _interopRequireDefault(_gender);
	
	var _name = __webpack_require__("./app/components/fields/name.js");
	
	var _name2 = _interopRequireDefault(_name);
	
	var _readingHeaderPrice = __webpack_require__("./app/components/reading-header-price.js");
	
	var _readingHeaderPrice2 = _interopRequireDefault(_readingHeaderPrice);
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderFields = function () {
	            if (_this.props.fields) {
	                return _this.props.fields.map(_this.renderField);
	            }
	
	            return null;
	        }, _this.renderField = function (field) {
	            var FieldType = null;
	
	            if (field.type == 'name') {
	                FieldType = _name2.default;
	            } else if (field.type == 'string' && field.name == 'gender') {
	                FieldType = _gender2.default;
	            } else if (field.type == 'date') {
	                FieldType = _date2.default;
	            }
	
	            if (FieldType) {
	                return (0, _preact.h)(FieldType, _extends({}, _this.state.fields[field.name], {
	                    name: field.name,
	                    category: _this.props.category,
	                    reportInput: _this.reportInput,
	                    dirty: _this.state.dirty
	                }));
	            }
	
	            return null;
	        }, _this.renderForRadios = function () {
	            if (_this.props.default_profile) {
	                return (0, _preact.h)(
	                    'div',
	                    { 'class': 'radio-input profile_chooser' },
	                    (0, _preact.h)(
	                        'fieldset',
	                        null,
	                        (0, _preact.h)(
	                            'legend',
	                            null,
	                            'Enter Your Information'
	                        ),
	                        (0, _preact.h)('br', null),
	                        (0, _preact.h)(
	                            'label',
	                            null,
	                            'For you',
	                            (0, _preact.h)('input', {
	                                checked: _this.state.profile_chooser == 'self',
	                                type: 'radio',
	                                onClick: _this.populateForm
	                            })
	                        ),
	                        (0, _preact.h)(
	                            'label',
	                            null,
	                            'For a friend',
	                            (0, _preact.h)('input', {
	                                checked: _this.state.profile_chooser == 'friend',
	                                type: 'radio',
	                                onClick: _this.clearForm
	                            })
	                        )
	                    )
	                );
	            }
	
	            return null;
	        }, _this.populateForm = function () {
	            var profile = _this.props.default_profile;
	            var state = _this.state;
	
	            state.profile_chooser = 'self';
	
	            if (profile) {
	
	                var birth_name = profile.birth_mname ? (profile.birth_fname + ' ' + profile.birth_mname + ' ' + profile.birth_lname).trim() : (profile.birth_fname + ' ' + profile.birth_lname).trim();
	
	                var _ref2 = [birth_name, null, (profile.cur_fname + ' ' + profile.cur_lname).trim(), null, profile.sex];
	                state.fields.birth_name.value = _ref2[0];
	                state.fields.birth_name.error = _ref2[1];
	                state.fields.name.value = _ref2[2];
	                state.fields.name.error = _ref2[3];
	                state.fields.gender.value = _ref2[4];
	
	
	                if (profile.birth_date) {
	                    var birth_date = (0, _moment2.default)(profile.birth_date);
	                    var _ref3 = [birth_date.format('YYYY'), birth_date.format('MM'), birth_date.format('DD'), birth_date.format('YYYY-MM-DD'), null];
	                    state.fields.birth_date.year = _ref3[0];
	                    state.fields.birth_date.month = _ref3[1];
	                    state.fields.birth_date.day = _ref3[2];
	                    state.fields.birth_date.value = _ref3[3];
	                    state.fields.birth_date.error = _ref3[4];
	                }
	            }
	
	            _this.setState(state);
	        }, _this.clearForm = function () {
	            var state = _this.state;
	
	            var _ref4 = ['friend', 'female', null, null, null, null, null, null];
	            state.profile_chooser = _ref4[0];
	            state.fields.gender.value = _ref4[1];
	            state.fields.birth_name.value = _ref4[2];
	            state.fields.name.value = _ref4[3];
	            state.fields.birth_date.month = _ref4[4];
	            state.fields.birth_date.day = _ref4[5];
	            state.fields.birth_date.year = _ref4[6];
	            state.fields.birth_date.value = _ref4[7];
	
	
	            _this.setState(state);
	        }, _this.submit = function (e) {
	            e.preventDefault();
	            _this.setState({ submitting: true });
	
	            var state = _this.state;
	            var error = false;
	
	            Object.keys(state.fields).forEach(function (name) {
	                if (name == 'name' || name == 'birth_name') {
	                    var value = state.fields[name].value;
	                    if (value) {
	                        var number_of_values = value.replace(/[^\s]+/g, '').length + 1;
	                        var _error = null;
	
	                        if (number_of_values == 0) {
	                            _error = "This field can't be empty.";
	                        } else if (number_of_values == 1) {
	                            _error = 'This field requires at least first and last names.';
	                        } else if (number_of_values > 3) {
	                            _error = 'This field requires first and last name. Middle name is optional';
	                        }
	
	                        _this.reportInput(name, value, _error);
	                    }
	                }
	
	                if (!state.fields[name].value) {
	                    error = true;
	                    state.fields[name].error = 'This field is required';
	                } else if (state.fields[name].error) {
	                    error = true;
	                }
	            });
	
	            if (error) {
	                var _ref5 = [true, false];
	                state.dirty = _ref5[0];
	                state.submitting = _ref5[1];
	
	                _this.setState(state);
	            } else {
	                var payload = [{
	                    name: 'birth_name',
	                    value: _this.state.fields.birth_name.value
	                }, {
	                    name: 'name',
	                    value: _this.state.fields.name.value
	                }, {
	                    name: 'gender',
	                    value: _this.state.fields.gender.value
	                }, {
	                    name: 'month',
	                    value: _this.state.fields.birth_date.month
	                }, {
	                    name: 'day',
	                    value: _this.state.fields.birth_date.day
	                }, {
	                    name: 'year',
	                    value: _this.state.fields.birth_date.year
	                }, {
	                    name: 'month',
	                    value: _this.state.fields.forecast_date.month
	                }, {
	                    name: 'year',
	                    value: _this.state.fields.forecast_date.year
	                }];
	                _this.props.submit(payload);
	            }
	
	            return false;
	        }, _this.reportInput = function (name, value, error) {
	            var state = _this.state;
	
	            if (name == 'birth_date') {
	                var birth_date = (0, _moment2.default)(value);
	
	                var _ref6 = [birth_date.format('MM'), birth_date.format('DD'), birth_date.format('YYYY')];
	                state.fields[name].month = _ref6[0];
	                state.fields[name].day = _ref6[1];
	                state.fields[name].year = _ref6[2];
	            } else if (name == 'forecast_date') {
	                var forecast_date = (0, _moment2.default)(value);
	
	                var _ref7 = [forecast_date.format('MM'), forecast_date.format('YYYY')];
	                state.fields[name].month = _ref7[0];
	                state.fields[name].year = _ref7[1];
	            }
	
	            var _ref8 = [value, error];
	            state.fields[name].value = _ref8[0];
	            state.fields[name].error = _ref8[1];
	
	
	            _this.setState(state);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.init(this.props.upc);
	
	            this.setState({
	                submitting: false,
	                dirty: false,
	                profile_chooser: 'friend',
	                fields: {
	                    birth_name: {
	                        label: 'Birth Name',
	                        info: 'This is where you enter your name as given to you at birth. Enter the name given to you at' + ' birth.',
	                        value: null,
	                        error: null
	                    },
	                    name: {
	                        label: 'Current Name',
	                        info: 'This is where you enter the name you currently use when introducing yourself, signing ' + 'papers, etc. If you are married and have changed your name, this would require you to enter ' + 'your new name. If you have multiple last names, or a hyphenated one, use it all.',
	                        value: null,
	                        error: null
	                    },
	                    gender: {
	                        value: 'female',
	                        error: null
	                    },
	                    birth_date: {
	                        label: 'Birth Date',
	                        direction: 'past',
	                        month: null,
	                        day: null,
	                        year: null,
	                        value: null,
	                        error: null
	                    },
	                    forecast_date: {
	                        label: 'Start Report',
	                        month_only: true,
	                        direction: 'future',
	                        month: null,
	                        year: null,
	                        value: null,
	                        error: null
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return (0, _preact.h)(
	                'report-teeup',
	                null,
	                this.renderForRadios(),
	                (0, _preact.h)(
	                    'form',
	                    { 'class': 'report-teeup-form', onSubmit: this.submit },
	                    this.renderFields(),
	                    (0, _preact.h)(
	                        'p',
	                        { 'class': 'price' },
	                        (0, _preact.h)(_readingHeaderPrice2.default, null)
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'button-container' },
	                        (0, _preact.h)(
	                            'button',
	                            {
	                                'class': 'button ' + (this.state.submitting ? 'disabled' : ''),
	                                onClick: this.submit,
	                                disabled: this.state.submitting
	                            },
	                            this.state.submitting ? 'submitting…' : 'Get my report'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        default_profile: state.user.profiles && state.user.profiles.length ? state.user.profiles[0] : null,
	        fields: state.fields
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        init: function init(upc) {
	            return dispatch({ type: 'forecast:init', payload: upc });
	        },
	        submit: function submit(payload) {
	            return dispatch({ type: 'product:submit', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/responsive/birthday-select.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _underscore = __webpack_require__("../node_modules/underscore/underscore.js");
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderMonths = function () {
	            return (0, _preact.h)(
	                'select',
	                {
	                    'data-action': 'Select-Month',
	                    'data-category': 'Birthday Select',
	                    'data-ga-event': true,
	                    'data-label': 'Birthday Horoscopes',
	                    onChange: _this.setMonth,
	                    name: 'month'
	                },
	                (0, _preact.h)(
	                    'option',
	                    { selected: true, disabled: true },
	                    'month'
	                ),
	                _this.state.months.map(function (month) {
	                    return (0, _preact.h)(
	                        'option',
	                        { value: (0, _moment2.default)().month(month).format('MM') },
	                        (0, _moment2.default)().month(month).format('MMMM')
	                    );
	                })
	            );
	        }, _this.setMonth = function (e) {
	            _this.setState({
	                month: e.target.value,
	                day: null
	            });
	            _this.getDays();
	            _this.setFullDate();
	        }, _this.renderDays = function () {
	            return (0, _preact.h)(
	                'select',
	                {
	                    'data-action': 'Select-Day',
	                    'data-category': 'Birthday Select',
	                    'data-ga-event': true,
	                    'data-label': 'Birthday Horoscopes',
	                    onChange: _this.setDay,
	                    name: 'day'
	                },
	                (0, _preact.h)(
	                    'option',
	                    { selected: true, disabled: true },
	                    'day'
	                ),
	                _this.state.days.map(function (day) {
	                    return (0, _preact.h)(
	                        'option',
	                        { value: ('0' + (day + 1)).substr(-2) },
	                        day + 1
	                    );
	                })
	            );
	        }, _this.getDays = function () {
	            var year = _this.state.year ? _this.state.year : _this.state.years[0];
	            var month = _this.state.month ? _this.state.month : 1;
	            var daysInMonth = (0, _moment2.default)(year + '-' + month, 'YYYY-MM').daysInMonth();
	            var days = _underscore2.default.range(daysInMonth);
	
	            _this.setState({
	                days: days
	            });
	        }, _this.setDay = function (e) {
	            _this.setState({ day: e.target.value });
	            _this.setFullDate();
	        }, _this.renderYears = function () {
	            return (0, _preact.h)(
	                'select',
	                {
	                    'data-action': 'Select-Year',
	                    'data-category': 'Birthday Select',
	                    'data-ga-event': true,
	                    'data-label': 'Birthday Horoscopes',
	                    onChange: _this.setYear,
	                    name: 'year'
	                },
	                (0, _preact.h)(
	                    'option',
	                    { selected: true, disabled: true },
	                    'year'
	                ),
	                _this.state.years.map(function (year) {
	                    return (0, _preact.h)(
	                        'option',
	                        { value: year },
	                        year
	                    );
	                })
	            );
	        }, _this.setYear = function (e) {
	            _this.setState({ year: e.target.value });
	            _this.setFullDate();
	        }, _this.setFullDate = function () {
	            if (_this.state.month && _this.state.day && _this.state.year && _this.props.base_url) {
	                document.location.href = _this.props.base_url + '/' + _this.state.year + '-' + _this.state.month + '-' + _this.state.day;
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var months = _underscore2.default.range(12);
	            var days = _underscore2.default.range(31);
	            var years = this.props.direction == 'future' ? _underscore2.default.range((0, _moment2.default)().year() - 1, (0, _moment2.default)().year() + 10) : _underscore2.default.range((0, _moment2.default)().year(), (0, _moment2.default)().year() - 100, -1);
	
	            this.setState({
	                month: null,
	                months: months,
	                day: null,
	                days: days,
	                year: null,
	                years: years
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return (0, _preact.h)(
	                'birthday-select',
	                null,
	                (0, _preact.h)(
	                    'label',
	                    null,
	                    this.renderMonths()
	                ),
	                (0, _preact.h)(
	                    'label',
	                    null,
	                    this.renderDays()
	                ),
	                (0, _preact.h)(
	                    'label',
	                    null,
	                    this.renderYears()
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	exports.default = (0, _preactRedux.connect)()(Component);

/***/ },

/***/ "./app/components/responsive/desktop-nav-dropdown.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.toggle = function () {
	            _this.setState({ isOpen: !_this.state.isOpen });
	        }, _this.renderLink = function (_ref2) {
	            var label = _ref2.label,
	                url = _ref2.url;
	
	            if (_this.state.isOpen) {
	                var impression_label = _this.props.page_name ? _this.props.page_name + ':' + label : label;
	                _this.trackImpression(impression_label);
	
	                return (0, _preact.h)(
	                    'div',
	                    { 'class': 'desktop-nav-dropdown' },
	                    (0, _preact.h)(
	                        'a',
	                        { href: url, onClick: function onClick() {
	                                return _this.trackClick(label);
	                            } },
	                        label
	                    )
	                );
	            }
	
	            return null;
	        }, _this.trackImpression = function (label) {
	            _this.props.trackEvent(['Dropdown', (_this.props.logged_in ? 'LI' : 'LO') + ' Impression', label]);
	        }, _this.trackClick = function (label) {
	            var click_label = _this.props.page_name ? _this.props.page_name + ':' + label : label;
	            _this.props.trackEvent(['Dropdown', (_this.props.logged_in ? 'LI' : 'LO') + ' Click', click_label]);
	            _this.props.trackPromo(['Dropdown', label]);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({ isOpen: false });
	            this.props.requireState();
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref3) {
	            var logged_in = _ref3.logged_in;
	
	            if (this.props.links) {
	                var links = this.props.links.map(function (link) {
	                    return link.logged_in && logged_in ? link.logged_in : link;
	                });
	
	                return (0, _preact.h)(
	                    'desktop-nav-dropdown',
	                    null,
	                    (0, _preact.h)(
	                        'span',
	                        { onClick: this.toggle, 'class': 'desktop-nav-dropdown ' + (this.state.isOpen ? 'active' : '') },
	                        'More For Today'
	                    ),
	                    links.map(this.renderLink)
	                );
	            }
	
	            return null;
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        logged_in: state.user && state.user.logged_in,
	        links: state['mobile-nav-dropdown']
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        requireState: function requireState() {
	            return dispatch({ type: 'mobile-nav-dropdown:init' });
	        },
	        trackEvent: function trackEvent(payload) {
	            return dispatch({ type: 'ga:event', payload: payload });
	        },
	        trackPromo: function trackPromo(payload) {
	            return dispatch({ type: 'promo-tracker:recordInternal', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/responsive/login-modal.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this));
	
	        _this.renderError = function (error) {
	            if (error) {
	                return (0, _preact.h)(
	                    'span',
	                    { 'class': 'error-message' },
	                    error
	                );
	            }
	
	            return null;
	        };
	
	        _this.close = function () {
	            _this.props.trackEvent(['Modal', 'close', 'Login']);
	            _this.props.routeTo('');
	        };
	
	        _this.setEmail = function (e) {
	            _this.setState({
	                email: e.target.value
	            });
	        };
	
	        _this.setPassword = function (e) {
	            _this.setState({
	                password: e.target.value
	            });
	        };
	
	        _this.validate = function () {
	            var validEmail = _this.state.email && _this.isValidEmail(_this.state.email);
	            var validPassword = _this.state.password && _this.state.password.length > 3;
	
	            if (validEmail && validPassword) {
	                _this.props.userUpdate({
	                    emailError: null,
	                    passwordError: null
	                });
	
	                _this.props.userLogin({
	                    email: _this.state.email,
	                    password: _this.state.password
	                });
	            } else {
	                if (validEmail) {
	                    _this.props.userUpdate({ emailError: null });
	                } else {
	                    _this.props.userUpdate({ emailError: 'Please enter a valid email.' });
	                }
	
	                if (validPassword) {
	                    _this.props.userUpdate({ passwordError: null });
	                } else {
	                    _this.props.userUpdate({ passwordError: 'Please enter a password longer than 3 characters.' });
	                }
	            }
	        };
	
	        _this.isValidEmail = function (email) {
	            var atpos = email.indexOf('@');
	            var dotpos = email.lastIndexOf('.');
	            return !(atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= email.length);
	        };
	
	        _this.setState({
	            email: null,
	            password: null,
	            formError: null
	        });
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            if (nextProps.route != this.props.route) {
	                var dialog = document.getElementById('login-modal');
	
	                if (dialog) {
	                    if (nextProps.route == 'login' && !nextProps.user.logged_in && !this.props.user.logged_in) {
	                        this.props.trackEvent(['Modal', 'show', 'Login']);
	                        dialog.showModal();
	                        return false;
	                    } else if (nextProps.route == 'login') {
	                        this.props.routeTo('');
	                    } else if (this.props.route == 'login') {
	                        this.props.trackEvent(['Modal', 'close', 'Login']);
	                        dialog.close();
	                        return false;
	                    }
	                }
	            }
	
	            return true;
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var that = this;
	            var dialog = document.getElementById('login-modal');
	            dialogPolyfill.registerDialog(dialog); //eslint-disable-line no-undef
	
	            dialog.addEventListener('keydown', function (e) {
	                if (e.keyCode == 13) {
	                    that.validate();
	                } else if (e.keyCode == 27) {
	                    e.preventDefault();
	                    that.close();
	                }
	            });
	
	            dialog.addEventListener('click', function (e) {
	                if (e.target.tagName == 'DIALOG') {
	                    that.close();
	                }
	            });
	
	            if (this.props.route && this.props.route == 'login') {
	                that.props.trackEvent(['Modal', 'show', 'Login']);
	                dialog.showModal();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref) {
	            var emailError = _ref.emailError,
	                passwordError = _ref.passwordError,
	                product = _ref.product;
	
	            var title = 'Welcome!';
	            var subtitle = 'We’re so happy to see you! Log in or signup to get started.';
	            var button_text = 'ENTER';
	
	            if (product && product.type) {
	                title = 'your ' + product.type + ' awaits!';
	                subtitle = 'Log in or sign up below for your ' + product.type + '. It\'s easy!';
	                button_text = ('GET MY ' + product.type + '!').toUpperCase();
	            }
	
	            return (0, _preact.h)(
	                'responsive-login-modal',
	                null,
	                (0, _preact.h)(
	                    'dialog',
	                    { id: 'login-modal' },
	                    (0, _preact.h)(
	                        'dialog-header',
	                        null,
	                        (0, _preact.h)(
	                            'button',
	                            { 'class': 'button-close', onClick: this.close },
	                            '\xD7'
	                        ),
	                        (0, _preact.h)(
	                            'h1',
	                            null,
	                            title
	                        ),
	                        (0, _preact.h)(
	                            'h5',
	                            null,
	                            subtitle
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'dialog-content',
	                        null,
	                        (0, _preact.h)(
	                            'row',
	                            null,
	                            (0, _preact.h)(
	                                'column',
	                                null,
	                                (0, _preact.h)(
	                                    'label',
	                                    null,
	                                    'Your Email'
	                                ),
	                                (0, _preact.h)('input', {
	                                    type: 'email',
	                                    'class': emailError ? 'error' : '',
	                                    onKeyup: this.setEmail
	                                }),
	                                this.renderError(emailError)
	                            )
	                        ),
	                        (0, _preact.h)(
	                            'row',
	                            null,
	                            (0, _preact.h)(
	                                'column',
	                                null,
	                                (0, _preact.h)(
	                                    'label',
	                                    null,
	                                    'Password'
	                                ),
	                                (0, _preact.h)('input', {
	                                    type: 'password',
	                                    'class': passwordError ? 'error' : '',
	                                    onKeyup: this.setPassword
	                                }),
	                                this.renderError(passwordError)
	                            )
	                        ),
	                        (0, _preact.h)(
	                            'row',
	                            null,
	                            (0, _preact.h)(
	                                'column',
	                                null,
	                                this.renderError(this.state.formError)
	                            )
	                        ),
	                        (0, _preact.h)(
	                            'row',
	                            null,
	                            (0, _preact.h)(
	                                'column',
	                                { 'class': 'has-text-centered' },
	                                (0, _preact.h)(
	                                    'button',
	                                    { 'class': 'button-modal', onClick: this.validate },
	                                    button_text
	                                ),
	                                (0, _preact.h)(
	                                    'a',
	                                    { href: '/password-reset', 'class': 'forgot-password' },
	                                    'Forgot your password?'
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        user: state.user,
	        product: state.product,
	        route: state.route,
	        emailError: state.user && state.user.emailError,
	        passwordError: state.user && typeof state.user.passwordError === 'boolean' ? 'Password did not match this email' : state.user.passwordError
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        routeTo: function routeTo(route) {
	            return dispatch({ type: 'route:to', payload: route });
	        },
	        userUpdate: function userUpdate(payload) {
	            return dispatch({ type: 'user:update', payload: payload });
	        },
	        userLogin: function userLogin(payload) {
	            return dispatch({ type: 'user:login', payload: payload });
	        },
	        trackEvent: function trackEvent(payload) {
	            return dispatch({ type: 'ga:event', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/responsive/oranum-psychics.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderPsychic = function (psychic) {
	            var last = psychic.likes.lastIndexOf(' ');
	            var truncated_likes = psychic.likes.substring(0, last);
	            var likes = psychic.likes != truncated_likes ? truncated_likes + '…' : psychic.likes;
	
	            return (0, _preact.h)(
	                'column',
	                { 'class': 'is-12-mobile is-6' },
	                (0, _preact.h)(
	                    'a',
	                    { href: psychic.link, target: '_blank' },
	                    (0, _preact.h)('img', { src: psychic.thumb, alt: psychic.performerid }),
	                    (0, _preact.h)(
	                        'h4',
	                        null,
	                        psychic.performerid
	                    )
	                ),
	                (0, _preact.h)(
	                    'p',
	                    null,
	                    (0, _util.truncate)(likes, 70)
	                ),
	                (0, _preact.h)(
	                    'a',
	                    { 'class': 'arrow', href: psychic.link, target: '_blank' },
	                    'ENTER MY FREE CHAT ROOM'
	                )
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.getPsychics();
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var _this2 = this;
	
	            var psychics = _ref2.psychics;
	
	            if (psychics) {
	                return (0, _preact.h)(
	                    'oranum-psychics-responsive',
	                    null,
	                    (0, _preact.h)(
	                        'h3',
	                        null,
	                        'Online Spiritual Advisors',
	                        (0, _preact.h)(
	                            'span',
	                            null,
	                            'Chat now for up to 10 minutes free!'
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'row',
	                        null,
	                        psychics.map(function (psychic) {
	                            return _this2.renderPsychic(psychic);
	                        })
	                    )
	                );
	            }
	
	            return (0, _preact.h)('oranum-psychics-responsive', null);
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        psychics: state.oranum && state.oranum.psychics
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        getPsychics: function getPsychics() {
	            return dispatch({ type: 'oranum:get-psychics' });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/responsive/planet-tracker.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.requireState();
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref) {
	            var transits = _ref.transits;
	
	            if (!transits) {
	                return (0, _preact.h)('planet-tracker', null);
	            }
	
	            return (0, _preact.h)(
	                'responsive-planet-tracker',
	                null,
	                (0, _preact.h)(
	                    'h1',
	                    null,
	                    'Planet Tracker'
	                ),
	                (0, _preact.h)(
	                    'p',
	                    null,
	                    'Use this guide to see where the planets are right now! Click on the transit below to learn more:'
	                ),
	                (0, _preact.h)(
	                    'ul',
	                    null,
	                    transits.map(this.renderTransit)
	                )
	            );
	        }
	    }, {
	        key: 'renderTransit',
	        value: function renderTransit(_ref2) {
	            var planet = _ref2.planet,
	                sign = _ref2.sign,
	                date_range = _ref2.date_range;
	
	            var href = ('/astrology/planets/' + planet + '-in-' + sign).toLowerCase();
	
	            var _date_range$split = date_range.split(' – '),
	                _date_range$split2 = _slicedToArray(_date_range$split, 2),
	                from = _date_range$split2[0],
	                to = _date_range$split2[1];
	
	            from = from.match(/, 20[0-9]{2}$/) ? (0, _moment2.default)(from).format('M.D.YY') : (0, _moment2.default)(from + ' ' + (0, _moment2.default)().format('YYYY')).format('M.D.YY');
	
	            to = to.match(/, 20[0-9]{2}$/) ? (0, _moment2.default)(to).format('M.D.YY') : (0, _moment2.default)(to + ' ' + (0, _moment2.default)().format('YYYY')).format('M.D.YY');
	
	            return (0, _preact.h)(
	                'li',
	                null,
	                (0, _preact.h)(
	                    'a',
	                    { href: href },
	                    planet,
	                    ' in ',
	                    sign
	                ),
	                (0, _preact.h)(
	                    'small',
	                    null,
	                    from,
	                    ' \u2013 ',
	                    to
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        transits: state['planet-tracker'] && state['planet-tracker'].data && state['planet-tracker'].data.transits
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        requireState: function requireState() {
	            return dispatch({ type: 'planet-tracker:init' });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/responsive/promoted-content.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _promotedContentStory = __webpack_require__("./app/components/responsive/promoted-content-story.js");
	
	var _promotedContentStory2 = _interopRequireDefault(_promotedContentStory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.rowLength = 2, _this.renderStory = function (story, index) {
	            return (0, _preact.h)(_promotedContentStory2.default, { story: story, index: index, img_size: _this.props.img_size });
	        }, _this.groupRows = function (rows, story) {
	            if (rows.length) {
	                var lastRow = rows[rows.length - 1];
	                if (lastRow.length < _this.rowLength) {
	                    lastRow.push(story);
	                    return rows;
	                }
	            }
	            rows.push([story]);
	            return rows;
	        }, _this.wrapRows = function (row) {
	            return (0, _preact.h)(
	                'row',
	                { 'class': 'is-wrap' },
	                row
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	    // necessary for desktop to handle 2 line headlines.
	    // mobile doesn't care either way.
	
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.requireState(this.props.limit);
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var stories = _ref2.stories,
	                title = _ref2.title;
	
	            if (!stories) {
	                return (0, _preact.h)('promoted-content', null);
	            }
	
	            return (0, _preact.h)(
	                'responsive-promoted-content',
	                null,
	                (0, _preact.h)(
	                    'header',
	                    { 'class': 'promoted_content_header' },
	                    (0, _preact.h)(
	                        'h1',
	                        { 'class': 'text-header-2' },
	                        title || 'The Latest',
	                        (0, _preact.h)(
	                            'span',
	                            { 'class': 'text-header-6' },
	                            ' FROM TAROT.COM'
	                        )
	                    )
	                ),
	                stories.map(this.renderStory).reduce(this.groupRows, []).map(this.wrapRows)
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        stories: state.content && state.content.promoted
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        requireState: function requireState(limit) {
	            return dispatch({ type: 'content:fetchPromoted', payload: limit });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/responsive/promoted-content-story.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.trackClick = function (label, number) {
	            var action = _this.props.logged_in ? 'LI Click-' : 'LO Click-';
	
	            _this.props.trackEvent(['Top Stories', action + number, label]);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var number = this.props.index + 1;
	
	            if (this.props.story && this.props.story.title) {
	                var action = this.props.logged_in ? 'LI Impression-' : 'LO Impression-';
	
	                this.props.trackEvent(['Top Stories', action + number, this.props.story.title]);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var _this2 = this;
	
	            var story = _ref2.story,
	                index = _ref2.index,
	                img_size = _ref2.img_size;
	
	            if (!story) {
	                return (0, _preact.h)('top-story', null);
	            }
	
	            var number = index + 1;
	            var alt = story.image_alt || story.title;
	            var src = 'https://gfx.tarot.com/images/feeds/' + img_size + '/' + story.picture_frag + '-' + img_size + '.jpg';
	
	            return (0, _preact.h)(
	                'column',
	                { 'class': 'is-6 is-12-mobile' },
	                (0, _preact.h)(
	                    'responsive-promoted-content-story',
	                    null,
	                    (0, _preact.h)(
	                        'a',
	                        {
	                            'class': 'text-link-undecorated promoted_content_link',
	                            onClick: function onClick() {
	                                return _this2.trackClick(story.title, number);
	                            },
	                            href: story.url,
	                            title: story.title
	                        },
	                        (0, _preact.h)('img', { alt: alt, 'class': 'promoted_content_img', src: src }),
	                        (0, _preact.h)(
	                            'h3',
	                            { 'class': 'text-header-4 promoted_content_headline' },
	                            story.title
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        logged_in: state.user && state.user.logged_in
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        trackEvent: function trackEvent(payload) {
	            return dispatch({ type: 'ga:event', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/responsive/signup-modal.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _invisibleRecaptcha = __webpack_require__("./app/components/invisible-recaptcha.js");
	
	var _invisibleRecaptcha2 = _interopRequireDefault(_invisibleRecaptcha);
	
	var _mediaQuery = __webpack_require__("./app/media-query.js");
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this));
	
	        _this.renderPPC = function () {
	            if (!_this.props.ppc) {
	                return (0, _preact.h)(
	                    'row',
	                    null,
	                    (0, _preact.h)(
	                        'column',
	                        null,
	                        (0, _preact.h)(
	                            'label',
	                            { 'class': 'checkbox ' + (_this.state.privacyPolicyError ? 'error' : '') },
	                            (0, _preact.h)('input', {
	                                type: 'checkbox',
	                                name: 'privacy_policy',
	                                value: '1',
	                                onChange: _this.setPrivacyPolicy
	                            }),
	                            'I agree to Tarot.com\'s updated ',
	                            (0, _preact.h)(
	                                'a',
	                                { href: '/privacy-policy', target: '_blank' },
	                                'Privacy Policy'
	                            ),
	                            ' and ',
	                            (0, _preact.h)(
	                                'a',
	                                { href: '/terms-of-use', target: '_blank' },
	                                'Terms of Use'
	                            )
	                        ),
	                        _this.renderError(_this.state.privacyPolicyError)
	                    )
	                );
	            }
	
	            return null;
	        };
	
	        _this.renderRecaptcha = function () {
	            if (!_mediaQuery.MediaQuery.isMobile()) {
	                return (0, _preact.h)(_invisibleRecaptcha2.default, {
	                    ref: function ref(e) {
	                        return _this.recaptchaInstance = e;
	                    },
	                    onChange: _this.handleChanged,
	                    onExpired: _this.handleExpired
	                });
	            }
	
	            return null;
	        };
	
	        _this.renderTOS = function () {
	            if (_this.props.ppc) {
	                return (0, _preact.h)(
	                    'row',
	                    null,
	                    (0, _preact.h)(
	                        'column',
	                        null,
	                        (0, _preact.h)(
	                            'label',
	                            { 'class': 'checkbox has-text-centered' },
	                            (0, _preact.h)('br', null),
	                            'By continuing, you accept our ',
	                            (0, _preact.h)(
	                                'a',
	                                { href: '/privacy-policy', target: '_blank' },
	                                'Privacy Policy'
	                            ),
	                            '\xA0and ',
	                            (0, _preact.h)(
	                                'a',
	                                { href: '/terms-of-use', target: '_blank' },
	                                'Terms of Use'
	                            ),
	                            '.'
	                        )
	                    )
	                );
	            }
	
	            return null;
	        };
	
	        _this.close = function () {
	            _this.props.trackEvent(['Modal', 'close', 'Signup']);
	            _this.props.routeTo('');
	        };
	
	        _this.setName = function (e) {
	            _this.setState({
	                name: e.target.value
	            });
	        };
	
	        _this.setBirthdate = function (e) {
	            _this.setState({
	                birthdate: e.target.value
	            });
	        };
	
	        _this.setDHOptin = function (e) {
	            _this.setState({
	                dh_optin: e.target.checked
	            });
	        };
	
	        _this.setWRSOptin = function (e) {
	            _this.setState({
	                wrs_optin: e.target.checked
	            });
	        };
	
	        _this.setPrivacyPolicy = function (e) {
	            _this.setState({
	                privacy_policy: e.target.checked
	            });
	        };
	
	        _this.renderError = function (error) {
	            if (error) {
	                return (0, _preact.h)(
	                    'span',
	                    { 'class': 'error-message' },
	                    error
	                );
	            }
	
	            return null;
	        };
	
	        _this.validate = function () {
	            var nameError = _this.state.name ? null : 'Please enter your name.';
	            var birthdateError = _this.validateBirthdate();
	            var privacyPolicyError = null;
	
	            if (!_this.props.ppc) {
	                privacyPolicyError = _this.state.privacy_policy ? null : 'Please accept before continuing';
	            }
	
	            _this.setState({
	                nameError: nameError,
	                birthdateError: birthdateError,
	                privacyPolicyError: privacyPolicyError
	            });
	
	            if (!nameError && !birthdateError && !privacyPolicyError) {
	                var subscribe_lists = ['ipe'];
	
	                if (_this.state.dh_optin) {
	                    subscribe_lists.push('dailyhoroscope');
	                }
	
	                if (_this.state.wrs_optin) {
	                    subscribe_lists.push('weekly_love');
	                }
	
	                _this.setState({
	                    subscribe_lists: subscribe_lists
	                });
	
	                if (!_mediaQuery.MediaQuery.isMobile()) {
	                    _this.dialog.close();
	                    _this.recaptchaInstance._component.execute();
	                } else {
	                    _this.userSignup();
	                }
	            }
	        };
	
	        _this.validateBirthdate = function () {
	            if (!_this.state.birthdate) {
	                return 'Please enter your birth date';
	            } else if (_this.state.birthdate.match(/^\d{2,4}-\d{2}-\d{2}$/) || _this.state.birthdate.match(/^\d{1,2}\/\d{1,2}\/\d{2,4}$/) || _this.state.birthdate.match(/^\d{2}-\d{2}-\d{2,4}$/)) {
	                var thirteen_years_ago = (0, _moment2.default)().subtract(13, 'years');
	                if ((0, _moment2.default)(_this.state.birthdate).isAfter(thirteen_years_ago)) {
	                    return 'You must be at least 13 years of age to signup.';
	                }
	
	                return null;
	            }
	
	            return 'Birthday format is mm/dd/yyyy';
	        };
	
	        _this.handleChanged = function () {
	            _this.setState({ recaptchaCompleted: true });
	        };
	
	        _this.handleExpired = function () {
	            _this.setState({ recaptchaCompleted: false });
	        };
	
	        _this.userSignup = function () {
	            _this.props.userSignup({
	                first_name: _this.state.name,
	                display_name: _this.state.name,
	                email: _this.props.user.email,
	                password: _this.props.user.password,
	                password_verify: _this.props.user.password,
	                signup_gateway: '#signup',
	                signup_bonus: true,
	                signup_url: window.location.href,
	                account_type_id: 1,
	                award_pfero: true,
	                birth_date: (0, _moment2.default)(_this.state.birthdate).format('YYYY-MM-DD'),
	                timezone: new Date().getTimezoneOffset() / 60 * -1,
	                subscribe_lists: _this.state.subscribe_lists,
	                privacy_policy: true
	            });
	        };
	
	        if (!_mediaQuery.MediaQuery.isMobile()) {
	            _this.recaptchaInstance;
	            _this.setState({ recaptchaCompleted: false });
	        }
	
	        _this.dialog;
	
	        _this.setState({
	            name: null,
	            nameError: null,
	            email: null,
	            emailError: null,
	            birthdate: null,
	            birthdateError: null,
	            password: null,
	            password_verify: null,
	            passwordError: null,
	            dh_optin: false,
	            wrs_optin: false,
	            privacy_policy: false,
	            subscribe_lists: []
	        });
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            if (nextProps.route != this.props.route) {
	                if (this.dialog) {
	                    if (nextProps.route == 'signup' && !nextProps.user.logged_in && !this.props.user.logged_in) {
	                        if (nextProps.user.email && nextProps.user.password) {
	                            this.props.trackEvent(['Modal', 'show', 'Signup']);
	                            this.dialog.showModal();
	                            return false;
	                        }
	
	                        this.props.routeTo('login');
	                    } else if (nextProps.route == 'signup') {
	                        this.props.routeTo('');
	                    } else if (this.props.route == 'signup') {
	                        this.props.trackEvent(['Modal', 'close', 'Signup']);
	                        this.dialog.close();
	                        return false;
	                    }
	                }
	            }
	
	            if (!_mediaQuery.MediaQuery.isMobile() && !this.state.recaptchaCompleted && nextState.recaptchaCompleted) {
	                this.userSignup();
	            }
	
	            return true;
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var that = this;
	            this.dialog = document.getElementById('signup-modal');
	            dialogPolyfill.registerDialog(this.dialog); //eslint-disable-line no-undef
	
	            this.dialog.addEventListener('keydown', function (e) {
	                if (e.keyCode == 13) {
	                    _this2.validate();
	                } else if (e.keyCode == 27) {
	                    e.preventDefault();
	                    _this2.close();
	                }
	            });
	
	            this.dialog.addEventListener('click', function (e) {
	                if (e.target.tagName == 'DIALOG') {
	                    that.close();
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref) {
	            var product = _ref.product;
	
	            var title = 'Let Us Get to Know You';
	            var subtitle = 'Personalize your experience by telling us a bit about yourself…';
	            var button_text = 'ENTER';
	
	            if (product && product.type) {
	                title = 'your ' + product.type + ' awaits!';
	                button_text = ('GET MY ' + product.type + '!').toUpperCase();
	            }
	
	            return (0, _preact.h)(
	                'responsive-signup-modal',
	                null,
	                (0, _preact.h)(
	                    'dialog',
	                    { id: 'signup-modal' },
	                    (0, _preact.h)(
	                        'dialog-header',
	                        null,
	                        (0, _preact.h)(
	                            'button',
	                            { 'class': 'button-close', onClick: this.close },
	                            '\xD7'
	                        ),
	                        (0, _preact.h)(
	                            'h1',
	                            null,
	                            title
	                        ),
	                        (0, _preact.h)(
	                            'h5',
	                            null,
	                            subtitle
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'dialog-content',
	                        null,
	                        (0, _preact.h)(
	                            'row',
	                            null,
	                            (0, _preact.h)(
	                                'column',
	                                { 'class': 'is-7' },
	                                (0, _preact.h)(
	                                    'label',
	                                    null,
	                                    'Your Name'
	                                ),
	                                (0, _preact.h)('input', {
	                                    type: 'text',
	                                    'class': this.state.nameError ? 'error' : '',
	                                    onKeyup: this.setName
	                                }),
	                                this.renderError(this.state.nameError)
	                            ),
	                            (0, _preact.h)(
	                                'column',
	                                { 'class': 'is-5' },
	                                (0, _preact.h)(
	                                    'label',
	                                    null,
	                                    'Your Birth Date'
	                                ),
	                                (0, _preact.h)('input', {
	                                    type: 'date',
	                                    placeholder: 'mm/dd/yyyy',
	                                    'class': this.state.birthdateError ? 'error' : '',
	                                    onChange: this.setBirthdate
	                                }),
	                                this.renderError(this.state.birthdateError)
	                            )
	                        ),
	                        (0, _preact.h)(
	                            'row',
	                            null,
	                            (0, _preact.h)(
	                                'column',
	                                null,
	                                (0, _preact.h)(
	                                    'label',
	                                    { 'class': 'checkbox' },
	                                    (0, _preact.h)('input', {
	                                        type: 'checkbox',
	                                        name: 'dh_optin',
	                                        checked: this.state.dh_optin,
	                                        onChange: this.setDHOptin
	                                    }),
	                                    'Get my FREE daily horoscope emails'
	                                )
	                            )
	                        ),
	                        (0, _preact.h)(
	                            'row',
	                            null,
	                            (0, _preact.h)(
	                                'column',
	                                null,
	                                (0, _preact.h)(
	                                    'label',
	                                    { 'class': 'checkbox' },
	                                    (0, _preact.h)('input', {
	                                        type: 'checkbox',
	                                        name: 'wrs_optin',
	                                        checked: this.state.wrs_optin,
	                                        onChange: this.setWRSOptin
	                                    }),
	                                    'Get my FREE weekly horoscope emails'
	                                )
	                            )
	                        ),
	                        this.renderPPC(),
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'has-text-centered' },
	                            this.renderRecaptcha(),
	                            (0, _preact.h)(
	                                'button',
	                                { 'class': 'button-modal', onClick: this.validate },
	                                button_text
	                            )
	                        ),
	                        this.renderTOS()
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        route: state.route,
	        product: state.product,
	        user: state.user,
	        ppc: state.cookie && state.cookie.PRIVACY_POLICY_CONSENT
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        routeTo: function routeTo(route) {
	            return dispatch({ type: 'route:to', payload: route });
	        },
	        userSignup: function userSignup(payload) {
	            return dispatch({ type: 'user:signup-api', payload: payload });
	        },
	        trackEvent: function trackEvent(payload) {
	            return dispatch({ type: 'ga:event', payload: payload });
	        },
	        setCookie: function setCookie(payload) {
	            return dispatch({ type: 'cookie:set', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/responsive/top-bar.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _mediaQuery = __webpack_require__("./app/media-query.js");
	
	var _userMenu = __webpack_require__("./app/components/responsive/user-menu.js");
	
	var _userMenu2 = _interopRequireDefault(_userMenu);
	
	var _promoMessage = __webpack_require__("./app/components/promo-message.js");
	
	var _promoMessage2 = _interopRequireDefault(_promoMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderTopBarContent = function () {
	            if (_mediaQuery.MediaQuery.isMobile()) {
	                return (0, _preact.h)(
	                    'div',
	                    { 'class': 'tarot-top-bar-mobile' },
	                    (0, _preact.h)(_promoMessage2.default, { placement: 'topbar' }),
	                    (0, _preact.h)(
	                        'a',
	                        { href: '/', onClick: function onClick() {
	                                return _this.trackEvent('Navigation', 'Tarot.com Logo');
	                            } },
	                        _this.renderImg()
	                    ),
	                    (0, _preact.h)(
	                        'a',
	                        { 'class': 'toggle-menu', onClick: _this.toggle },
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'icon' },
	                            (0, _preact.h)('span', null),
	                            (0, _preact.h)('span', null),
	                            (0, _preact.h)('span', null),
	                            (0, _preact.h)('span', null)
	                        )
	                    )
	                );
	            }
	
	            return (0, _preact.h)(
	                'div',
	                { 'class': 'user-bar' },
	                (0, _preact.h)(_promoMessage2.default, { placement: 'topbar' }),
	                (0, _preact.h)(
	                    'a',
	                    { href: '/' },
	                    (0, _preact.h)('div', { 'class': 'tarot-main-logo' })
	                ),
	                (0, _preact.h)(_userMenu2.default, null)
	            );
	        }, _this.renderImg = function () {
	            var img_src = _this.props.code ? 'https://gfx.tarot.com/images/holiday-campaigns/' + _this.props.code + '/mobile_logo.svg' : 'https://gfx.tarot.com/images/site/logo/logo.svg';
	
	            return (0, _preact.h)('img', { 'class': 'top-bar-logo', src: img_src });
	        }, _this.toggle = function () {
	            var _ref2 = _this.props.isOpen ? ['Close', 'X'] : ['Open', 'Hamburger'],
	                _ref3 = _slicedToArray(_ref2, 2),
	                action = _ref3[0],
	                label = _ref3[1];
	
	            _this.props.trackEvent(['Navigation', action, label]);
	
	            _this.props.updateNavBar({
	                isOpen: !_this.props.isOpen,
	                currentOpen: null
	            });
	        }, _this.trackEvent = function (category, label) {
	            var action = _this.props.logged_in ? 'LI Click' : 'LO Click';
	
	            _this.props.trackEvent([category, action, label]);
	        }, _this.updateDimensions = function () {
	            _this.setState({ width: window.innerWidth });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.updateDimensions();
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.updateDimensions);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.updateDimensions);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return (0, _preact.h)(
	                'top-bar',
	                null,
	                this.renderTopBarContent()
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        isOpen: state['nav-bar-mobile'] && state['nav-bar-mobile'].isOpen,
	        logged_in: state.user && state.user.logged_in
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        trackEvent: function trackEvent(payload) {
	            return dispatch({ type: 'ga:event', payload: payload });
	        },
	        trackPromo: function trackPromo(payload) {
	            return dispatch({ type: 'promo-tracker:recordInternal', payload: payload });
	        },
	        updateNavBar: function updateNavBar(payload) {
	            return dispatch({ type: 'nav-bar-mobile:update', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/responsive/user-menu.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderMyAccount = function () {
	            var avatar = _this.props.user.avatar_url || 'https://gfx.tarot.com/images/site/tarot/ui/avatar-unknown.jpg';
	
	            if (_util.hasTouchEvents) {
	                return [(0, _preact.h)(
	                    'li',
	                    { 'class': 'my-account' },
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'avatar-mask' },
	                        (0, _preact.h)('img', { src: avatar, alt: 'User profile picture', 'class': 'avatar' })
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'account-details' },
	                        (0, _preact.h)(
	                            'h5',
	                            null,
	                            'My Account'
	                        ),
	                        (0, _preact.h)(
	                            'p',
	                            null,
	                            _this.props.user.kcs.total.toLocaleString(),
	                            ' Karma Coins',
	                            (0, _preact.h)(
	                                'sup',
	                                null,
	                                '\xAE'
	                            )
	                        )
	                    )
	                ), (0, _preact.h)(
	                    'li',
	                    { 'class': 'my-account' },
	                    (0, _preact.h)(
	                        'a',
	                        { href: '/member/profile', 'data-label': 'My Account - Karma Coins\xAE' },
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'avatar-mask' },
	                            (0, _preact.h)('img', { src: 'https://gfx.tarot.com/images/site/topbar/my-profile.svg', alt: 'My Profile' })
	                        ),
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'account-details' },
	                            (0, _preact.h)(
	                                'h5',
	                                null,
	                                'My Profile'
	                            )
	                        )
	                    )
	                )];
	            }
	
	            return (0, _preact.h)(
	                'li',
	                { 'class': 'my-account' },
	                (0, _preact.h)(
	                    'a',
	                    { href: '/member/profile', 'data-label': 'My Account - Karma Coins\xAE' },
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'avatar-mask' },
	                        (0, _preact.h)('img', { src: avatar, alt: 'User profile picture', 'class': 'avatar' })
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'account-details' },
	                        (0, _preact.h)(
	                            'h5',
	                            null,
	                            'My Account'
	                        ),
	                        (0, _preact.h)(
	                            'p',
	                            null,
	                            _this.props.user.kcs.total.toLocaleString(),
	                            ' Karma Coins',
	                            (0, _preact.h)(
	                                'sup',
	                                null,
	                                '\xAE'
	                            )
	                        )
	                    )
	                )
	            );
	        }, _this.login = function () {
	            _this.props.routeTo('login');
	        }, _this.trackClicks = function (node) {
	            if (node) {
	                var anchors = node.querySelectorAll('a');
	
	                if (anchors.length) {
	                    Array.prototype.forEach.call(anchors, function (a) {
	                        a.addEventListener('click', _this.trackClick);
	                    });
	                }
	            }
	        }, _this.trackClick = function (e) {
	            var category = 'UserBar';
	            var action = _this.props.user.logged_in ? 'LI Click' : 'LO CLick';
	            var label = e.currentTarget.dataset.label;
	
	            _this.props.trackEvent([category, action, label]);
	            _this.props.trackPromo([category, label]);
	
	            return true;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref2) {
	            var user = _ref2.user;
	
	            return (0, _preact.h)(
	                'user-menu',
	                { ref: this.trackClicks },
	                user.logged_in ? this.renderLoggedIn() : this.renderLoggedOut()
	            );
	        }
	    }, {
	        key: 'renderLoggedIn',
	        value: function renderLoggedIn() {
	            return (0, _preact.h)(
	                'ul',
	                { 'class': 'user-li' },
	                this.renderMyAccount(),
	                (0, _preact.h)(
	                    'li',
	                    { 'class': 'ub-journal no-detail-link' },
	                    (0, _preact.h)(
	                        'a',
	                        {
	                            href: 'https://product.tarot.com/about-you/journal',
	                            'data-label': 'My Journal'
	                        },
	                        (0, _preact.h)(
	                            'h5',
	                            null,
	                            'My Journal'
	                        )
	                    )
	                ),
	                (0, _preact.h)(
	                    'li',
	                    { 'class': 'my-kcs' },
	                    (0, _preact.h)(
	                        'a',
	                        { href: '/store/karma-coins', 'data-label': 'My Account - Karma Coins\xA9 Balance' },
	                        (0, _preact.h)('span', null),
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'account-details' },
	                            (0, _preact.h)(
	                                'h5',
	                                null,
	                                'Karma Coins',
	                                (0, _preact.h)(
	                                    'sup',
	                                    null,
	                                    '\xAE'
	                                )
	                            ),
	                            (0, _preact.h)(
	                                'p',
	                                null,
	                                this.props.user.kcs.total.toLocaleString(),
	                                ' Balance'
	                            )
	                        )
	                    )
	                ),
	                (0, _preact.h)(
	                    'li',
	                    { 'class': 'ub-gear no-detail-link' },
	                    (0, _preact.h)(
	                        'a',
	                        { href: '/member/settings', 'data-label': 'My Account - Settings' },
	                        (0, _preact.h)(
	                            'h5',
	                            null,
	                            'Account Settings'
	                        )
	                    )
	                ),
	                (0, _preact.h)(
	                    'li',
	                    { 'class': 'ub-logout no-detail-link' },
	                    (0, _preact.h)(
	                        'a',
	                        { href: '#logout', 'data-label': 'Log Out' },
	                        (0, _preact.h)(
	                            'h5',
	                            null,
	                            'Log Out'
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderLoggedOut',
	        value: function renderLoggedOut() {
	            return (0, _preact.h)(
	                'ul',
	                { 'class': 'user-lo' },
	                (0, _preact.h)(
	                    'li',
	                    null,
	                    (0, _preact.h)(
	                        'a',
	                        { href: '#login', 'data-label': 'Log In', onClick: this.login },
	                        'Log In'
	                    )
	                ),
	                (0, _preact.h)(
	                    'li',
	                    null,
	                    (0, _preact.h)(
	                        'a',
	                        { href: '#login', 'class': 'button', 'data-label': 'Sign Up', onClick: this.signUp },
	                        'Sign Up!'
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'signUp',
	        value: function signUp() {
	            var signup_gateway = document.querySelector('input[name="signup_gateway"]');
	
	            if (signup_gateway) {
	                signup_gateway.value = '#signup';
	            }
	
	            return true;
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        user: state.user
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        trackEvent: function trackEvent(data) {
	            return dispatch({ type: 'ga:event', payload: data });
	        },
	        trackPromo: function trackPromo(payload) {
	            return dispatch({ type: 'promo-tracker:recordInternal', payload: payload });
	        },
	        routeTo: function routeTo(route) {
	            return dispatch({ type: 'route:to', payload: route });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/sale-message.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Component = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = exports.Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var price = _ref.price;
	
	            if (!price) {
	                return (0, _preact.h)('sale-message', null);
	            }
	
	            var message = '';
	            if (price.usd && price.usd.message) {
	                message = price.usd.message;
	            } else if (price.kc && price.kc.message) {
	                message = price.kc.message;
	            } else {
	                return (0, _preact.h)('sale-message', null);
	            }
	
	            return (0, _preact.h)(
	                'sale-message',
	                null,
	                (0, _preact.h)('p', { 'class': 'sale-msg', dangerouslySetInnerHTML: { __html: message } })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        price: state.product.price
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/show-details.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this));
	
	        _this.renderDetails = function () {
	            if (_this.state.isOpen) {
	                return (0, _preact.h)(
	                    'p',
	                    { 'class': 'details' },
	                    _this.props.details
	                );
	            }
	
	            return null;
	        };
	
	        _this.toggle = function () {
	            _this.setState({ isOpen: !_this.state.isOpen });
	        };
	
	        _this.setState({ isOpen: false });
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var summary = _ref.summary;
	
	            return (0, _preact.h)(
	                'show-details',
	                { onclick: this.toggle },
	                (0, _preact.h)(
	                    'p',
	                    null,
	                    summary,
	                    ' ',
	                    (0, _preact.h)(
	                        'a',
	                        null,
	                        this.state.isOpen ? 'Show Less' : 'Learn More'
	                    )
	                ),
	                this.renderDetails()
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	exports.default = (0, _preactRedux.connect)()(Component);

/***/ },

/***/ "./app/components/smooth-scroll.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _scroll = __webpack_require__("./app/scroll.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component(props) {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this, props));
	
	        _this.click = function (e) {
	            var el = document.querySelector(_this.state.attrs.href);
	
	            if (el) {
	                e.preventDefault();
	                e.stopPropagation();
	
	                (0, _scroll.smoothScrollToElement)(el);
	
	                _this.props.routeTo(_this.state.attrs.href.replace(/^#/, ''));
	
	                return false;
	            }
	
	            return true;
	        };
	
	        var attrs = _extends({}, props); // html attributes, without any weird routeTo etc
	        delete attrs.children;
	        delete attrs.innerHTML;
	        delete attrs.routeTo;
	
	        _this.setState({ attrs: attrs });
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref, _ref2) {
	            var innerHTML = _ref.innerHTML;
	            var attrs = _ref2.attrs;
	
	            return (0, _preact.h)('a', _extends({}, attrs, {
	                dangerouslySetInnerHTML: { __html: innerHTML || '' },
	                onClick: this.click
	            }));
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        routeTo: function routeTo(hash) {
	            return dispatch({ type: 'route:to', payload: hash });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(null, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/subscription-teeup.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _productDetails = __webpack_require__("./app/components/product-details.js");
	
	var _productDetails2 = _interopRequireDefault(_productDetails);
	
	var _saleMessage = __webpack_require__("./app/components/sale-message.js");
	
	var _saleMessage2 = _interopRequireDefault(_saleMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component(props) {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this, props));
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.requireState(this.props.upc);
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref) {
	            var _this2 = this;
	
	            var message = _ref.message,
	                description = _ref.description,
	                product = _ref.product;
	
	            if (!description) {
	                return (0, _preact.h)('subscription-teeup', null);
	            }
	
	            return (0, _preact.h)(
	                'subscription-teeup',
	                null,
	                (0, _preact.h)(
	                    'p',
	                    { 'class': 'price' },
	                    product.price && product.price.usd.current < product.price.usd.original && (0, _preact.h)(
	                        's',
	                        null,
	                        '$',
	                        product.price.usd.original.toFixed(2)
	                    ),
	                    product.price && (0, _preact.h)(
	                        'span',
	                        null,
	                        '$',
	                        product.price.usd.current.toFixed(2)
	                    )
	                ),
	                (0, _preact.h)(
	                    'header',
	                    null,
	                    (0, _preact.h)(_saleMessage2.default, null),
	                    (0, _preact.h)('img', { 'class': 'product-logo',
	                        alt: 'subscription',
	                        src: 'https://gfx.tarot.com/images/site/tarot/daily-reflection-tarot-redux/icon.svg'
	                    }),
	                    (0, _preact.h)(
	                        'h1',
	                        { 'class': 'fancy-title' },
	                        description.product_name
	                    ),
	                    (0, _preact.h)(_productDetails2.default, { summary: description.medium_description, details: description.long_description })
	                ),
	                message && (0, _preact.h)('div', { 'class': 'marketing-message', dangerouslySetInnerHTML: { __html: message } }),
	                (0, _preact.h)(
	                    'form',
	                    { onSubmit: function onSubmit(e) {
	                            return _this2.submit(e);
	                        } },
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'button-container' },
	                        (0, _preact.h)(
	                            'button',
	                            { 'class': 'button button-warning' },
	                            product.submitting ? 'submitting…' : 'Purchase subscription'
	                        ),
	                        product.error && (0, _preact.h)(
	                            'p',
	                            { 'class': 'error' },
	                            product.error
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'submit',
	        value: function submit(e) {
	            e.preventDefault();
	            this.props.submit();
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        message: state.product.marketing_message,
	        description: state.product.description,
	        product: state.product
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        requireState: function requireState(upc) {
	            return dispatch({ type: 'subscription:init', payload: upc });
	        },
	        submit: function submit() {
	            return dispatch({ type: 'product:submit' });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/tarot-card-browser.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            if (!this.props.deck) {
	                this.props.requireDeck();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref) {
	            var deck = _ref.deck;
	
	            if (deck) {
	                return (0, _preact.h)(
	                    'tarot-card-browser',
	                    null,
	                    (0, _preact.h)(
	                        'h1',
	                        null,
	                        'Learn Tarot'
	                    ),
	                    (0, _preact.h)(
	                        'p',
	                        null,
	                        'Explore the meaning of any Tarot card while browsing our extensive library of Tarot decks! Start by choosing any card below:'
	                    ),
	                    (0, _preact.h)(
	                        'row',
	                        { 'class': 'is-wrap' },
	                        (0, _preact.h)(
	                            'column',
	                            { 'class': 'is-12' },
	                            (0, _preact.h)(
	                                'h5',
	                                null,
	                                'Major Arcana'
	                            )
	                        ),
	                        deck.cards.slice(0, 22).map(function (card) {
	                            return (0, _preact.h)(
	                                'column',
	                                { 'class': 'is-6' },
	                                (0, _preact.h)(
	                                    'a',
	                                    { href: '/tarot/cards/' + card.canonical_rank + '/' + deck.slug },
	                                    card.name
	                                )
	                            );
	                        })
	                    ),
	                    (0, _preact.h)('br', null),
	                    (0, _preact.h)(
	                        'row',
	                        null,
	                        (0, _preact.h)(
	                            'column',
	                            { 'class': 'is-6' },
	                            (0, _preact.h)(
	                                'h5',
	                                null,
	                                'Wands'
	                            ),
	                            (0, _preact.h)(
	                                'row',
	                                { 'class': 'is-wrap' },
	                                deck.cards.slice(22, 36).map(function (card) {
	                                    return (0, _preact.h)(
	                                        'column',
	                                        { 'class': 'is-12' },
	                                        (0, _preact.h)(
	                                            'a',
	                                            { href: '/tarot/cards/' + card.canonical_rank + '/' + deck.slug },
	                                            card.name
	                                        )
	                                    );
	                                })
	                            )
	                        ),
	                        (0, _preact.h)(
	                            'column',
	                            { 'class': 'is-6' },
	                            (0, _preact.h)(
	                                'h5',
	                                null,
	                                'Cups'
	                            ),
	                            (0, _preact.h)(
	                                'row',
	                                { 'class': 'is-wrap' },
	                                deck.cards.slice(36, 50).map(function (card) {
	                                    return (0, _preact.h)(
	                                        'column',
	                                        { 'class': 'is-12' },
	                                        (0, _preact.h)(
	                                            'a',
	                                            { href: '/tarot/cards/' + card.canonical_rank + '/' + deck.slug },
	                                            card.name
	                                        )
	                                    );
	                                })
	                            )
	                        )
	                    ),
	                    (0, _preact.h)('br', null),
	                    (0, _preact.h)(
	                        'row',
	                        null,
	                        (0, _preact.h)(
	                            'column',
	                            { 'class': 'is-6' },
	                            (0, _preact.h)(
	                                'h5',
	                                null,
	                                'Swords'
	                            ),
	                            (0, _preact.h)(
	                                'row',
	                                { 'class': 'is-wrap' },
	                                deck.cards.slice(50, 64).map(function (card) {
	                                    return (0, _preact.h)(
	                                        'column',
	                                        { 'class': 'is-12' },
	                                        (0, _preact.h)(
	                                            'a',
	                                            { href: '/tarot/cards/' + card.canonical_rank + '/' + deck.slug },
	                                            card.name
	                                        )
	                                    );
	                                })
	                            )
	                        ),
	                        (0, _preact.h)(
	                            'column',
	                            { 'class': 'is-6' },
	                            (0, _preact.h)(
	                                'h5',
	                                null,
	                                'Coins'
	                            ),
	                            (0, _preact.h)(
	                                'row',
	                                { 'class': 'is-wrap' },
	                                deck.cards.slice(64, 78).map(function (card) {
	                                    return (0, _preact.h)(
	                                        'column',
	                                        { 'class': 'is-12' },
	                                        (0, _preact.h)(
	                                            'a',
	                                            { href: '/tarot/cards/' + card.canonical_rank + '/' + deck.slug },
	                                            card.name
	                                        )
	                                    );
	                                })
	                            )
	                        )
	                    )
	                );
	            }
	
	            return (0, _preact.h)('tarot-card-browser', null);
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        deck: state.deck
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        requireDeck: function requireDeck() {
	            return dispatch({ type: 'deck:required', payload: 'universal_waite' });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/spread-card.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderTitle = function (position) {
	            if (_this.props.upc == 'yes-or-no-tarot-redux' && _this.props.spread.length > 8) {
	                //no titles on view 1
	                return null;
	            }
	
	            if (position.title) {
	                return (0, _preact.h)(
	                    'h3',
	                    { 'class': 'position-name' },
	                    position.title.replace(/\/.*/, '')
	                );
	            }
	
	            return null;
	        }, _this.renderSpreadCardContent = function (card_index) {
	            if (_this.props.card) {
	                if (_this.props.upc == 'yes-or-no-tarot-redux') {
	                    if (_this.props.spread.length > 8 && card_index == 0) {
	                        //Show the Wheel of Fortune card (pre-selected)
	                        return (0, _preact.h)('img', { alt: _this.props.card.name, src: _this.props.card.images.full });
	                    }
	
	                    //Show the back for all other cards
	                    return [(0, _preact.h)('img', {
	                        alt: 'card back',
	                        src: 'https://gfx.tarot.com/images/site/tarot/' + _this.props.upc + '/card-back.svg'
	                    }), (0, _preact.h)('p', { 'class': 'card-name' })];
	                }
	
	                return [(0, _preact.h)('img', { alt: _this.props.card.name, src: _this.props.card.images.full }), (0, _preact.h)(
	                    'p',
	                    { 'class': 'card-name' },
	                    _this.props.card.name
	                )];
	            }
	
	            return [(0, _preact.h)('div', { 'class': 'outline' }), (0, _preact.h)('p', { 'class': 'card-name' })];
	        }, _this.pick = function () {
	            var available_ids = _this.props.spread.filter(function (cardId) {
	                return cardId != 'picked';
	            });
	            var card_index = Math.floor(Math.random() * available_ids.length);
	            var card_id = available_ids[card_index];
	
	            if (_this.props.completed) {
	                if (_this.props.upc == 'yes-or-no-tarot-redux' && _this.props.spread.length > 8) {
	                    document.querySelector('button[data-action="Click-Shuffle-Cards-Button"]').click();
	                    return;
	                }
	
	                _this.props.tarotFetch();
	                return;
	            }
	
	            _this.props.tarotPicked(card_id);
	            _this.props.deckSpread(card_id);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref2) {
	            var completed = _ref2.completed,
	                next_position = _ref2.next_position,
	                position = _ref2.position,
	                card_index = _ref2.card_index,
	                house = _ref2.house;
	
	            return (0, _preact.h)(
	                'spread-card',
	                {
	                    onmousedown: this.pick,
	                    'class': !completed && next_position === card_index ? 'next' : '',
	                    house: house,
	                    orientation: position.orientation
	                },
	                this.renderTitle(position),
	                this.renderSpreadCardContent(card_index)
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        card: state.deck && state.deck.cards[props.card_id],
	        completed: state['tarot-reading'].cards.length === state['tarot-reading'].positions.length,
	        next_position: state['tarot-reading'].cards.length,
	        spread: state.deck.spread,
	        upc: state.product && state.product.teeup.code
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        tarotFetch: function tarotFetch() {
	            return dispatch({ type: 'tarot-reading:fetch' });
	        },
	        deckSpread: function deckSpread(card_id) {
	            return dispatch({ type: 'deck:spread', payload: card_id });
	        },
	        tarotPicked: function tarotPicked(card_id) {
	            return dispatch({ type: 'tarot-reading:picked', payload: { card: card_id, source: 'Layout' } });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/spread-partial.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _spreadCard = __webpack_require__("./app/components/tarot-readings/spread-card.js");
	
	var _spreadCard2 = _interopRequireDefault(_spreadCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderSpreadCard = function (position, i) {
	            var attrs = {
	                position: position,
	                card_id: _this.props.picked_cards[position.card_index],
	                card_index: position.card_index,
	                orientation: position.orientation
	            };
	
	            if (_this.props.houses) {
	                attrs.house = _this.props.houses[i];
	            }
	
	            return (0, _preact.h)(_spreadCard2.default, attrs);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            if (this.props.positions.length && this.props.houses) {
	                this.props.orientPositions();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var _this2 = this;
	
	            var positions = _ref2.positions;
	
	            return (0, _preact.h)(
	                'spread-partial',
	                null,
	                positions.map(function (position, i) {
	                    return _this2.renderSpreadCard(position, i);
	                })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        completed: state['tarot-reading'].cards.length === state['tarot-reading'].positions.length,
	        next_position: state['tarot-reading'].cards.length,
	        picked_cards: state['tarot-reading'].cards,
	        upc: state.product.teeup && state.product.teeup.code,
	        spread: state.deck && state.deck.spread
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        orientPositions: function orientPositions() {
	            return dispatch({ type: 'tarot-reading:orient' });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/spreads/analysis.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _spreadPartial = __webpack_require__("./app/components/tarot-readings/spread-partial.js");
	
	var _spreadPartial2 = _interopRequireDefault(_spreadPartial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var positions = _ref.positions;
	
	            return (0, _preact.h)(
	                'analysis-spread',
	                null,
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(0, 5).map(function (p, i) {
	                        return _extends({}, p, { card_index: i });
	                    }) }),
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(5, 10).map(function (p, i) {
	                        return _extends({}, p, { card_index: i + 5 });
	                    }) })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        positions: state['tarot-reading'].positions
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/spreads/bottom-line.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _spreadPartial = __webpack_require__("./app/components/tarot-readings/spread-partial.js");
	
	var _spreadPartial2 = _interopRequireDefault(_spreadPartial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var positions = _ref.positions;
	
	            return (0, _preact.h)(
	                'bottom-line-spread',
	                null,
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.map(function (p, i) {
	                        return _extends({}, p, { card_index: i });
	                    }) })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        positions: state['tarot-reading'].positions
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/spreads/celtic-cross.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _spreadPartial = __webpack_require__("./app/components/tarot-readings/spread-partial.js");
	
	var _spreadPartial2 = _interopRequireDefault(_spreadPartial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var positions = _ref.positions;
	
	            return (0, _preact.h)(
	                'celtic-cross-spread',
	                null,
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(0, 3).map(function (p, i) {
	                        return _extends({}, p, { card_index: i });
	                    }) }),
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(3, 6).map(function (p, i) {
	                        return _extends({}, p, { card_index: i + 3 });
	                    }) }),
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(6, 10).map(function (p, i) {
	                        return _extends({}, p, { card_index: i + 6 });
	                    }) })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        positions: state['tarot-reading'].positions
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/spreads/celtic-cross-sample.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _spreadPartial = __webpack_require__("./app/components/tarot-readings/spread-partial.js");
	
	var _spreadPartial2 = _interopRequireDefault(_spreadPartial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var positions = _ref.positions;
	
	            return (0, _preact.h)(
	                'celtic-cross-sample-spread',
	                null,
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(0, 3).map(function (p, i) {
	                        return _extends({}, p, { card_index: i });
	                    }) })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        positions: state['tarot-reading'].positions
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/spreads/heartbreak.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _spreadPartial = __webpack_require__("./app/components/tarot-readings/spread-partial.js");
	
	var _spreadPartial2 = _interopRequireDefault(_spreadPartial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var positions = _ref.positions;
	
	            return (0, _preact.h)(
	                'heartbreak-spread',
	                null,
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(0, 3).map(function (p, i) {
	                        return _extends({}, p, { card_index: i });
	                    }) })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        positions: state['tarot-reading'].positions
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/spreads/horoscope-tarot.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _spreadPartial = __webpack_require__("./app/components/tarot-readings/spread-partial.js");
	
	var _spreadPartial2 = _interopRequireDefault(_spreadPartial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderImg = function () {
	            if (_this.props.cards.length < 12) {
	                var base_url = 'https://gfx.tarot.com/images/site/tarot/horoscope-tarot-redux/';
	                var src = '' + base_url + (_this.props.cards.length + 1) + '.svg';
	
	                return (0, _preact.h)('img', { src: src, 'class': 'position-img' });
	            }
	
	            return null;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref2) {
	            var positions = _ref2.positions;
	
	            return (0, _preact.h)(
	                'horoscope-tarot-spread',
	                null,
	                this.renderImg(),
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.map(function (p, i) {
	                        return _extends({}, p, { card_index: i });
	                    }) })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        positions: state['tarot-reading'] && state['tarot-reading'].positions,
	        cards: state['tarot-reading'] && state['tarot-reading'].cards
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/spreads/karma.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _spreadPartial = __webpack_require__("./app/components/tarot-readings/spread-partial.js");
	
	var _spreadPartial2 = _interopRequireDefault(_spreadPartial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var positions = _ref.positions;
	
	            return (0, _preact.h)(
	                'karma-spread',
	                null,
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.map(function (p, i) {
	                        return _extends({}, p, { card_index: i });
	                    }) })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        positions: state['tarot-reading'].positions
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/spreads/life-cycle.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _spreadPartial = __webpack_require__("./app/components/tarot-readings/spread-partial.js");
	
	var _spreadPartial2 = _interopRequireDefault(_spreadPartial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var positions = _ref.positions;
	
	            return (0, _preact.h)(
	                'life-cycle-spread',
	                null,
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(0, 3).map(function (p, i) {
	                        return _extends({}, p, { card_index: i });
	                    }) }),
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(3, 6).map(function (p, i) {
	                        return _extends({}, p, { card_index: i + 3 });
	                    }) }),
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(6, 9).map(function (p, i) {
	                        return _extends({}, p, { card_index: i + 6 });
	                    }) })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        positions: state['tarot-reading'].positions
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/spreads/mandala.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _spreadPartial = __webpack_require__("./app/components/tarot-readings/spread-partial.js");
	
	var _spreadPartial2 = _interopRequireDefault(_spreadPartial);
	
	var _util = __webpack_require__("./app/util.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderHouseSelector = function () {
	            if (_this.props.positions.length == 1) {
	                return (0, _preact.h)(
	                    'select',
	                    { onChange: _this.changeHouse },
	                    (0, _preact.h)(
	                        'option',
	                        { disabled: true, selected: true },
	                        'Choose a House'
	                    ),
	                    _this.state.houses.map(function (house, i) {
	                        return (0, _preact.h)(
	                            'option',
	                            { value: house, selected: _this.state.house == house },
	                            (0, _util.ordinal)(i + 1) + ' House - ' + house
	                        );
	                    })
	                );
	            }
	
	            return null;
	        }, _this.changeHouse = function (e) {
	            var house = e.target.value;
	
	            _this.setState({ house: house });
	        }, _this.renderImg = function () {
	            if (_this.props.cards.length < 12) {
	                var base_url = 'https://gfx.tarot.com/images/site/tarot/mandala-tarot-redux/';
	                var image_filename = _this.props.cards.length + 1 + '.svg';
	
	                return (0, _preact.h)('img', { src: base_url + image_filename, 'class': 'position-img' });
	            }
	
	            return null;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var houses = this.props.positions.map(function (position) {
	                return position.title;
	            });
	
	            var keep = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
	
	            if (this.props.type == 'balance') {
	                keep = [1, 4, 7, 10];
	            } else if (this.props.type == 'beginnings') {
	                keep = [0, 3, 6, 9];
	            } else if (this.props.type == 'changes') {
	                keep = [2, 5, 8, 11];
	            }
	
	            var activeHouses = keep.map(function (k) {
	                return houses[k];
	            });
	
	            this.setState({
	                house: null,
	                houses: activeHouses
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var type = _ref2.type,
	                positions = _ref2.positions;
	
	            return (0, _preact.h)(
	                'mandala-spread',
	                { type: type, house: this.state.house },
	                this.renderHouseSelector(),
	                this.renderImg(),
	                (0, _preact.h)(_spreadPartial2.default, {
	                    positions: positions.map(function (p, i) {
	                        return _extends({}, p, { card_index: i });
	                    }),
	                    houses: this.state.houses
	                })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        positions: state['tarot-reading'].positions,
	        cards: state['tarot-reading'] && state['tarot-reading'].cards
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/spreads/potentials.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _spreadPartial = __webpack_require__("./app/components/tarot-readings/spread-partial.js");
	
	var _spreadPartial2 = _interopRequireDefault(_spreadPartial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var positions = _ref.positions;
	
	            return (0, _preact.h)(
	                'potentials-spread',
	                { 'class': 'clearfix' },
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(0, 3).map(function (p, i) {
	                        return _extends({}, p, { card_index: i });
	                    }) }),
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(3, 7).map(function (p, i) {
	                        return _extends({}, p, { card_index: i + 3 });
	                    }) })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        positions: state['tarot-reading'].positions
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/spreads/reconciliation.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _spreadPartial = __webpack_require__("./app/components/tarot-readings/spread-partial.js");
	
	var _spreadPartial2 = _interopRequireDefault(_spreadPartial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var positions = _ref.positions;
	
	            return (0, _preact.h)(
	                'reconciliation-spread',
	                null,
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(0, 4).map(function (p, i) {
	                        return _extends({}, p, { card_index: i });
	                    }) }),
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(4, 5).map(function (p, i) {
	                        return _extends({}, p, { card_index: i + 4 });
	                    }) })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        positions: state['tarot-reading'].positions
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/spreads/revelation.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _spreadPartial = __webpack_require__("./app/components/tarot-readings/spread-partial.js");
	
	var _spreadPartial2 = _interopRequireDefault(_spreadPartial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var positions = _ref.positions;
	
	            return (0, _preact.h)(
	                'revelation-spread',
	                null,
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(0, 3).map(function (p, i) {
	                        return _extends({}, p, { card_index: i });
	                    }) }),
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(3, 6).map(function (p, i) {
	                        return _extends({}, p, { card_index: i + 3 });
	                    }) })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        positions: state['tarot-reading'].positions
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/spreads/soulmate.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _spreadPartial = __webpack_require__("./app/components/tarot-readings/spread-partial.js");
	
	var _spreadPartial2 = _interopRequireDefault(_spreadPartial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var positions = _ref.positions;
	
	            return (0, _preact.h)(
	                'soulmate-spread',
	                null,
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(0, 2).map(function (p, i) {
	                        return _extends({}, p, { card_index: i });
	                    }) }),
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(2, 5).map(function (p, i) {
	                        return _extends({}, p, { card_index: i + 2 });
	                    }) }),
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(5, 8).map(function (p, i) {
	                        return _extends({}, p, { card_index: i + 5 });
	                    }) })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        positions: state['tarot-reading'].positions
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/spreads/star-of-david.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _spreadPartial = __webpack_require__("./app/components/tarot-readings/spread-partial.js");
	
	var _spreadPartial2 = _interopRequireDefault(_spreadPartial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var positions = _ref.positions;
	
	            return (0, _preact.h)(
	                'star-of-david-spread',
	                null,
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.map(function (p, i) {
	                        return _extends({}, p, { card_index: i });
	                    }) })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        positions: state['tarot-reading'].positions
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/spreads/timeline.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _spreadPartial = __webpack_require__("./app/components/tarot-readings/spread-partial.js");
	
	var _spreadPartial2 = _interopRequireDefault(_spreadPartial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var positions = _ref.positions;
	
	            return (0, _preact.h)(
	                'timeline-spread',
	                null,
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.map(function (p, i) {
	                        return _extends({}, p, { card_index: i });
	                    }) })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        positions: state['tarot-reading'].positions
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/spreads/tree-of-life.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _spreadPartial = __webpack_require__("./app/components/tarot-readings/spread-partial.js");
	
	var _spreadPartial2 = _interopRequireDefault(_spreadPartial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var positions = _ref.positions;
	
	            return (0, _preact.h)(
	                'tree-of-life-spread',
	                null,
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(0, 3).map(function (p, i) {
	                        return _extends({}, p, { card_index: i });
	                    }) }),
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(3, 6).map(function (p, i) {
	                        return _extends({}, p, { card_index: i + 3 });
	                    }) }),
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(6, 9).map(function (p, i) {
	                        return _extends({}, p, { card_index: i + 6 });
	                    }) }),
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(9, 10).map(function (p, i) {
	                        return _extends({}, p, { card_index: i + 9 });
	                    }) })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        positions: state['tarot-reading'].positions
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/spreads/yes-or-no.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _spreadPartial = __webpack_require__("./app/components/tarot-readings/spread-partial.js");
	
	var _spreadPartial2 = _interopRequireDefault(_spreadPartial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var positions = _ref.positions,
	                spread = _ref.spread;
	
	            if (spread.length > 8) {
	                //view 1
	                return (0, _preact.h)(
	                    'yes-or-no-spread-view-1',
	                    null,
	                    (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(0, 4).map(function (p, i) {
	                            return _extends({}, p, { card_index: i });
	                        }) }),
	                    (0, _preact.h)(_spreadPartial2.default, { positions: positions.slice(4, 8).map(function (p, i) {
	                            return _extends({}, p, { card_index: i + 4 });
	                        }) })
	                );
	            }
	
	            return (0, _preact.h)(
	                'yes-or-no-spread-view-2',
	                null,
	                (0, _preact.h)(_spreadPartial2.default, { positions: positions.map(function (p, i) {
	                        return _extends({}, p, { card_index: i });
	                    }), offset: '0' })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        positions: state['tarot-reading'].positions,
	        spread: state.deck && state.deck.spread
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/tarot-reading.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _teeup = __webpack_require__("./app/components/tarot-readings/tarot-reading/teeup.js");
	
	var _teeup2 = _interopRequireDefault(_teeup);
	
	var _sampleInterp = __webpack_require__("./app/components/tarot-readings/tarot-reading/sample-interp.js");
	
	var _sampleInterp2 = _interopRequireDefault(_sampleInterp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.trackClick = function (e) {
	            if (e.target.dataset.action) {
	                _this.props.trackEvent(e.target.dataset.action);
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            var bgImg = 'background-image: url(https://gfx.tarot.com/images/site/tarot/' + this.props.upc;
	            var styleSheet = document.createElement('style');
	            var styleRules = ['tarot-reading .icon-teeup { ' + bgImg + '/icon.svg); }', 'tarot-reading-deck-card { ' + bgImg + '/card-back.svg); }', 'tarot-reading-deck-card:hover { ' + bgImg + '/card-back-highlight.svg); }', 'tarot-reading-deck-card.shuffle { ' + bgImg + '/card-back-highlight.svg); }', 'tarot-spread .outline { ' + bgImg + '/question-grey.svg); }', 'tarot-spread spread-card.next .outline { ' + bgImg + '/question-highlight.svg); }'];
	
	            styleRules.forEach(function (rule) {
	                styleSheet.appendChild(document.createTextNode(rule));
	            });
	
	            document.head.appendChild(styleSheet);
	
	            this.props.init(this.props.upc, this.props.type);
	            var deck_name = 'universal_waite';
	
	            if (this.props.upc.match(/mandala/)) {
	                deck_name = 'mandala';
	            } else {
	                if (this.props.user.logged_in && this.props.user.favorite_deck_id && this.props.decks) {
	                    var deck = this.props.decks.filter(function (deck) {
	                        return deck.deck == _this2.props.user.favorite_deck_id;
	                    });
	
	                    if (deck && deck[0] && deck[0].deck) {
	                        deck_name = deck[0].deck;
	                    }
	                }
	            }
	
	            this.props.requireDeck(deck_name);
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var _this3 = this;
	
	            var type = _ref2.type,
	                upc = _ref2.upc;
	
	            var view = null;
	
	            if (upc == 'yes-or-no-tarot-redux') {
	                view = 'view-1';
	
	                if (this.props.spread && this.props.spread.length == 8) {
	                    view = 'view-2';
	                }
	            }
	
	            return (0, _preact.h)(
	                'tarot-reading',
	                { 'class': type, upc: upc, type: type, onclick: function onclick(e) {
	                        return _this3.trackClick(e);
	                    }, view: view },
	                this.renderReadingOrInterp()
	            );
	        }
	    }, {
	        key: 'renderReadingOrInterp',
	        value: function renderReadingOrInterp() {
	            if (this.props.sample_interps) {
	                return (0, _preact.h)(_sampleInterp2.default, { type: this.props.type });
	            }
	
	            return (0, _preact.h)(_teeup2.default, { upc: this.props.upc, type: this.props.type });
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        user: state.user,
	        deck: state.deck,
	        decks: state.decks,
	        spread: state.deck && state.deck.spread,
	        sample_interps: state['tarot-reading'].interps
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        init: function init(upc, type) {
	            return dispatch({ type: 'tarot-reading:init', payload: { upc: upc, type: type } });
	        },
	        requireDeck: function requireDeck(deck) {
	            return dispatch({ type: 'deck:required', payload: deck });
	        },
	        trackEvent: function trackEvent(action) {
	            return dispatch({ type: 'tarot-ga:event', payload: action });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/tarot-reading/teeup.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _underscore = __webpack_require__("../node_modules/underscore/underscore.js");
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _question = __webpack_require__("./app/components/tarot-readings/tarot-reading/question.js");
	
	var _question2 = _interopRequireDefault(_question);
	
	var _shuffle = __webpack_require__("./app/components/tarot-readings/tarot-reading/shuffle.js");
	
	var _shuffle2 = _interopRequireDefault(_shuffle);
	
	var _deck = __webpack_require__("./app/components/tarot-readings/tarot-reading/deck.js");
	
	var _deck2 = _interopRequireDefault(_deck);
	
	var _sampleInterp = __webpack_require__("./app/components/tarot-readings/tarot-reading/sample-interp.js");
	
	var _sampleInterp2 = _interopRequireDefault(_sampleInterp);
	
	var _tarotSpread = __webpack_require__("./app/components/tarot-readings/tarot-spread.js");
	
	var _tarotSpread2 = _interopRequireDefault(_tarotSpread);
	
	var _readingHeaderPrice = __webpack_require__("./app/components/reading-header-price.js");
	
	var _readingHeaderPrice2 = _interopRequireDefault(_readingHeaderPrice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this));
	
	        _this.renderSample = function () {
	            if (_this.props.upc.match(/sample/)) {
	                return (0, _preact.h)(
	                    'div',
	                    null,
	                    (0, _preact.h)('img', {
	                        'class': 'free-tag',
	                        src: 'https://gfx.tarot.com/images/site/tarot/' + _this.props.upc + '/corner-burst.svg',
	                        alt: 'FREE!'
	                    })
	                );
	            }
	
	            return null;
	        };
	
	        _this.renderSaleMessage = function () {
	            if (!_this.props.upsell_upc) {
	                return (0, _preact.h)('sale-message', null);
	            }
	
	            return null;
	        };
	
	        _this.renderReadingHeader = function () {
	            if (_this.props.teeup && _this.props.teeup.display_name) {
	                return (0, _preact.h)(
	                    'h1',
	                    { 'class': 'reading-header fancy-title' },
	                    _this.props.teeup.display_name
	                );
	            }
	
	            return null;
	        };
	
	        _this.renderHeaderP = function () {
	            if (_this.props.type != 'full' || _this.props.sample_interps) {
	                return null;
	            }
	
	            var subhead = null;
	
	            if (_this.props.teeup) {
	                if (_this.props.teeup.code == 'yes-or-no-tarot-redux') {
	                    subhead = _this.props.teeup.medium_description;
	                } else if (_this.props.teeup.display_caption) {
	                    subhead = _this.props.teeup.display_caption;
	                }
	
	                if (subhead) {
	                    return (0, _preact.h)(
	                        'p',
	                        null,
	                        subhead,
	                        _this.renderLearnMoreLink()
	                    );
	                }
	            }
	
	            return null;
	        };
	
	        _this.renderLearnMoreLink = function () {
	            if (_this.props.teeup.long_description) {
	                return (0, _preact.h)(
	                    'a',
	                    { href: '#', onClick: _this.toggleAccordion, 'data-action': 'Click-Learn-More' },
	                    '\xA0Learn More'
	                );
	            }
	
	            return null;
	        };
	
	        _this.renderAside = function () {
	            if (_this.state.accordionOpen) {
	                return (0, _preact.h)(
	                    'aside',
	                    { 'class': 'details' },
	                    (0, _preact.h)(
	                        'button',
	                        { onClick: _this.toggleAccordion },
	                        '\u2715'
	                    ),
	                    (0, _preact.h)(
	                        'h3',
	                        null,
	                        _this.props.teeup.display_name,
	                        ' description'
	                    ),
	                    (0, _preact.h)(
	                        'summary',
	                        null,
	                        _this.props.teeup.long_description.map(function (section) {
	                            return _this.renderSummaryP(section);
	                        })
	                    ),
	                    (0, _preact.h)('br', null),
	                    _this.renderCardDescriptions()
	                );
	            }
	
	            return null;
	        };
	
	        _this.renderCardDescriptions = function () {
	            if (_this.props.upc != 'yes-or-no-tarot-redux' && _this.props.teeup.positions[0].title && _this.props.teeup.positions[0].title) {
	                return [(0, _preact.h)(
	                    'h3',
	                    null,
	                    'Card Descriptions'
	                ), (0, _preact.h)(
	                    'dl',
	                    null,
	                    _this.props.teeup.positions.map(function (position) {
	                        return _this.renderPosition(position);
	                    })
	                )];
	            }
	
	            return null;
	        };
	
	        _this.renderSummaryP = function (section) {
	            if (section) {
	                return (0, _preact.h)('p', { dangerouslySetInnerHTML: { __html: section } });
	            }
	
	            return null;
	        };
	
	        _this.renderPosition = function (position) {
	            if (position.title && position.short_description) {
	                return (0, _preact.h)(
	                    'virtual',
	                    { 'no-reorder': true },
	                    (0, _preact.h)(
	                        'dt',
	                        null,
	                        position.title,
	                        ': '
	                    ),
	                    (0, _preact.h)(
	                        'dd',
	                        null,
	                        position.short_description
	                    ),
	                    (0, _preact.h)('br', null)
	                );
	            }
	
	            return null;
	        };
	
	        _this.renderSpreadH2 = function () {
	            if (!_this.props.completed) {
	                if (_this.props.upc == 'yes-or-no-tarot-redux' || !_this.props.next_position) {
	                    return (0, _preact.h)(
	                        'h2',
	                        { 'class': _this.props.picked_cards.length ? 'card-next inactive' : 'card-next' },
	                        'Choose card:'
	                    );
	                }
	
	                return (0, _preact.h)(
	                    'h2',
	                    { 'class': _this.props.picked_cards.length ? 'card-next inactive' : 'card-next' },
	                    'Choose ',
	                    _this.props.next_position.title,
	                    ' card:'
	                );
	            }
	
	            return (0, _preact.h)(
	                'h2',
	                { 'class': 'card-next inactive' },
	                'All Cards Chosen'
	            );
	        };
	
	        _this.renderDeckSelect = function () {
	            if (_this.props.decks && _this.props.deck.type == 'tarot') {
	                return (0, _preact.h)(
	                    'select',
	                    { onChange: _this.props.changeDeck },
	                    (0, _preact.h)(
	                        'option',
	                        { disabled: true, selected: true },
	                        'Choose a Deck'
	                    ),
	                    _this.props.decks.map(function (deck) {
	                        return deck.type == 'tarot' ? _this.renderDeckSelectOption(deck) : null;
	                    })
	                );
	            }
	
	            return null;
	        };
	
	        _this.renderDeckSelectOption = function (deck) {
	            if (deck) {
	                return (0, _preact.h)(
	                    'option',
	                    { value: deck.code },
	                    deck.name
	                );
	            }
	
	            return null;
	        };
	
	        _this.renderCaption = function () {
	            if (_this.props.type !== 'full' && _this.props.teeup && _this.props.teeup.display_caption) {
	                return (0, _preact.h)(
	                    'aside',
	                    { 'class': 'details-caption text-left' },
	                    (0, _preact.h)(
	                        'p',
	                        null,
	                        _this.props.teeup.display_caption
	                    )
	                );
	            }
	
	            return null;
	        };
	
	        _this.renderError = function () {
	            if (_this.props.error) {
	                return (0, _preact.h)(
	                    'p',
	                    { 'class': _this.props.error.remaining ? 'show' : '' },
	                    'Please choose ',
	                    _this.props.error.remaining,
	                    ' more\xA0',
	                    parseInt(_this.props.error.remaining, 10) > 1 ? 'cards' : 'card',
	                    ' from the deck above first.'
	                );
	            }
	
	            return null;
	        };
	
	        _this.renderSampleInterps = function () {
	            if (_this.props.sample_interps) {
	                return (0, _preact.h)(
	                    'section',
	                    null,
	                    _this.props.positions.map(function (position, i) {
	                        return _this.renderSampleInterp(i);
	                    })
	                );
	            }
	
	            return null;
	        };
	
	        _this.renderSampleInterp = function (i) {
	            if (i) {
	                return (0, _preact.h)(_sampleInterp2.default, { i: i });
	            }
	
	            return null;
	        };
	
	        _this.reveal = function (e) {
	            e.preventDefault();
	
	            if (_this.props.upc == 'yes-or-no-tarot-redux' && _this.props.completed) {
	                if (_this.props.deck.spread.length > 8) {
	                    //moving from view 1 to view 2
	                    //set deck.spread to picked_cards (shuffled)
	                    var cards = _underscore2.default.shuffle(_this.props.picked_cards);
	                    _this.props.spread(cards);
	
	                    //set tarot-reading.button_text to 'reveal the meaning'
	                    _this.props.buttonText('reveal the meaning');
	
	                    //empty tarot-reading.cards
	                    _this.props.cards([]);
	
	                    //hide 'choose a deck' select input
	                    document.querySelector('tarot-reading select').style.display = 'none';
	
	                    //set question subject, in new p.subject-set
	                    var questionP = document.querySelector('tarot-question p.subject'); //old p.subject
	                    if (questionP) {
	                        questionP.style.display = 'none';
	                    }
	
	                    var questionInput = document.querySelector('tarot-question input'); //old question input
	                    if (questionInput) {
	                        questionInput.style.display = 'none';
	                    }
	
	                    //new question p
	                    var subjectP = document.createElement('p');
	                    subjectP.classList.add('subject-set');
	                    subjectP.innerHTML = 'Your Question: ' + _this.props.subject;
	
	                    //add new question p to tarot-question element
	                    document.querySelector('tarot-question').appendChild(subjectP);
	
	                    //remove subheadline and 'Learn More' link
	                    document.querySelector('tarot-reading header > p').style.display = 'none';
	
	                    return false;
	                }
	            }
	
	            _this.props.fetch();
	            return false;
	        };
	
	        _this.toggleAccordion = function (e) {
	            e.preventDefault();
	            _this.setState({ accordionOpen: !_this.state.accordionOpen });
	        };
	
	        _this.setState({ accordionOpen: false });
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var upc = _ref.upc,
	                deck = _ref.deck,
	                button_text = _ref.button_text;
	
	            if (deck) {
	                return (0, _preact.h)(
	                    'tarot-reading-teeup',
	                    null,
	                    (0, _preact.h)(
	                        'section',
	                        null,
	                        this.renderSample(),
	                        this.renderSaleMessage(),
	                        (0, _preact.h)(
	                            'header',
	                            null,
	                            (0, _preact.h)(_readingHeaderPrice2.default, null),
	                            (0, _preact.h)('div', { 'class': 'icon-teeup icon-' + upc }),
	                            this.renderReadingHeader(),
	                            this.renderHeaderP()
	                        ),
	                        this.renderAside(),
	                        (0, _preact.h)(_question2.default, null)
	                    ),
	                    (0, _preact.h)(
	                        'section',
	                        null,
	                        (0, _preact.h)(_shuffle2.default, null),
	                        this.renderSpreadH2(),
	                        (0, _preact.h)(_deck2.default, { upc: upc }),
	                        this.renderDeckSelect()
	                    ),
	                    this.renderCaption(),
	                    (0, _preact.h)(_tarotSpread2.default, null),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'error' },
	                        this.renderError()
	                    ),
	                    (0, _preact.h)(
	                        'form',
	                        { onSubmit: this.reveal },
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'button-wrapper' },
	                            (0, _preact.h)(
	                                'button',
	                                {
	                                    'class': this.props.completed ? 'button-warning' : 'disabled button-warning',
	                                    'data-action': button_text == 'shuffle cards' ? 'Click-Shuffle-Cards-Button' : 'Click-Reveal-Meaning-Button'
	                                },
	                                button_text
	                            )
	                        )
	                    ),
	                    this.renderSampleInterps()
	                );
	            }
	
	            return null;
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        button_text: state.product.submitting ? 'submitting…' : state['tarot-reading'].button_text,
	        completed: state['tarot-reading'].cards.length === state['tarot-reading'].positions.length,
	        deck: state.deck,
	        decks: state.decks,
	        error: state['tarot-reading'].error,
	        next_position: state['tarot-reading'].positions[state['tarot-reading'].cards.length],
	        picked_cards: state['tarot-reading'].cards,
	        positions: state['tarot-reading'].positions,
	        sample_interps: state['tarot-reading'].sample_interps,
	        teeup: state.product.teeup,
	        upsell_upc: state.product.teeup && state.product.teeup.upsell_upc,
	        subject: state['tarot-reading'].subject || 'Unspoken'
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        changeDeck: function changeDeck(e) {
	            return dispatch({ type: 'deck:required', payload: e.target.value });
	        },
	        fetch: function fetch() {
	            return dispatch({ type: 'tarot-reading:fetch' });
	        },
	        spread: function spread(cards) {
	            return dispatch({ type: 'deck:update_spread', payload: cards });
	        },
	        buttonText: function buttonText(text) {
	            return dispatch({ type: 'tarot-reading:button_text', payload: text });
	        },
	        cards: function cards(_cards) {
	            return dispatch({ type: 'tarot-reading:cards', payload: _cards });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/tarot-reading/shuffle.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this));
	
	        _this.renderButton = function () {
	            if (_this.state.isShuffling) {
	                return (0, _preact.h)(
	                    'button',
	                    { 'class': 'shuffle-button', onClick: _this.stopShuffle },
	                    'Stop Shuffle'
	                );
	            }
	
	            return (0, _preact.h)(
	                'button',
	                { 'class': 'shuffle-button', onClick: _this.startShuffle },
	                'Shuffle Cards'
	            );
	        };
	
	        _this.stopShuffle = function () {
	            window.clearInterval(_this.state.shuffleDeck);
	            _this.setState({ isShuffling: false });
	            [].map.call(document.querySelectorAll('tarot-reading-deck-card'), function (el) {
	                el.classList.remove('shuffle');
	            });
	            _this.props.shuffleDeck();
	        };
	
	        _this.startShuffle = function () {
	            _this.setState({
	                isShuffling: true,
	                shuffleDeck: window.setInterval(_this.shuffle, 100)
	            });
	        };
	
	        _this.shuffle = function () {
	            var max = _this.props.spread.length + 1;
	            var math_random = Math.random() * (max - 1) + 1;
	            var random = Math.floor(math_random);
	            var el = $('tarot-reading-deck-card:nth-of-type(' + random + ')');
	
	            if (el) {
	                el.addClass('shuffle').delay(500).queue(function (next) {
	                    el.removeClass('shuffle');
	                    next();
	                });
	            }
	        };
	
	        _this.setState({
	            isShuffling: false,
	            shuffleDeck: null
	        });
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render() {
	            return (0, _preact.h)(
	                'tarot-reading-shuffle',
	                null,
	                this.renderButton()
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        spread: state.deck && state.deck.spread
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        shuffleDeck: function shuffleDeck() {
	            return dispatch({ type: 'tarot-reading:shuffle-deck' });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/tarot-reading/deck.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _deckCard = __webpack_require__("./app/components/tarot-readings/tarot-reading/deck-card.js");
	
	var _deckCard2 = _interopRequireDefault(_deckCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderCard = function (card_id) {
	            if (card_id) {
	                return (0, _preact.h)(_deckCard2.default, { card_id: card_id, upsell: _this.props.upsell, upc: _this.props.upc });
	            }
	
	            return null;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref2) {
	            var _this2 = this;
	
	            var spread = _ref2.spread;
	
	            return (0, _preact.h)(
	                'tarot-reading-deck',
	                null,
	                spread.map(function (card_id) {
	                    return _this2.renderCard(card_id);
	                })
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        spread: state.deck && state.deck.spread
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/tarot-reading/deck-card.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.pick = function () {
	            if (_this.props.card_id == 'picked' || _this.props.card_id === null) {
	                return;
	            }
	
	            if (_this.props.upsell) {
	                _this.props.tarotInit(_this.props.upc);
	                _this.props.tarotUpsell();
	            }
	
	            if (_this.props.completed) {
	                if (_this.props.upc == 'yes-or-no-tarot-redux' && _this.props.spread.length > 8) {
	                    document.querySelector('button[data-action="Click-Shuffle-Cards-Button"]').click();
	                    return;
	                }
	
	                if (!_this.props.upsell) {
	                    _this.props.tarotFetch();
	                    return;
	                }
	            }
	
	            _this.props.tarotPicked(_this.props.card_id);
	            _this.props.deckSpread(_this.props.card_id);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref2) {
	            var card_id = _ref2.card_id;
	
	            return (0, _preact.h)('tarot-reading-deck-card', { card_id: card_id, onmousedown: this.pick });
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        completed: state['tarot-reading'].cards.length === state['tarot-reading'].positions.length,
	        spread: state.deck.spread
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        tarotInit: function tarotInit(upc) {
	            return dispatch({ type: 'tarot-reading:init', payload: { upc: upc } });
	        },
	        tarotUpsell: function tarotUpsell() {
	            return dispatch({ type: 'tarot-reading:upsell' });
	        },
	        tarotFetch: function tarotFetch() {
	            return dispatch({ type: 'tarot-reading:fetch' });
	        },
	        tarotPicked: function tarotPicked(card_id) {
	            return dispatch({ type: 'tarot-reading:picked', payload: { card: card_id, source: 'Deck' } });
	        },
	        deckSpread: function deckSpread(card_id) {
	            return dispatch({ type: 'deck:spread', payload: card_id });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/tarot-reading/sample-interp.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _deck = __webpack_require__("./app/components/tarot-readings/tarot-reading/deck.js");
	
	var _deck2 = _interopRequireDefault(_deck);
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderPosition = function (position, i) {
	            var route_position = /^tarot-reading/.test(_this.props.route) && _this.props.route.match(/^tarot-reading\/(.+)$/)[1];
	            var className = position.position == route_position ? 'active' : '';
	            var href = '#tarot-reading/' + position.position;
	            var action = 'Click-' + position.position + '-Interp';
	            var src = 'https://gfx.tarot.com/images/site/decks/' + _this.props.deck.slug + '/full_size/' + _this.props.cards[i] + '.jpg';
	
	            return (0, _preact.h)(
	                'li',
	                { 'class': className },
	                (0, _preact.h)(
	                    'h3',
	                    { 'class': 'card-next' },
	                    position.title.replace(/\/.*/, '')
	                ),
	                (0, _preact.h)(
	                    'a',
	                    { href: href },
	                    (0, _preact.h)('img', {
	                        alt: _this.props.deck.cards[_this.props.cards[i]].name,
	                        'class': 'interp-card spread-card',
	                        'data-action': action,
	                        src: src
	                    })
	                )
	            );
	        }, _this.scrollTop = function () {
	            var elTop = $(_this.parent).offset().top;
	            var topBarHeight = $('.js-top_bar, .user_bar').outerHeight();
	            var currentScroll = $(window).scrollTop();
	            var topScroll = elTop - topBarHeight;
	
	            if (currentScroll > topScroll) {
	                window.scrollTo(0, topScroll);
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref2) {
	            var deck = _ref2.deck,
	                user = _ref2.user,
	                positions = _ref2.positions,
	                cards = _ref2.cards,
	                interps = _ref2.interps,
	                route = _ref2.route,
	                teeup = _ref2.teeup;
	
	            var position = /^tarot-reading/.test(route) && route.match(/^tarot-reading\/(.+)$/)[1];
	            var current = positions.map(function (i) {
	                return i.position;
	            }).indexOf(position);
	
	            if (deck && interps && cards && positions.length && current !== -1) {
	                var next = current < cards.length - 1 ? current + 1 : 0;
	                var prev = current == 0 ? cards.length - 1 : current - 1;
	                var nextCard = cards[next];
	                var prevCard = cards[prev];
	                var attribution_href = '/tarot/decks/' + deck.slug;
	                var nav_previous_href = '#tarot-reading/' + positions[prev].position;
	                var nav_next_href = '#tarot-reading/' + positions[next].position;
	
	                return (0, _preact.h)(
	                    'tarot-reading-sample-interp',
	                    null,
	                    (0, _preact.h)(
	                        'header',
	                        null,
	                        (0, _preact.h)(
	                            'time',
	                            { 'class': 'pre-header', dateTime: (0, _moment2.default)().toString },
	                            (0, _moment2.default)().format('MMMM Do, YYYY')
	                        ),
	                        (0, _preact.h)(
	                            'h1',
	                            { 'class': 'reading-header fancy-title' },
	                            user.username,
	                            '\'s Tarot Reading'
	                        ),
	                        (0, _preact.h)(
	                            'p',
	                            { 'class': 'subject-set' },
	                            'your question: ',
	                            this.props.subject || 'unspoken'
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'section',
	                        null,
	                        (0, _preact.h)(
	                            'ol',
	                            { 'class': 'interp' },
	                            positions.map(this.renderPosition)
	                        ),
	                        (0, _preact.h)(
	                            'p',
	                            { 'class': 'copyright attribution clear' },
	                            (0, _preact.h)(
	                                'a',
	                                { href: attribution_href },
	                                deck.name
	                            ),
	                            ' deck ',
	                            deck.deck_vendor_copyright
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'section',
	                        { 'class': 'interp-main' },
	                        (0, _preact.h)(
	                            'h1',
	                            { 'class': 'interp-main-header' },
	                            deck.cards[cards[current]].name
	                        ),
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'interp-header' },
	                            (0, _preact.h)(
	                                'h2',
	                                null,
	                                interps[current].position_name,
	                                ': '
	                            ),
	                            (0, _preact.h)(
	                                'p',
	                                { 'class': 'interp-header' },
	                                interps[current].interp_header
	                            )
	                        ),
	                        (0, _preact.h)('p', { dangerouslySetInnerHTML: { __html: interps[current].interp } }),
	                        (0, _preact.h)(
	                            'nav',
	                            null,
	                            (0, _preact.h)(
	                                'ul',
	                                null,
	                                (0, _preact.h)(
	                                    'li',
	                                    { 'class': 'nav-previous' },
	                                    (0, _preact.h)(
	                                        'a',
	                                        {
	                                            href: nav_previous_href,
	                                            'class': 'text-link-undecorated',
	                                            'data-action': 'Click-Last-Card'
	                                        },
	                                        (0, _preact.h)(
	                                            'h5',
	                                            null,
	                                            'Last Card:'
	                                        ),
	                                        (0, _preact.h)(
	                                            'span',
	                                            { 'class': 'text-link', 'data-action': 'Click-Last-Card' },
	                                            deck.cards[prevCard].name
	                                        )
	                                    )
	                                ),
	                                (0, _preact.h)(
	                                    'li',
	                                    { 'class': 'nav-next', 'data-action': 'Click-Next-Card' },
	                                    (0, _preact.h)(
	                                        'a',
	                                        { href: nav_next_href, 'class': 'text-link-undecorated' },
	                                        (0, _preact.h)(
	                                            'h5',
	                                            null,
	                                            'Next Card:'
	                                        ),
	                                        (0, _preact.h)(
	                                            'span',
	                                            { 'class': 'text-link', 'data-action': 'Click-Last-Card' },
	                                            deck.cards[nextCard].name
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'section',
	                        null,
	                        (0, _preact.h)('br', null),
	                        (0, _preact.h)(
	                            'h1',
	                            { 'class': 'fancy-title' },
	                            'Need More Clarity?'
	                        ),
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'upsell' },
	                            (0, _preact.h)(
	                                'p',
	                                null,
	                                'Continue your reading by selecting your final 7 cards:'
	                            ),
	                            (0, _preact.h)(
	                                'p',
	                                { 'class': 'card-next' },
	                                'choose recent past card:'
	                            ),
	                            (0, _preact.h)(
	                                'a',
	                                { href: '#tarot-reading/celtic-cross', 'data-action': 'Click-Upsell-Deck' },
	                                (0, _preact.h)(_deck2.default, { spread: deck.spread, upsell: true, upc: teeup.upsell_upc })
	                            )
	                        )
	                    )
	                );
	            }
	
	            return null;
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        deck: state.deck,
	        user: state.user,
	        subject: state['tarot-reading'].subject,
	        positions: state['tarot-reading'].positions,
	        cards: state['tarot-reading'].cards,
	        interps: state['tarot-reading'].interps,
	        route: state.route,
	        teeup: state.product.teeup
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/tarot-readings/tarot-spread.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _analysis = __webpack_require__("./app/components/tarot-readings/spreads/analysis.js");
	
	var _analysis2 = _interopRequireDefault(_analysis);
	
	var _bottomLine = __webpack_require__("./app/components/tarot-readings/spreads/bottom-line.js");
	
	var _bottomLine2 = _interopRequireDefault(_bottomLine);
	
	var _celticCrossSample = __webpack_require__("./app/components/tarot-readings/spreads/celtic-cross-sample.js");
	
	var _celticCrossSample2 = _interopRequireDefault(_celticCrossSample);
	
	var _celticCross = __webpack_require__("./app/components/tarot-readings/spreads/celtic-cross.js");
	
	var _celticCross2 = _interopRequireDefault(_celticCross);
	
	var _heartbreak = __webpack_require__("./app/components/tarot-readings/spreads/heartbreak.js");
	
	var _heartbreak2 = _interopRequireDefault(_heartbreak);
	
	var _horoscopeTarot = __webpack_require__("./app/components/tarot-readings/spreads/horoscope-tarot.js");
	
	var _horoscopeTarot2 = _interopRequireDefault(_horoscopeTarot);
	
	var _karma = __webpack_require__("./app/components/tarot-readings/spreads/karma.js");
	
	var _karma2 = _interopRequireDefault(_karma);
	
	var _lifeCycle = __webpack_require__("./app/components/tarot-readings/spreads/life-cycle.js");
	
	var _lifeCycle2 = _interopRequireDefault(_lifeCycle);
	
	var _mandala = __webpack_require__("./app/components/tarot-readings/spreads/mandala.js");
	
	var _mandala2 = _interopRequireDefault(_mandala);
	
	var _potentials = __webpack_require__("./app/components/tarot-readings/spreads/potentials.js");
	
	var _potentials2 = _interopRequireDefault(_potentials);
	
	var _reconciliation = __webpack_require__("./app/components/tarot-readings/spreads/reconciliation.js");
	
	var _reconciliation2 = _interopRequireDefault(_reconciliation);
	
	var _revelation = __webpack_require__("./app/components/tarot-readings/spreads/revelation.js");
	
	var _revelation2 = _interopRequireDefault(_revelation);
	
	var _soulmate = __webpack_require__("./app/components/tarot-readings/spreads/soulmate.js");
	
	var _soulmate2 = _interopRequireDefault(_soulmate);
	
	var _starOfDavid = __webpack_require__("./app/components/tarot-readings/spreads/star-of-david.js");
	
	var _starOfDavid2 = _interopRequireDefault(_starOfDavid);
	
	var _timeline = __webpack_require__("./app/components/tarot-readings/spreads/timeline.js");
	
	var _timeline2 = _interopRequireDefault(_timeline);
	
	var _treeOfLife = __webpack_require__("./app/components/tarot-readings/spreads/tree-of-life.js");
	
	var _treeOfLife2 = _interopRequireDefault(_treeOfLife);
	
	var _yesOrNo = __webpack_require__("./app/components/tarot-readings/spreads/yes-or-no.js");
	
	var _yesOrNo2 = _interopRequireDefault(_yesOrNo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TarotSpread = function (_Component) {
	    _inherits(TarotSpread, _Component);
	
	    function TarotSpread() {
	        _classCallCheck(this, TarotSpread);
	
	        return _possibleConstructorReturn(this, (TarotSpread.__proto__ || Object.getPrototypeOf(TarotSpread)).apply(this, arguments));
	    }
	
	    _createClass(TarotSpread, [{
	        key: 'render',
	
	        /* eslint-disable complexity */
	        value: function render(_ref) {
	            var positions = _ref.positions,
	                upc = _ref.upc;
	
	            var Spread = null;
	            var attrs = {};
	
	            if (positions.length == 12) {
	                if (upc.match(/mandala/)) {
	                    Spread = _mandala2.default;
	                } else {
	                    Spread = _horoscopeTarot2.default;
	                }
	            } else if (positions.length == 10) {
	                if (upc.match(/analysis/)) {
	                    Spread = _analysis2.default;
	                } else if (upc.match(/tree-of-life/)) {
	                    Spread = _treeOfLife2.default;
	                } else {
	                    Spread = _celticCross2.default;
	                }
	            } else if (positions.length == 9) {
	                Spread = _lifeCycle2.default;
	            } else if (positions.length == 8) {
	                if (upc.match(/soulmate/)) {
	                    Spread = _soulmate2.default;
	                } else {
	                    Spread = _yesOrNo2.default;
	                }
	            } else if (positions.length == 7) {
	                Spread = _potentials2.default;
	            } else if (positions.length == 6) {
	                if (upc.match(/star-of-david/)) {
	                    Spread = _starOfDavid2.default;
	                } else {
	                    Spread = _revelation2.default;
	                }
	            } else if (positions.length == 5) {
	                if (upc.match(/karma/)) {
	                    Spread = _karma2.default;
	                } else if (upc.match(/timeline/)) {
	                    Spread = _timeline2.default;
	                } else if (upc.match(/reconciliation/)) {
	                    Spread = _reconciliation2.default;
	                } else {
	                    Spread = _bottomLine2.default;
	                }
	            } else if (positions.length == 4) {
	                Spread = _mandala2.default;
	                if (upc.match(/balance/)) {
	                    attrs.type = 'balance';
	                } else if (upc.match(/beginnings/)) {
	                    attrs.type = 'beginnings';
	                } else if (upc.match(/changes/)) {
	                    attrs.type = 'changes';
	                }
	            } else if (positions.length == 3) {
	                if (upc.match(/heartbreak/)) {
	                    Spread = _heartbreak2.default;
	                } else {
	                    Spread = _celticCrossSample2.default;
	                }
	            } else if (positions.length == 1) {
	                Spread = _mandala2.default;
	                attrs.type = 'one-card';
	            } else {
	                Spread = _celticCrossSample2.default;
	            }
	
	            return (0, _preact.h)(
	                'tarot-spread',
	                null,
	                (0, _preact.h)(Spread, attrs)
	            );
	        }
	        /* eslint-enable complexity */
	
	    }]);
	
	    return TarotSpread;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        positions: state['tarot-reading'].positions,
	        upc: state.product.teeup && state.product.teeup.code
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(TarotSpread);

/***/ },

/***/ "./app/components/tarot-readings/tarot-reading/sample-interp-item.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this));
	
	        _this.renderInterp = function (i) {
	            if (_this.props.sample_interps[i]) {
	                return (0, _preact.h)(
	                    'div',
	                    { 'class': 'interp-accordion', onClick: _this.toggle },
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'flow-root', 'data-action': 'Click-' + _this.props.teeup.positions[i].title + '-Interp' },
	                        (0, _preact.h)('img', {
	                            'class': 'interp-thumb left',
	                            src: _this.props.deck.cards[_this.props.picked_cards[i]].images.table,
	                            alt: _this.props.deck.cards[_this.props.picked_cards[i]].name
	                        }),
	                        (0, _preact.h)(
	                            'h1',
	                            null,
	                            _this.props.sample_interps[i].position_name
	                        ),
	                        (0, _preact.h)(
	                            'h2',
	                            null,
	                            _this.props.deck.cards[_this.props.picked_cards[i]].name
	                        )
	                    ),
	                    _this.renderInterpContent(i)
	                );
	            }
	
	            return (0, _preact.h)(
	                'div',
	                { 'class': 'position-description' },
	                (0, _preact.h)(
	                    'div',
	                    { 'class': 'flow-root' },
	                    (0, _preact.h)('img', {
	                        src: 'https://gfx.tarot.com/images/site/tarot/free-tarot-reading/question-grey.svg',
	                        'class': 'position-thumb left'
	                    }),
	                    (0, _preact.h)(
	                        'div',
	                        null,
	                        (0, _preact.h)(
	                            'h2',
	                            null,
	                            _this.props.teeup.positions[i].title
	                        ),
	                        (0, _preact.h)(
	                            'p',
	                            null,
	                            _this.props.teeup.positions[i].seo_description
	                        )
	                    )
	                )
	            );
	        };
	
	        _this.renderInterpContent = function (i) {
	            if (_this.state.isOpen) {
	                return (0, _preact.h)(
	                    'div',
	                    { 'class': 'flow-root' },
	                    (0, _preact.h)('img', {
	                        'class': 'interp-card left',
	                        src: _this.props.deck.cards[_this.props.picked_cards[i]].images.full,
	                        alt: _this.props.deck.cards[_this.props.picked_cards[i]].name
	                    }),
	                    (0, _preact.h)(
	                        'h3',
	                        null,
	                        _this.props.sample_interps[i].interp_header
	                    ),
	                    (0, _preact.h)('p', {
	                        'class': 'interp-description',
	                        dangerouslySetInnerHTML: { __html: _this.props.sample_interps[i].interp }
	                    })
	                );
	            }
	
	            return null;
	        };
	
	        _this.toggle = function () {
	            _this.setState({ isOpen: !_this.state.isOpen });
	        };
	
	        _this.setState({
	            isOpen: false
	        });
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var i = _ref.i;
	
	            return (0, _preact.h)(
	                'tarot-reading-sample-interp-item',
	                { 'class': 'interp-item' },
	                this.renderInterp(i)
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        sample_interps: state['tarot-reading'].interps,
	        teeup: state.product.teeup,
	        deck: state.deck,
	        picked_cards: state['tarot-reading'].cards
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/tarot-top-bar.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.toggle = function () {
	            var _ref2 = _this.props.isOpen ? ['Close', 'X'] : ['Open', 'Hamburger'],
	                _ref3 = _slicedToArray(_ref2, 2),
	                action = _ref3[0],
	                label = _ref3[1];
	
	            _this.props.trackEvent(['Navigation', action, label]);
	            _this.props.updateNavBar({
	                isOpen: !_this.props.isOpen,
	                currentOpen: null
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render() {
	            return (0, _preact.h)(
	                'tarot-top-bar',
	                { 'class': 'js-top_bar' },
	                (0, _preact.h)(
	                    'a',
	                    { href: '/' },
	                    this.renderImg()
	                ),
	                (0, _preact.h)(
	                    'a',
	                    { 'class': 'js-menu_toggle toggle_menu', onClick: this.toggle },
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'icon' },
	                        (0, _preact.h)('span', null),
	                        (0, _preact.h)('span', null),
	                        (0, _preact.h)('span', null),
	                        (0, _preact.h)('span', null)
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderImg',
	        value: function renderImg() {
	            return (0, _preact.h)('img', { 'class': 'top_bar_logo', src: 'https://gfx.tarot.com/images/site/logo/logo.svg' });
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        isOpen: state['nav-bar-mobile'] && state['nav-bar-mobile'].isOpen
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        trackEvent: function trackEvent(payload) {
	            return dispatch({ type: 'ga:event', payload: payload });
	        },
	        trackPromo: function trackPromo(payload) {
	            return dispatch({ type: 'promo-tracker:recordInternal', payload: payload });
	        },
	        updateNavBar: function updateNavBar(payload) {
	            return dispatch({ type: 'nav-bar-mobile:update', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/today-module-nav.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this));
	
	        _this.trackClick = function (e) {
	            var category = 'Daily Page Tabs';
	            var action = _this.props.logged_in ? 'LI Click' : 'LO Click';
	            var label = e.target.dataset.label;
	
	            _this.props.trackEvent([category, action, label]);
	        };
	
	        _this.setState({
	            sections: [{
	                name: 'Horoscope',
	                mode: 'daily',
	                url: '/daily-horoscope'
	            }, {
	                name: 'Love',
	                mode: 'love',
	                url: '/daily-love-horoscope'
	            }, {
	                name: 'Tarot',
	                mode: 'tarot',
	                url: '/daily-tarot-card'
	            }, {
	                name: 'Number',
	                mode: 'number',
	                url: '/daily-number'
	            }, {
	                name: 'Hexagram',
	                mode: 'hexagram',
	                url: '/daily-hexagram'
	            }, {
	                name: 'Psychic',
	                mode: 'psychic',
	                url: '/daily-psychic-tip'
	            }]
	        });
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var _this2 = this;
	
	            var mode = _ref.mode;
	
	            return (0, _preact.h)(
	                'today-module-nav',
	                null,
	                (0, _preact.h)(
	                    'nav',
	                    { variant: mode },
	                    this.state.sections.map(function (section) {
	                        var category = 'Daily Page Tabs';
	                        var action = _this2.props.logged_in ? 'LI Impression' : 'LO Impression';
	                        var label = section.name;
	
	                        _this2.props.trackEvent([category, action, label]);
	                        return (0, _preact.h)(
	                            'a',
	                            {
	                                'class': '' + section.mode + (mode == section.mode ? ' active' : ''),
	                                href: section.url,
	                                onClick: _this2.trackClick,
	                                'data-label': section.name
	                            },
	                            section.name
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        logged_in: state.user && state.user.logged_in
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        trackEvent: function trackEvent(payload) {
	            return dispatch({ type: 'ga:event', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/today-user-nav.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderLinks = function () {
	            var everyone_link_active = false;
	            var everyone_link = _this.props.everyone_link || '#everyone';
	            var you_link = _this.props.you_link || '#you';
	
	            if (_this.props.variant == 'number') {
	                return _this.renderLink('you active', you_link, 'For You');
	            } else if (/general/.test(document.location.pathname) || !_this.props.logged_in) {
	                everyone_link_active = true;
	            } else if (_this.props.variant == 'tarot' || _this.props.variant == 'hexagram') {
	                if (!_this.props.route || _this.props.route == 'everyone') {
	                    everyone_link_active = true;
	                }
	            }
	
	            return [_this.renderLink('everyone ' + (everyone_link_active ? 'active' : ''), everyone_link, 'For Everyone'), _this.renderLink('you ' + (everyone_link_active ? '' : 'active'), you_link, 'For You')];
	        }, _this.renderLink = function (className, href, label) {
	            var variant = _this.props.variant == 'water' || _this.props.variant == 'air' ? 'horoscope' : _this.props.variant;
	
	            var category = 'Daily Page Tabs';
	            var action = _this.props.logged_in ? 'LI Impression' : 'LO Impression';
	            var gaLabel = variant.charAt(0).toUpperCase() + variant.slice(1) + ':' + label;
	
	            _this.props.trackEvent([category, action, gaLabel]);
	
	            return (0, _preact.h)(
	                'a',
	                { 'class': className, href: href, 'data-label': label, onClick: _this.trackClick },
	                label
	            );
	        }, _this.trackClick = function (e) {
	            var variant = _this.props.variant == 'water' || _this.props.variant == 'air' ? 'horoscope' : _this.props.variant;
	
	            var category = 'Daily Page Tabs';
	            var action = _this.props.logged_in ? 'LI Click' : 'LO Click';
	            var label = variant.charAt(0).toUpperCase() + variant.slice(1) + ':' + e.target.dataset.label;
	
	            _this.props.trackEvent([category, action, label]);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref2) {
	            var variant = _ref2.variant;
	
	            return (0, _preact.h)(
	                'today-user-nav',
	                { variant: variant },
	                (0, _preact.h)(
	                    'nav',
	                    { variant: variant },
	                    this.renderLinks()
	                )
	            );
	        }
	
	        /* eslint-disable complexity */
	
	        /* eslint-enable complexity */
	
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        route: state.route,
	        logged_in: state.user && state.user.logged_in
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        trackEvent: function trackEvent(payload) {
	            return dispatch({ type: 'ga:event', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/user/login-modal.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.close = function (e) {
	            e.preventDefault();
	            _this.props.routeTo('');
	        }, _this.submit = function (e) {
	            e.preventDefault();
	            var form = e.target;
	            var email = form.querySelector('input[type="email"]').value;
	            var password = form.querySelector('input[type="password"]').value;
	            var validEmail = _this.isValidEmail(email);
	            var validPassword = password.length > 3;
	
	            if (validEmail && validPassword) {
	                _this.props.userUpdate({ emailError: null, passwordError: null });
	                _this.props.userLogin({ email: email, password: password });
	            } else {
	                if (validEmail) {
	                    _this.props.userUpdate({ emailError: null });
	                } else {
	                    _this.props.userUpdate({ emailError: 'Please enter a valid email.' });
	                }
	
	                if (validPassword) {
	                    _this.props.userUpdate({ passwordError: null });
	                } else {
	                    _this.props.userUpdate({ passwordError: 'Please enter a password longer than 3 characters.' });
	                }
	            }
	        }, _this.keyup = function (e) {
	            if (e.keyCode == 27 && _this.props.isOpen) {
	                _this.props.routeTo('');
	            }
	        }, _this.renderHeader = function () {
	            if (_this.props.product) {
	                return (0, _preact.h)(
	                    'header',
	                    null,
	                    (0, _preact.h)(
	                        'h1',
	                        null,
	                        _this.props.h1Text
	                    ),
	                    (0, _preact.h)(
	                        'h2',
	                        null,
	                        'Log in or sign up below for your ',
	                        _this.props.product.type,
	                        '! It\'s easy!'
	                    )
	                );
	            }
	
	            return (0, _preact.h)(
	                'header',
	                null,
	                (0, _preact.h)(
	                    'h1',
	                    null,
	                    'Welcome Back!'
	                ),
	                (0, _preact.h)(
	                    'h2',
	                    null,
	                    'Sign in to Tarot.com'
	                )
	            );
	        }, _this.renderError = function () {
	            var error = _this.props.emailError ? _this.props.emailError : _this.props.passwordError;
	
	            if (error) {
	                return (0, _preact.h)(
	                    'div',
	                    { 'class': 'error' },
	                    error
	                );
	            }
	
	            return null;
	        }, _this.isValidEmail = function (email) {
	            var atpos = email.indexOf('@');
	            var dotpos = email.lastIndexOf('.');
	            return !(atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= email.length);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.reposition();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.reposition();
	        }
	    }, {
	        key: 'reposition',
	        value: function reposition() {
	            var modalInner = document.querySelector('login-modal .modal-inner');
	            var top = window.pageYOffset + window.innerHeight / 2 - modalInner.offsetHeight / 2;
	            modalInner.style.top = top + 'px';
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var passwordError = _ref2.passwordError,
	                emailError = _ref2.emailError,
	                buttonText = _ref2.buttonText,
	                isOpen = _ref2.isOpen;
	
	            var className = isOpen ? 'open' : null;
	            var emailErrorClassName = emailError ? 'error' : null;
	            var passwordErrorClassName = passwordError ? 'error' : null;
	
	            return (0, _preact.h)(
	                'login-modal',
	                { 'class': className },
	                (0, _preact.h)('a', { 'class': 'backdrop', href: '#', onClick: this.close }),
	                (0, _preact.h)(
	                    'aside',
	                    { 'class': 'modal-inner' },
	                    this.renderHeader(),
	                    this.renderError(),
	                    (0, _preact.h)(
	                        'form',
	                        { onSubmit: this.submit, onKeyUp: this.keyup },
	                        (0, _preact.h)(
	                            'label',
	                            { 'class': emailErrorClassName },
	                            'Your Email',
	                            (0, _preact.h)('input', {
	                                'data-action': 'Type-Email',
	                                'data-category': 'Three-Card-Reading',
	                                'data-label': 'Login',
	                                'data-ga-event': true,
	                                name: 'email',
	                                type: 'email'
	                            })
	                        ),
	                        (0, _preact.h)(
	                            'label',
	                            { 'class': passwordErrorClassName },
	                            'Password',
	                            (0, _preact.h)('input', {
	                                'data-action': 'Type-Password',
	                                'data-category': 'Three-Card-Reading',
	                                'data-label': 'Login',
	                                'data-ga-event': true,
	                                maxLength: '15',
	                                name: 'password',
	                                type: 'password'
	                            })
	                        ),
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'modal-button-bar' },
	                            (0, _preact.h)(
	                                'a',
	                                { 'class': 'forgot-password', target: '_blank', href: '/password-reset' },
	                                'Forgot your password?'
	                            ),
	                            (0, _preact.h)(
	                                'button',
	                                { 'class': 'button button-warning' },
	                                buttonText
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        passwordError: state.user && typeof state.user.passwordError === 'boolean' ? 'Password did not match this email' : state.user.passwordError,
	        emailError: state.user && state.user.emailError,
	        product: state.product,
	        buttonText: state.product ? 'Get my ' + state.product.type + '!' : 'Log In!',
	        h1Text: state.product.type && state.product.type.match(/s$/) ? 'Your ' + state.product.type + ' Await!' : 'Your ' + state.product.type + ' Awaits!',
	        isOpen: state.route === 'login'
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        routeTo: function routeTo(route) {
	            return dispatch({ type: 'route:to', payload: route });
	        },
	        userUpdate: function userUpdate(payload) {
	            return dispatch({ type: 'user:update', payload: payload });
	        },
	        userLogin: function userLogin(payload) {
	            return dispatch({ type: 'user:login', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/user/menu.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _util = __webpack_require__("./app/util.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderMyAccount = function () {
	            var avatar = _this.props.user.avatar_url || 'https://gfx.tarot.com/images/site/tarot/ui/avatar-unknown.jpg';
	
	            if (_util.hasTouchEvents) {
	                return [(0, _preact.h)(
	                    'li',
	                    { 'class': 'my-account' },
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'avatar-mask' },
	                        (0, _preact.h)('img', { src: avatar, alt: 'User profile picture', 'class': 'avatar' })
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'account-details' },
	                        (0, _preact.h)(
	                            'h5',
	                            null,
	                            'My Account'
	                        ),
	                        (0, _preact.h)(
	                            'p',
	                            null,
	                            _this.props.user.kcs.total.toLocaleString(),
	                            ' Karma Coins',
	                            (0, _preact.h)(
	                                'sup',
	                                null,
	                                '\xAE'
	                            )
	                        )
	                    )
	                ), (0, _preact.h)(
	                    'li',
	                    { 'class': 'my-account' },
	                    (0, _preact.h)(
	                        'a',
	                        { href: '/member/profile', 'data-label': 'My Account - Karma Coins\xAE' },
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'avatar-mask' },
	                            (0, _preact.h)('img', { src: 'https://gfx.tarot.com/images/site/topbar/my-profile.svg', alt: 'My Profile' })
	                        ),
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'account-details' },
	                            (0, _preact.h)(
	                                'h5',
	                                null,
	                                'My Profile'
	                            )
	                        )
	                    )
	                )];
	            }
	
	            return (0, _preact.h)(
	                'li',
	                { 'class': 'my-account' },
	                (0, _preact.h)(
	                    'a',
	                    { href: '/member/profile', 'data-label': 'My Account - Karma Coins\xAE' },
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'avatar-mask' },
	                        (0, _preact.h)('img', { src: avatar, alt: 'User profile picture', 'class': 'avatar' })
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'account-details' },
	                        (0, _preact.h)(
	                            'h5',
	                            null,
	                            'My Account'
	                        ),
	                        (0, _preact.h)(
	                            'p',
	                            null,
	                            _this.props.user.kcs.total.toLocaleString(),
	                            ' Karma Coins',
	                            (0, _preact.h)(
	                                'sup',
	                                null,
	                                '\xAE'
	                            )
	                        )
	                    )
	                )
	            );
	        }, _this.login = function () {
	            _this.props.routeTo('login');
	        }, _this.trackClicks = function (node) {
	            if (node) {
	                var anchors = node.querySelectorAll('a');
	
	                if (anchors.length) {
	                    Array.prototype.forEach.call(anchors, function (a) {
	                        a.addEventListener('click', _this.trackClick);
	                    });
	                }
	            }
	        }, _this.trackClick = function (e) {
	            var category = 'UserBar';
	            var action = _this.props.user.logged_in ? 'LI Click' : 'LO CLick';
	            var label = e.currentTarget.dataset.label;
	
	            _this.props.trackEvent([category, action, label]);
	            _this.props.trackPromo([category, label]);
	
	            return true;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref2) {
	            var user = _ref2.user;
	
	            return (0, _preact.h)(
	                'user-menu',
	                { ref: this.trackClicks },
	                user.logged_in ? this.renderLoggedIn() : this.renderLoggedOut()
	            );
	        }
	    }, {
	        key: 'renderLoggedIn',
	        value: function renderLoggedIn() {
	            return (0, _preact.h)(
	                'ul',
	                { 'class': 'user-li' },
	                this.renderMyAccount(),
	                (0, _preact.h)(
	                    'li',
	                    { 'class': 'ub-journal no-detail-link' },
	                    (0, _preact.h)(
	                        'a',
	                        {
	                            href: 'https://product.tarot.com/about-you/journal',
	                            'data-label': 'My Journal'
	                        },
	                        (0, _preact.h)(
	                            'h5',
	                            null,
	                            'My Journal'
	                        )
	                    )
	                ),
	                (0, _preact.h)(
	                    'li',
	                    { 'class': 'my-kcs' },
	                    (0, _preact.h)(
	                        'a',
	                        { href: '/store/karma-coins', 'data-label': 'My Account - Karma Coins\xA9 Balance' },
	                        (0, _preact.h)('span', null),
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'account-details' },
	                            (0, _preact.h)(
	                                'h5',
	                                null,
	                                'Karma Coins',
	                                (0, _preact.h)(
	                                    'sup',
	                                    null,
	                                    '\xAE'
	                                )
	                            ),
	                            (0, _preact.h)(
	                                'p',
	                                null,
	                                this.props.user.kcs.total.toLocaleString(),
	                                ' Balance'
	                            )
	                        )
	                    )
	                ),
	                (0, _preact.h)(
	                    'li',
	                    { 'class': 'ub-gear no-detail-link' },
	                    (0, _preact.h)(
	                        'a',
	                        { href: '/member/settings', 'data-label': 'My Account - Settings' },
	                        (0, _preact.h)(
	                            'h5',
	                            null,
	                            'Account Settings'
	                        )
	                    )
	                ),
	                (0, _preact.h)(
	                    'li',
	                    { 'class': 'ub-logout no-detail-link' },
	                    (0, _preact.h)(
	                        'a',
	                        { href: '#logout', 'data-label': 'Log Out' },
	                        (0, _preact.h)(
	                            'h5',
	                            null,
	                            'Log Out'
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderLoggedOut',
	        value: function renderLoggedOut() {
	            return (0, _preact.h)(
	                'ul',
	                { 'class': 'user-lo' },
	                (0, _preact.h)(
	                    'li',
	                    null,
	                    (0, _preact.h)(
	                        'a',
	                        { href: '#login', 'data-label': 'Log In', onClick: this.login },
	                        'Log In'
	                    )
	                ),
	                (0, _preact.h)(
	                    'li',
	                    null,
	                    (0, _preact.h)(
	                        'a',
	                        { href: '#signup', 'class': 'button', 'data-label': 'Sign Up', onClick: this.signUp },
	                        'Sign Up!'
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'signUp',
	        value: function signUp() {
	            var signup_gateway = document.querySelector('input[name="signup_gateway"]');
	
	            if (signup_gateway) {
	                signup_gateway.value = '#signup';
	            }
	
	            return true;
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        user: state.user
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        trackEvent: function trackEvent(data) {
	            return dispatch({ type: 'ga:event', payload: data });
	        },
	        trackPromo: function trackPromo(payload) {
	            return dispatch({ type: 'promo-tracker:recordInternal', payload: payload });
	        },
	        routeTo: function routeTo(route) {
	            return dispatch({ type: 'route:to', payload: route });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/user/signup-forums.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _birthdate = __webpack_require__("./app/components/form/birthdate.js");
	
	var _birthdate2 = _interopRequireDefault(_birthdate);
	
	var _recaptcha = __webpack_require__("./app/components/recaptcha.js");
	
	var _recaptcha2 = _interopRequireDefault(_recaptcha);
	
	var _mediaQuery = __webpack_require__("./app/media-query.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this));
	
	        _this.handleChange = function (e, name) {
	            name = name || e.target.name;
	
	            _this.setState(_defineProperty({}, name, e.target.type === 'checkbox' ? e.target.checked : e.target.value));
	        };
	
	        _this.handleRecaptchaResponse = function (response) {
	            _this.setState({
	                recaptcha: {
	                    response: response
	                }
	            });
	        };
	
	        _this.renderWRS = function () {
	            if (_mediaQuery.MediaQuery.isMobile()) {
	                return (0, _preact.h)(
	                    'span',
	                    null,
	                    'Get my FREE weekly horoscope emails'
	                );
	            }
	
	            return 'Get my FREE weekly horoscope emails';
	        };
	
	        _this.renderPPC = function () {
	            if (!_this.props.ppc) {
	                return (0, _preact.h)(
	                    'label',
	                    { 'class': 'checkbox ' + (_this.props.user.privacyPolicyError ? 'error' : '') },
	                    (0, _preact.h)('input', {
	                        'data-action': 'Select-Privacy-Policy-Terms-of-Use',
	                        'data-category': 'Forums',
	                        'data-label': 'Signup',
	                        'data-ga-event': true,
	                        name: 'privacy_policy',
	                        onChange: function onChange(e) {
	                            return _this.handleChange(e, 'privacy_policy');
	                        },
	                        type: 'checkbox',
	                        value: '1',
	                        checked: _this.state.privacy_policy
	                    }),
	                    (0, _preact.h)(
	                        'span',
	                        null,
	                        '\xA0I agree to Tarot.com\'s updated ',
	                        (0, _preact.h)(
	                            'a',
	                            { href: '/privacy-policy', target: '_blank' },
	                            'Privacy Policy'
	                        ),
	                        ' and ',
	                        (0, _preact.h)(
	                            'a',
	                            { href: '/terms-of-use', target: '_blank' },
	                            'Terms of Use'
	                        ),
	                        '.'
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'error' },
	                        _this.props.user.privacyPolicyError
	                    )
	                );
	            }
	
	            return null;
	        };
	
	        _this.renderToS = function () {
	            if (_this.props.ppc) {
	                return (0, _preact.h)(
	                    'p',
	                    { 'class': 'tos-warning' },
	                    'By continuing, you accept our',
	                    (0, _preact.h)(
	                        'a',
	                        {
	                            'class': 'text-link-undecorated',
	                            'data-action': 'goto_privacy_policy',
	                            'data-category': 'Forums',
	                            'data-label': 'Signup',
	                            'data-ga-event': true,
	                            href: '/privacy-policy',
	                            target: '_blank'
	                        },
	                        'Privacy Policy'
	                    ),
	                    '\xA0and\xA0',
	                    (0, _preact.h)(
	                        'a',
	                        {
	                            'class': 'text-link-undecorated',
	                            'data-action': 'goto_terms_of_use',
	                            'data-category': 'Forums',
	                            'data-label': 'Signup',
	                            'data-ga-event': true,
	                            href: '/terms-of-use',
	                            target: '_blank'
	                        },
	                        'Terms of Use'
	                    ),
	                    '.'
	                );
	            }
	
	            return null;
	        };
	
	        _this.hasErrors = function (inputs) {
	            _this.props.userUpdate({
	                birthDateError: null,
	                generalError: null,
	                emailError: null,
	                forumNameError: null,
	                passwordError: null,
	                nameError: null,
	                captchaError: null,
	                privacyPolicyError: null
	            });
	
	            var errs = 0;
	
	            if (inputs.email.trim().length < 5) {
	                _this.props.userUpdate({ emailError: 'Please enter your email.' });
	                errs++;
	            }
	
	            if (!inputs.birth_date) {
	                _this.props.userUpdate({ birthDateError: 'Please check your birth date.' });
	                errs++;
	            }
	
	            if (!inputs.user_name.trim().length) {
	                _this.props.userUpdate({ nameError: 'Please enter your name.' });
	                errs++;
	            }
	
	            if (!inputs.forum_name.trim().length) {
	                _this.props.userUpdate({ forumNameError: 'Please enter your forum name.' });
	                errs++;
	            }
	
	            if (inputs.password.length < 4) {
	                _this.props.userUpdate({ passwordError: 'Please enter a password longer than 3 characters.' });
	                errs++;
	            }
	
	            if (!_this.props.ppc && !_this.state.privacy_policy) {
	                _this.props.userUpdate({ privacyPolicyError: 'Please accept before continuing.' });
	                errs++;
	            }
	
	            if (errs) {
	                _this.props.userUpdate({ generalError: 'Please fill out required fields.' });
	            }
	
	            return errs;
	        };
	
	        _this.submit = function (e) {
	            e.preventDefault();
	
	            var inputs = {
	                birth_date: _this.state.birth_date,
	                email: _this.state.email || '',
	                forum_name: _this.state.forum_name || '',
	                password: _this.state.password || '',
	                user_name: _this.state.user_name || ''
	            };
	
	            var errors = _this.hasErrors(inputs);
	            var subscribe_lists = ['ipe'];
	
	            if (_this.state.dailyhoroscope) {
	                subscribe_lists.push('dailyhoroscope');
	            }
	
	            if (_this.state.weekly_love) {
	                subscribe_lists.push('weekly_love');
	            }
	
	            if (_this.state.recaptcha.response) {
	                _this.props.checkRecaptcha({ response: _this.state.recaptcha.response });
	            } else {
	                if (!_this.props.recaptcha || !_this.props.recaptcha.success) {
	                    errors = true;
	                    _this.props.userUpdate({ captchaError: 'Captcha validation failed. Please try again.' });
	                } else {
	                    errors = true;
	                    _this.props.userUpdate({ captchaError: 'Please click the "I\'m not a robot box"' });
	                }
	            }
	
	            if (!errors) {
	                var params = {
	                    account_type_id: 1,
	                    birth_date: inputs.birth_date,
	                    cur_fname: inputs.user_name,
	                    display_name: inputs.user_name,
	                    first_name: inputs.user_name,
	                    forum_name: inputs.forum_name,
	                    email: inputs.email,
	                    name: inputs.user_name,
	                    password: inputs.password,
	                    password_verify: inputs.password,
	                    privacy_policy: true,
	                    signup_bonus: true,
	                    signup_gateway: 'forums-signup',
	                    signup_pfero: true,
	                    signup_url: window.location.href,
	                    subscribe_lists: subscribe_lists,
	                    timezone: new Date().getTimezoneOffset() / 60 * -1,
	                    user_name: inputs.user_name
	                };
	
	                if (_this.state.dailyhoroscope) {
	                    params.subscribe_lists.push('dailyhoroscope');
	                }
	
	                if (_this.state.weekly_love) {
	                    params.subscribe_lists.push('weekly_love');
	                }
	
	                _this.props.userSignupApi(params);
	            }
	
	            return false;
	        };
	
	        _this.keyup = function (e) {
	            if (e.keyCode == 27) {
	                _this.props.routeTo('');
	            }
	        };
	
	        _this.getErrorClass = function (error) {
	            return error ? 'error' : null;
	        };
	
	        _this.renderError = function () {
	            var error = _this.props.user.generalError ? _this.props.user.generalError : null;
	
	            if (error) {
	                return (0, _preact.h)(
	                    'div',
	                    { 'class': 'error error-center' },
	                    error
	                );
	            }
	
	            return null;
	        };
	
	        _this.renderAside = function () {
	            if (_this.state.accordionOpen) {
	                return (0, _preact.h)(
	                    'aside',
	                    { 'class': 'details' },
	                    (0, _preact.h)(
	                        'button',
	                        { onClick: _this.toggleAccordion },
	                        '\u2715'
	                    ),
	                    (0, _preact.h)(
	                        'h3',
	                        null,
	                        'Why Should I Join?'
	                    ),
	                    (0, _preact.h)(
	                        'summary',
	                        null,
	                        (0, _preact.h)(
	                            'p',
	                            null,
	                            'At Tarot.com we translate ancient wisdom for the modern world. Through our unique and personalized content, we want to help guide our users toward understanding what humans knew thousands of years ago \u2026 that the answers are within you!'
	                        ),
	                        (0, _preact.h)(
	                            'p',
	                            null,
	                            'By becoming a Tarot.com member, you\'ll join a community of more than six million members who want to learn and grow as individuals and ultimately, make the world a better place.'
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'h3',
	                        null,
	                        'You\'ll also get:'
	                    ),
	                    (0, _preact.h)(
	                        'ul',
	                        null,
	                        (0, _preact.h)(
	                            'li',
	                            null,
	                            '20 FREE Karma Coins\xAE tokens'
	                        ),
	                        (0, _preact.h)(
	                            'li',
	                            null,
	                            'A FREE Tarot reading on your birthday'
	                        ),
	                        (0, _preact.h)(
	                            'li',
	                            null,
	                            'Personalized daily Tarot, Astrology & Numerology advice and tips'
	                        ),
	                        (0, _preact.h)(
	                            'li',
	                            null,
	                            'Special discounts on in-depth Tarot readings'
	                        )
	                    )
	                );
	            }
	
	            return null;
	        };
	
	        _this.toggleAccordion = function (e) {
	            e.preventDefault();
	            _this.setState({ accordionOpen: !_this.state.accordionOpen });
	        };
	
	        _this.setState({
	            accordionOpen: false,
	            dailyhoroscope: false,
	            weekly_love: false,
	            privacy_policy: false,
	            recaptcha: { response: null }
	        });
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref) {
	            var _this2 = this;
	
	            var user = _ref.user;
	
	            return (0, _preact.h)(
	                'signup-forums',
	                null,
	                (0, _preact.h)(
	                    'p',
	                    null,
	                    'Please create a Tarot.com account! Your unique username will allow you to post and reply to topics in the forums and personalize your forums profile page. Plus, a membership comes with many other great perks!',
	                    (0, _preact.h)(
	                        'a',
	                        { href: '#', onClick: this.toggleAccordion },
	                        '\xA0Learn More'
	                    )
	                ),
	                this.renderAside(),
	                (0, _preact.h)(
	                    'form',
	                    { onSubmit: this.submit, onKeyUp: this.keyup },
	                    (0, _preact.h)(
	                        'fieldset',
	                        { 'class': 'name-field' },
	                        (0, _preact.h)(
	                            'label',
	                            { 'class': this.getErrorClass(user.nameError) },
	                            'Your Name',
	                            (0, _preact.h)('input', {
	                                'data-action': 'Type-Name',
	                                'data-category': 'Forums',
	                                'data-label': 'Signup',
	                                'data-ga-event': true,
	                                name: 'user_name',
	                                onChange: this.handleChange,
	                                type: 'text'
	                            })
	                        ),
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'error' },
	                            user.nameError
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'fieldset',
	                        { 'class': 'email-field' },
	                        (0, _preact.h)(
	                            'label',
	                            { 'class': this.getErrorClass(user.emailError) },
	                            'Your Email',
	                            (0, _preact.h)('input', {
	                                'data-action': 'Type-Email',
	                                'data-category': 'Forums',
	                                'data-label': 'Login',
	                                'data-ga-event': true,
	                                name: 'email',
	                                onChange: this.handleChange,
	                                type: 'email'
	                            })
	                        ),
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'error' },
	                            user.emailError
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'fieldset',
	                        { 'class': 'forum-name-field' },
	                        (0, _preact.h)(
	                            'label',
	                            { 'class': this.getErrorClass(user.forumNameError) },
	                            'Your Forums Username',
	                            (0, _preact.h)('input', {
	                                'data-action': 'Type-Forum-Name',
	                                'data-category': 'Forums',
	                                'data-label': 'Signup',
	                                'data-ga-event': true,
	                                name: 'forum_name',
	                                onChange: this.handleChange,
	                                type: 'text'
	                            })
	                        ),
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'error' },
	                            user.forumNameError
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'fieldset',
	                        { 'class': 'birthdate-field' },
	                        (0, _preact.h)(
	                            'label',
	                            { 'class': this.getErrorClass(user.birthDateError) },
	                            'Your Birth Date',
	                            (0, _preact.h)(_birthdate2.default, {
	                                'data-action': 'Type-BirthDate',
	                                'data-category': 'Forums',
	                                'data-label': 'Signup',
	                                'data-ga-event': true,
	                                max: (0, _moment2.default)((0, _moment2.default)().subtract(13, 'year')).format('YYYY-MM-DD'),
	                                min: '1900-01-01',
	                                name: 'birth_date',
	                                onChange: this.handleChange,
	                                type: 'date'
	                            })
	                        ),
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'error' },
	                            user.birthDateError
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'fieldset',
	                        { 'class': 'password-field' },
	                        (0, _preact.h)(
	                            'label',
	                            { 'class': this.getErrorClass(user.passwordError) },
	                            'Password',
	                            (0, _preact.h)('input', {
	                                'data-action': 'Type-Password',
	                                'data-category': 'Forums',
	                                'data-label': 'Login',
	                                'data-ga-event': true,
	                                name: 'password',
	                                onChange: this.handleChange,
	                                type: 'password'
	                            })
	                        ),
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'error' },
	                            user.passwordError
	                        )
	                    ),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'row' },
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'small-12 medium-6 columns' },
	                            (0, _preact.h)(
	                                'fieldset',
	                                { 'class': 'checkbox' },
	                                (0, _preact.h)(
	                                    'label',
	                                    null,
	                                    (0, _preact.h)('input', {
	                                        'data-action': 'Select-Subscribe-DHE',
	                                        'data-category': 'Forums',
	                                        'data-label': 'Signup',
	                                        'data-ga-event': true,
	                                        name: 'dailyhoroscope',
	                                        onChange: function onChange(e) {
	                                            return _this2.handleChange(e, 'dailyhoroscope');
	                                        },
	                                        type: 'checkbox',
	                                        value: '1',
	                                        checked: this.state.dailyhoroscope
	                                    }),
	                                    'Get my FREE daily horoscope emails'
	                                ),
	                                (0, _preact.h)(
	                                    'label',
	                                    { 'class': _mediaQuery.MediaQuery.isMobile() ? 'checkbox' : '' },
	                                    (0, _preact.h)('input', {
	                                        'data-action': 'Select-Subscribe-WRS',
	                                        'data-category': 'Forums',
	                                        'data-label': 'Signup',
	                                        'data-ga-event': true,
	                                        name: 'weekly_love',
	                                        onChange: function onChange(e) {
	                                            return _this2.handleChange(e, 'weekly_love');
	                                        },
	                                        type: 'checkbox',
	                                        value: '1',
	                                        checked: this.state.weekly_love
	                                    }),
	                                    this.renderWRS()
	                                ),
	                                this.renderPPC()
	                            )
	                        ),
	                        (0, _preact.h)(
	                            'div',
	                            { 'class': 'small-12 medium-6 columns' },
	                            (0, _preact.h)(_recaptcha2.default, {
	                                onChange: this.handleRecaptchaResponse,
	                                onExpired: this.handleRecaptchaResponse
	                            }),
	                            (0, _preact.h)(
	                                'div',
	                                { 'class': 'error' },
	                                user.captchaError
	                            )
	                        )
	                    ),
	                    (0, _preact.h)('br', null),
	                    (0, _preact.h)(
	                        'button',
	                        { 'class': 'button' },
	                        'Submit'
	                    ),
	                    this.renderError(),
	                    this.renderToS()
	                )
	            );
	        }
	
	        /* eslint-disable complexity */
	
	        /* eslint-enable complexity */
	
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        user: state.user,
	        recaptcha: state.recaptcha,
	        ppc: state.cookie && state.cookie.PRIVACY_POLICY_CONSENT
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        routeTo: function routeTo(route) {
	            return dispatch({ type: 'route:to', payload: route });
	        },
	        userUpdate: function userUpdate(payload) {
	            return dispatch({ type: 'user:update', payload: payload });
	        },
	        userSignupApi: function userSignupApi(payload) {
	            return dispatch({ type: 'user:signup-api', payload: payload });
	        },
	        checkRecaptcha: function checkRecaptcha(payload) {
	            return dispatch({ type: 'recaptcha:check', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/user/signup-modal.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this));
	
	        _this.renderPPC = function () {
	            if (!_this.props.ppc) {
	                return (0, _preact.h)(
	                    'label',
	                    { 'class': _this.state.privacyPolicyError ? 'error' : '' },
	                    (0, _preact.h)('input', {
	                        'data-action': 'Select-Privacy-Policy-Terms-of-Use',
	                        'data-category': 'Three-Card-Reading',
	                        'data-label': 'Signup',
	                        'data-ga-event': true,
	                        name: 'privacy_policy',
	                        type: 'checkbox',
	                        value: '1'
	                    }),
	                    'I agree to Tarot.com\'s updated ',
	                    (0, _preact.h)(
	                        'a',
	                        { href: '/privacy-policy', target: '_blank' },
	                        'Privacy Policy'
	                    ),
	                    ' and ',
	                    (0, _preact.h)(
	                        'a',
	                        { href: '/terms-of-use', target: '_blank' },
	                        'Terms of Use'
	                    ),
	                    '.',
	                    _this.renderError(_this.state.privacyPolicyError)
	                );
	            }
	
	            return null;
	        };
	
	        _this.renderTOS = function () {
	            if (_this.props.ppc) {
	                return (0, _preact.h)(
	                    'p',
	                    { 'class': 'tos-warning' },
	                    'By continuing, you accept our\xA0',
	                    (0, _preact.h)(
	                        'a',
	                        {
	                            'class': 'text-link-undecorated',
	                            'data-action': 'goto_privacy_policy',
	                            'data-category': 'Three-Card-Reading',
	                            'data-label': 'Signup',
	                            'data-ga-event': 'true',
	                            href: '/privacy-policy',
	                            target: '_blank'
	                        },
	                        'Privacy Policy'
	                    ),
	                    '\xA0and\xA0',
	                    (0, _preact.h)(
	                        'a',
	                        {
	                            'class': 'text-link-undecorated',
	                            'data-action': 'goto_terms_of_use',
	                            'data-category': 'Three-Card-Reading',
	                            'data-label': 'Signup',
	                            'data-ga-event': 'true',
	                            href: '/terms-of-use',
	                            target: '_blank'
	                        },
	                        'Terms of Use'
	                    ),
	                    '.'
	                );
	            }
	
	            return null;
	        };
	
	        _this.renderError = function (errorText) {
	            if (errorText) {
	                return (0, _preact.h)(
	                    'div',
	                    { 'class': 'form-error' },
	                    errorText
	                );
	            }
	
	            return null;
	        };
	
	        _this.close = function (e) {
	            e.preventDefault();
	            _this.props.routeTo('');
	        };
	
	        _this.submit = function (e) {
	            e.preventDefault();
	            var form = e.target;
	            var user_name = form.querySelector('input[name="user_name"]').value;
	
	            var birth_date = form.querySelector('input[name="birth_date"]').value;
	            var privacyPolicyError = null;
	
	            var nameError = user_name.trim().length ? null : 'Please enter your name.';
	            var birthdateError = _this.validateBirthdate(birth_date);
	
	            if (!_this.props.ppc) {
	                var pp = form.querySelector('input[name="privacy_policy"]').checked;
	                privacyPolicyError = pp ? null : 'Please accept before continuing.';
	            }
	
	            _this.setState({
	                nameError: nameError,
	                birthdateError: birthdateError,
	                privacyPolicyError: privacyPolicyError
	            });
	
	            var subscribe_lists = ['ipe'];
	
	            if (form.querySelector('input[name="dh_optin"]').checked) {
	                subscribe_lists.push('dailyhoroscope');
	            }
	
	            if (form.querySelector('input[name="wrs_optin"]').checked) {
	                subscribe_lists.push('weekly_love');
	            }
	
	            if (!nameError && !birthdateError && !privacyPolicyError) {
	                birth_date = (0, _moment2.default)(birth_date).format('YYYY-MM-DD');
	                _this.props.userSignup({
	                    user_name: user_name,
	                    cur_fname: user_name,
	                    display_name: user_name,
	                    birth_date: birth_date,
	                    email: _this.props.user.email,
	                    password: _this.props.user.password,
	                    password_verify: _this.props.user.password,
	                    signup_gateway: _this.props.upc || _this.props.compatSlant || '#signup',
	                    signup_url: window.location.href,
	                    account_type_id: 1,
	                    timezone: new Date().getTimezoneOffset() / 60 * -1,
	                    welcome_email: true,
	                    privacy_policy: true,
	                    subscribe_lists: subscribe_lists,
	                    signup_bonus: true,
	                    award_pfero: true
	                });
	            }
	        };
	
	        _this.keyup = function (e) {
	            if (e.keyCode == 27 && _this.props.isOpen) {
	                _this.props.routeTo('');
	            }
	        };
	
	        _this.renderHeader = function () {
	            if (_this.props.product) {
	                return (0, _preact.h)(
	                    'header',
	                    null,
	                    (0, _preact.h)(
	                        'h1',
	                        null,
	                        _this.props.h1Text
	                    ),
	                    (0, _preact.h)(
	                        'h2',
	                        null,
	                        'Help us personalize your experience\u2026'
	                    )
	                );
	            }
	
	            return (0, _preact.h)(
	                'header',
	                null,
	                (0, _preact.h)(
	                    'h1',
	                    null,
	                    'So nice to see you!'
	                ),
	                (0, _preact.h)(
	                    'h2',
	                    null,
	                    'Join our community'
	                )
	            );
	        };
	
	        _this.validateBirthdate = function (birthdate) {
	            if (!birthdate) {
	                return 'Please enter your birth date';
	            } else if (birthdate.match(/^\d{2,4}-\d{2}-\d{2}$/)) {
	                return null;
	            } else if (birthdate.match(/^\d{1,2}\/\d{1,2}\/\d{2,4}$/)) {
	                return null;
	            } else if (birthdate.match(/^\d{2}-\d{2}-\d{2,4}$/)) {
	                return null;
	            }
	
	            return 'Birthday format is mm/dd/yyyy';
	        };
	
	        _this.setState({
	            nameError: null,
	            birthdateError: null,
	            privacyPolicyError: null
	        });
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            var modalInner = document.querySelector('signup-modal .modal-inner');
	            var top = window.pageYOffset + window.innerHeight / 2 - modalInner.offsetHeight / 2;
	            modalInner.style.top = top + 'px';
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref) {
	            var isOpen = _ref.isOpen,
	                buttonText = _ref.buttonText;
	
	            return (0, _preact.h)(
	                'signup-modal',
	                { 'class': isOpen ? 'open' : '' },
	                (0, _preact.h)('a', { 'class': 'backdrop', onClick: this.close }),
	                (0, _preact.h)(
	                    'aside',
	                    { 'class': 'modal-inner' },
	                    (0, _preact.h)('a', { 'class': 'modal-close-button', onClick: this.close }),
	                    this.renderHeader(),
	                    (0, _preact.h)(
	                        'form',
	                        { onSubmit: this.submit, onKeyUp: this.keyup },
	                        (0, _preact.h)(
	                            'fieldset',
	                            { 'class': 'name-field' },
	                            (0, _preact.h)(
	                                'label',
	                                null,
	                                'Your Name',
	                                (0, _preact.h)('input', {
	                                    'data-action': 'Type-Name',
	                                    'data-category': 'Three-Card-Reading',
	                                    'data-label': 'Signup',
	                                    'data-ga-event': true,
	                                    name: 'user_name',
	                                    type: 'text'
	                                }),
	                                this.renderError(this.state.nameError)
	                            )
	                        ),
	                        (0, _preact.h)(
	                            'fieldset',
	                            { 'class': 'birthdate-field' },
	                            (0, _preact.h)(
	                                'label',
	                                null,
	                                'Your Birth Date',
	                                (0, _preact.h)('input', {
	                                    'data-action': 'Type-BirthDate',
	                                    'data-category': 'Three-Card-Reading',
	                                    'data-label': 'Signup',
	                                    'data-ga-event': true,
	                                    max: (0, _moment2.default)((0, _moment2.default)().subtract(13, 'year')).format('YYYY-MM-DD'),
	                                    min: '1900-01-01',
	                                    name: 'birth_date',
	                                    type: 'date'
	                                }),
	                                this.renderError(this.state.birthdateError)
	                            )
	                        ),
	                        (0, _preact.h)(
	                            'fieldset',
	                            { 'class': 'checkbox' },
	                            (0, _preact.h)(
	                                'label',
	                                null,
	                                (0, _preact.h)('input', {
	                                    'data-action': 'Select-Subscribe-DHE',
	                                    'data-category': 'Three-Card-Reading',
	                                    'data-label': 'Signup',
	                                    'data-ga-event': true,
	                                    name: 'dh_optin',
	                                    type: 'checkbox',
	                                    value: '1'
	                                }),
	                                'Get my FREE daily horoscope emails'
	                            ),
	                            (0, _preact.h)(
	                                'label',
	                                null,
	                                (0, _preact.h)('input', {
	                                    'data-action': 'Select-Subscribe-WRS',
	                                    'data-category': 'Three-Card-Reading',
	                                    'data-label': 'Signup',
	                                    'data-ga-event': true,
	                                    name: 'wrs_optin',
	                                    type: 'checkbox',
	                                    value: '1'
	                                }),
	                                'Get my FREE weekly horoscope emails'
	                            ),
	                            this.renderPPC()
	                        ),
	                        (0, _preact.h)('input', { type: 'hidden', name: 'special_offer_optin', value: '1' }),
	                        (0, _preact.h)('div', { 'class': 'clear' }),
	                        (0, _preact.h)(
	                            'button',
	                            { 'class': 'button button-warning' },
	                            buttonText
	                        ),
	                        this.renderTOS()
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        isOpen: state.route === 'signup',
	        buttonText: state.product ? 'Get my ' + state.product.type + '!' : 'Sign Up!',
	        product: state.product,
	        user: state.user,
	        upc: state.product && state.product.teeup && state.product.teeup.code,
	        h1Text: state.product.type && state.product.type.match(/s$/) ? 'Your ' + state.product.type + ' Await!' : 'Your ' + state.product.type + ' Awaits!',
	        compatSlant: state['compatibility-chooser'] && state['compatibility-chooser'].slant ? 'compat-tag-' + state['compatibility-chooser'].slant : null,
	        ppc: state.cookie && state.cookie.PRIVACY_POLICY_CONSENT
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        routeTo: function routeTo(route) {
	            return dispatch({ type: 'route:to', payload: route });
	        },
	        userSignup: function userSignup(payload) {
	            return dispatch({ type: 'user:signup-api', payload: payload });
	        },
	        setCookie: function setCookie(payload) {
	            return dispatch({ type: 'cookie:set', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/user/signup-modal-desktop.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _invisibleRecaptcha = __webpack_require__("./app/components/invisible-recaptcha.js");
	
	var _invisibleRecaptcha2 = _interopRequireDefault(_invisibleRecaptcha);
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        _classCallCheck(this, Component);
	
	        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this));
	
	        _this.renderPPC = function () {
	            if (!_this.props.ppc) {
	                return (0, _preact.h)(
	                    'div',
	                    { 'class': 'row' },
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'small-12 columns' },
	                        (0, _preact.h)(
	                            'label',
	                            { 'class': 'checkbox ' + (_this.props.user.privacyPolicyError ? 'error' : '') },
	                            (0, _preact.h)('input', {
	                                name: 'privacy_policy',
	                                onChange: _this.setPrivacyPolicy,
	                                type: 'checkbox'
	                            }),
	                            'I agree to Tarot.com\'s ',
	                            (0, _preact.h)(
	                                'a',
	                                { href: '/privacy-policy', target: '_blank' },
	                                'Privacy Policy'
	                            ),
	                            ' and ',
	                            (0, _preact.h)(
	                                'a',
	                                { href: '/terms-of-use', target: '_blank' },
	                                'Terms of Use'
	                            ),
	                            '.'
	                        ),
	                        _this.renderError(_this.props.user.privacyPolicyError)
	                    )
	                );
	            }
	
	            return (0, _preact.h)(
	                'div',
	                { 'class': 'row' },
	                (0, _preact.h)(
	                    'div',
	                    { 'class': 'small-12 columns' },
	                    (0, _preact.h)(
	                        'p',
	                        { 'class': 'legal-notice-link' },
	                        'By clicking "Enter" you accept our\xA0',
	                        (0, _preact.h)(
	                            'a',
	                            {
	                                href: '/privacy-policy',
	                                'data-name': 'goto_privacy_policy',
	                                target: '_blank'
	                            },
	                            'Privacy Policy'
	                        ),
	                        '\xA0and\xA0',
	                        (0, _preact.h)(
	                            'a',
	                            {
	                                href: '/terms-of-use',
	                                'data-name': 'goto_terms_of_use',
	                                target: '_blank'
	                            },
	                            'Terms of Use'
	                        ),
	                        '.'
	                    )
	                )
	            );
	        };
	
	        _this.close = function () {
	            _this.props.trackEvent(['Modal', 'hide', 'Signup']);
	            _this.props.routeTo('');
	        };
	
	        _this.submit = function (e) {
	            e.preventDefault();
	
	            _this.setState({ formError: false });
	
	            _this.props.userUpdate({
	                nameError: null,
	                emailError: null,
	                birthdateError: null,
	                passwordError: null,
	                privacyPolicyError: null
	            });
	
	            _this.validateName();
	            _this.validateEmail();
	            _this.validateBirthdate();
	            _this.validatePassword();
	
	            if (!_this.props.ppc) {
	                _this.validatePrivacyPolicy();
	            }
	
	            var subscribe_lists = ['ipe'];
	
	            if (_this.state.dh_wrs_optin) {
	                subscribe_lists.push('dailyhoroscope');
	                subscribe_lists.push('weekly_love');
	            }
	
	            if (_this.state.partner_optin) {
	                subscribe_lists.push('ope');
	            }
	
	            _this.setState({ subscribe_lists: subscribe_lists });
	
	            if (!_this.state.formError) {
	                _this.recaptchaInstance._component.execute();
	            }
	        };
	
	        _this.renderError = function (errorText) {
	            if (errorText) {
	                return (0, _preact.h)(
	                    'p',
	                    { 'class': 'error' },
	                    errorText
	                );
	            }
	
	            return null;
	        };
	
	        _this.renderDayOptions = function () {
	            if (_this.state.month) {
	                var year = _this.state.year || (0, _moment2.default)().year();
	                var days = (0, _moment2.default)(year + '-' + _this.state.month, 'YYYY-MM').daysInMonth();
	
	                return Array.from(Array(days).keys()).map(function (day) {
	                    return (0, _preact.h)(
	                        'option',
	                        {
	                            value: (day + 1).toString().padStart(2, 0),
	                            selected: _this.state.day == day + 1
	                        },
	                        day + 1
	                    );
	                });
	            }
	
	            return null;
	        };
	
	        _this.renderYearOptions = function () {
	            return Array.from(Array(101).keys()).map(function (d) {
	                var year = (0, _moment2.default)().year() - d;
	
	                if (year <= (0, _moment2.default)().year() - 13) {
	                    return (0, _preact.h)(
	                        'option',
	                        {
	                            value: year,
	                            selected: _this.state.year == year
	                        },
	                        year
	                    );
	                }
	
	                return null;
	            });
	        };
	
	        _this.setName = function (e) {
	            _this.setState({ name: e.target.value });
	        };
	
	        _this.setEmail = function (e) {
	            _this.setState({ email: e.target.value });
	        };
	
	        _this.setMonth = function (e) {
	            _this.setState({ month: e.target.value });
	        };
	
	        _this.setDay = function (e) {
	            _this.setState({ day: e.target.value });
	        };
	
	        _this.setYear = function (e) {
	            _this.setState({ year: e.target.value });
	        };
	
	        _this.setPassword = function (e) {
	            _this.setState({ password: e.target.value });
	        };
	
	        _this.setVerifyPassword = function (e) {
	            _this.setState({ verify_password: e.target.value });
	        };
	
	        _this.setDHWRSOptin = function (e) {
	            var action = e.target.checked ? 'Subscribe' : 'Unsubscribe';
	
	            _this.props.trackEvent(['Modal', 'Select-' + action + '-Newsletter-Email', 'Signup']);
	
	            _this.setState({ dh_wrs_optin: e.target.checked });
	        };
	
	        _this.setPartnerOptin = function (e) {
	            var action = e.target.checked ? 'Subscribe' : 'Unsubscribe';
	
	            _this.props.trackEvent(['Modal', 'Select-' + action + '-Partner-Email', 'Signup']);
	
	            _this.setState({ partner_optin: e.target.checked });
	        };
	
	        _this.setPrivacyPolicy = function (e) {
	            var action = e.target.checked ? 'Agree' : 'Disagree';
	
	            _this.props.trackEvent(['Modal', 'Select-' + action + '-Privacy-Policy', 'Signup']);
	
	            _this.setState({ privacy_policy: e.target.checked });
	        };
	
	        _this.validateName = function () {
	            if (!_this.state.name) {
	                _this.setState({ formError: true });
	
	                _this.props.userUpdate({
	                    nameError: 'Please enter your name.'
	                });
	            }
	        };
	
	        _this.validateEmail = function () {
	            if (!_this.state.email) {
	                _this.setState({ formError: true });
	
	                _this.props.userUpdate({
	                    emailError: 'Please enter your email address.'
	                });
	            } else {
	                var atpos = _this.state.email.indexOf('@');
	                var dotpos = _this.state.email.lastIndexOf('.');
	
	                if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= _this.state.email.length) {
	                    _this.setState({ formError: true });
	
	                    _this.props.userUpdate({
	                        emailError: 'Please enter a valid email address.'
	                    });
	                }
	            }
	        };
	
	        _this.validateBirthdate = function () {
	            if (!_this.state.month || !_this.state.day || !_this.state.year) {
	                _this.setState({ formError: true });
	
	                _this.props.userUpdate({
	                    birthdateError: 'Please enter your birth date.'
	                });
	            } else {
	                var birthdate = (0, _moment2.default)(_this.state.year + '-' + _this.state.month + '-' + _this.state.day);
	
	                if (birthdate.isAfter((0, _moment2.default)().subtract(13, 'years'))) {
	                    _this.setState({ formError: true });
	
	                    _this.props.userUpdate({
	                        birthdateError: 'You must be at least 13 years of age to signup.'
	                    });
	                }
	            }
	        };
	
	        _this.validatePassword = function () {
	            if (!_this.state.password || !_this.state.verify_password) {
	                _this.setState({ formError: true });
	
	                _this.props.userUpdate({
	                    passwordError: 'Please enter a password.'
	                });
	            } else if (_this.state.password != _this.state.verify_password) {
	                _this.setState({ formError: true });
	
	                _this.props.userUpdate({
	                    passwordError: 'Your passwords don\'t match.'
	                });
	            } else if (_this.state.password.length < 3 || _this.state.password.length > 15) {
	                _this.setState({ formError: true });
	
	                _this.props.userUpdate({
	                    passwordError: 'Passwords must be between 3 and 15 characters long.'
	                });
	            }
	        };
	
	        _this.validatePrivacyPolicy = function () {
	            if (!_this.state.privacy_policy) {
	                _this.setState({ formError: true });
	
	                _this.props.userUpdate({
	                    privacyPolicyError: 'Please agree before continuing.'
	                });
	            }
	        };
	
	        _this.handleChanged = function () {
	            _this.setState({ recaptchaCompleted: true });
	        };
	
	        _this.handleExpired = function () {
	            _this.setState({ recaptchaCompleted: false });
	        };
	
	        _this.userSignup = function () {
	            var birthdate = (0, _moment2.default)(_this.state.year + '-' + _this.state.month + '-' + _this.state.day).format('YYYY-MM-DD');
	
	            _this.props.userSignup({
	                first_name: _this.state.name,
	                display_name: _this.state.name,
	                email: _this.state.email,
	                password: _this.state.password,
	                password_verify: _this.state.verify_password,
	                signup_gateway: '#signup',
	                signup_url: window.location.href,
	                account_type_id: 1,
	                signup_bonus: true,
	                award_pfero: true,
	                birth_date: birthdate,
	                timezone: new Date().getTimezoneOffset() / 60 * -1,
	                welcome_email: true,
	                subscribe_lists: _this.state.subscribe_lists,
	                privacy_policy: true
	            });
	        };
	
	        _this.recaptchaInstance;
	
	        _this.setState({
	            name: null,
	            email: null,
	            month: null,
	            day: null,
	            year: null,
	            password: null,
	            verify_password: null,
	            dh_wrs_optin: false,
	            partner_optin: false,
	            privacy_policy: false,
	            formError: false,
	            recaptchaCompleted: false,
	            subscribe_lists: []
	        });
	        return _this;
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            window.addEventListener('keydown', function (e) {
	                if (e.keyCode == 27 && _this2.props.isOpen) {
	                    _this2.close();
	                }
	            });
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            if (nextProps.isOpen && !this.props.isOpen) {
	                this.props.trackEvent(['Modal', 'show', 'Signup']);
	            }
	
	            if (!this.state.recaptchaCompleted && nextState.recaptchaCompleted) {
	                this.userSignup();
	            }
	
	            return true;
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref) {
	            var _this3 = this;
	
	            var isOpen = _ref.isOpen,
	                user = _ref.user;
	
	            if (isOpen) {
	                return (0, _preact.h)(
	                    'signup-modal-desktop',
	                    { 'class': 'open' },
	                    (0, _preact.h)('div', { 'class': 'backdrop', onClick: this.close }),
	                    (0, _preact.h)(
	                        'form',
	                        { id: 'signup-form', onSubmit: this.submit },
	                        (0, _preact.h)(
	                            'header',
	                            null,
	                            (0, _preact.h)(
	                                'a',
	                                { 'class': 'close', onClick: this.close },
	                                '\xD7'
	                            ),
	                            (0, _preact.h)(
	                                'h2',
	                                null,
	                                'SO NICE TO SEE YOU!'
	                            ),
	                            (0, _preact.h)(
	                                'h1',
	                                null,
	                                'Join Our Community'
	                            )
	                        ),
	                        (0, _preact.h)(
	                            'main',
	                            null,
	                            (0, _preact.h)(
	                                'h3',
	                                null,
	                                'Quick and easy!'
	                            ),
	                            (0, _preact.h)(
	                                'div',
	                                { 'class': 'row' },
	                                (0, _preact.h)(
	                                    'div',
	                                    { 'class': 'small-12 columns' },
	                                    (0, _preact.h)(
	                                        'p',
	                                        null,
	                                        'Already a member? ',
	                                        (0, _preact.h)(
	                                            'a',
	                                            { href: '#login' },
	                                            'Login here.'
	                                        )
	                                    )
	                                )
	                            ),
	                            (0, _preact.h)(
	                                'div',
	                                { 'class': 'row' },
	                                (0, _preact.h)(
	                                    'div',
	                                    { 'class': 'small-12 columns' },
	                                    (0, _preact.h)(
	                                        'div',
	                                        { 'class': 'input-container ' + (user.nameError ? 'error' : '') },
	                                        (0, _preact.h)('input', {
	                                            onFocus: function onFocus() {
	                                                return _this3.props.trackEvent(['Modal', 'Type-Name', 'Signup']);
	                                            },
	                                            onKeyup: this.setName,
	                                            name: 'name',
	                                            placeholder: 'What shall we call you?',
	                                            type: 'text'
	                                        })
	                                    ),
	                                    this.renderError(user.nameError)
	                                )
	                            ),
	                            (0, _preact.h)(
	                                'div',
	                                { 'class': 'row' },
	                                (0, _preact.h)(
	                                    'div',
	                                    { 'class': 'small-12 columns' },
	                                    (0, _preact.h)(
	                                        'div',
	                                        { 'class': 'input-container ' + (user.emailError ? 'error' : '') },
	                                        (0, _preact.h)('input', {
	                                            onFocus: function onFocus() {
	                                                return _this3.props.trackEvent(['Modal', 'Type-Email', 'Signup']);
	                                            },
	                                            onKeyup: this.setEmail,
	                                            name: 'email',
	                                            placeholder: 'Your email address',
	                                            type: 'email'
	                                        })
	                                    ),
	                                    this.renderError(user.emailError)
	                                )
	                            ),
	                            (0, _preact.h)(
	                                'div',
	                                { 'class': 'row' },
	                                (0, _preact.h)(
	                                    'div',
	                                    { 'class': 'small-3 columns' },
	                                    (0, _preact.h)(
	                                        'label',
	                                        null,
	                                        'Birth date'
	                                    )
	                                ),
	                                (0, _preact.h)(
	                                    'div',
	                                    { 'class': 'small-4 columns' },
	                                    (0, _preact.h)(
	                                        'div',
	                                        { 'class': 'select-container ' + (user.birthdateError ? 'error' : '') },
	                                        (0, _preact.h)(
	                                            'select',
	                                            {
	                                                name: 'month',
	                                                onFocus: function onFocus() {
	                                                    return _this3.props.trackEvent(['Modal', 'Select-Month', 'Signup']);
	                                                },
	                                                onChange: this.setMonth
	                                            },
	                                            (0, _preact.h)(
	                                                'option',
	                                                { disabled: true, selected: true, value: '' },
	                                                'Month'
	                                            ),
	                                            (0, _preact.h)(
	                                                'option',
	                                                { value: '01' },
	                                                'January'
	                                            ),
	                                            (0, _preact.h)(
	                                                'option',
	                                                { value: '02' },
	                                                'February'
	                                            ),
	                                            (0, _preact.h)(
	                                                'option',
	                                                { value: '03' },
	                                                'March'
	                                            ),
	                                            (0, _preact.h)(
	                                                'option',
	                                                { value: '04' },
	                                                'April'
	                                            ),
	                                            (0, _preact.h)(
	                                                'option',
	                                                { value: '05' },
	                                                'May'
	                                            ),
	                                            (0, _preact.h)(
	                                                'option',
	                                                { value: '06' },
	                                                'June'
	                                            ),
	                                            (0, _preact.h)(
	                                                'option',
	                                                { value: '07' },
	                                                'July'
	                                            ),
	                                            (0, _preact.h)(
	                                                'option',
	                                                { value: '08' },
	                                                'August'
	                                            ),
	                                            (0, _preact.h)(
	                                                'option',
	                                                { value: '09' },
	                                                'September'
	                                            ),
	                                            (0, _preact.h)(
	                                                'option',
	                                                { value: '10' },
	                                                'October'
	                                            ),
	                                            (0, _preact.h)(
	                                                'option',
	                                                { value: '11' },
	                                                'November'
	                                            ),
	                                            (0, _preact.h)(
	                                                'option',
	                                                { value: '12' },
	                                                'December'
	                                            )
	                                        )
	                                    )
	                                ),
	                                (0, _preact.h)(
	                                    'div',
	                                    { 'class': 'small-2 columns' },
	                                    (0, _preact.h)(
	                                        'div',
	                                        { 'class': 'select-container ' + (user.birthdateError ? 'error' : '') },
	                                        (0, _preact.h)(
	                                            'select',
	                                            {
	                                                name: 'day',
	                                                onFocus: function onFocus() {
	                                                    return _this3.props.trackEvent(['Modal', 'Select-Day', 'Signup']);
	                                                },
	                                                onChange: this.setDay
	                                            },
	                                            (0, _preact.h)(
	                                                'option',
	                                                { disabled: true, selected: true, value: '' },
	                                                'Day'
	                                            ),
	                                            this.renderDayOptions()
	                                        )
	                                    )
	                                ),
	                                (0, _preact.h)(
	                                    'div',
	                                    { 'class': 'small-3 columns' },
	                                    (0, _preact.h)(
	                                        'div',
	                                        { 'class': 'select-container ' + (user.birthdateError ? 'error' : '') },
	                                        (0, _preact.h)(
	                                            'select',
	                                            {
	                                                name: 'year',
	                                                onFocus: function onFocus() {
	                                                    return _this3.props.trackEvent(['Modal', 'Select-Year', 'Signup']);
	                                                },
	                                                onChange: this.setYear
	                                            },
	                                            (0, _preact.h)(
	                                                'option',
	                                                { disabled: true, selected: true, value: '' },
	                                                'Year'
	                                            ),
	                                            this.renderYearOptions()
	                                        )
	                                    )
	                                )
	                            ),
	                            (0, _preact.h)(
	                                'div',
	                                { 'class': 'row' },
	                                (0, _preact.h)(
	                                    'div',
	                                    { 'class': 'small-12 columns' },
	                                    this.renderError(user.birthdateError)
	                                )
	                            ),
	                            (0, _preact.h)(
	                                'div',
	                                { 'class': 'row' },
	                                (0, _preact.h)(
	                                    'div',
	                                    { 'class': 'small-12 columns' },
	                                    (0, _preact.h)(
	                                        'div',
	                                        { 'class': 'input-container ' + (user.passwordError ? 'error' : '') },
	                                        (0, _preact.h)('input', {
	                                            onFocus: function onFocus() {
	                                                return _this3.props.trackEvent(['Modal', 'Type-Password', 'Signup']);
	                                            },
	                                            onKeyup: this.setPassword,
	                                            name: 'password',
	                                            placeholder: 'Password (case-sensitive)',
	                                            type: 'password',
	                                            maxLength: '15'
	                                        })
	                                    )
	                                )
	                            ),
	                            (0, _preact.h)(
	                                'div',
	                                { 'class': 'row' },
	                                (0, _preact.h)(
	                                    'div',
	                                    { 'class': 'small-12 columns' },
	                                    (0, _preact.h)(
	                                        'div',
	                                        { 'class': 'input-container ' + (user.passwordError ? 'error' : '') },
	                                        (0, _preact.h)('input', {
	                                            onFocus: function onFocus() {
	                                                return _this3.props.trackEvent(['Modal', 'Type-Password-Verify', 'Signup']);
	                                            },
	                                            onKeyup: this.setVerifyPassword,
	                                            name: 'password-verify',
	                                            placeholder: 'Verify Password',
	                                            type: 'password',
	                                            maxLength: '15'
	                                        })
	                                    )
	                                )
	                            ),
	                            (0, _preact.h)(
	                                'div',
	                                { 'class': 'row' },
	                                (0, _preact.h)(
	                                    'div',
	                                    { 'class': 'small-12 columns' },
	                                    this.renderError(user.passwordError)
	                                )
	                            ),
	                            (0, _preact.h)(
	                                'div',
	                                { 'class': 'row' },
	                                (0, _preact.h)(
	                                    'div',
	                                    { 'class': 'small-12 columns' },
	                                    (0, _preact.h)(
	                                        'label',
	                                        { 'class': 'checkbox' },
	                                        (0, _preact.h)('input', {
	                                            name: 'dh_wrs_optin',
	                                            onChange: this.setDHWRSOptin,
	                                            checked: this.state.dh_wrs_optin,
	                                            type: 'checkbox'
	                                        }),
	                                        'Get your Free Daily and Weekly Love Horoscope by email'
	                                    )
	                                )
	                            ),
	                            (0, _preact.h)(
	                                'div',
	                                { 'class': 'row' },
	                                (0, _preact.h)(
	                                    'div',
	                                    { 'class': 'small-12 columns' },
	                                    (0, _preact.h)(
	                                        'label',
	                                        { 'class': 'checkbox' },
	                                        (0, _preact.h)('input', {
	                                            name: 'partner_optin',
	                                            onChange: this.setPartnerOptin,
	                                            checked: this.state.partner_optin,
	                                            type: 'checkbox'
	                                        }),
	                                        'Get member discounts and exclusive offers from our partners'
	                                    )
	                                )
	                            ),
	                            this.renderPPC()
	                        ),
	                        (0, _preact.h)(
	                            'footer',
	                            null,
	                            (0, _preact.h)(_invisibleRecaptcha2.default, {
	                                ref: function ref(e) {
	                                    return _this3.recaptchaInstance = e;
	                                },
	                                onChange: this.handleChanged,
	                                onExpired: this.handleExpired
	                            }),
	                            (0, _preact.h)(
	                                'button',
	                                { 'class': 'button-warning' },
	                                'Enter'
	                            )
	                        )
	                    )
	                );
	            }
	
	            return (0, _preact.h)('signup-modal-desktop', null);
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        isOpen: state.route === 'signup',
	        user: state.user,
	        ppc: state.cookie && state.cookie.PRIVACY_POLICY_CONSENT
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        routeTo: function routeTo(route) {
	            return dispatch({ type: 'route:to', payload: route });
	        },
	        userSignup: function userSignup(payload) {
	            return dispatch({ type: 'user:signup-api', payload: payload });
	        },
	        trackEvent: function trackEvent(payload) {
	            return dispatch({ type: 'ga:event', payload: payload });
	        },
	        userUpdate: function userUpdate(payload) {
	            return dispatch({ type: 'user:update', payload: payload });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ },

/***/ "./app/components/weekly/love-horoscope.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	var _moment = __webpack_require__("../node_modules/moment/moment.js");
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _promoMessage = __webpack_require__("./app/components/promo-message.js");
	
	var _promoMessage2 = _interopRequireDefault(_promoMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.renderH1 = function () {
	            return (0, _preact.h)(
	                'h1',
	                null,
	                _this.state.sign.charAt(0).toUpperCase() + _this.state.sign.slice(1),
	                ' Weekly Love Horoscope'
	            );
	        }, _this.renderHoroscope = function () {
	            return [(0, _preact.h)(
	                'p',
	                null,
	                (0, _preact.h)(
	                    'b',
	                    null,
	                    'Week of ',
	                    (0, _moment2.default)(_this.props.date).format('dddd, MMMM D'),
	                    ': '
	                ),
	                _this.props.horoscopes[_this.signs_map[_this.state.sign]].content
	            ), (0, _preact.h)(
	                'p',
	                null,
	                (0, _preact.h)(_promoMessage2.default, { placement: 'text-love-horoscope' })
	            )];
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.signs_map = {
	                general: 0,
	                aries: 1,
	                taurus: 2,
	                gemini: 3,
	                cancer: 4,
	                leo: 5,
	                virgo: 6,
	                libra: 7,
	                scorpio: 8,
	                sagittarius: 9,
	                capricorn: 10,
	                aquarius: 11,
	                pisces: 12
	            };
	
	            var sign = this.props.sign || 'general';
	
	            if (this.props.user.logged_in && !this.props.sign) {
	                sign = this.props.signs[this.props.user.default_sign - 1].name;
	            }
	
	            this.setState({ sign: sign });
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            if (nextProps.user.logged_in != this.props.user.logged_in) {
	                if (nextProps.user.logged_in && !this.props.sign) {
	                    this.setState({ sign: this.props.signs[nextProps.user.default_sign - 1].name });
	                } else if (!nextProps.user.logged_in && !this.props.sign) {
	                    this.setState({ sign: 'general' });
	                }
	            }
	
	            return true;
	        }
	    }, {
	        key: 'render',
	        value: function render(_ref2) {
	            var horoscopes = _ref2.horoscopes,
	                date = _ref2.date;
	
	            var last_week = (0, _moment2.default)().day(1).subtract(1, 'week').format('YYYY-MM-DD');
	            var this_week = (0, _moment2.default)().day(1).format('YYYY-MM-DD');
	            var next_week = (0, _moment2.default)().day(1).add(1, 'week').format('YYYY-MM-DD');
	
	            if (horoscopes) {
	                return (0, _preact.h)(
	                    'weekly-love-horoscope',
	                    { date: date },
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'daily-links' },
	                        (0, _preact.h)(
	                            'a',
	                            {
	                                href: '/astrology/weekly-love-horoscopes/' + this.state.sign + '/' + last_week,
	                                'class': last_week == date ? 'selected' : ''
	                            },
	                            'Last Week'
	                        ),
	                        (0, _preact.h)(
	                            'a',
	                            {
	                                href: '/astrology/weekly-love-horoscopes/' + this.state.sign + '/' + this_week,
	                                'class': this_week == date ? 'selected' : ''
	                            },
	                            'This Week'
	                        ),
	                        (0, _preact.h)(
	                            'a',
	                            {
	                                href: '/astrology/weekly-love-horoscopes/' + this.state.sign + '/' + next_week,
	                                'class': next_week == date ? 'selected' : ''
	                            },
	                            'Next Week'
	                        )
	                    ),
	                    this.renderH1(),
	                    (0, _preact.h)(
	                        'div',
	                        { 'class': 'daily-links' },
	                        (0, _preact.h)(
	                            'a',
	                            { href: '/bios/maria-desimone' },
	                            'by Maria DeSimone'
	                        )
	                    ),
	                    (0, _preact.h)('br', null),
	                    this.renderHoroscope()
	                );
	            }
	
	            return null;
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        horoscopes: state['weekly-love-horoscopes'],
	        signs: state.zodiac && state.zodiac.signs,
	        user: state.user
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps)(Component);

/***/ },

/***/ "./app/components/catalog/item.js":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _preact = __webpack_require__("../node_modules/preact/dist/preact.js");
	
	var _preactRedux = __webpack_require__("../node_modules/preact-redux/dist/preact-redux.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Component = function (_BaseComponent) {
	    _inherits(Component, _BaseComponent);
	
	    function Component() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Component);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (item) {
	            item.checked = !item.checked;
	            _this.props.callback();
	            _this.props.getFilter();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Component, [{
	        key: 'render',
	        value: function render(_ref2) {
	            var _this2 = this;
	
	            var item = _ref2.item;
	
	            return (0, _preact.h)(
	                'catalog-input-item',
	                { key: item.key },
	                (0, _preact.h)(
	                    'label',
	                    null,
	                    (0, _preact.h)('input', {
	                        type: 'checkbox',
	                        name: item.key,
	                        value: item.value,
	                        checked: item.checked,
	                        onChange: function onChange() {
	                            return _this2.handleChange(item);
	                        }
	                    }),
	                    item.name
	                )
	            );
	        }
	    }]);
	
	    return Component;
	}(_preact.Component);
	
	var mapStateToProps = function mapStateToProps() {
	    return {};
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        getFilter: function getFilter() {
	            return dispatch({ type: 'catalog:get-filter' });
	        }
	    };
	};
	
	exports.default = (0, _preactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);

/***/ }

/******/ });


// WEBPACK FOOTER //
// app.e3e252adf36f0d8c3163.js